{
  "schemaVersion": 1,
  "generatedAt": "2026-10-18T12:08:32.383Z",
  "sourceUpdatedAt": "2026-10-18T12:08:38.409Z",
  "views": {
    "30d": {
      "meta": {
        "asOf": "2026-10-18T12:08:38.409Z",
        "availableStart": "2025-01-01",
        "availableEnd": "2026-10-17",
        "rangeStart": "2026-09-18",
        "rangeEnd": "2026-10-17",
        "previousStart": "2026-08-19",
        "previousEnd": "2026-09-17",
        "lastSync": "2026-10-18T12:08:32.383Z",
        "grain": "day",
        "sourceStatus": "live",
        "sourceCitation": "Source: OpenRouter (openrouter.ai/rankings), as of 2026-10-18T12:08:38.409Z.",
        "inputTokenShare": 0.8,
        "pricedTokenShare": 0.010419851964381766,
        "modelCount": 471,
        "providerCount": 52,
        "notes": [
          "公开需求样本、模型牌价与重点模型端点报价已在本地完成更新。",
          "Token 数据来自公开路由市场样本，不代表全球全部 AI 推理需求。",
          "公开排名只提供输入与输出 Token 合计，不提供两者的实际拆分。",
          "价格趋势是按当期模型结构加权的公开零售牌价，不是历史成交价。",
          "金额为 Token 与公开牌价的情景估算，不是平台流水或已确认收入。",
          "不同模型沿用上游 tokenizer，跨模型 Token 数量并非完全等价。"
        ]
      },
      "analysis": {
        "headline": "Token 需求较上一等长区间增长 37.5%，加权牌价上升 12.6%，估算金额下降 15.8%。",
        "bullets": [
          "本期累计 682.93 万亿 Token，对比区间为 2026-08-19 至 2026-09-17（+37.5%）。",
          "可定价 Token 覆盖率 1.0%；加权零售价 $0.33/百万 Token。",
          "deepseek-v4.1-flash-20260910 的样本份额变化最大，上升 15.7 个百分点。",
          "估算金额仅用于观察需求与牌价的共同变化，不等同于平台实际收入。"
        ],
        "generatedAt": "2026-10-18T12:08:32.383Z"
      },
      "headline": {
        "tokenTotal": 682928905145459,
        "tokenDeltaPct": 37.46294268777734,
        "blendedPricePerMillion": 0.32508658623049663,
        "priceDeltaPct": 12.647241956524876,
        "estimatedRetailValue": 2313322.029672114,
        "valueDeltaPct": -15.841879175012233
      },
      "trends": [
        {
          "key": "2026-09-18",
          "label": "09-18",
          "startDate": "2026-09-18",
          "endDate": "2026-09-18",
          "totalTokens": 19516151287053,
          "pricedTokens": 231359189673,
          "blendedPricePerMillion": 0.3644483888182467,
          "estimatedRetailValue": 84318.48391461998,
          "pricedTokenShare": 0.01185475487815487
        },
        {
          "key": "2026-09-19",
          "label": "09-19",
          "startDate": "2026-09-19",
          "endDate": "2026-09-19",
          "totalTokens": 17822770536307,
          "pricedTokens": 264643847380,
          "blendedPricePerMillion": 0.2765440682906293,
          "estimatedRetailValue": 73185.6862025496,
          "pricedTokenShare": 0.01484863685143062
        },
        {
          "key": "2026-09-20",
          "label": "09-20",
          "startDate": "2026-09-20",
          "endDate": "2026-09-20",
          "totalTokens": 17331480167240,
          "pricedTokens": 241826466273,
          "blendedPricePerMillion": 0.27304305233957493,
          "estimatedRetailValue": 66029.03648767319,
          "pricedTokenShare": 0.013953018665428293
        },
        {
          "key": "2026-09-21",
          "label": "09-21",
          "startDate": "2026-09-21",
          "endDate": "2026-09-21",
          "totalTokens": 20836773421509,
          "pricedTokens": 262530519265,
          "blendedPricePerMillion": 0.36344919896161076,
          "estimatedRetailValue": 95416.50692983998,
          "pricedTokenShare": 0.012599384461031756
        },
        {
          "key": "2026-09-22",
          "label": "09-22",
          "startDate": "2026-09-22",
          "endDate": "2026-09-22",
          "totalTokens": 20461970574170,
          "pricedTokens": 283999745819,
          "blendedPricePerMillion": 0.35555734772958514,
          "estimatedRetailValue": 100978.19637927998,
          "pricedTokenShare": 0.013879393716727592
        },
        {
          "key": "2026-09-23",
          "label": "09-23",
          "startDate": "2026-09-23",
          "endDate": "2026-09-23",
          "totalTokens": 19839776739539,
          "pricedTokens": 280902925074,
          "blendedPricePerMillion": 0.3538065239449476,
          "estimatedRetailValue": 99385.28748639999,
          "pricedTokenShare": 0.014158572889289837
        },
        {
          "key": "2026-09-24",
          "label": "09-24",
          "startDate": "2026-09-24",
          "endDate": "2026-09-24",
          "totalTokens": 21879527010648,
          "pricedTokens": 287375435625,
          "blendedPricePerMillion": 0.33466753942177685,
          "estimatedRetailValue": 96175.22993087998,
          "pricedTokenShare": 0.013134444610486526
        },
        {
          "key": "2026-09-25",
          "label": "09-25",
          "startDate": "2026-09-25",
          "endDate": "2026-09-25",
          "totalTokens": 22441110438066,
          "pricedTokens": 279534118126,
          "blendedPricePerMillion": 0.3360153059611924,
          "estimatedRetailValue": 93927.74222869998,
          "pricedTokenShare": 0.012456340736679275
        },
        {
          "key": "2026-09-26",
          "label": "09-26",
          "startDate": "2026-09-26",
          "endDate": "2026-09-26",
          "totalTokens": 19855703336813,
          "pricedTokens": 276054180732,
          "blendedPricePerMillion": 0.27508994458115776,
          "estimatedRetailValue": 75939.72927896278,
          "pricedTokenShare": 0.013903016984555174
        },
        {
          "key": "2026-09-27",
          "label": "09-27",
          "startDate": "2026-09-27",
          "endDate": "2026-09-27",
          "totalTokens": 20530243814309,
          "pricedTokens": 247114322236,
          "blendedPricePerMillion": 0.2671825661244551,
          "estimatedRetailValue": 66024.63874111998,
          "pricedTokenShare": 0.012036599490541281
        },
        {
          "key": "2026-09-28",
          "label": "09-28",
          "startDate": "2026-09-28",
          "endDate": "2026-09-28",
          "totalTokens": 23934998683834,
          "pricedTokens": 251115364890,
          "blendedPricePerMillion": 0.3381985391812317,
          "estimatedRetailValue": 84926.84957175997,
          "pricedTokenShare": 0.010491555408340443
        },
        {
          "key": "2026-09-29",
          "label": "09-29",
          "startDate": "2026-09-29",
          "endDate": "2026-09-29",
          "totalTokens": 24936730343781,
          "pricedTokens": 294549377433,
          "blendedPricePerMillion": 0.33522575965090984,
          "estimatedRetailValue": 98740.53880467998,
          "pricedTokenShare": 0.011811868411467906
        },
        {
          "key": "2026-09-30",
          "label": "09-30",
          "startDate": "2026-09-30",
          "endDate": "2026-09-30",
          "totalTokens": 24377727661254,
          "pricedTokens": 279687677951,
          "blendedPricePerMillion": 0.3350739732747848,
          "estimatedRetailValue": 93716.06152703997,
          "pricedTokenShare": 0.011473082390510746
        },
        {
          "key": "2026-10-01",
          "label": "10-01",
          "startDate": "2026-10-01",
          "endDate": "2026-10-01",
          "totalTokens": 23446998494287,
          "pricedTokens": 245998461212,
          "blendedPricePerMillion": 0.353093077105894,
          "estimatedRetailValue": 86860.35363265999,
          "pricedTokenShare": 0.010491682390474797
        },
        {
          "key": "2026-10-02",
          "label": "10-02",
          "startDate": "2026-10-02",
          "endDate": "2026-10-02",
          "totalTokens": 24060063479633,
          "pricedTokens": 249191811848,
          "blendedPricePerMillion": 0.3720436382073044,
          "estimatedRetailValue": 92710.22829139998,
          "pricedTokenShare": 0.010357072085821489
        },
        {
          "key": "2026-10-03",
          "label": "10-03",
          "startDate": "2026-10-03",
          "endDate": "2026-10-03",
          "totalTokens": 22318533815723,
          "pricedTokens": 187993466065,
          "blendedPricePerMillion": 0.36287259329701,
          "estimatedRetailValue": 68217.67655389999,
          "pricedTokenShare": 0.00842319964282609
        },
        {
          "key": "2026-10-04",
          "label": "10-04",
          "startDate": "2026-10-04",
          "endDate": "2026-10-04",
          "totalTokens": 22780997379051,
          "pricedTokens": 231168070625,
          "blendedPricePerMillion": 0.2957920090131772,
          "estimatedRetailValue": 68377.66802986879,
          "pricedTokenShare": 0.010147407805664296
        },
        {
          "key": "2026-10-05",
          "label": "10-05",
          "startDate": "2026-10-05",
          "endDate": "2026-10-05",
          "totalTokens": 25873213536983,
          "pricedTokens": 229769497429,
          "blendedPricePerMillion": 0.36379532161761136,
          "estimatedRetailValue": 83589.06821509998,
          "pricedTokenShare": 0.008880593711352051
        },
        {
          "key": "2026-10-06",
          "label": "10-06",
          "startDate": "2026-10-06",
          "endDate": "2026-10-06",
          "totalTokens": 22109724903182,
          "pricedTokens": 238757267127,
          "blendedPricePerMillion": 0.3537147238240007,
          "estimatedRetailValue": 84451.96080279998,
          "pricedTokenShare": 0.010798744361248854
        },
        {
          "key": "2026-10-07",
          "label": "10-07",
          "startDate": "2026-10-07",
          "endDate": "2026-10-07",
          "totalTokens": 25121204185746,
          "pricedTokens": 242325593416,
          "blendedPricePerMillion": 0.34370764855884456,
          "estimatedRetailValue": 83289.15989863998,
          "pricedTokenShare": 0.009646257067306421
        },
        {
          "key": "2026-10-08",
          "label": "10-08",
          "startDate": "2026-10-08",
          "endDate": "2026-10-08",
          "totalTokens": 24455189713768,
          "pricedTokens": 222206560125,
          "blendedPricePerMillion": 0.3526312592492367,
          "estimatedRetailValue": 78356.97911031998,
          "pricedTokenShare": 0.009086274231595928
        },
        {
          "key": "2026-10-09",
          "label": "10-09",
          "startDate": "2026-10-09",
          "endDate": "2026-10-09",
          "totalTokens": 26639007266335,
          "pricedTokens": 218411177448,
          "blendedPricePerMillion": 0.3458721059711577,
          "estimatedRetailValue": 75542.33391157999,
          "pricedTokenShare": 0.008198923303122363
        },
        {
          "key": "2026-10-10",
          "label": "10-10",
          "startDate": "2026-10-10",
          "endDate": "2026-10-10",
          "totalTokens": 24019743394927,
          "pricedTokens": 175286831314,
          "blendedPricePerMillion": 0.3512843624503469,
          "estimatedRetailValue": 61575.52278407999,
          "pricedTokenShare": 0.007297614651079944
        },
        {
          "key": "2026-10-11",
          "label": "10-11",
          "startDate": "2026-10-11",
          "endDate": "2026-10-11",
          "totalTokens": 23624418723773,
          "pricedTokens": 67891727613,
          "blendedPricePerMillion": 0.15999999999999998,
          "estimatedRetailValue": 10862.676418079998,
          "pricedTokenShare": 0.0028737946277882925
        },
        {
          "key": "2026-10-12",
          "label": "10-12",
          "startDate": "2026-10-12",
          "endDate": "2026-10-12",
          "totalTokens": 26944742365440,
          "pricedTokens": 221344983099,
          "blendedPricePerMillion": 0.34164369500770325,
          "estimatedRetailValue": 75621.11789735999,
          "pricedTokenShare": 0.008214774522502119
        },
        {
          "key": "2026-10-13",
          "label": "10-13",
          "startDate": "2026-10-13",
          "endDate": "2026-10-13",
          "totalTokens": 26210571251367,
          "pricedTokens": 253224515864,
          "blendedPricePerMillion": 0.3285624978251493,
          "estimatedRetailValue": 83200.07944283998,
          "pricedTokenShare": 0.009661159744879395
        },
        {
          "key": "2026-10-14",
          "label": "10-14",
          "startDate": "2026-10-14",
          "endDate": "2026-10-14",
          "totalTokens": 26374532234884,
          "pricedTokens": 253160917129,
          "blendedPricePerMillion": 0.3283624024448499,
          "estimatedRetailValue": 83128.52695361999,
          "pricedTokenShare": 0.009598688419359316
        },
        {
          "key": "2026-10-15",
          "label": "10-15",
          "startDate": "2026-10-15",
          "endDate": "2026-10-15",
          "totalTokens": 24438956540182,
          "pricedTokens": 256875059185,
          "blendedPricePerMillion": 0.3186298716692984,
          "estimatedRetailValue": 81848.06714315998,
          "pricedTokenShare": 0.010510884896523779
        },
        {
          "key": "2026-10-16",
          "label": "10-16",
          "startDate": "2026-10-16",
          "endDate": "2026-10-16",
          "totalTokens": 22407801051165,
          "pricedTokens": 188782226366,
          "blendedPricePerMillion": 0.19654341472753425,
          "estimatedRetailValue": 37103.90340983999,
          "pricedTokenShare": 0.008424843916408525
        },
        {
          "key": "2026-10-17",
          "label": "10-17",
          "startDate": "2026-10-17",
          "endDate": "2026-10-17",
          "totalTokens": 18338242794490,
          "pricedTokens": 152936757471,
          "blendedPricePerMillion": 0.1950003399216503,
          "estimatedRetailValue": 29822.71969335999,
          "pricedTokenShare": 0.008339771655600074
        }
      ],
      "modelShares": [
        {
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "name": "deepseek-v4.1-flash-20260910",
          "tokens": 124552983603352,
          "previousTokens": 12520558593021,
          "share": 0.18238060018388458,
          "previousShare": 0.025201932665667726,
          "shareDeltaPctPoints": 15.717866751821685,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "stealth/space-bunny-alpha",
          "name": "space-bunny-alpha",
          "tokens": 56716522847075,
          "previousTokens": 0,
          "share": 0.08304894172695002,
          "previousShare": 0,
          "shareDeltaPctPoints": 8.304894172695002,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "name": "glm-5.3-flash-20260826",
          "tokens": 56234937160102,
          "previousTokens": 37367798778355,
          "share": 0.08234376482882118,
          "previousShare": 0.0752155538173235,
          "shareDeltaPctPoints": 0.7128211011497674,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "tencent/hy4-preview-20260827",
          "name": "hy4-preview-20260827",
          "tokens": 36549512467462,
          "previousTokens": 41662933208276,
          "share": 0.05351876629043431,
          "previousShare": 0.08386098987264429,
          "shareDeltaPctPoints": -3.0342223582209975,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "xiaomi/mimo-v2.6-flash-20260921",
          "name": "mimo-v2.6-flash-20260921",
          "tokens": 35479245491272,
          "previousTokens": 0,
          "share": 0.05195159441042428,
          "previousShare": 0,
          "shareDeltaPctPoints": 5.195159441042428,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "deepseek/deepseek-v4-flash-20260731",
          "name": "deepseek-v4-flash-20260731",
          "tokens": 26341840768256,
          "previousTokens": 50293112006224,
          "share": 0.03857186387892803,
          "previousShare": 0.10123219446728533,
          "shareDeltaPctPoints": -6.266033058835729,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "nvidia/nemotron-3-ultra-550b-a55b-20260604:free",
          "name": "nemotron-3-ultra-550b-a55b-20260604:free",
          "tokens": 24758352758756,
          "previousTokens": 18350289920933,
          "share": 0.03625319205588852,
          "previousShare": 0.03693627305419207,
          "shareDeltaPctPoints": -0.06830809983035535,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "openai/gpt-6-luna-20260922",
          "name": "gpt-6-luna-20260922",
          "tokens": 21680101231798,
          "previousTokens": 0,
          "share": 0.03174576602110624,
          "previousShare": 0,
          "shareDeltaPctPoints": 3.1745766021106245,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "stepfun/step-5-preview-20261008",
          "name": "step-5-preview-20261008",
          "tokens": 20293436655399,
          "previousTokens": 0,
          "share": 0.02971529906334341,
          "previousShare": 0,
          "shareDeltaPctPoints": 2.971529906334341,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "openai/gpt-5.6-luna-20260709",
          "name": "gpt-5.6-luna-20260709",
          "tokens": 19785910187338,
          "previousTokens": 47936264446145,
          "share": 0.028972137565510925,
          "previousShare": 0.0964882277288155,
          "shareDeltaPctPoints": -6.751609016330458,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "z-ai/glm-5.3-20260816",
          "name": "glm-5.3-20260816",
          "tokens": 15463900277039,
          "previousTokens": 9091735491495,
          "share": 0.022643499433876356,
          "previousShare": 0.01830024626844012,
          "shareDeltaPctPoints": 0.4343253165436236,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "anthropic/claude-opus-5.5-20260921",
          "name": "claude-opus-5.5-20260921",
          "tokens": 13896369156570,
          "previousTokens": 0,
          "share": 0.020348192984466183,
          "previousShare": 0,
          "shareDeltaPctPoints": 2.0348192984466182,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "deepseek/deepseek-v4-flash-20260423",
          "name": "deepseek-v4-flash-20260423",
          "tokens": 13664171243557,
          "previousTokens": 21174971140319,
          "share": 0.020008189931053848,
          "previousShare": 0.042621916020043636,
          "shareDeltaPctPoints": -2.261372608898979,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "typesafe/jev-1.13-20260917",
          "name": "jev-1.13-20260917",
          "tokens": 12201246536593,
          "previousTokens": 0,
          "share": 0.01786605669296458,
          "previousShare": 0,
          "shareDeltaPctPoints": 1.786605669296458,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "tencent/hy3-20260706",
          "name": "hy3-20260706",
          "tokens": 11652548051290,
          "previousTokens": 22580955358774,
          "share": 0.017062607781710586,
          "previousShare": 0.04545194307828088,
          "shareDeltaPctPoints": -2.8389335296570297,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "meta/muse-spark-1.3-contributor-20260902",
          "name": "muse-spark-1.3-contributor-20260902",
          "tokens": 9110128286137,
          "previousTokens": 4061871608210,
          "share": 0.01333979015604356,
          "previousShare": 0.008175914357667364,
          "shareDeltaPctPoints": 0.5163875798376196,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "google/gemini-3.8-flash-20260902",
          "name": "gemini-3.8-flash-20260902",
          "tokens": 8736833095443,
          "previousTokens": 5053397273405,
          "share": 0.012793181002614198,
          "previousShare": 0.010171700956553965,
          "shareDeltaPctPoints": 0.2621480046060233,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "moonshotai/kimi-k3-20260715",
          "name": "kimi-k3-20260715",
          "tokens": 7722079165083,
          "previousTokens": 6843641745374,
          "share": 0.011307295835484153,
          "previousShare": 0.01377518400425084,
          "shareDeltaPctPoints": -0.2467888168766688,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "xiaomi/mimo-v2.5-20260422",
          "name": "mimo-v2.5-20260422",
          "tokens": 7583154385894,
          "previousTokens": 30580663716747,
          "share": 0.011103870884303604,
          "previousShare": 0.0615541089588824,
          "shareDeltaPctPoints": -5.04502380745788,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "z-ai/glm-5.2-20260616",
          "name": "glm-5.2-20260616",
          "tokens": 5994348216737,
          "previousTokens": 10271660252526,
          "share": 0.008777411779722879,
          "previousShare": 0.020675250878428728,
          "shareDeltaPctPoints": -1.189783909870585,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        }
      ],
      "providerPrices": [
        {
          "provider": "OpenInference",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.04,
          "completionPricePerMillion": 0.144,
          "blendedPricePerMillion": 0.060799999999999986,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Relace",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.049999999999999996,
          "completionPricePerMillion": 0.6,
          "blendedPricePerMillion": 0.15999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Morph",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.081,
          "completionPricePerMillion": 0.55,
          "blendedPricePerMillion": 0.17479999999999998,
          "throughput": null,
          "latency": null,
          "uptime": null,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Decart",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.09,
          "completionPricePerMillion": 0.18,
          "blendedPricePerMillion": 0.108,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Sail Research",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.09,
          "completionPricePerMillion": 0.3,
          "blendedPricePerMillion": 0.13199999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Wafer",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.09999999999999999,
          "completionPricePerMillion": 0.65,
          "blendedPricePerMillion": 0.20999999999999996,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "InferenceNet",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.103,
          "completionPricePerMillion": 0.7150000000000001,
          "blendedPricePerMillion": 0.22539999999999996,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DeepInfra",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.112,
          "completionPricePerMillion": 0.33599999999999997,
          "blendedPricePerMillion": 0.15679999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "AtlasCloud",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.135,
          "completionPricePerMillion": 0.54,
          "blendedPricePerMillion": 0.21599999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DeepInfra",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.14,
          "completionPricePerMillion": 0.42,
          "blendedPricePerMillion": 0.196,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "StreamLake",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.1497,
          "completionPricePerMillion": 0.5988,
          "blendedPricePerMillion": 0.23952,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "CoreWeave",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.65,
          "blendedPricePerMillion": 0.24999999999999994,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "GMICloud",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.18,
          "completionPricePerMillion": 0.72,
          "blendedPricePerMillion": 0.288,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DigitalOcean",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.195,
          "completionPricePerMillion": 0.78,
          "blendedPricePerMillion": 0.312,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Novita",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.195,
          "completionPricePerMillion": 0.78,
          "blendedPricePerMillion": 0.312,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DeepInfra",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.21,
          "completionPricePerMillion": 0.63,
          "blendedPricePerMillion": 0.294,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Phala",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.21,
          "completionPricePerMillion": 0.84,
          "blendedPricePerMillion": 0.33599999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Ionstream",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.27,
          "completionPricePerMillion": 0.75,
          "blendedPricePerMillion": 0.366,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Makora",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.27,
          "completionPricePerMillion": 1.15,
          "blendedPricePerMillion": 0.44599999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Crusoe",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.29,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47199999999999986,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Nebius",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "PrimeIntellect",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Baidu",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "BaseTen",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Alibaba",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Together",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "SiliconFlow",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Modal",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "BaseTen",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Parasail",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Fireworks",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Venice",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Fireworks",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.44999999999999996,
          "completionPricePerMillion": 1.7999999999999998,
          "blendedPricePerMillion": 0.7199999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "BaseTen",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.6,
          "completionPricePerMillion": 2.4,
          "blendedPricePerMillion": 0.9599999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "OpenInference",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.048,
          "completionPricePerMillion": 0.19999999999999998,
          "blendedPricePerMillion": 0.07839999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Reka",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.06,
          "completionPricePerMillion": 1.5999999999999999,
          "blendedPricePerMillion": 0.3679999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "StreamLake",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.075,
          "completionPricePerMillion": 0.25,
          "blendedPricePerMillion": 0.10999999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DeepInfra",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.075,
          "completionPricePerMillion": 0.25,
          "blendedPricePerMillion": 0.10999999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Relace",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.075,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.15999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Sail Research",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.07835,
          "completionPricePerMillion": 0.3,
          "blendedPricePerMillion": 0.12267999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Sail Research",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.07835,
          "completionPricePerMillion": 0.3,
          "blendedPricePerMillion": 0.12267999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Near AI",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.08,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.16399999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Novita",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.08399999999999999,
          "completionPricePerMillion": 0.28,
          "blendedPricePerMillion": 0.12319999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "GMICloud",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.09,
          "completionPricePerMillion": 0.3,
          "blendedPricePerMillion": 0.13199999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Inceptron",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.09999999999999999,
          "completionPricePerMillion": 0.69,
          "blendedPricePerMillion": 0.21799999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "InferenceNet",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.12,
          "completionPricePerMillion": 0.38799999999999996,
          "blendedPricePerMillion": 0.17359999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Wafer",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.12,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.19599999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 96.66666666666667,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Phala",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.1275,
          "completionPricePerMillion": 0.425,
          "blendedPricePerMillion": 0.18699999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Morph",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.129,
          "completionPricePerMillion": 0.65,
          "blendedPricePerMillion": 0.2332,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DigitalOcean",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.13124999999999998,
          "completionPricePerMillion": 0.4375,
          "blendedPricePerMillion": 0.19249999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Makora",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.14,
          "completionPricePerMillion": 0.47,
          "blendedPricePerMillion": 0.206,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "PrimeIntellect",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Modal",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "BaseTen",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Crusoe",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "CoreWeave",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "AtlasCloud",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 96.29629629629629,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Fireworks",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Friendli",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "SiliconFlow",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Together",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Parasail",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "BaseTen",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Venice",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Z.AI",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Parasail",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.1875,
          "completionPricePerMillion": 0.625,
          "blendedPricePerMillion": 0.275,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Fireworks",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.22499999999999998,
          "completionPricePerMillion": 0.75,
          "blendedPricePerMillion": 0.32999999999999996,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "NextBit",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.25,
          "completionPricePerMillion": 0.7,
          "blendedPricePerMillion": 0.3399999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Darkbloom",
          "modelSlug": "xiaomi/mimo-v2.6-flash-20260921",
          "modelName": "Xiaomi: MiMo-V2.6-Flash",
          "promptPricePerMillion": 0.09999999999999999,
          "completionPricePerMillion": 0.28,
          "blendedPricePerMillion": 0.136,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Makora",
          "modelSlug": "xiaomi/mimo-v2.6-flash-20260921",
          "modelName": "Xiaomi: MiMo-V2.6-Flash",
          "promptPricePerMillion": 0.13,
          "completionPricePerMillion": 0.28,
          "blendedPricePerMillion": 0.16,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DeepInfra",
          "modelSlug": "xiaomi/mimo-v2.6-flash-20260921",
          "modelName": "Xiaomi: MiMo-V2.6-Flash",
          "promptPricePerMillion": 0.133,
          "completionPricePerMillion": 0.266,
          "blendedPricePerMillion": 0.1596,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Novita",
          "modelSlug": "xiaomi/mimo-v2.6-flash-20260921",
          "modelName": "Xiaomi: MiMo-V2.6-Flash",
          "promptPricePerMillion": 0.14,
          "completionPricePerMillion": 0.28,
          "blendedPricePerMillion": 0.16799999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 95.23809523809523,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "GMICloud",
          "modelSlug": "xiaomi/mimo-v2.6-flash-20260921",
          "modelName": "Xiaomi: MiMo-V2.6-Flash",
          "promptPricePerMillion": 0.14,
          "completionPricePerMillion": 0.28,
          "blendedPricePerMillion": 0.16799999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 88.23529411764706,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Xiaomi",
          "modelSlug": "xiaomi/mimo-v2.6-flash-20260921",
          "modelName": "Xiaomi: MiMo-V2.6-Flash",
          "promptPricePerMillion": 0.14,
          "completionPricePerMillion": 0.28,
          "blendedPricePerMillion": 0.16799999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Io Net",
          "modelSlug": "xiaomi/mimo-v2.6-flash-20260921",
          "modelName": "Xiaomi: MiMo-V2.6-Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.29,
          "blendedPricePerMillion": 0.178,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Venice",
          "modelSlug": "xiaomi/mimo-v2.6-flash-20260921",
          "modelName": "Xiaomi: MiMo-V2.6-Flash",
          "promptPricePerMillion": 0.175,
          "completionPricePerMillion": 0.35,
          "blendedPricePerMillion": 0.21,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DeepInfra",
          "modelSlug": "tencent/hy4-preview-20260827",
          "modelName": "Tencent: Hy4 preview",
          "promptPricePerMillion": 0.834,
          "completionPricePerMillion": 2.501,
          "blendedPricePerMillion": 1.1674,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Novita",
          "modelSlug": "tencent/hy4-preview-20260827",
          "modelName": "Tencent: Hy4 preview",
          "promptPricePerMillion": 0.834,
          "completionPricePerMillion": 2.501,
          "blendedPricePerMillion": 1.1674,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "SiliconFlow",
          "modelSlug": "tencent/hy4-preview-20260827",
          "modelName": "Tencent: Hy4 preview",
          "promptPricePerMillion": 0.834,
          "completionPricePerMillion": 2.501,
          "blendedPricePerMillion": 1.1674,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Tencent",
          "modelSlug": "tencent/hy4-preview-20260827",
          "modelName": "Tencent: Hy4 preview",
          "promptPricePerMillion": 0.834,
          "completionPricePerMillion": 2.501,
          "blendedPricePerMillion": 1.1674,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Amazon Bedrock",
          "modelSlug": "anthropic/claude-opus-5.5-20260921",
          "modelName": "Anthropic: Claude Opus 5.5",
          "promptPricePerMillion": 4,
          "completionPricePerMillion": 20,
          "blendedPricePerMillion": 7.199999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Azure",
          "modelSlug": "anthropic/claude-opus-5.5-20260921",
          "modelName": "Anthropic: Claude Opus 5.5",
          "promptPricePerMillion": 4,
          "completionPricePerMillion": 20,
          "blendedPricePerMillion": 7.199999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Google",
          "modelSlug": "anthropic/claude-opus-5.5-20260921",
          "modelName": "Anthropic: Claude Opus 5.5",
          "promptPricePerMillion": 4,
          "completionPricePerMillion": 20,
          "blendedPricePerMillion": 7.199999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Claude Platform on AWS",
          "modelSlug": "anthropic/claude-opus-5.5-20260921",
          "modelName": "Anthropic: Claude Opus 5.5",
          "promptPricePerMillion": 4,
          "completionPricePerMillion": 20,
          "blendedPricePerMillion": 7.199999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Anthropic",
          "modelSlug": "anthropic/claude-opus-5.5-20260921",
          "modelName": "Anthropic: Claude Opus 5.5",
          "promptPricePerMillion": 4,
          "completionPricePerMillion": 20,
          "blendedPricePerMillion": 7.199999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Amazon Bedrock",
          "modelSlug": "anthropic/claude-opus-5.5-20260921",
          "modelName": "Anthropic: Claude Opus 5.5",
          "promptPricePerMillion": 4.4,
          "completionPricePerMillion": 22,
          "blendedPricePerMillion": 7.919999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Amazon Bedrock",
          "modelSlug": "anthropic/claude-opus-5.5-20260921",
          "modelName": "Anthropic: Claude Opus 5.5",
          "promptPricePerMillion": 4.4,
          "completionPricePerMillion": 22,
          "blendedPricePerMillion": 7.919999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Azure",
          "modelSlug": "anthropic/claude-opus-5.5-20260921",
          "modelName": "Anthropic: Claude Opus 5.5",
          "promptPricePerMillion": 4.4,
          "completionPricePerMillion": 22,
          "blendedPricePerMillion": 7.919999999999999,
          "throughput": null,
          "latency": null,
          "uptime": null,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Google",
          "modelSlug": "anthropic/claude-opus-5.5-20260921",
          "modelName": "Anthropic: Claude Opus 5.5",
          "promptPricePerMillion": 4.4,
          "completionPricePerMillion": 22,
          "blendedPricePerMillion": 7.919999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Google",
          "modelSlug": "anthropic/claude-opus-5.5-20260921",
          "modelName": "Anthropic: Claude Opus 5.5",
          "promptPricePerMillion": 4.4,
          "completionPricePerMillion": 22,
          "blendedPricePerMillion": 7.919999999999999,
          "throughput": null,
          "latency": null,
          "uptime": null,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Anthropic",
          "modelSlug": "anthropic/claude-opus-5.5-20260921",
          "modelName": "Anthropic: Claude Opus 5.5",
          "promptPricePerMillion": 8,
          "completionPricePerMillion": 40,
          "blendedPricePerMillion": 14.399999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Relace",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.049999999999999996,
          "completionPricePerMillion": 0.6,
          "blendedPricePerMillion": 0.15999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DeepInfra",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.0784,
          "completionPricePerMillion": 0.2352,
          "blendedPricePerMillion": 0.10976,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "InferenceNet",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.08,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.16399999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Morph",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.081,
          "completionPricePerMillion": 0.55,
          "blendedPricePerMillion": 0.17479999999999998,
          "throughput": null,
          "latency": null,
          "uptime": null,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DeepInfra",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.098,
          "completionPricePerMillion": 0.29400000000000004,
          "blendedPricePerMillion": 0.13720000000000002,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Cloudflare",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.09999999999999999,
          "completionPricePerMillion": 0.6,
          "blendedPricePerMillion": 0.19999999999999996,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DeepInfra",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.14700000000000002,
          "completionPricePerMillion": 0.441,
          "blendedPricePerMillion": 0.2058,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DeepSeek",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.6,
          "blendedPricePerMillion": 0.23999999999999994,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Wafer",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Fireworks",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "PrimeIntellect",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "BaseTen",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Parasail",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "OpenAI",
          "modelSlug": "openai/gpt-6-luna-20260922",
          "modelName": "OpenAI: GPT-6 Luna",
          "promptPricePerMillion": 0.049999999999999996,
          "completionPricePerMillion": 0.25,
          "blendedPricePerMillion": 0.08999999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "OpenAI",
          "modelSlug": "openai/gpt-6-luna-20260922",
          "modelName": "OpenAI: GPT-6 Luna",
          "promptPricePerMillion": 0.09999999999999999,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.17999999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Azure",
          "modelSlug": "openai/gpt-6-luna-20260922",
          "modelName": "OpenAI: GPT-6 Luna",
          "promptPricePerMillion": 0.09999999999999999,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.17999999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Azure",
          "modelSlug": "openai/gpt-6-luna-20260922",
          "modelName": "OpenAI: GPT-6 Luna",
          "promptPricePerMillion": 0.11,
          "completionPricePerMillion": 0.55,
          "blendedPricePerMillion": 0.198,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Azure",
          "modelSlug": "openai/gpt-6-luna-20260922",
          "modelName": "OpenAI: GPT-6 Luna",
          "promptPricePerMillion": 0.11,
          "completionPricePerMillion": 0.55,
          "blendedPricePerMillion": 0.198,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Amazon Bedrock",
          "modelSlug": "openai/gpt-6-luna-20260922",
          "modelName": "OpenAI: GPT-6 Luna",
          "promptPricePerMillion": 0.11,
          "completionPricePerMillion": 0.55,
          "blendedPricePerMillion": 0.198,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "OpenAI",
          "modelSlug": "openai/gpt-6-luna-20260922",
          "modelName": "OpenAI: GPT-6 Luna",
          "promptPricePerMillion": 0.19999999999999998,
          "completionPricePerMillion": 1,
          "blendedPricePerMillion": 0.35999999999999993,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Relace",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.075,
          "completionPricePerMillion": 2.2,
          "blendedPricePerMillion": 0.4999999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Wafer",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.079,
          "completionPricePerMillion": 2.5,
          "blendedPricePerMillion": 0.5631999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "InferenceNet",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.08,
          "completionPricePerMillion": 4.381,
          "blendedPricePerMillion": 0.9401999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Morph",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.08,
          "completionPricePerMillion": 6,
          "blendedPricePerMillion": 1.2639999999999996,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Reka",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.14,
          "completionPricePerMillion": 4.199999999999999,
          "blendedPricePerMillion": 0.9519999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Makora",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.14,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 0.9919999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Wafer",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.179,
          "completionPricePerMillion": 2.5,
          "blendedPricePerMillion": 0.6432,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DekaLLM",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.18,
          "completionPricePerMillion": 2.95,
          "blendedPricePerMillion": 0.7339999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "AkashML",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.19,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 1.0319999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Io Net",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.49,
          "completionPricePerMillion": 2.6,
          "blendedPricePerMillion": 0.9119999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Sail Research",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.5,
          "completionPricePerMillion": 1.505,
          "blendedPricePerMillion": 0.701,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Sail Research",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.5,
          "completionPricePerMillion": 1.505,
          "blendedPricePerMillion": 0.701,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Inceptron",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.55,
          "completionPricePerMillion": 1.505,
          "blendedPricePerMillion": 0.741,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DeepInfra",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.5625,
          "completionPricePerMillion": 2.5,
          "blendedPricePerMillion": 0.95,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Baidu",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.5992000000000001,
          "completionPricePerMillion": 1.8832,
          "blendedPricePerMillion": 0.856,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Tenstorrent",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.6,
          "completionPricePerMillion": 2.5,
          "blendedPricePerMillion": 0.98,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "SiliconFlow",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.7,
          "completionPricePerMillion": 2.2,
          "blendedPricePerMillion": 1,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Novita",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.7,
          "completionPricePerMillion": 2.2,
          "blendedPricePerMillion": 1,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Phala",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.84,
          "completionPricePerMillion": 2.64,
          "blendedPricePerMillion": 1.2,
          "throughput": null,
          "latency": null,
          "uptime": null,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Decart",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.84,
          "completionPricePerMillion": 2.66,
          "blendedPricePerMillion": 1.2039999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DigitalOcean",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.9099999999999999,
          "completionPricePerMillion": 2.8600000000000003,
          "blendedPricePerMillion": 1.2999999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "GMICloud",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.98,
          "completionPricePerMillion": 3.08,
          "blendedPricePerMillion": 1.4,
          "throughput": null,
          "latency": null,
          "uptime": null,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Alibaba",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.19,
          "completionPricePerMillion": 3.74,
          "blendedPricePerMillion": 1.6999999999999997,
          "throughput": null,
          "latency": null,
          "uptime": null,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "CoreWeave",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.2,
          "completionPricePerMillion": 4,
          "blendedPricePerMillion": 1.7599999999999996,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Friendli",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.26,
          "completionPricePerMillion": 3.9600000000000004,
          "blendedPricePerMillion": 1.8,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Mistral",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "BaseTen",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Mistral",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Nebius",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Crusoe",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "PrimeIntellect",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Venice",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": null,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Together",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Parasail",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Modal",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "BaseTen",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": null,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Fireworks",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Cloudflare",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": null,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "AtlasCloud",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": 96.66666666666667,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Z.AI",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Mistral",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.54,
          "completionPricePerMillion": 4.84,
          "blendedPricePerMillion": 2.2,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "ModelRun",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 2.0999999999999996,
          "completionPricePerMillion": 6.6000000000000005,
          "blendedPricePerMillion": 3,
          "throughput": null,
          "latency": null,
          "uptime": null,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Fireworks",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 2.0999999999999996,
          "completionPricePerMillion": 6.6000000000000005,
          "blendedPricePerMillion": 3,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "BaseTen",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 2.0999999999999996,
          "completionPricePerMillion": 6.6000000000000005,
          "blendedPricePerMillion": 3,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "BaseTen",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 2.0999999999999996,
          "completionPricePerMillion": 6.6000000000000005,
          "blendedPricePerMillion": 3,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Alibaba",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 2.8,
          "completionPricePerMillion": 8.8,
          "blendedPricePerMillion": 4,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "OpenInference",
          "modelSlug": "deepseek/deepseek-v4-flash-20260731",
          "modelName": "DeepSeek: DeepSeek V4 Flash 0731",
          "promptPricePerMillion": 0.00392,
          "completionPricePerMillion": 0.143616,
          "blendedPricePerMillion": 0.0318592,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Relace",
          "modelSlug": "deepseek/deepseek-v4-flash-20260731",
          "modelName": "DeepSeek: DeepSeek V4 Flash 0731",
          "promptPricePerMillion": 0.0199,
          "completionPricePerMillion": 0.44999999999999996,
          "blendedPricePerMillion": 0.10591999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Reka",
          "modelSlug": "deepseek/deepseek-v4-flash-20260731",
          "modelName": "DeepSeek: DeepSeek V4 Flash 0731",
          "promptPricePerMillion": 0.020999999999999998,
          "completionPricePerMillion": 0.5279999999999999,
          "blendedPricePerMillion": 0.12239999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        }
      ]
    },
    "90d": {
      "meta": {
        "asOf": "2026-10-18T12:08:38.409Z",
        "availableStart": "2025-01-01",
        "availableEnd": "2026-10-17",
        "rangeStart": "2026-07-20",
        "rangeEnd": "2026-10-17",
        "previousStart": "2026-04-21",
        "previousEnd": "2026-07-19",
        "lastSync": "2026-10-18T12:08:32.383Z",
        "grain": "day",
        "sourceStatus": "live",
        "sourceCitation": "Source: OpenRouter (openrouter.ai/rankings), as of 2026-10-18T12:08:38.409Z.",
        "inputTokenShare": 0.8,
        "pricedTokenShare": 0.01751253197249061,
        "modelCount": 471,
        "providerCount": 52,
        "notes": [
          "公开需求样本、模型牌价与重点模型端点报价已在本地完成更新。",
          "Token 数据来自公开路由市场样本，不代表全球全部 AI 推理需求。",
          "公开排名只提供输入与输出 Token 合计，不提供两者的实际拆分。",
          "价格趋势是按当期模型结构加权的公开零售牌价，不是历史成交价。",
          "金额为 Token 与公开牌价的情景估算，不是平台流水或已确认收入。",
          "不同模型沿用上游 tokenizer，跨模型 Token 数量并非完全等价。"
        ]
      },
      "analysis": {
        "headline": "Token 需求较上一等长区间增长 197.7%，加权牌价下降 4.6%，估算金额下降 26.0%。",
        "bullets": [
          "本期累计 1.46 千万亿 Token，对比区间为 2026-04-21 至 2026-07-19（+197.7%）。",
          "可定价 Token 覆盖率 1.8%；加权零售价 $0.31/百万 Token。",
          "deepseek-v4.1-flash-20260910 的样本份额变化最大，上升 9.4 个百分点。",
          "估算金额仅用于观察需求与牌价的共同变化，不等同于平台实际收入。"
        ],
        "generatedAt": "2026-10-18T12:08:32.383Z"
      },
      "headline": {
        "tokenTotal": 1464971705487332,
        "tokenDeltaPct": 197.68277066789184,
        "blendedPricePerMillion": 0.3102665461101952,
        "priceDeltaPct": -4.568664805391562,
        "estimatedRetailValue": 7960001.125088545,
        "valueDeltaPct": -25.968911572381398
      },
      "trends": [
        {
          "key": "2026-07-20",
          "label": "07-20",
          "startDate": "2026-07-20",
          "endDate": "2026-07-20",
          "totalTokens": 8440173824425,
          "pricedTokens": 321507957846,
          "blendedPricePerMillion": 0.32964291879426816,
          "estimatedRetailValue": 105982.82163993997,
          "pricedTokenShare": 0.03809257540592219
        },
        {
          "key": "2026-07-21",
          "label": "07-21",
          "startDate": "2026-07-21",
          "endDate": "2026-07-21",
          "totalTokens": 8372722163355,
          "pricedTokens": 340859610228,
          "blendedPricePerMillion": 0.3192527695500536,
          "estimatedRetailValue": 108820.37459304077,
          "pricedTokenShare": 0.04071072747640482
        },
        {
          "key": "2026-07-22",
          "label": "07-22",
          "startDate": "2026-07-22",
          "endDate": "2026-07-22",
          "totalTokens": 9013659246552,
          "pricedTokens": 321791787679,
          "blendedPricePerMillion": 0.34254353652146546,
          "estimatedRetailValue": 110227.69697512919,
          "pricedTokenShare": 0.03570046069825584
        },
        {
          "key": "2026-07-23",
          "label": "07-23",
          "startDate": "2026-07-23",
          "endDate": "2026-07-23",
          "totalTokens": 8751994182349,
          "pricedTokens": 360209548807,
          "blendedPricePerMillion": 0.33711530563320413,
          "estimatedRetailValue": 121432.15213807038,
          "pricedTokenShare": 0.04115742553091154
        },
        {
          "key": "2026-07-24",
          "label": "07-24",
          "startDate": "2026-07-24",
          "endDate": "2026-07-24",
          "totalTokens": 8661084724352,
          "pricedTokens": 354176731590,
          "blendedPricePerMillion": 0.33818130241797684,
          "estimatedRetailValue": 119775.9483752484,
          "pricedTokenShare": 0.040892883843310815
        },
        {
          "key": "2026-07-25",
          "label": "07-25",
          "startDate": "2026-07-25",
          "endDate": "2026-07-25",
          "totalTokens": 7305381415398,
          "pricedTokens": 276505895113,
          "blendedPricePerMillion": 0.3304115529748509,
          "estimatedRetailValue": 91360.74221098758,
          "pricedTokenShare": 0.03784961788992859
        },
        {
          "key": "2026-07-26",
          "label": "07-26",
          "startDate": "2026-07-26",
          "endDate": "2026-07-26",
          "totalTokens": 7496481859549,
          "pricedTokens": 313723455624,
          "blendedPricePerMillion": 0.3008545555711349,
          "estimatedRetailValue": 94385.13081399917,
          "pricedTokenShare": 0.04184942503720993
        },
        {
          "key": "2026-07-27",
          "label": "07-27",
          "startDate": "2026-07-27",
          "endDate": "2026-07-27",
          "totalTokens": 8784326010554,
          "pricedTokens": 339547665528,
          "blendedPricePerMillion": 0.3198407612369487,
          "estimatedRetailValue": 108601.18381870438,
          "pricedTokenShare": 0.03865380965142319
        },
        {
          "key": "2026-07-28",
          "label": "07-28",
          "startDate": "2026-07-28",
          "endDate": "2026-07-28",
          "totalTokens": 8890418317802,
          "pricedTokens": 357699052766,
          "blendedPricePerMillion": 0.3100418288597073,
          "estimatedRetailValue": 110901.6685009556,
          "pricedTokenShare": 0.04023422070587504
        },
        {
          "key": "2026-07-29",
          "label": "07-29",
          "startDate": "2026-07-29",
          "endDate": "2026-07-29",
          "totalTokens": 8196705797925,
          "pricedTokens": 310741636624,
          "blendedPricePerMillion": 0.34196632263985705,
          "estimatedRetailValue": 106263.17476739999,
          "pricedTokenShare": 0.03791055141965256
        },
        {
          "key": "2026-07-30",
          "label": "07-30",
          "startDate": "2026-07-30",
          "endDate": "2026-07-30",
          "totalTokens": 8321933504398,
          "pricedTokens": 289425220012,
          "blendedPricePerMillion": 0.35702563653007047,
          "estimatedRetailValue": 103332.22340264,
          "pricedTokenShare": 0.0347786028161657
        },
        {
          "key": "2026-07-31",
          "label": "07-31",
          "startDate": "2026-07-31",
          "endDate": "2026-07-31",
          "totalTokens": 8296221899663,
          "pricedTokens": 273866881768,
          "blendedPricePerMillion": 0.3633439961121542,
          "estimatedRetailValue": 99507.88722435998,
          "pricedTokenShare": 0.03301103623796812
        },
        {
          "key": "2026-08-01",
          "label": "08-01",
          "startDate": "2026-08-01",
          "endDate": "2026-08-01",
          "totalTokens": 7066940419625,
          "pricedTokens": 282964612423,
          "blendedPricePerMillion": 0.3198421774492591,
          "estimatedRetailValue": 90504.01777845799,
          "pricedTokenShare": 0.04004061101706801
        },
        {
          "key": "2026-08-02",
          "label": "08-02",
          "startDate": "2026-08-02",
          "endDate": "2026-08-02",
          "totalTokens": 7232042961954,
          "pricedTokens": 275872947151,
          "blendedPricePerMillion": 0.291309152559374,
          "estimatedRetailValue": 80364.31444861478,
          "pricedTokenShare": 0.03814592205858009
        },
        {
          "key": "2026-08-03",
          "label": "08-03",
          "startDate": "2026-08-03",
          "endDate": "2026-08-03",
          "totalTokens": 9143823075351,
          "pricedTokens": 293451529922,
          "blendedPricePerMillion": 0.3336625568556186,
          "estimatedRetailValue": 97913.78778696757,
          "pricedTokenShare": 0.032092870509826156
        },
        {
          "key": "2026-08-04",
          "label": "08-04",
          "startDate": "2026-08-04",
          "endDate": "2026-08-04",
          "totalTokens": 9996550853376,
          "pricedTokens": 316135264853,
          "blendedPricePerMillion": 0.3349163175197892,
          "estimatedRetailValue": 105878.85874271,
          "pricedTokenShare": 0.031624434216351326
        },
        {
          "key": "2026-08-05",
          "label": "08-05",
          "startDate": "2026-08-05",
          "endDate": "2026-08-05",
          "totalTokens": 10787614259704,
          "pricedTokens": 291249741136,
          "blendedPricePerMillion": 0.3335921360297363,
          "estimatedRetailValue": 97158.623263666,
          "pricedTokenShare": 0.026998531290086336
        },
        {
          "key": "2026-08-06",
          "label": "08-06",
          "startDate": "2026-08-06",
          "endDate": "2026-08-06",
          "totalTokens": 11001204844264,
          "pricedTokens": 257968945149,
          "blendedPricePerMillion": 0.3501425601816092,
          "estimatedRetailValue": 90325.90690181998,
          "pricedTokenShare": 0.023449153870042184
        },
        {
          "key": "2026-08-07",
          "label": "08-07",
          "startDate": "2026-08-07",
          "endDate": "2026-08-07",
          "totalTokens": 10378071121073,
          "pricedTokens": 265331623255,
          "blendedPricePerMillion": 0.34572631954375593,
          "estimatedRetailValue": 91732.12556652159,
          "pricedTokenShare": 0.025566564360523198
        },
        {
          "key": "2026-08-08",
          "label": "08-08",
          "startDate": "2026-08-08",
          "endDate": "2026-08-08",
          "totalTokens": 8765239038152,
          "pricedTokens": 249300764212,
          "blendedPricePerMillion": 0.30508757684387283,
          "estimatedRetailValue": 76058.56605876477,
          "pricedTokenShare": 0.028441981231416683
        },
        {
          "key": "2026-08-09",
          "label": "08-09",
          "startDate": "2026-08-09",
          "endDate": "2026-08-09",
          "totalTokens": 8974034656012,
          "pricedTokens": 257630709551,
          "blendedPricePerMillion": 0.3102689527744963,
          "estimatedRetailValue": 79934.81045493919,
          "pricedTokenShare": 0.028708459397179253
        },
        {
          "key": "2026-08-10",
          "label": "08-10",
          "startDate": "2026-08-10",
          "endDate": "2026-08-10",
          "totalTokens": 10613720303759,
          "pricedTokens": 290701979537,
          "blendedPricePerMillion": 0.33822714226242817,
          "estimatedRetailValue": 98323.29978883038,
          "pricedTokenShare": 0.02738926325711106
        },
        {
          "key": "2026-08-11",
          "label": "08-11",
          "startDate": "2026-08-11",
          "endDate": "2026-08-11",
          "totalTokens": 10931401727980,
          "pricedTokens": 328385002311,
          "blendedPricePerMillion": 0.3114852319485385,
          "estimatedRetailValue": 102287.07861326319,
          "pricedTokenShare": 0.030040520921527036
        },
        {
          "key": "2026-08-12",
          "label": "08-12",
          "startDate": "2026-08-12",
          "endDate": "2026-08-12",
          "totalTokens": 11234116355431,
          "pricedTokens": 312500288113,
          "blendedPricePerMillion": 0.30699950343605903,
          "estimatedRetailValue": 95937.43327431638,
          "pricedTokenShare": 0.027817077750127223
        },
        {
          "key": "2026-08-13",
          "label": "08-13",
          "startDate": "2026-08-13",
          "endDate": "2026-08-13",
          "totalTokens": 11135113794296,
          "pricedTokens": 300462200979,
          "blendedPricePerMillion": 0.3143821817172257,
          "estimatedRetailValue": 94459.96226733757,
          "pricedTokenShare": 0.026983307627526248
        },
        {
          "key": "2026-08-14",
          "label": "08-14",
          "startDate": "2026-08-14",
          "endDate": "2026-08-14",
          "totalTokens": 11486043370983,
          "pricedTokens": 288731161015,
          "blendedPricePerMillion": 0.3070000144387567,
          "estimatedRetailValue": 88640.47060052399,
          "pricedTokenShare": 0.025137564928965593
        },
        {
          "key": "2026-08-15",
          "label": "08-15",
          "startDate": "2026-08-15",
          "endDate": "2026-08-15",
          "totalTokens": 9565041906391,
          "pricedTokens": 244567625468,
          "blendedPricePerMillion": 0.2883113145543278,
          "estimatedRetailValue": 70511.61359610959,
          "pricedTokenShare": 0.02556890266257894
        },
        {
          "key": "2026-08-16",
          "label": "08-16",
          "startDate": "2026-08-16",
          "endDate": "2026-08-16",
          "totalTokens": 10375143625991,
          "pricedTokens": 260893002897,
          "blendedPricePerMillion": 0.2649574469537024,
          "estimatedRetailValue": 69125.543975674,
          "pricedTokenShare": 0.025145965424847826
        },
        {
          "key": "2026-08-17",
          "label": "08-17",
          "startDate": "2026-08-17",
          "endDate": "2026-08-17",
          "totalTokens": 13311262793704,
          "pricedTokens": 306119980683,
          "blendedPricePerMillion": 0.2973499534071914,
          "estimatedRetailValue": 91024.76199310037,
          "pricedTokenShare": 0.02299706537442785
        },
        {
          "key": "2026-08-18",
          "label": "08-18",
          "startDate": "2026-08-18",
          "endDate": "2026-08-18",
          "totalTokens": 12704870921171,
          "pricedTokens": 332097642009,
          "blendedPricePerMillion": 0.2924633764764045,
          "estimatedRetailValue": 97126.39770180438,
          "pricedTokenShare": 0.02613939520279603
        },
        {
          "key": "2026-08-19",
          "label": "08-19",
          "startDate": "2026-08-19",
          "endDate": "2026-08-19",
          "totalTokens": 12119291448118,
          "pricedTokens": 322061107310,
          "blendedPricePerMillion": 0.30732065165586786,
          "estimatedRetailValue": 98976.02937151959,
          "pricedTokenShare": 0.026574252190297208
        },
        {
          "key": "2026-08-20",
          "label": "08-20",
          "startDate": "2026-08-20",
          "endDate": "2026-08-20",
          "totalTokens": 12130101854803,
          "pricedTokens": 334367011663,
          "blendedPricePerMillion": 0.3051728032706636,
          "estimatedRetailValue": 102039.71827043238,
          "pricedTokenShare": 0.027565062162326775
        },
        {
          "key": "2026-08-21",
          "label": "08-21",
          "startDate": "2026-08-21",
          "endDate": "2026-08-21",
          "totalTokens": 13888795396670,
          "pricedTokens": 306368580859,
          "blendedPricePerMillion": 0.30764873427990863,
          "estimatedRetailValue": 94253.90612440319,
          "pricedTokenShare": 0.02205868630856607
        },
        {
          "key": "2026-08-22",
          "label": "08-22",
          "startDate": "2026-08-22",
          "endDate": "2026-08-22",
          "totalTokens": 14075709916673,
          "pricedTokens": 292220352115,
          "blendedPricePerMillion": 0.26480017917842885,
          "estimatedRetailValue": 77380.00159963558,
          "pricedTokenShare": 0.02076061199363439
        },
        {
          "key": "2026-08-23",
          "label": "08-23",
          "startDate": "2026-08-23",
          "endDate": "2026-08-23",
          "totalTokens": 15147544875185,
          "pricedTokens": 243902068556,
          "blendedPricePerMillion": 0.2859918537674232,
          "estimatedRetailValue": 69754.00472403958,
          "pricedTokenShare": 0.016101755800411264
        },
        {
          "key": "2026-08-24",
          "label": "08-24",
          "startDate": "2026-08-24",
          "endDate": "2026-08-24",
          "totalTokens": 18352938225742,
          "pricedTokens": 331466644065,
          "blendedPricePerMillion": 0.2678427713184745,
          "estimatedRetailValue": 88780.94454600397,
          "pricedTokenShare": 0.018060685432923315
        },
        {
          "key": "2026-08-25",
          "label": "08-25",
          "startDate": "2026-08-25",
          "endDate": "2026-08-25",
          "totalTokens": 18775140916501,
          "pricedTokens": 314529503557,
          "blendedPricePerMillion": 0.29707741478098065,
          "estimatedRetailValue": 93439.6117890588,
          "pricedTokenShare": 0.01675244436011492
        },
        {
          "key": "2026-08-26",
          "label": "08-26",
          "startDate": "2026-08-26",
          "endDate": "2026-08-26",
          "totalTokens": 18436449188941,
          "pricedTokens": 423824142437,
          "blendedPricePerMillion": 0.26590863486820976,
          "estimatedRetailValue": 112698.49913961237,
          "pricedTokenShare": 0.022988382312317954
        },
        {
          "key": "2026-08-27",
          "label": "08-27",
          "startDate": "2026-08-27",
          "endDate": "2026-08-27",
          "totalTokens": 15797679821005,
          "pricedTokens": 401818624256,
          "blendedPricePerMillion": 0.26418688866033285,
          "estimatedRetailValue": 106155.21214796798,
          "pricedTokenShare": 0.025435293587969268
        },
        {
          "key": "2026-08-28",
          "label": "08-28",
          "startDate": "2026-08-28",
          "endDate": "2026-08-28",
          "totalTokens": 15116796693545,
          "pricedTokens": 376584970890,
          "blendedPricePerMillion": 0.2594257662004308,
          "estimatedRetailValue": 97695.84461270517,
          "pricedTokenShare": 0.024911691181955565
        },
        {
          "key": "2026-08-29",
          "label": "08-29",
          "startDate": "2026-08-29",
          "endDate": "2026-08-29",
          "totalTokens": 13204155770914,
          "pricedTokens": 283828507167,
          "blendedPricePerMillion": 0.24035996380446126,
          "estimatedRetailValue": 68221.0097093344,
          "pricedTokenShare": 0.021495392215245976
        },
        {
          "key": "2026-08-30",
          "label": "08-30",
          "startDate": "2026-08-30",
          "endDate": "2026-08-30",
          "totalTokens": 13313663519421,
          "pricedTokens": 338687366725,
          "blendedPricePerMillion": 0.23506913114544245,
          "estimatedRetailValue": 79614.94502598359,
          "pricedTokenShare": 0.025439081153804707
        },
        {
          "key": "2026-08-31",
          "label": "08-31",
          "startDate": "2026-08-31",
          "endDate": "2026-08-31",
          "totalTokens": 14318704603016,
          "pricedTokens": 366004128697,
          "blendedPricePerMillion": 0.26371863090855224,
          "estimatedRetailValue": 96522.1077268504,
          "pricedTokenShare": 0.02556125982373484
        },
        {
          "key": "2026-09-01",
          "label": "09-01",
          "startDate": "2026-09-01",
          "endDate": "2026-09-01",
          "totalTokens": 16194588394672,
          "pricedTokens": 370433871734,
          "blendedPricePerMillion": 0.291462273132615,
          "estimatedRetailValue": 107967.49830090719,
          "pricedTokenShare": 0.022873929408164045
        },
        {
          "key": "2026-09-02",
          "label": "09-02",
          "startDate": "2026-09-02",
          "endDate": "2026-09-02",
          "totalTokens": 18488527970063,
          "pricedTokens": 361900962748,
          "blendedPricePerMillion": 0.28966459894613167,
          "estimatedRetailValue": 104829.89723261837,
          "pricedTokenShare": 0.01957435244893468
        },
        {
          "key": "2026-09-03",
          "label": "09-03",
          "startDate": "2026-09-03",
          "endDate": "2026-09-03",
          "totalTokens": 18567158117428,
          "pricedTokens": 312924798740,
          "blendedPricePerMillion": 0.30509251302580864,
          "estimatedRetailValue": 95471.01323568198,
          "pricedTokenShare": 0.016853672315434973
        },
        {
          "key": "2026-09-04",
          "label": "09-04",
          "startDate": "2026-09-04",
          "endDate": "2026-09-04",
          "totalTokens": 18269560527417,
          "pricedTokens": 321335351997,
          "blendedPricePerMillion": 0.2997301029648862,
          "estimatedRetailValue": 96313.87814031877,
          "pricedTokenShare": 0.017588564952877455
        },
        {
          "key": "2026-09-05",
          "label": "09-05",
          "startDate": "2026-09-05",
          "endDate": "2026-09-05",
          "totalTokens": 15344774218059,
          "pricedTokens": 276895614905,
          "blendedPricePerMillion": 0.26708721658346696,
          "estimatedRetailValue": 73955.27906914399,
          "pricedTokenShare": 0.01804494552804344
        },
        {
          "key": "2026-09-06",
          "label": "09-06",
          "startDate": "2026-09-06",
          "endDate": "2026-09-06",
          "totalTokens": 14279989875501,
          "pricedTokens": 280699865049,
          "blendedPricePerMillion": 0.24989294527509673,
          "estimatedRetailValue": 70144.91601541679,
          "pricedTokenShare": 0.01965686723143786
        },
        {
          "key": "2026-09-07",
          "label": "09-07",
          "startDate": "2026-09-07",
          "endDate": "2026-09-07",
          "totalTokens": 19050916850409,
          "pricedTokens": 271727137632,
          "blendedPricePerMillion": 0.289699840590719,
          "estimatedRetailValue": 78719.30845616278,
          "pricedTokenShare": 0.014263205270677896
        },
        {
          "key": "2026-09-08",
          "label": "09-08",
          "startDate": "2026-09-08",
          "endDate": "2026-09-08",
          "totalTokens": 19046273585455,
          "pricedTokens": 337469787931,
          "blendedPricePerMillion": 0.29118431423469326,
          "estimatedRetailValue": 98265.90877361559,
          "pricedTokenShare": 0.017718415437900373
        },
        {
          "key": "2026-09-09",
          "label": "09-09",
          "startDate": "2026-09-09",
          "endDate": "2026-09-09",
          "totalTokens": 17947794799521,
          "pricedTokens": 316786293512,
          "blendedPricePerMillion": 0.29839309890933663,
          "estimatedRetailValue": 94526.84381304837,
          "pricedTokenShare": 0.01765042987456345
        },
        {
          "key": "2026-09-10",
          "label": "09-10",
          "startDate": "2026-09-10",
          "endDate": "2026-09-10",
          "totalTokens": 19184120113922,
          "pricedTokens": 275223532281,
          "blendedPricePerMillion": 0.3442348129754762,
          "estimatedRetailValue": 94741.52116119998,
          "pricedTokenShare": 0.014346424576505288
        },
        {
          "key": "2026-09-11",
          "label": "09-11",
          "startDate": "2026-09-11",
          "endDate": "2026-09-11",
          "totalTokens": 17751297946007,
          "pricedTokens": 286958504071,
          "blendedPricePerMillion": 0.3270616282446141,
          "estimatedRetailValue": 93853.11558009998,
          "pricedTokenShare": 0.016165494204639207
        },
        {
          "key": "2026-09-12",
          "label": "09-12",
          "startDate": "2026-09-12",
          "endDate": "2026-09-12",
          "totalTokens": 17051827575447,
          "pricedTokens": 260990405645,
          "blendedPricePerMillion": 0.2829325804580842,
          "estimatedRetailValue": 73842.68894394199,
          "pricedTokenShare": 0.015305714562866049
        },
        {
          "key": "2026-09-13",
          "label": "09-13",
          "startDate": "2026-09-13",
          "endDate": "2026-09-13",
          "totalTokens": 16730791173422,
          "pricedTokens": 269395938835,
          "blendedPricePerMillion": 0.2612975831776576,
          "estimatedRetailValue": 70392.50773546158,
          "pricedTokenShare": 0.01610180511146142
        },
        {
          "key": "2026-09-14",
          "label": "09-14",
          "startDate": "2026-09-14",
          "endDate": "2026-09-14",
          "totalTokens": 18120484812487,
          "pricedTokens": 304252208171,
          "blendedPricePerMillion": 0.30659372804281254,
          "estimatedRetailValue": 93281.81876840477,
          "pricedTokenShare": 0.01679051147468951
        },
        {
          "key": "2026-09-15",
          "label": "09-15",
          "startDate": "2026-09-15",
          "endDate": "2026-09-15",
          "totalTokens": 17750550231758,
          "pricedTokens": 304656628562,
          "blendedPricePerMillion": 0.3351054740079074,
          "estimatedRetailValue": 102092.10392391999,
          "pricedTokenShare": 0.01716322167956971
        },
        {
          "key": "2026-09-16",
          "label": "09-16",
          "startDate": "2026-09-16",
          "endDate": "2026-09-16",
          "totalTokens": 18403097790101,
          "pricedTokens": 380026082007,
          "blendedPricePerMillion": 0.3259471129426804,
          "estimatedRetailValue": 123868.40427309996,
          "pricedTokenShare": 0.020650114798140967
        },
        {
          "key": "2026-09-17",
          "label": "09-17",
          "startDate": "2026-09-17",
          "endDate": "2026-09-17",
          "totalTokens": 19950735154131,
          "pricedTokens": 257585280962,
          "blendedPricePerMillion": 0.35321109805712075,
          "estimatedRetailValue": 90981.97993193999,
          "pricedTokenShare": 0.012911067134719813
        },
        {
          "key": "2026-09-18",
          "label": "09-18",
          "startDate": "2026-09-18",
          "endDate": "2026-09-18",
          "totalTokens": 19516151287053,
          "pricedTokens": 231359189673,
          "blendedPricePerMillion": 0.3644483888182467,
          "estimatedRetailValue": 84318.48391461998,
          "pricedTokenShare": 0.01185475487815487
        },
        {
          "key": "2026-09-19",
          "label": "09-19",
          "startDate": "2026-09-19",
          "endDate": "2026-09-19",
          "totalTokens": 17822770536307,
          "pricedTokens": 264643847380,
          "blendedPricePerMillion": 0.2765440682906293,
          "estimatedRetailValue": 73185.6862025496,
          "pricedTokenShare": 0.01484863685143062
        },
        {
          "key": "2026-09-20",
          "label": "09-20",
          "startDate": "2026-09-20",
          "endDate": "2026-09-20",
          "totalTokens": 17331480167240,
          "pricedTokens": 241826466273,
          "blendedPricePerMillion": 0.27304305233957493,
          "estimatedRetailValue": 66029.03648767319,
          "pricedTokenShare": 0.013953018665428293
        },
        {
          "key": "2026-09-21",
          "label": "09-21",
          "startDate": "2026-09-21",
          "endDate": "2026-09-21",
          "totalTokens": 20836773421509,
          "pricedTokens": 262530519265,
          "blendedPricePerMillion": 0.36344919896161076,
          "estimatedRetailValue": 95416.50692983998,
          "pricedTokenShare": 0.012599384461031756
        },
        {
          "key": "2026-09-22",
          "label": "09-22",
          "startDate": "2026-09-22",
          "endDate": "2026-09-22",
          "totalTokens": 20461970574170,
          "pricedTokens": 283999745819,
          "blendedPricePerMillion": 0.35555734772958514,
          "estimatedRetailValue": 100978.19637927998,
          "pricedTokenShare": 0.013879393716727592
        },
        {
          "key": "2026-09-23",
          "label": "09-23",
          "startDate": "2026-09-23",
          "endDate": "2026-09-23",
          "totalTokens": 19839776739539,
          "pricedTokens": 280902925074,
          "blendedPricePerMillion": 0.3538065239449476,
          "estimatedRetailValue": 99385.28748639999,
          "pricedTokenShare": 0.014158572889289837
        },
        {
          "key": "2026-09-24",
          "label": "09-24",
          "startDate": "2026-09-24",
          "endDate": "2026-09-24",
          "totalTokens": 21879527010648,
          "pricedTokens": 287375435625,
          "blendedPricePerMillion": 0.33466753942177685,
          "estimatedRetailValue": 96175.22993087998,
          "pricedTokenShare": 0.013134444610486526
        },
        {
          "key": "2026-09-25",
          "label": "09-25",
          "startDate": "2026-09-25",
          "endDate": "2026-09-25",
          "totalTokens": 22441110438066,
          "pricedTokens": 279534118126,
          "blendedPricePerMillion": 0.3360153059611924,
          "estimatedRetailValue": 93927.74222869998,
          "pricedTokenShare": 0.012456340736679275
        },
        {
          "key": "2026-09-26",
          "label": "09-26",
          "startDate": "2026-09-26",
          "endDate": "2026-09-26",
          "totalTokens": 19855703336813,
          "pricedTokens": 276054180732,
          "blendedPricePerMillion": 0.27508994458115776,
          "estimatedRetailValue": 75939.72927896278,
          "pricedTokenShare": 0.013903016984555174
        },
        {
          "key": "2026-09-27",
          "label": "09-27",
          "startDate": "2026-09-27",
          "endDate": "2026-09-27",
          "totalTokens": 20530243814309,
          "pricedTokens": 247114322236,
          "blendedPricePerMillion": 0.2671825661244551,
          "estimatedRetailValue": 66024.63874111998,
          "pricedTokenShare": 0.012036599490541281
        },
        {
          "key": "2026-09-28",
          "label": "09-28",
          "startDate": "2026-09-28",
          "endDate": "2026-09-28",
          "totalTokens": 23934998683834,
          "pricedTokens": 251115364890,
          "blendedPricePerMillion": 0.3381985391812317,
          "estimatedRetailValue": 84926.84957175997,
          "pricedTokenShare": 0.010491555408340443
        },
        {
          "key": "2026-09-29",
          "label": "09-29",
          "startDate": "2026-09-29",
          "endDate": "2026-09-29",
          "totalTokens": 24936730343781,
          "pricedTokens": 294549377433,
          "blendedPricePerMillion": 0.33522575965090984,
          "estimatedRetailValue": 98740.53880467998,
          "pricedTokenShare": 0.011811868411467906
        },
        {
          "key": "2026-09-30",
          "label": "09-30",
          "startDate": "2026-09-30",
          "endDate": "2026-09-30",
          "totalTokens": 24377727661254,
          "pricedTokens": 279687677951,
          "blendedPricePerMillion": 0.3350739732747848,
          "estimatedRetailValue": 93716.06152703997,
          "pricedTokenShare": 0.011473082390510746
        },
        {
          "key": "2026-10-01",
          "label": "10-01",
          "startDate": "2026-10-01",
          "endDate": "2026-10-01",
          "totalTokens": 23446998494287,
          "pricedTokens": 245998461212,
          "blendedPricePerMillion": 0.353093077105894,
          "estimatedRetailValue": 86860.35363265999,
          "pricedTokenShare": 0.010491682390474797
        },
        {
          "key": "2026-10-02",
          "label": "10-02",
          "startDate": "2026-10-02",
          "endDate": "2026-10-02",
          "totalTokens": 24060063479633,
          "pricedTokens": 249191811848,
          "blendedPricePerMillion": 0.3720436382073044,
          "estimatedRetailValue": 92710.22829139998,
          "pricedTokenShare": 0.010357072085821489
        },
        {
          "key": "2026-10-03",
          "label": "10-03",
          "startDate": "2026-10-03",
          "endDate": "2026-10-03",
          "totalTokens": 22318533815723,
          "pricedTokens": 187993466065,
          "blendedPricePerMillion": 0.36287259329701,
          "estimatedRetailValue": 68217.67655389999,
          "pricedTokenShare": 0.00842319964282609
        },
        {
          "key": "2026-10-04",
          "label": "10-04",
          "startDate": "2026-10-04",
          "endDate": "2026-10-04",
          "totalTokens": 22780997379051,
          "pricedTokens": 231168070625,
          "blendedPricePerMillion": 0.2957920090131772,
          "estimatedRetailValue": 68377.66802986879,
          "pricedTokenShare": 0.010147407805664296
        },
        {
          "key": "2026-10-05",
          "label": "10-05",
          "startDate": "2026-10-05",
          "endDate": "2026-10-05",
          "totalTokens": 25873213536983,
          "pricedTokens": 229769497429,
          "blendedPricePerMillion": 0.36379532161761136,
          "estimatedRetailValue": 83589.06821509998,
          "pricedTokenShare": 0.008880593711352051
        },
        {
          "key": "2026-10-06",
          "label": "10-06",
          "startDate": "2026-10-06",
          "endDate": "2026-10-06",
          "totalTokens": 22109724903182,
          "pricedTokens": 238757267127,
          "blendedPricePerMillion": 0.3537147238240007,
          "estimatedRetailValue": 84451.96080279998,
          "pricedTokenShare": 0.010798744361248854
        },
        {
          "key": "2026-10-07",
          "label": "10-07",
          "startDate": "2026-10-07",
          "endDate": "2026-10-07",
          "totalTokens": 25121204185746,
          "pricedTokens": 242325593416,
          "blendedPricePerMillion": 0.34370764855884456,
          "estimatedRetailValue": 83289.15989863998,
          "pricedTokenShare": 0.009646257067306421
        },
        {
          "key": "2026-10-08",
          "label": "10-08",
          "startDate": "2026-10-08",
          "endDate": "2026-10-08",
          "totalTokens": 24455189713768,
          "pricedTokens": 222206560125,
          "blendedPricePerMillion": 0.3526312592492367,
          "estimatedRetailValue": 78356.97911031998,
          "pricedTokenShare": 0.009086274231595928
        },
        {
          "key": "2026-10-09",
          "label": "10-09",
          "startDate": "2026-10-09",
          "endDate": "2026-10-09",
          "totalTokens": 26639007266335,
          "pricedTokens": 218411177448,
          "blendedPricePerMillion": 0.3458721059711577,
          "estimatedRetailValue": 75542.33391157999,
          "pricedTokenShare": 0.008198923303122363
        },
        {
          "key": "2026-10-10",
          "label": "10-10",
          "startDate": "2026-10-10",
          "endDate": "2026-10-10",
          "totalTokens": 24019743394927,
          "pricedTokens": 175286831314,
          "blendedPricePerMillion": 0.3512843624503469,
          "estimatedRetailValue": 61575.52278407999,
          "pricedTokenShare": 0.007297614651079944
        },
        {
          "key": "2026-10-11",
          "label": "10-11",
          "startDate": "2026-10-11",
          "endDate": "2026-10-11",
          "totalTokens": 23624418723773,
          "pricedTokens": 67891727613,
          "blendedPricePerMillion": 0.15999999999999998,
          "estimatedRetailValue": 10862.676418079998,
          "pricedTokenShare": 0.0028737946277882925
        },
        {
          "key": "2026-10-12",
          "label": "10-12",
          "startDate": "2026-10-12",
          "endDate": "2026-10-12",
          "totalTokens": 26944742365440,
          "pricedTokens": 221344983099,
          "blendedPricePerMillion": 0.34164369500770325,
          "estimatedRetailValue": 75621.11789735999,
          "pricedTokenShare": 0.008214774522502119
        },
        {
          "key": "2026-10-13",
          "label": "10-13",
          "startDate": "2026-10-13",
          "endDate": "2026-10-13",
          "totalTokens": 26210571251367,
          "pricedTokens": 253224515864,
          "blendedPricePerMillion": 0.3285624978251493,
          "estimatedRetailValue": 83200.07944283998,
          "pricedTokenShare": 0.009661159744879395
        },
        {
          "key": "2026-10-14",
          "label": "10-14",
          "startDate": "2026-10-14",
          "endDate": "2026-10-14",
          "totalTokens": 26374532234884,
          "pricedTokens": 253160917129,
          "blendedPricePerMillion": 0.3283624024448499,
          "estimatedRetailValue": 83128.52695361999,
          "pricedTokenShare": 0.009598688419359316
        },
        {
          "key": "2026-10-15",
          "label": "10-15",
          "startDate": "2026-10-15",
          "endDate": "2026-10-15",
          "totalTokens": 24438956540182,
          "pricedTokens": 256875059185,
          "blendedPricePerMillion": 0.3186298716692984,
          "estimatedRetailValue": 81848.06714315998,
          "pricedTokenShare": 0.010510884896523779
        },
        {
          "key": "2026-10-16",
          "label": "10-16",
          "startDate": "2026-10-16",
          "endDate": "2026-10-16",
          "totalTokens": 22407801051165,
          "pricedTokens": 188782226366,
          "blendedPricePerMillion": 0.19654341472753425,
          "estimatedRetailValue": 37103.90340983999,
          "pricedTokenShare": 0.008424843916408525
        },
        {
          "key": "2026-10-17",
          "label": "10-17",
          "startDate": "2026-10-17",
          "endDate": "2026-10-17",
          "totalTokens": 18338242794490,
          "pricedTokens": 152936757471,
          "blendedPricePerMillion": 0.1950003399216503,
          "estimatedRetailValue": 29822.71969335999,
          "pricedTokenShare": 0.008339771655600074
        }
      ],
      "modelShares": [
        {
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "name": "deepseek-v4.1-flash-20260910",
          "tokens": 137073542196373,
          "previousTokens": 0,
          "share": 0.09356736494154652,
          "previousShare": 0,
          "shareDeltaPctPoints": 9.356736494154653,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "deepseek/deepseek-v4-flash-20260731",
          "name": "deepseek-v4-flash-20260731",
          "tokens": 101390812122071,
          "previousTokens": 0,
          "share": 0.06921008217584838,
          "previousShare": 0,
          "shareDeltaPctPoints": 6.921008217584839,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "name": "glm-5.3-flash-20260826",
          "tokens": 93602735938457,
          "previousTokens": 0,
          "share": 0.06389388654255235,
          "previousShare": 0,
          "shareDeltaPctPoints": 6.389388654255235,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "openai/gpt-5.6-luna-20260709",
          "name": "gpt-5.6-luna-20260709",
          "tokens": 81846807189415,
          "previousTokens": 322399987300,
          "share": 0.055869206813238856,
          "previousShare": 0.0006551179188189928,
          "shareDeltaPctPoints": 5.521408889441987,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "tencent/hy4-preview-20260827",
          "name": "hy4-preview-20260827",
          "tokens": 78212445675738,
          "previousTokens": 0,
          "share": 0.05338836605702234,
          "previousShare": 0,
          "shareDeltaPctPoints": 5.338836605702234,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "xiaomi/mimo-v2.5-20260422",
          "name": "mimo-v2.5-20260422",
          "tokens": 67143103632639,
          "previousTokens": 35429330361596,
          "share": 0.04583235524695914,
          "previousShare": 0.07199252508047269,
          "shareDeltaPctPoints": -2.6160169833513547,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "tencent/hy3-20260706",
          "name": "hy3-20260706",
          "tokens": 64150843539083,
          "previousTokens": 0,
          "share": 0.043789817440701234,
          "previousShare": 0,
          "shareDeltaPctPoints": 4.378981744070123,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "deepseek/deepseek-v4-flash-20260423",
          "name": "deepseek-v4-flash-20260423",
          "tokens": 60609602778397,
          "previousTokens": 44206286495887,
          "share": 0.04137254156607403,
          "previousShare": 0.08982733110641669,
          "shareDeltaPctPoints": -4.845478954034267,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "stealth/space-bunny-alpha",
          "name": "space-bunny-alpha",
          "tokens": 56716522847075,
          "previousTokens": 0,
          "share": 0.038715097796518806,
          "previousShare": 0,
          "shareDeltaPctPoints": 3.8715097796518805,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "nvidia/nemotron-3-ultra-550b-a55b-20260604:free",
          "name": "nemotron-3-ultra-550b-a55b-20260604:free",
          "tokens": 53457817864818,
          "previousTokens": 8598224406715,
          "share": 0.03649068283338273,
          "previousShare": 0.01747162252095349,
          "shareDeltaPctPoints": 1.9019060312429237,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "xiaomi/mimo-v2.6-flash-20260921",
          "name": "mimo-v2.6-flash-20260921",
          "tokens": 35479245491272,
          "previousTokens": 0,
          "share": 0.024218382756730175,
          "previousShare": 0,
          "shareDeltaPctPoints": 2.4218382756730175,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "z-ai/glm-5.2-20260616",
          "name": "glm-5.2-20260616",
          "tokens": 31453298344795,
          "previousTokens": 12814897890584,
          "share": 0.021470242890685637,
          "previousShare": 0.02603991801074519,
          "shareDeltaPctPoints": -0.4569675120059555,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "stealth/ox-alpha",
          "name": "ox-alpha",
          "tokens": 27237502959584,
          "previousTokens": 0,
          "share": 0.018592511280293482,
          "previousShare": 0,
          "shareDeltaPctPoints": 1.8592511280293482,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "z-ai/glm-5.3-20260816",
          "name": "glm-5.3-20260816",
          "tokens": 24555635768534,
          "previousTokens": 0,
          "share": 0.01676184985454406,
          "previousShare": 0,
          "shareDeltaPctPoints": 1.676184985454406,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "deepseek/deepseek-v4-pro-20260423",
          "name": "deepseek-v4-pro-20260423",
          "tokens": 21815602382732,
          "previousTokens": 20595718119932,
          "share": 0.014891483774749699,
          "previousShare": 0.041850572341236784,
          "shareDeltaPctPoints": -2.6959088566487086,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "openai/gpt-6-luna-20260922",
          "name": "gpt-6-luna-20260922",
          "tokens": 21680101231798,
          "previousTokens": 0,
          "share": 0.014798989735153948,
          "previousShare": 0,
          "shareDeltaPctPoints": 1.479898973515395,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "moonshotai/kimi-k3-20260715",
          "name": "kimi-k3-20260715",
          "tokens": 20340374785732,
          "previousTokens": 376645965095,
          "share": 0.01388448303099864,
          "previousShare": 0.0007653459382893946,
          "shareDeltaPctPoints": 1.3119137092709245,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "stepfun/step-5-preview-20261008",
          "name": "step-5-preview-20261008",
          "tokens": 20293436655399,
          "previousTokens": 0,
          "share": 0.013852442732775007,
          "previousShare": 0,
          "shareDeltaPctPoints": 1.3852442732775008,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "minimax/minimax-m3-20260531",
          "name": "minimax-m3-20260531",
          "tokens": 19919624688242,
          "previousTokens": 26523080305275,
          "share": 0.013597276052246764,
          "previousShare": 0.05389499334592801,
          "shareDeltaPctPoints": -4.029771729368124,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "openai/gpt-5.6-sol-20260709",
          "name": "gpt-5.6-sol-20260709",
          "tokens": 16045051900865,
          "previousTokens": 599096278418,
          "share": 0.01095246538944417,
          "previousShare": 0.0012173657647330932,
          "shareDeltaPctPoints": 0.9735099624711077,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        }
      ],
      "providerPrices": [
        {
          "provider": "OpenInference",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.04,
          "completionPricePerMillion": 0.144,
          "blendedPricePerMillion": 0.060799999999999986,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Relace",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.049999999999999996,
          "completionPricePerMillion": 0.6,
          "blendedPricePerMillion": 0.15999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Morph",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.081,
          "completionPricePerMillion": 0.55,
          "blendedPricePerMillion": 0.17479999999999998,
          "throughput": null,
          "latency": null,
          "uptime": null,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Decart",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.09,
          "completionPricePerMillion": 0.18,
          "blendedPricePerMillion": 0.108,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Sail Research",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.09,
          "completionPricePerMillion": 0.3,
          "blendedPricePerMillion": 0.13199999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Wafer",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.09999999999999999,
          "completionPricePerMillion": 0.65,
          "blendedPricePerMillion": 0.20999999999999996,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "InferenceNet",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.103,
          "completionPricePerMillion": 0.7150000000000001,
          "blendedPricePerMillion": 0.22539999999999996,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DeepInfra",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.112,
          "completionPricePerMillion": 0.33599999999999997,
          "blendedPricePerMillion": 0.15679999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "AtlasCloud",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.135,
          "completionPricePerMillion": 0.54,
          "blendedPricePerMillion": 0.21599999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DeepInfra",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.14,
          "completionPricePerMillion": 0.42,
          "blendedPricePerMillion": 0.196,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "StreamLake",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.1497,
          "completionPricePerMillion": 0.5988,
          "blendedPricePerMillion": 0.23952,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "CoreWeave",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.65,
          "blendedPricePerMillion": 0.24999999999999994,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "GMICloud",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.18,
          "completionPricePerMillion": 0.72,
          "blendedPricePerMillion": 0.288,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DigitalOcean",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.195,
          "completionPricePerMillion": 0.78,
          "blendedPricePerMillion": 0.312,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Novita",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.195,
          "completionPricePerMillion": 0.78,
          "blendedPricePerMillion": 0.312,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DeepInfra",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.21,
          "completionPricePerMillion": 0.63,
          "blendedPricePerMillion": 0.294,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Phala",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.21,
          "completionPricePerMillion": 0.84,
          "blendedPricePerMillion": 0.33599999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Ionstream",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.27,
          "completionPricePerMillion": 0.75,
          "blendedPricePerMillion": 0.366,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Makora",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.27,
          "completionPricePerMillion": 1.15,
          "blendedPricePerMillion": 0.44599999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Crusoe",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.29,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47199999999999986,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Nebius",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "PrimeIntellect",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Baidu",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "BaseTen",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Alibaba",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Together",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "SiliconFlow",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Modal",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "BaseTen",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Parasail",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Fireworks",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Venice",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Fireworks",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.44999999999999996,
          "completionPricePerMillion": 1.7999999999999998,
          "blendedPricePerMillion": 0.7199999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "BaseTen",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.6,
          "completionPricePerMillion": 2.4,
          "blendedPricePerMillion": 0.9599999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "OpenInference",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.048,
          "completionPricePerMillion": 0.19999999999999998,
          "blendedPricePerMillion": 0.07839999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Reka",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.06,
          "completionPricePerMillion": 1.5999999999999999,
          "blendedPricePerMillion": 0.3679999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "StreamLake",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.075,
          "completionPricePerMillion": 0.25,
          "blendedPricePerMillion": 0.10999999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DeepInfra",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.075,
          "completionPricePerMillion": 0.25,
          "blendedPricePerMillion": 0.10999999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Relace",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.075,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.15999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Sail Research",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.07835,
          "completionPricePerMillion": 0.3,
          "blendedPricePerMillion": 0.12267999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Sail Research",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.07835,
          "completionPricePerMillion": 0.3,
          "blendedPricePerMillion": 0.12267999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Near AI",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.08,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.16399999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Novita",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.08399999999999999,
          "completionPricePerMillion": 0.28,
          "blendedPricePerMillion": 0.12319999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "GMICloud",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.09,
          "completionPricePerMillion": 0.3,
          "blendedPricePerMillion": 0.13199999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Inceptron",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.09999999999999999,
          "completionPricePerMillion": 0.69,
          "blendedPricePerMillion": 0.21799999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "InferenceNet",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.12,
          "completionPricePerMillion": 0.38799999999999996,
          "blendedPricePerMillion": 0.17359999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Wafer",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.12,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.19599999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 96.66666666666667,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Phala",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.1275,
          "completionPricePerMillion": 0.425,
          "blendedPricePerMillion": 0.18699999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Morph",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.129,
          "completionPricePerMillion": 0.65,
          "blendedPricePerMillion": 0.2332,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DigitalOcean",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.13124999999999998,
          "completionPricePerMillion": 0.4375,
          "blendedPricePerMillion": 0.19249999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Makora",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.14,
          "completionPricePerMillion": 0.47,
          "blendedPricePerMillion": 0.206,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "PrimeIntellect",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Modal",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "BaseTen",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Crusoe",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "CoreWeave",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "AtlasCloud",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 96.29629629629629,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Fireworks",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Friendli",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "SiliconFlow",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Together",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Parasail",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "BaseTen",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Venice",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Z.AI",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Parasail",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.1875,
          "completionPricePerMillion": 0.625,
          "blendedPricePerMillion": 0.275,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Fireworks",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.22499999999999998,
          "completionPricePerMillion": 0.75,
          "blendedPricePerMillion": 0.32999999999999996,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "NextBit",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.25,
          "completionPricePerMillion": 0.7,
          "blendedPricePerMillion": 0.3399999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Darkbloom",
          "modelSlug": "xiaomi/mimo-v2.6-flash-20260921",
          "modelName": "Xiaomi: MiMo-V2.6-Flash",
          "promptPricePerMillion": 0.09999999999999999,
          "completionPricePerMillion": 0.28,
          "blendedPricePerMillion": 0.136,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Makora",
          "modelSlug": "xiaomi/mimo-v2.6-flash-20260921",
          "modelName": "Xiaomi: MiMo-V2.6-Flash",
          "promptPricePerMillion": 0.13,
          "completionPricePerMillion": 0.28,
          "blendedPricePerMillion": 0.16,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DeepInfra",
          "modelSlug": "xiaomi/mimo-v2.6-flash-20260921",
          "modelName": "Xiaomi: MiMo-V2.6-Flash",
          "promptPricePerMillion": 0.133,
          "completionPricePerMillion": 0.266,
          "blendedPricePerMillion": 0.1596,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Novita",
          "modelSlug": "xiaomi/mimo-v2.6-flash-20260921",
          "modelName": "Xiaomi: MiMo-V2.6-Flash",
          "promptPricePerMillion": 0.14,
          "completionPricePerMillion": 0.28,
          "blendedPricePerMillion": 0.16799999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 95.23809523809523,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "GMICloud",
          "modelSlug": "xiaomi/mimo-v2.6-flash-20260921",
          "modelName": "Xiaomi: MiMo-V2.6-Flash",
          "promptPricePerMillion": 0.14,
          "completionPricePerMillion": 0.28,
          "blendedPricePerMillion": 0.16799999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 88.23529411764706,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Xiaomi",
          "modelSlug": "xiaomi/mimo-v2.6-flash-20260921",
          "modelName": "Xiaomi: MiMo-V2.6-Flash",
          "promptPricePerMillion": 0.14,
          "completionPricePerMillion": 0.28,
          "blendedPricePerMillion": 0.16799999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Io Net",
          "modelSlug": "xiaomi/mimo-v2.6-flash-20260921",
          "modelName": "Xiaomi: MiMo-V2.6-Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.29,
          "blendedPricePerMillion": 0.178,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Venice",
          "modelSlug": "xiaomi/mimo-v2.6-flash-20260921",
          "modelName": "Xiaomi: MiMo-V2.6-Flash",
          "promptPricePerMillion": 0.175,
          "completionPricePerMillion": 0.35,
          "blendedPricePerMillion": 0.21,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DeepInfra",
          "modelSlug": "tencent/hy4-preview-20260827",
          "modelName": "Tencent: Hy4 preview",
          "promptPricePerMillion": 0.834,
          "completionPricePerMillion": 2.501,
          "blendedPricePerMillion": 1.1674,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Novita",
          "modelSlug": "tencent/hy4-preview-20260827",
          "modelName": "Tencent: Hy4 preview",
          "promptPricePerMillion": 0.834,
          "completionPricePerMillion": 2.501,
          "blendedPricePerMillion": 1.1674,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "SiliconFlow",
          "modelSlug": "tencent/hy4-preview-20260827",
          "modelName": "Tencent: Hy4 preview",
          "promptPricePerMillion": 0.834,
          "completionPricePerMillion": 2.501,
          "blendedPricePerMillion": 1.1674,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Tencent",
          "modelSlug": "tencent/hy4-preview-20260827",
          "modelName": "Tencent: Hy4 preview",
          "promptPricePerMillion": 0.834,
          "completionPricePerMillion": 2.501,
          "blendedPricePerMillion": 1.1674,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Amazon Bedrock",
          "modelSlug": "anthropic/claude-opus-5.5-20260921",
          "modelName": "Anthropic: Claude Opus 5.5",
          "promptPricePerMillion": 4,
          "completionPricePerMillion": 20,
          "blendedPricePerMillion": 7.199999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Azure",
          "modelSlug": "anthropic/claude-opus-5.5-20260921",
          "modelName": "Anthropic: Claude Opus 5.5",
          "promptPricePerMillion": 4,
          "completionPricePerMillion": 20,
          "blendedPricePerMillion": 7.199999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Google",
          "modelSlug": "anthropic/claude-opus-5.5-20260921",
          "modelName": "Anthropic: Claude Opus 5.5",
          "promptPricePerMillion": 4,
          "completionPricePerMillion": 20,
          "blendedPricePerMillion": 7.199999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Claude Platform on AWS",
          "modelSlug": "anthropic/claude-opus-5.5-20260921",
          "modelName": "Anthropic: Claude Opus 5.5",
          "promptPricePerMillion": 4,
          "completionPricePerMillion": 20,
          "blendedPricePerMillion": 7.199999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Anthropic",
          "modelSlug": "anthropic/claude-opus-5.5-20260921",
          "modelName": "Anthropic: Claude Opus 5.5",
          "promptPricePerMillion": 4,
          "completionPricePerMillion": 20,
          "blendedPricePerMillion": 7.199999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Amazon Bedrock",
          "modelSlug": "anthropic/claude-opus-5.5-20260921",
          "modelName": "Anthropic: Claude Opus 5.5",
          "promptPricePerMillion": 4.4,
          "completionPricePerMillion": 22,
          "blendedPricePerMillion": 7.919999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Amazon Bedrock",
          "modelSlug": "anthropic/claude-opus-5.5-20260921",
          "modelName": "Anthropic: Claude Opus 5.5",
          "promptPricePerMillion": 4.4,
          "completionPricePerMillion": 22,
          "blendedPricePerMillion": 7.919999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Azure",
          "modelSlug": "anthropic/claude-opus-5.5-20260921",
          "modelName": "Anthropic: Claude Opus 5.5",
          "promptPricePerMillion": 4.4,
          "completionPricePerMillion": 22,
          "blendedPricePerMillion": 7.919999999999999,
          "throughput": null,
          "latency": null,
          "uptime": null,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Google",
          "modelSlug": "anthropic/claude-opus-5.5-20260921",
          "modelName": "Anthropic: Claude Opus 5.5",
          "promptPricePerMillion": 4.4,
          "completionPricePerMillion": 22,
          "blendedPricePerMillion": 7.919999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Google",
          "modelSlug": "anthropic/claude-opus-5.5-20260921",
          "modelName": "Anthropic: Claude Opus 5.5",
          "promptPricePerMillion": 4.4,
          "completionPricePerMillion": 22,
          "blendedPricePerMillion": 7.919999999999999,
          "throughput": null,
          "latency": null,
          "uptime": null,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Anthropic",
          "modelSlug": "anthropic/claude-opus-5.5-20260921",
          "modelName": "Anthropic: Claude Opus 5.5",
          "promptPricePerMillion": 8,
          "completionPricePerMillion": 40,
          "blendedPricePerMillion": 14.399999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Relace",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.049999999999999996,
          "completionPricePerMillion": 0.6,
          "blendedPricePerMillion": 0.15999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DeepInfra",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.0784,
          "completionPricePerMillion": 0.2352,
          "blendedPricePerMillion": 0.10976,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "InferenceNet",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.08,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.16399999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Morph",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.081,
          "completionPricePerMillion": 0.55,
          "blendedPricePerMillion": 0.17479999999999998,
          "throughput": null,
          "latency": null,
          "uptime": null,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DeepInfra",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.098,
          "completionPricePerMillion": 0.29400000000000004,
          "blendedPricePerMillion": 0.13720000000000002,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Cloudflare",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.09999999999999999,
          "completionPricePerMillion": 0.6,
          "blendedPricePerMillion": 0.19999999999999996,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DeepInfra",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.14700000000000002,
          "completionPricePerMillion": 0.441,
          "blendedPricePerMillion": 0.2058,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DeepSeek",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.6,
          "blendedPricePerMillion": 0.23999999999999994,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Wafer",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Fireworks",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "PrimeIntellect",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "BaseTen",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Parasail",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "OpenAI",
          "modelSlug": "openai/gpt-6-luna-20260922",
          "modelName": "OpenAI: GPT-6 Luna",
          "promptPricePerMillion": 0.049999999999999996,
          "completionPricePerMillion": 0.25,
          "blendedPricePerMillion": 0.08999999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "OpenAI",
          "modelSlug": "openai/gpt-6-luna-20260922",
          "modelName": "OpenAI: GPT-6 Luna",
          "promptPricePerMillion": 0.09999999999999999,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.17999999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Azure",
          "modelSlug": "openai/gpt-6-luna-20260922",
          "modelName": "OpenAI: GPT-6 Luna",
          "promptPricePerMillion": 0.09999999999999999,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.17999999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Azure",
          "modelSlug": "openai/gpt-6-luna-20260922",
          "modelName": "OpenAI: GPT-6 Luna",
          "promptPricePerMillion": 0.11,
          "completionPricePerMillion": 0.55,
          "blendedPricePerMillion": 0.198,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Azure",
          "modelSlug": "openai/gpt-6-luna-20260922",
          "modelName": "OpenAI: GPT-6 Luna",
          "promptPricePerMillion": 0.11,
          "completionPricePerMillion": 0.55,
          "blendedPricePerMillion": 0.198,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Amazon Bedrock",
          "modelSlug": "openai/gpt-6-luna-20260922",
          "modelName": "OpenAI: GPT-6 Luna",
          "promptPricePerMillion": 0.11,
          "completionPricePerMillion": 0.55,
          "blendedPricePerMillion": 0.198,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "OpenAI",
          "modelSlug": "openai/gpt-6-luna-20260922",
          "modelName": "OpenAI: GPT-6 Luna",
          "promptPricePerMillion": 0.19999999999999998,
          "completionPricePerMillion": 1,
          "blendedPricePerMillion": 0.35999999999999993,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Relace",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.075,
          "completionPricePerMillion": 2.2,
          "blendedPricePerMillion": 0.4999999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Wafer",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.079,
          "completionPricePerMillion": 2.5,
          "blendedPricePerMillion": 0.5631999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "InferenceNet",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.08,
          "completionPricePerMillion": 4.381,
          "blendedPricePerMillion": 0.9401999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Morph",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.08,
          "completionPricePerMillion": 6,
          "blendedPricePerMillion": 1.2639999999999996,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Reka",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.14,
          "completionPricePerMillion": 4.199999999999999,
          "blendedPricePerMillion": 0.9519999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Makora",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.14,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 0.9919999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Wafer",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.179,
          "completionPricePerMillion": 2.5,
          "blendedPricePerMillion": 0.6432,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DekaLLM",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.18,
          "completionPricePerMillion": 2.95,
          "blendedPricePerMillion": 0.7339999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "AkashML",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.19,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 1.0319999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Io Net",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.49,
          "completionPricePerMillion": 2.6,
          "blendedPricePerMillion": 0.9119999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Sail Research",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.5,
          "completionPricePerMillion": 1.505,
          "blendedPricePerMillion": 0.701,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Sail Research",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.5,
          "completionPricePerMillion": 1.505,
          "blendedPricePerMillion": 0.701,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Inceptron",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.55,
          "completionPricePerMillion": 1.505,
          "blendedPricePerMillion": 0.741,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DeepInfra",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.5625,
          "completionPricePerMillion": 2.5,
          "blendedPricePerMillion": 0.95,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Baidu",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.5992000000000001,
          "completionPricePerMillion": 1.8832,
          "blendedPricePerMillion": 0.856,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Tenstorrent",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.6,
          "completionPricePerMillion": 2.5,
          "blendedPricePerMillion": 0.98,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "SiliconFlow",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.7,
          "completionPricePerMillion": 2.2,
          "blendedPricePerMillion": 1,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Novita",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.7,
          "completionPricePerMillion": 2.2,
          "blendedPricePerMillion": 1,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Phala",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.84,
          "completionPricePerMillion": 2.64,
          "blendedPricePerMillion": 1.2,
          "throughput": null,
          "latency": null,
          "uptime": null,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Decart",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.84,
          "completionPricePerMillion": 2.66,
          "blendedPricePerMillion": 1.2039999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DigitalOcean",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.9099999999999999,
          "completionPricePerMillion": 2.8600000000000003,
          "blendedPricePerMillion": 1.2999999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "GMICloud",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.98,
          "completionPricePerMillion": 3.08,
          "blendedPricePerMillion": 1.4,
          "throughput": null,
          "latency": null,
          "uptime": null,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Alibaba",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.19,
          "completionPricePerMillion": 3.74,
          "blendedPricePerMillion": 1.6999999999999997,
          "throughput": null,
          "latency": null,
          "uptime": null,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "CoreWeave",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.2,
          "completionPricePerMillion": 4,
          "blendedPricePerMillion": 1.7599999999999996,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Friendli",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.26,
          "completionPricePerMillion": 3.9600000000000004,
          "blendedPricePerMillion": 1.8,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Mistral",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "BaseTen",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Mistral",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Nebius",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Crusoe",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "PrimeIntellect",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Venice",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": null,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Together",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Parasail",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Modal",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "BaseTen",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": null,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Fireworks",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Cloudflare",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": null,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "AtlasCloud",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": 96.66666666666667,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Z.AI",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Mistral",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.54,
          "completionPricePerMillion": 4.84,
          "blendedPricePerMillion": 2.2,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "ModelRun",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 2.0999999999999996,
          "completionPricePerMillion": 6.6000000000000005,
          "blendedPricePerMillion": 3,
          "throughput": null,
          "latency": null,
          "uptime": null,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Fireworks",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 2.0999999999999996,
          "completionPricePerMillion": 6.6000000000000005,
          "blendedPricePerMillion": 3,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "BaseTen",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 2.0999999999999996,
          "completionPricePerMillion": 6.6000000000000005,
          "blendedPricePerMillion": 3,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "BaseTen",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 2.0999999999999996,
          "completionPricePerMillion": 6.6000000000000005,
          "blendedPricePerMillion": 3,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Alibaba",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 2.8,
          "completionPricePerMillion": 8.8,
          "blendedPricePerMillion": 4,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "OpenInference",
          "modelSlug": "deepseek/deepseek-v4-flash-20260731",
          "modelName": "DeepSeek: DeepSeek V4 Flash 0731",
          "promptPricePerMillion": 0.00392,
          "completionPricePerMillion": 0.143616,
          "blendedPricePerMillion": 0.0318592,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Relace",
          "modelSlug": "deepseek/deepseek-v4-flash-20260731",
          "modelName": "DeepSeek: DeepSeek V4 Flash 0731",
          "promptPricePerMillion": 0.0199,
          "completionPricePerMillion": 0.44999999999999996,
          "blendedPricePerMillion": 0.10591999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Reka",
          "modelSlug": "deepseek/deepseek-v4-flash-20260731",
          "modelName": "DeepSeek: DeepSeek V4 Flash 0731",
          "promptPricePerMillion": 0.020999999999999998,
          "completionPricePerMillion": 0.5279999999999999,
          "blendedPricePerMillion": 0.12239999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        }
      ]
    },
    "1y": {
      "meta": {
        "asOf": "2026-10-18T12:08:38.409Z",
        "availableStart": "2025-01-01",
        "availableEnd": "2026-10-17",
        "rangeStart": "2025-10-18",
        "rangeEnd": "2026-10-17",
        "previousStart": "2024-10-18",
        "previousEnd": "2025-10-17",
        "lastSync": "2026-10-18T12:08:32.383Z",
        "grain": "day",
        "sourceStatus": "live",
        "sourceCitation": "Source: OpenRouter (openrouter.ai/rankings), as of 2026-10-18T12:08:38.409Z.",
        "inputTokenShare": 0.8,
        "pricedTokenShare": 0.048598019612350454,
        "modelCount": 471,
        "providerCount": 52,
        "notes": [
          "公开需求样本、模型牌价与重点模型端点报价已在本地完成更新。",
          "Token 数据来自公开路由市场样本，不代表全球全部 AI 推理需求。",
          "公开排名只提供输入与输出 Token 合计，不提供两者的实际拆分。",
          "价格趋势是按当期模型结构加权的公开零售牌价，不是历史成交价。",
          "金额为 Token 与公开牌价的情景估算，不是平台流水或已确认收入。",
          "不同模型沿用上游 tokenizer，跨模型 Token 数量并非完全等价。"
        ]
      },
      "analysis": {
        "headline": "Token 需求较上一等长区间增长 2157.9%，加权牌价下降 39.8%，估算金额增长 158.1%。",
        "bullets": [
          "本期累计 2.25 千万亿 Token，对比区间为 2024-10-18 至 2025-10-17（+2157.9%）。",
          "可定价 Token 覆盖率 4.9%；加权零售价 $0.43/百万 Token。",
          "deepseek-v4.1-flash-20260910 的样本份额变化最大，上升 6.1 个百分点。",
          "估算金额仅用于观察需求与牌价的共同变化，不等同于平台实际收入。"
        ],
        "generatedAt": "2026-10-18T12:08:32.383Z"
      },
      "headline": {
        "tokenTotal": 2249242925945522,
        "tokenDeltaPct": 2157.930686974676,
        "blendedPricePerMillion": 0.4334200968031255,
        "priceDeltaPct": -39.775289912393326,
        "estimatedRetailValue": 47376609.798738346,
        "valueDeltaPct": 158.05526288750795
      },
      "trends": [
        {
          "key": "2025-10-18",
          "label": "10-18",
          "startDate": "2025-10-18",
          "endDate": "2025-10-18",
          "totalTokens": 561448579540,
          "pricedTokens": 163195094700,
          "blendedPricePerMillion": 0.729050671371313,
          "estimatedRetailValue": 118977.49335554,
          "pricedTokenShare": 0.2906679269430288
        },
        {
          "key": "2025-10-19",
          "label": "10-19",
          "startDate": "2025-10-19",
          "endDate": "2025-10-19",
          "totalTokens": 556555665134,
          "pricedTokens": 167914134401,
          "blendedPricePerMillion": 0.7315785244712263,
          "estimatedRetailValue": 122842.37468294676,
          "pricedTokenShare": 0.3017023182408392
        },
        {
          "key": "2025-10-20",
          "label": "10-20",
          "startDate": "2025-10-20",
          "endDate": "2025-10-20",
          "totalTokens": 689957530774,
          "pricedTokens": 188822014937,
          "blendedPricePerMillion": 0.7704332394436512,
          "estimatedRetailValue": 145474.7566461904,
          "pricedTokenShare": 0.273671938510734
        },
        {
          "key": "2025-10-21",
          "label": "10-21",
          "startDate": "2025-10-21",
          "endDate": "2025-10-21",
          "totalTokens": 747952422691,
          "pricedTokens": 209103985207,
          "blendedPricePerMillion": 0.7564852246589465,
          "estimatedRetailValue": 158184.07522639842,
          "pricedTokenShare": 0.2795685646082688
        },
        {
          "key": "2025-10-22",
          "label": "10-22",
          "startDate": "2025-10-22",
          "endDate": "2025-10-22",
          "totalTokens": 728888793419,
          "pricedTokens": 198024817523,
          "blendedPricePerMillion": 0.7874929780928596,
          "estimatedRetailValue": 155943.15328748236,
          "pricedTokenShare": 0.2716804254790702
        },
        {
          "key": "2025-10-23",
          "label": "10-23",
          "startDate": "2025-10-23",
          "endDate": "2025-10-23",
          "totalTokens": 754399295557,
          "pricedTokens": 200306076451,
          "blendedPricePerMillion": 0.8165926019599204,
          "estimatedRetailValue": 163568.46015750483,
          "pricedTokenShare": 0.2655173164008681
        },
        {
          "key": "2025-10-24",
          "label": "10-24",
          "startDate": "2025-10-24",
          "endDate": "2025-10-24",
          "totalTokens": 746130090866,
          "pricedTokens": 212638375825,
          "blendedPricePerMillion": 0.7655529083716711,
          "estimatedRetailValue": 162785.9270442572,
          "pricedTokenShare": 0.2849883397387178
        },
        {
          "key": "2025-10-25",
          "label": "10-25",
          "startDate": "2025-10-25",
          "endDate": "2025-10-25",
          "totalTokens": 612859382202,
          "pricedTokens": 177583570364,
          "blendedPricePerMillion": 0.7548843038413706,
          "estimatedRetailValue": 134055.0498878932,
          "pricedTokenShare": 0.28976234275135565
        },
        {
          "key": "2025-10-26",
          "label": "10-26",
          "startDate": "2025-10-26",
          "endDate": "2025-10-26",
          "totalTokens": 606124678848,
          "pricedTokens": 179762964758,
          "blendedPricePerMillion": 0.7667752343937518,
          "estimatedRetailValue": 137837.7894376312,
          "pricedTokenShare": 0.2965775376439998
        },
        {
          "key": "2025-10-27",
          "label": "10-27",
          "startDate": "2025-10-27",
          "endDate": "2025-10-27",
          "totalTokens": 808198435444,
          "pricedTokens": 230284066822,
          "blendedPricePerMillion": 0.7215775494708002,
          "estimatedRetailValue": 166167.81261958875,
          "pricedTokenShare": 0.28493505644500394
        },
        {
          "key": "2025-10-28",
          "label": "10-28",
          "startDate": "2025-10-28",
          "endDate": "2025-10-28",
          "totalTokens": 836836800480,
          "pricedTokens": 216714629426,
          "blendedPricePerMillion": 0.8217501885004856,
          "estimatedRetailValue": 178085.2875816284,
          "pricedTokenShare": 0.25896880885459983
        },
        {
          "key": "2025-10-29",
          "label": "10-29",
          "startDate": "2025-10-29",
          "endDate": "2025-10-29",
          "totalTokens": 882670634720,
          "pricedTokens": 234947442179,
          "blendedPricePerMillion": 0.7893199230181844,
          "estimatedRetailValue": 185448.6969740476,
          "pricedTokenShare": 0.26617792972520243
        },
        {
          "key": "2025-10-30",
          "label": "10-30",
          "startDate": "2025-10-30",
          "endDate": "2025-10-30",
          "totalTokens": 839936886983,
          "pricedTokens": 221566498506,
          "blendedPricePerMillion": 0.8172721911295572,
          "estimatedRetailValue": 181080.13771490238,
          "pricedTokenShare": 0.26378946077943166
        },
        {
          "key": "2025-10-31",
          "label": "10-31",
          "startDate": "2025-10-31",
          "endDate": "2025-10-31",
          "totalTokens": 795584528430,
          "pricedTokens": 205735992361,
          "blendedPricePerMillion": 0.8671202192658035,
          "estimatedRetailValue": 178397.838806938,
          "pricedTokenShare": 0.2585972766049105
        },
        {
          "key": "2025-11-01",
          "label": "11-01",
          "startDate": "2025-11-01",
          "endDate": "2025-11-01",
          "totalTokens": 667615679989,
          "pricedTokens": 178203728456,
          "blendedPricePerMillion": 0.8159988136873912,
          "estimatedRetailValue": 145414.031014766,
          "pricedTokenShare": 0.2669256187316274
        },
        {
          "key": "2025-11-02",
          "label": "11-02",
          "startDate": "2025-11-02",
          "endDate": "2025-11-02",
          "totalTokens": 680316040142,
          "pricedTokens": 188998590401,
          "blendedPricePerMillion": 0.7716164810330287,
          "estimatedRetailValue": 145834.42724542238,
          "pricedTokenShare": 0.2778099871958788
        },
        {
          "key": "2025-11-03",
          "label": "11-03",
          "startDate": "2025-11-03",
          "endDate": "2025-11-03",
          "totalTokens": 855212355442,
          "pricedTokens": 219212257511,
          "blendedPricePerMillion": 0.7750048601205184,
          "estimatedRetailValue": 169890.56496901563,
          "pricedTokenShare": 0.25632494212236256
        },
        {
          "key": "2025-11-04",
          "label": "11-04",
          "startDate": "2025-11-04",
          "endDate": "2025-11-04",
          "totalTokens": 843660094744,
          "pricedTokens": 224609180840,
          "blendedPricePerMillion": 0.729177383803858,
          "estimatedRetailValue": 163779.93486323883,
          "pricedTokenShare": 0.26623184175631226
        },
        {
          "key": "2025-11-05",
          "label": "11-05",
          "startDate": "2025-11-05",
          "endDate": "2025-11-05",
          "totalTokens": 870220639953,
          "pricedTokens": 226998840268,
          "blendedPricePerMillion": 0.789850175554621,
          "estimatedRetailValue": 179295.07383637517,
          "pricedTokenShare": 0.2608520527394754
        },
        {
          "key": "2025-11-06",
          "label": "11-06",
          "startDate": "2025-11-06",
          "endDate": "2025-11-06",
          "totalTokens": 815410486832,
          "pricedTokens": 256521125165,
          "blendedPricePerMillion": 0.811892872442923,
          "estimatedRetailValue": 208267.67315250242,
          "pricedTokenShare": 0.31459139820684123
        },
        {
          "key": "2025-11-07",
          "label": "11-07",
          "startDate": "2025-11-07",
          "endDate": "2025-11-07",
          "totalTokens": 902186629114,
          "pricedTokens": 259028460133,
          "blendedPricePerMillion": 0.7478690748554369,
          "estimatedRetailValue": 193719.37484089512,
          "pricedTokenShare": 0.2871118367021035
        },
        {
          "key": "2025-11-08",
          "label": "11-08",
          "startDate": "2025-11-08",
          "endDate": "2025-11-08",
          "totalTokens": 797042525948,
          "pricedTokens": 258791956821,
          "blendedPricePerMillion": 0.6662175359725782,
          "estimatedRetailValue": 172411.73980280844,
          "pricedTokenShare": 0.3246902748547747
        },
        {
          "key": "2025-11-09",
          "label": "11-09",
          "startDate": "2025-11-09",
          "endDate": "2025-11-09",
          "totalTokens": 744474553464,
          "pricedTokens": 227486146399,
          "blendedPricePerMillion": 0.7053767307956796,
          "estimatedRetailValue": 160463.43424823397,
          "pricedTokenShare": 0.30556604700660245
        },
        {
          "key": "2025-11-10",
          "label": "11-10",
          "startDate": "2025-11-10",
          "endDate": "2025-11-10",
          "totalTokens": 910825672740,
          "pricedTokens": 269363179423,
          "blendedPricePerMillion": 0.7814949051520438,
          "estimatedRetailValue": 210505.95235463034,
          "pricedTokenShare": 0.29573516369239533
        },
        {
          "key": "2025-11-11",
          "label": "11-11",
          "startDate": "2025-11-11",
          "endDate": "2025-11-11",
          "totalTokens": 949647793603,
          "pricedTokens": 292553848517,
          "blendedPricePerMillion": 0.7586375353536476,
          "estimatedRetailValue": 221942.33059716126,
          "pricedTokenShare": 0.30806563284587807
        },
        {
          "key": "2025-11-12",
          "label": "11-12",
          "startDate": "2025-11-12",
          "endDate": "2025-11-12",
          "totalTokens": 881916356487,
          "pricedTokens": 265159049560,
          "blendedPricePerMillion": 0.7064929005248726,
          "estimatedRetailValue": 187332.98602406282,
          "pricedTokenShare": 0.30066235602685365
        },
        {
          "key": "2025-11-13",
          "label": "11-13",
          "startDate": "2025-11-13",
          "endDate": "2025-11-13",
          "totalTokens": 901368356290,
          "pricedTokens": 251010392185,
          "blendedPricePerMillion": 0.7412405354750161,
          "estimatedRetailValue": 186059.0775130032,
          "pricedTokenShare": 0.27847704041680565
        },
        {
          "key": "2025-11-14",
          "label": "11-14",
          "startDate": "2025-11-14",
          "endDate": "2025-11-14",
          "totalTokens": 812896999546,
          "pricedTokens": 229170848032,
          "blendedPricePerMillion": 0.7466383597306651,
          "estimatedRetailValue": 171107.74607269798,
          "pricedTokenShare": 0.28191867870098064
        },
        {
          "key": "2025-11-15",
          "label": "11-15",
          "startDate": "2025-11-15",
          "endDate": "2025-11-15",
          "totalTokens": 693672882394,
          "pricedTokens": 196919264433,
          "blendedPricePerMillion": 0.7081730332842309,
          "estimatedRetailValue": 139452.91280561718,
          "pricedTokenShare": 0.28387914452327057
        },
        {
          "key": "2025-11-16",
          "label": "11-16",
          "startDate": "2025-11-16",
          "endDate": "2025-11-16",
          "totalTokens": 777386360554,
          "pricedTokens": 207805709119,
          "blendedPricePerMillion": 0.6901042616940556,
          "estimatedRetailValue": 143407.60546737717,
          "pricedTokenShare": 0.26731329447420255
        },
        {
          "key": "2025-11-17",
          "label": "11-17",
          "startDate": "2025-11-17",
          "endDate": "2025-11-17",
          "totalTokens": 895158521563,
          "pricedTokens": 252417468132,
          "blendedPricePerMillion": 0.7469136034990644,
          "estimatedRetailValue": 188534.04070858238,
          "pricedTokenShare": 0.2819807464841692
        },
        {
          "key": "2025-11-18",
          "label": "11-18",
          "startDate": "2025-11-18",
          "endDate": "2025-11-18",
          "totalTokens": 946644725789,
          "pricedTokens": 249790270802,
          "blendedPricePerMillion": 0.7130379868092042,
          "estimatedRetailValue": 178109.95181718402,
          "pricedTokenShare": 0.2638690778040382
        },
        {
          "key": "2025-11-19",
          "label": "11-19",
          "startDate": "2025-11-19",
          "endDate": "2025-11-19",
          "totalTokens": 974905831481,
          "pricedTokens": 267770813367,
          "blendedPricePerMillion": 0.6502828930517179,
          "estimatedRetailValue": 174126.7791911044,
          "pricedTokenShare": 0.27466325948653286
        },
        {
          "key": "2025-11-20",
          "label": "11-20",
          "startDate": "2025-11-20",
          "endDate": "2025-11-20",
          "totalTokens": 950497881430,
          "pricedTokens": 263148023448,
          "blendedPricePerMillion": 0.636574949356898,
          "estimatedRetailValue": 167513.4396997784,
          "pricedTokenShare": 0.2768528248080895
        },
        {
          "key": "2025-11-21",
          "label": "11-21",
          "startDate": "2025-11-21",
          "endDate": "2025-11-21",
          "totalTokens": 914059968966,
          "pricedTokens": 240964646157,
          "blendedPricePerMillion": 0.6628591675588871,
          "estimatedRetailValue": 159725.6247627508,
          "pricedTokenShare": 0.26362017191233444
        },
        {
          "key": "2025-11-22",
          "label": "11-22",
          "startDate": "2025-11-22",
          "endDate": "2025-11-22",
          "totalTokens": 766516913255,
          "pricedTokens": 210775384434,
          "blendedPricePerMillion": 0.6434591604559872,
          "estimatedRetailValue": 135625.3519126896,
          "pricedTokenShare": 0.2749781261041537
        },
        {
          "key": "2025-11-23",
          "label": "11-23",
          "startDate": "2025-11-23",
          "endDate": "2025-11-23",
          "totalTokens": 824048259184,
          "pricedTokens": 223017873901,
          "blendedPricePerMillion": 0.6344760914817147,
          "estimatedRetailValue": 141499.5089632684,
          "pricedTokenShare": 0.2706369092046135
        },
        {
          "key": "2025-11-24",
          "label": "11-24",
          "startDate": "2025-11-24",
          "endDate": "2025-11-24",
          "totalTokens": 1015013853257,
          "pricedTokens": 257796032008,
          "blendedPricePerMillion": 0.6879541881367636,
          "estimatedRetailValue": 177351.85990494277,
          "pricedTokenShare": 0.2539827719402825
        },
        {
          "key": "2025-11-25",
          "label": "11-25",
          "startDate": "2025-11-25",
          "endDate": "2025-11-25",
          "totalTokens": 1043852595370,
          "pricedTokens": 255125289052,
          "blendedPricePerMillion": 0.6669917719367239,
          "estimatedRetailValue": 170166.46861066236,
          "pricedTokenShare": 0.2444073906446238
        },
        {
          "key": "2025-11-26",
          "label": "11-26",
          "startDate": "2025-11-26",
          "endDate": "2025-11-26",
          "totalTokens": 1084308770070,
          "pricedTokens": 262221496298,
          "blendedPricePerMillion": 0.6878656938486999,
          "estimatedRetailValue": 180373.17149306805,
          "pricedTokenShare": 0.24183286489610492
        },
        {
          "key": "2025-11-27",
          "label": "11-27",
          "startDate": "2025-11-27",
          "endDate": "2025-11-27",
          "totalTokens": 1088012755787,
          "pricedTokens": 247955800663,
          "blendedPricePerMillion": 0.690301177911632,
          "estimatedRetailValue": 171164.18126769073,
          "pricedTokenShare": 0.22789788018950602
        },
        {
          "key": "2025-11-28",
          "label": "11-28",
          "startDate": "2025-11-28",
          "endDate": "2025-11-28",
          "totalTokens": 1103763003384,
          "pricedTokens": 216244753565,
          "blendedPricePerMillion": 0.6944067230882157,
          "estimatedRetailValue": 150161.8107080904,
          "pricedTokenShare": 0.19591592842124667
        },
        {
          "key": "2025-11-29",
          "label": "11-29",
          "startDate": "2025-11-29",
          "endDate": "2025-11-29",
          "totalTokens": 927904867275,
          "pricedTokens": 194127114567,
          "blendedPricePerMillion": 0.6875954715130734,
          "estimatedRetailValue": 133480.9248741688,
          "pricedTokenShare": 0.2092101479509399
        },
        {
          "key": "2025-11-30",
          "label": "11-30",
          "startDate": "2025-11-30",
          "endDate": "2025-11-30",
          "totalTokens": 922030064198,
          "pricedTokens": 209079954032,
          "blendedPricePerMillion": 0.6820045242112012,
          "estimatedRetailValue": 142593.47457169398,
          "pricedTokenShare": 0.22676045190984295
        },
        {
          "key": "2025-12-01",
          "label": "12-01",
          "startDate": "2025-12-01",
          "endDate": "2025-12-01",
          "totalTokens": 1015109519099,
          "pricedTokens": 241021133844,
          "blendedPricePerMillion": 0.7219911678822993,
          "estimatedRetailValue": 174015.12990834555,
          "pricedTokenShare": 0.23743362593814282
        },
        {
          "key": "2025-12-02",
          "label": "12-02",
          "startDate": "2025-12-02",
          "endDate": "2025-12-02",
          "totalTokens": 1026570896607,
          "pricedTokens": 239472990311,
          "blendedPricePerMillion": 0.716653368846449,
          "estimatedRetailValue": 171619.1252541112,
          "pricedTokenShare": 0.2332746730912604
        },
        {
          "key": "2025-12-03",
          "label": "12-03",
          "startDate": "2025-12-03",
          "endDate": "2025-12-03",
          "totalTokens": 976117437403,
          "pricedTokens": 253199578175,
          "blendedPricePerMillion": 0.7352743639900339,
          "estimatedRetailValue": 186171.15880516797,
          "pricedTokenShare": 0.25939458560298617
        },
        {
          "key": "2025-12-04",
          "label": "12-04",
          "startDate": "2025-12-04",
          "endDate": "2025-12-04",
          "totalTokens": 898751591697,
          "pricedTokens": 281564469473,
          "blendedPricePerMillion": 0.6218929604723891,
          "estimatedRetailValue": 175102.96148440157,
          "pricedTokenShare": 0.3132839730957885
        },
        {
          "key": "2025-12-05",
          "label": "12-05",
          "startDate": "2025-12-05",
          "endDate": "2025-12-05",
          "totalTokens": 843822919210,
          "pricedTokens": 263058415680,
          "blendedPricePerMillion": 0.6425717604335858,
          "estimatedRetailValue": 169033.90926036757,
          "pricedTokenShare": 0.31174599515059315
        },
        {
          "key": "2025-12-06",
          "label": "12-06",
          "startDate": "2025-12-06",
          "endDate": "2025-12-06",
          "totalTokens": 703381365260,
          "pricedTokens": 223214173633,
          "blendedPricePerMillion": 0.6623898622488528,
          "estimatedRetailValue": 147854.80572475438,
          "pricedTokenShare": 0.3173444516126617
        },
        {
          "key": "2025-12-07",
          "label": "12-07",
          "startDate": "2025-12-07",
          "endDate": "2025-12-07",
          "totalTokens": 719935353270,
          "pricedTokens": 224507835121,
          "blendedPricePerMillion": 0.6551802648068027,
          "estimatedRetailValue": 147093.10286577878,
          "pricedTokenShare": 0.3118444372835265
        },
        {
          "key": "2025-12-08",
          "label": "12-08",
          "startDate": "2025-12-08",
          "endDate": "2025-12-08",
          "totalTokens": 926168784356,
          "pricedTokens": 269314036469,
          "blendedPricePerMillion": 0.7062765481177176,
          "estimatedRetailValue": 190210.1880369744,
          "pricedTokenShare": 0.29078289078406394
        },
        {
          "key": "2025-12-09",
          "label": "12-09",
          "startDate": "2025-12-09",
          "endDate": "2025-12-09",
          "totalTokens": 933583522452,
          "pricedTokens": 291181363026,
          "blendedPricePerMillion": 0.6940491122161669,
          "estimatedRetailValue": 202094.16650208872,
          "pricedTokenShare": 0.311896424929641
        },
        {
          "key": "2025-12-10",
          "label": "12-10",
          "startDate": "2025-12-10",
          "endDate": "2025-12-10",
          "totalTokens": 899477293159,
          "pricedTokens": 282297815529,
          "blendedPricePerMillion": 0.621659152174262,
          "estimatedRetailValue": 175493.02066240436,
          "pricedTokenShare": 0.3138465169449235
        },
        {
          "key": "2025-12-11",
          "label": "12-11",
          "startDate": "2025-12-11",
          "endDate": "2025-12-11",
          "totalTokens": 850751596689,
          "pricedTokens": 277085084020,
          "blendedPricePerMillion": 0.6582756725422999,
          "estimatedRetailValue": 182398.37003470518,
          "pricedTokenShare": 0.3256944625180539
        },
        {
          "key": "2025-12-12",
          "label": "12-12",
          "startDate": "2025-12-12",
          "endDate": "2025-12-12",
          "totalTokens": 838859646336,
          "pricedTokens": 271183542901,
          "blendedPricePerMillion": 0.6385237192640655,
          "estimatedRetailValue": 173157.12441635277,
          "pricedTokenShare": 0.32327641946478747
        },
        {
          "key": "2025-12-13",
          "label": "12-13",
          "startDate": "2025-12-13",
          "endDate": "2025-12-13",
          "totalTokens": 662233192347,
          "pricedTokens": 241635517536,
          "blendedPricePerMillion": 0.5879303099452741,
          "estimatedRetailValue": 142064.8447187272,
          "pricedTokenShare": 0.36487980416630444
        },
        {
          "key": "2025-12-14",
          "label": "12-14",
          "startDate": "2025-12-14",
          "endDate": "2025-12-14",
          "totalTokens": 661672600380,
          "pricedTokens": 243985116812,
          "blendedPricePerMillion": 0.574305182428237,
          "estimatedRetailValue": 140121.91702049036,
          "pricedTokenShare": 0.36873994279327693
        },
        {
          "key": "2025-12-15",
          "label": "12-15",
          "startDate": "2025-12-15",
          "endDate": "2025-12-15",
          "totalTokens": 862177267218,
          "pricedTokens": 303014232981,
          "blendedPricePerMillion": 0.5848099911455571,
          "estimatedRetailValue": 177205.7509065964,
          "pricedTokenShare": 0.3514523573078428
        },
        {
          "key": "2025-12-16",
          "label": "12-16",
          "startDate": "2025-12-16",
          "endDate": "2025-12-16",
          "totalTokens": 885696419175,
          "pricedTokens": 275678473321,
          "blendedPricePerMillion": 0.6353449358089799,
          "estimatedRetailValue": 175150.92193604834,
          "pricedTokenShare": 0.31125616786142857
        },
        {
          "key": "2025-12-17",
          "label": "12-17",
          "startDate": "2025-12-17",
          "endDate": "2025-12-17",
          "totalTokens": 923604614263,
          "pricedTokens": 265650512502,
          "blendedPricePerMillion": 0.6343007416404836,
          "estimatedRetailValue": 168502.31709719315,
          "pricedTokenShare": 0.2876236307177597
        },
        {
          "key": "2025-12-18",
          "label": "12-18",
          "startDate": "2025-12-18",
          "endDate": "2025-12-18",
          "totalTokens": 900483548874,
          "pricedTokens": 260711600733,
          "blendedPricePerMillion": 0.6249081550874372,
          "estimatedRetailValue": 162920.8054239516,
          "pricedTokenShare": 0.2895240019198619
        },
        {
          "key": "2025-12-19",
          "label": "12-19",
          "startDate": "2025-12-19",
          "endDate": "2025-12-19",
          "totalTokens": 858310522853,
          "pricedTokens": 232163922126,
          "blendedPricePerMillion": 0.6200423801440873,
          "estimatedRetailValue": 143951.47085859158,
          "pricedTokenShare": 0.2704894277123548
        },
        {
          "key": "2025-12-20",
          "label": "12-20",
          "startDate": "2025-12-20",
          "endDate": "2025-12-20",
          "totalTokens": 691575313543,
          "pricedTokens": 186318955925,
          "blendedPricePerMillion": 0.6530205501850865,
          "estimatedRetailValue": 121670.10710805439,
          "pricedTokenShare": 0.26941238687435487
        },
        {
          "key": "2025-12-21",
          "label": "12-21",
          "startDate": "2025-12-21",
          "endDate": "2025-12-21",
          "totalTokens": 718652924977,
          "pricedTokens": 193209199651,
          "blendedPricePerMillion": 0.6157921581942261,
          "estimatedRetailValue": 118976.7100360684,
          "pricedTokenShare": 0.2688491105176863
        },
        {
          "key": "2025-12-22",
          "label": "12-22",
          "startDate": "2025-12-22",
          "endDate": "2025-12-22",
          "totalTokens": 895710872569,
          "pricedTokens": 216994007463,
          "blendedPricePerMillion": 0.6371691426072771,
          "estimatedRetailValue": 138261.8856861168,
          "pricedTokenShare": 0.24225898569327026
        },
        {
          "key": "2025-12-23",
          "label": "12-23",
          "startDate": "2025-12-23",
          "endDate": "2025-12-23",
          "totalTokens": 919893606912,
          "pricedTokens": 216713426701,
          "blendedPricePerMillion": 0.6047882978893712,
          "estimatedRetailValue": 131065.74446427079,
          "pricedTokenShare": 0.23558531668514085
        },
        {
          "key": "2025-12-24",
          "label": "12-24",
          "startDate": "2025-12-24",
          "endDate": "2025-12-24",
          "totalTokens": 832020782412,
          "pricedTokens": 200736628243,
          "blendedPricePerMillion": 0.6223721859110553,
          "estimatedRetailValue": 124932.89411201078,
          "pricedTokenShare": 0.24126395937018705
        },
        {
          "key": "2025-12-25",
          "label": "12-25",
          "startDate": "2025-12-25",
          "endDate": "2025-12-25",
          "totalTokens": 737262325637,
          "pricedTokens": 188597507835,
          "blendedPricePerMillion": 0.6429141906882123,
          "estimatedRetailValue": 121252.0141155528,
          "pricedTokenShare": 0.2558078736385321
        },
        {
          "key": "2025-12-26",
          "label": "12-26",
          "startDate": "2025-12-26",
          "endDate": "2025-12-26",
          "totalTokens": 817227654508,
          "pricedTokens": 209359327546,
          "blendedPricePerMillion": 0.6016801129190057,
          "estimatedRetailValue": 125967.34383852438,
          "pricedTokenShare": 0.2561823824623773
        },
        {
          "key": "2025-12-27",
          "label": "12-27",
          "startDate": "2025-12-27",
          "endDate": "2025-12-27",
          "totalTokens": 733624354484,
          "pricedTokens": 199608318674,
          "blendedPricePerMillion": 0.5885238081135424,
          "estimatedRetailValue": 117474.247837164,
          "pricedTokenShare": 0.27208518563208817
        },
        {
          "key": "2025-12-28",
          "label": "12-28",
          "startDate": "2025-12-28",
          "endDate": "2025-12-28",
          "totalTokens": 729209611978,
          "pricedTokens": 210587843767,
          "blendedPricePerMillion": 0.5626116997599011,
          "estimatedRetailValue": 118479.18473052437,
          "pricedTokenShare": 0.28878917708692153
        },
        {
          "key": "2025-12-29",
          "label": "12-29",
          "startDate": "2025-12-29",
          "endDate": "2025-12-29",
          "totalTokens": 908489661987,
          "pricedTokens": 251041178149,
          "blendedPricePerMillion": 0.5885820694935444,
          "estimatedRetailValue": 147758.33616303597,
          "pricedTokenShare": 0.2763280515486947
        },
        {
          "key": "2025-12-30",
          "label": "12-30",
          "startDate": "2025-12-30",
          "endDate": "2025-12-30",
          "totalTokens": 875711094778,
          "pricedTokens": 239221868513,
          "blendedPricePerMillion": 0.5700666270378402,
          "estimatedRetailValue": 136372.4036968956,
          "pricedTokenShare": 0.2731744178411314
        },
        {
          "key": "2025-12-31",
          "label": "12-31",
          "startDate": "2025-12-31",
          "endDate": "2025-12-31",
          "totalTokens": 768652128021,
          "pricedTokens": 201187771811,
          "blendedPricePerMillion": 0.5784784875970336,
          "estimatedRetailValue": 116382.79796024438,
          "pricedTokenShare": 0.2617409937171259
        },
        {
          "key": "2026-01-01",
          "label": "01-01",
          "startDate": "2026-01-01",
          "endDate": "2026-01-01",
          "totalTokens": 676146556672,
          "pricedTokens": 187380445116,
          "blendedPricePerMillion": 0.5651223380194311,
          "estimatedRetailValue": 105892.8752430756,
          "pricedTokenShare": 0.2771299258525968
        },
        {
          "key": "2026-01-02",
          "label": "01-02",
          "startDate": "2026-01-02",
          "endDate": "2026-01-02",
          "totalTokens": 780433027499,
          "pricedTokens": 212728959964,
          "blendedPricePerMillion": 0.5706816137404203,
          "estimatedRetailValue": 121400.50616157678,
          "pricedTokenShare": 0.27257811044429764
        },
        {
          "key": "2026-01-03",
          "label": "01-03",
          "startDate": "2026-01-03",
          "endDate": "2026-01-03",
          "totalTokens": 752494217391,
          "pricedTokens": 201030960387,
          "blendedPricePerMillion": 0.5661467557739405,
          "estimatedRetailValue": 113813.02603321958,
          "pricedTokenShare": 0.2671528308669291
        },
        {
          "key": "2026-01-04",
          "label": "01-04",
          "startDate": "2026-01-04",
          "endDate": "2026-01-04",
          "totalTokens": 804614702335,
          "pricedTokens": 205345352418,
          "blendedPricePerMillion": 0.6019244225124453,
          "estimatedRetailValue": 123602.3826698192,
          "pricedTokenShare": 0.2552095454160677
        },
        {
          "key": "2026-01-05",
          "label": "01-05",
          "startDate": "2026-01-05",
          "endDate": "2026-01-05",
          "totalTokens": 920385666646,
          "pricedTokens": 244021149144,
          "blendedPricePerMillion": 0.5922928134128694,
          "estimatedRetailValue": 144531.97295874116,
          "pricedTokenShare": 0.2651292365658447
        },
        {
          "key": "2026-01-06",
          "label": "01-06",
          "startDate": "2026-01-06",
          "endDate": "2026-01-06",
          "totalTokens": 963414695887,
          "pricedTokens": 221883250057,
          "blendedPricePerMillion": 0.5974011956576846,
          "estimatedRetailValue": 132553.3188804648,
          "pricedTokenShare": 0.23030918150227692
        },
        {
          "key": "2026-01-07",
          "label": "01-07",
          "startDate": "2026-01-07",
          "endDate": "2026-01-07",
          "totalTokens": 1017214808143,
          "pricedTokens": 253171186360,
          "blendedPricePerMillion": 0.5770557419212639,
          "estimatedRetailValue": 146093.88677805636,
          "pricedTokenShare": 0.24888665042360375
        },
        {
          "key": "2026-01-08",
          "label": "01-08",
          "startDate": "2026-01-08",
          "endDate": "2026-01-08",
          "totalTokens": 969015458231,
          "pricedTokens": 244219514259,
          "blendedPricePerMillion": 0.56720243718754,
          "estimatedRetailValue": 138521.903696462,
          "pricedTokenShare": 0.25202850190319814
        },
        {
          "key": "2026-01-09",
          "label": "01-09",
          "startDate": "2026-01-09",
          "endDate": "2026-01-09",
          "totalTokens": 957089207783,
          "pricedTokens": 234248696878,
          "blendedPricePerMillion": 0.5451316258449866,
          "estimatedRetailValue": 127696.3729811736,
          "pricedTokenShare": 0.2447511631863589
        },
        {
          "key": "2026-01-10",
          "label": "01-10",
          "startDate": "2026-01-10",
          "endDate": "2026-01-10",
          "totalTokens": 802870338890,
          "pricedTokens": 214305555928,
          "blendedPricePerMillion": 0.5168435994802242,
          "estimatedRetailValue": 110762.45491443801,
          "pricedTokenShare": 0.2669242411225278
        },
        {
          "key": "2026-01-11",
          "label": "01-11",
          "startDate": "2026-01-11",
          "endDate": "2026-01-11",
          "totalTokens": 789693535502,
          "pricedTokens": 189333606457,
          "blendedPricePerMillion": 0.571650205086213,
          "estimatedRetailValue": 108232.5949608564,
          "pricedTokenShare": 0.23975580139027297
        },
        {
          "key": "2026-01-12",
          "label": "01-12",
          "startDate": "2026-01-12",
          "endDate": "2026-01-12",
          "totalTokens": 1014313612337,
          "pricedTokens": 225682013275,
          "blendedPricePerMillion": 0.5672399748708542,
          "estimatedRetailValue": 128015.85953891477,
          "pricedTokenShare": 0.22249727355529014
        },
        {
          "key": "2026-01-13",
          "label": "01-13",
          "startDate": "2026-01-13",
          "endDate": "2026-01-13",
          "totalTokens": 1098350562760,
          "pricedTokens": 251207312770,
          "blendedPricePerMillion": 0.5797180205526657,
          "estimatedRetailValue": 145629.4061073788,
          "pricedTokenShare": 0.22871323718244516
        },
        {
          "key": "2026-01-14",
          "label": "01-14",
          "startDate": "2026-01-14",
          "endDate": "2026-01-14",
          "totalTokens": 1168753721245,
          "pricedTokens": 261345463101,
          "blendedPricePerMillion": 0.5487685407701343,
          "estimatedRetailValue": 143418.16842283073,
          "pricedTokenShare": 0.22361037945839016
        },
        {
          "key": "2026-01-15",
          "label": "01-15",
          "startDate": "2026-01-15",
          "endDate": "2026-01-15",
          "totalTokens": 1227040917358,
          "pricedTokens": 276418628571,
          "blendedPricePerMillion": 0.5497503240036317,
          "estimatedRetailValue": 151961.23061754677,
          "pricedTokenShare": 0.22527254361343554
        },
        {
          "key": "2026-01-16",
          "label": "01-16",
          "startDate": "2026-01-16",
          "endDate": "2026-01-16",
          "totalTokens": 1111775956968,
          "pricedTokens": 283333722194,
          "blendedPricePerMillion": 0.8261729753226793,
          "estimatedRetailValue": 234082.66427426643,
          "pricedTokenShare": 0.2548478588857945
        },
        {
          "key": "2026-01-17",
          "label": "01-17",
          "startDate": "2026-01-17",
          "endDate": "2026-01-17",
          "totalTokens": 965416302518,
          "pricedTokens": 289910110549,
          "blendedPricePerMillion": 1.2284038098024612,
          "estimatedRetailValue": 356126.6842986443,
          "pricedTokenShare": 0.30029543710092327
        },
        {
          "key": "2026-01-18",
          "label": "01-18",
          "startDate": "2026-01-18",
          "endDate": "2026-01-18",
          "totalTokens": 1057621484506,
          "pricedTokens": 386013503821,
          "blendedPricePerMillion": 1.6292723412451686,
          "estimatedRetailValue": 628921.1251226915,
          "pricedTokenShare": 0.36498266107113114
        },
        {
          "key": "2026-01-19",
          "label": "01-19",
          "startDate": "2026-01-19",
          "endDate": "2026-01-19",
          "totalTokens": 1118470681107,
          "pricedTokens": 264504342240,
          "blendedPricePerMillion": 0.7232305618664099,
          "estimatedRetailValue": 191297.62405434038,
          "pricedTokenShare": 0.23648750629583631
        },
        {
          "key": "2026-01-20",
          "label": "01-20",
          "startDate": "2026-01-20",
          "endDate": "2026-01-20",
          "totalTokens": 1167369854809,
          "pricedTokens": 261929852257,
          "blendedPricePerMillion": 0.5475420993053333,
          "estimatedRetailValue": 143417.62117553357,
          "pricedTokenShare": 0.22437606314569072
        },
        {
          "key": "2026-01-21",
          "label": "01-21",
          "startDate": "2026-01-21",
          "endDate": "2026-01-21",
          "totalTokens": 1109751264958,
          "pricedTokens": 260650911148,
          "blendedPricePerMillion": 0.5668679561093877,
          "estimatedRetailValue": 147754.64926051637,
          "pricedTokenShare": 0.23487327239754457
        },
        {
          "key": "2026-01-22",
          "label": "01-22",
          "startDate": "2026-01-22",
          "endDate": "2026-01-22",
          "totalTokens": 1165644748031,
          "pricedTokens": 276225800645,
          "blendedPricePerMillion": 0.5441368168819587,
          "estimatedRetailValue": 150304.6279036408,
          "pricedTokenShare": 0.23697254340278112
        },
        {
          "key": "2026-01-23",
          "label": "01-23",
          "startDate": "2026-01-23",
          "endDate": "2026-01-23",
          "totalTokens": 1098227750683,
          "pricedTokens": 232021970395,
          "blendedPricePerMillion": 0.5679226948247139,
          "estimatedRetailValue": 131770.5426852684,
          "pricedTokenShare": 0.21126944775407738
        },
        {
          "key": "2026-01-24",
          "label": "01-24",
          "startDate": "2026-01-24",
          "endDate": "2026-01-24",
          "totalTokens": 921779225469,
          "pricedTokens": 207536513561,
          "blendedPricePerMillion": 0.5522431903320277,
          "estimatedRetailValue": 114610.62635931278,
          "pricedTokenShare": 0.2251477445213692
        },
        {
          "key": "2026-01-25",
          "label": "01-25",
          "startDate": "2026-01-25",
          "endDate": "2026-01-25",
          "totalTokens": 912436067961,
          "pricedTokens": 207084634246,
          "blendedPricePerMillion": 0.558718919740768,
          "estimatedRetailValue": 115702.10314083718,
          "pricedTokenShare": 0.22695796617155578
        },
        {
          "key": "2026-01-26",
          "label": "01-26",
          "startDate": "2026-01-26",
          "endDate": "2026-01-26",
          "totalTokens": 1123037386403,
          "pricedTokens": 257023351870,
          "blendedPricePerMillion": 0.5527929623834923,
          "estimatedRetailValue": 142080.700081952,
          "pricedTokenShare": 0.2288644661182879
        },
        {
          "key": "2026-01-27",
          "label": "01-27",
          "startDate": "2026-01-27",
          "endDate": "2026-01-27",
          "totalTokens": 1171091999378,
          "pricedTokens": 291622355864,
          "blendedPricePerMillion": 0.5408210422427958,
          "estimatedRetailValue": 157715.50643966798,
          "pricedTokenShare": 0.24901746064262148
        },
        {
          "key": "2026-01-28",
          "label": "01-28",
          "startDate": "2026-01-28",
          "endDate": "2026-01-28",
          "totalTokens": 1262244728033,
          "pricedTokens": 298718320550,
          "blendedPricePerMillion": 0.5356885090645463,
          "estimatedRetailValue": 160019.97176569476,
          "pricedTokenShare": 0.23665642162396128
        },
        {
          "key": "2026-01-29",
          "label": "01-29",
          "startDate": "2026-01-29",
          "endDate": "2026-01-29",
          "totalTokens": 1299991615800,
          "pricedTokens": 313199040098,
          "blendedPricePerMillion": 0.573721804720044,
          "estimatedRetailValue": 179689.11852160998,
          "pricedTokenShare": 0.24092389234776787
        },
        {
          "key": "2026-01-30",
          "label": "01-30",
          "startDate": "2026-01-30",
          "endDate": "2026-01-30",
          "totalTokens": 1226664854860,
          "pricedTokens": 256734451787,
          "blendedPricePerMillion": 0.534366485637398,
          "estimatedRetailValue": 137190.2867434632,
          "pricedTokenShare": 0.20929469917543309
        },
        {
          "key": "2026-01-31",
          "label": "01-31",
          "startDate": "2026-01-31",
          "endDate": "2026-01-31",
          "totalTokens": 1039939632945,
          "pricedTokens": 231073565869,
          "blendedPricePerMillion": 0.5092786717567057,
          "estimatedRetailValue": 117680.83870384998,
          "pricedTokenShare": 0.22219901862440217
        },
        {
          "key": "2026-02-01",
          "label": "02-01",
          "startDate": "2026-02-01",
          "endDate": "2026-02-01",
          "totalTokens": 1126964134499,
          "pricedTokens": 271720870086,
          "blendedPricePerMillion": 0.47574165440128396,
          "estimatedRetailValue": 129268.93627006999,
          "pricedTokenShare": 0.2411087112428786
        },
        {
          "key": "2026-02-02",
          "label": "02-02",
          "startDate": "2026-02-02",
          "endDate": "2026-02-02",
          "totalTokens": 1273715201835,
          "pricedTokens": 294643424580,
          "blendedPricePerMillion": 0.5081350353465933,
          "estimatedRetailValue": 149718.64696359957,
          "pricedTokenShare": 0.2313259857113402
        },
        {
          "key": "2026-02-03",
          "label": "02-03",
          "startDate": "2026-02-03",
          "endDate": "2026-02-03",
          "totalTokens": 1347876943352,
          "pricedTokens": 329867481021,
          "blendedPricePerMillion": 0.517921242668873,
          "estimatedRetailValue": 170845.37568644717,
          "pricedTokenShare": 0.24473115490844524
        },
        {
          "key": "2026-02-04",
          "label": "02-04",
          "startDate": "2026-02-04",
          "endDate": "2026-02-04",
          "totalTokens": 1420287125277,
          "pricedTokens": 324802169325,
          "blendedPricePerMillion": 0.5070338969941396,
          "estimatedRetailValue": 164685.70966500515,
          "pricedTokenShare": 0.22868768120506164
        },
        {
          "key": "2026-02-05",
          "label": "02-05",
          "startDate": "2026-02-05",
          "endDate": "2026-02-05",
          "totalTokens": 1547174716353,
          "pricedTokens": 312593631710,
          "blendedPricePerMillion": 0.5170357445095899,
          "estimatedRetailValue": 161622.0811001364,
          "pricedTokenShare": 0.20204158483590376
        },
        {
          "key": "2026-02-06",
          "label": "02-06",
          "startDate": "2026-02-06",
          "endDate": "2026-02-06",
          "totalTokens": 1535426387252,
          "pricedTokens": 309252270454,
          "blendedPricePerMillion": 0.6062426161494531,
          "estimatedRetailValue": 187481.90549019116,
          "pricedTokenShare": 0.2014113297919012
        },
        {
          "key": "2026-02-07",
          "label": "02-07",
          "startDate": "2026-02-07",
          "endDate": "2026-02-07",
          "totalTokens": 1326326438380,
          "pricedTokens": 262976637979,
          "blendedPricePerMillion": 0.5973768290255901,
          "estimatedRetailValue": 157096.15010370556,
          "pricedTokenShare": 0.19827444463838376
        },
        {
          "key": "2026-02-08",
          "label": "02-08",
          "startDate": "2026-02-08",
          "endDate": "2026-02-08",
          "totalTokens": 1353520117412,
          "pricedTokens": 271740047002,
          "blendedPricePerMillion": 0.4964673277439621,
          "estimatedRetailValue": 134910.0549761016,
          "pricedTokenShare": 0.20076542897757657
        },
        {
          "key": "2026-02-09",
          "label": "02-09",
          "startDate": "2026-02-09",
          "endDate": "2026-02-09",
          "totalTokens": 1662970178669,
          "pricedTokens": 325052579487,
          "blendedPricePerMillion": 0.5743148214686581,
          "estimatedRetailValue": 186682.5141560032,
          "pricedTokenShare": 0.19546506825947055
        },
        {
          "key": "2026-02-10",
          "label": "02-10",
          "startDate": "2026-02-10",
          "endDate": "2026-02-10",
          "totalTokens": 1771510403773,
          "pricedTokens": 357854358723,
          "blendedPricePerMillion": 0.5105761567260315,
          "estimatedRetailValue": 182711.90314444795,
          "pricedTokenShare": 0.20200522557521214
        },
        {
          "key": "2026-02-11",
          "label": "02-11",
          "startDate": "2026-02-11",
          "endDate": "2026-02-11",
          "totalTokens": 1809075488850,
          "pricedTokens": 354266359605,
          "blendedPricePerMillion": 0.4962979241593983,
          "estimatedRetailValue": 175821.6588714684,
          "pricedTokenShare": 0.19582729509546415
        },
        {
          "key": "2026-02-12",
          "label": "02-12",
          "startDate": "2026-02-12",
          "endDate": "2026-02-12",
          "totalTokens": 1817254332924,
          "pricedTokens": 364861423339,
          "blendedPricePerMillion": 0.5617786183846403,
          "estimatedRetailValue": 204971.34630523677,
          "pricedTokenShare": 0.20077620216864767
        },
        {
          "key": "2026-02-13",
          "label": "02-13",
          "startDate": "2026-02-13",
          "endDate": "2026-02-13",
          "totalTokens": 2083944013080,
          "pricedTokens": 303447918595,
          "blendedPricePerMillion": 0.4928887669958888,
          "estimatedRetailValue": 149566.0704437584,
          "pricedTokenShare": 0.14561231812869774
        },
        {
          "key": "2026-02-14",
          "label": "02-14",
          "startDate": "2026-02-14",
          "endDate": "2026-02-14",
          "totalTokens": 1862446469657,
          "pricedTokens": 234985313141,
          "blendedPricePerMillion": 0.47906583142277875,
          "estimatedRetailValue": 112573.43441203519,
          "pricedTokenShare": 0.12617023735682262
        },
        {
          "key": "2026-02-15",
          "label": "02-15",
          "startDate": "2026-02-15",
          "endDate": "2026-02-15",
          "totalTokens": 2007429240268,
          "pricedTokens": 240441584863,
          "blendedPricePerMillion": 0.4671635607901163,
          "estimatedRetailValue": 112325.54694661801,
          "pricedTokenShare": 0.11977587057110918
        },
        {
          "key": "2026-02-16",
          "label": "02-16",
          "startDate": "2026-02-16",
          "endDate": "2026-02-16",
          "totalTokens": 2160683192236,
          "pricedTokens": 270478555047,
          "blendedPricePerMillion": 0.4782622428566925,
          "estimatedRetailValue": 129359.68038141559,
          "pricedTokenShare": 0.12518195912242605
        },
        {
          "key": "2026-02-17",
          "label": "02-17",
          "startDate": "2026-02-17",
          "endDate": "2026-02-17",
          "totalTokens": 2144256740309,
          "pricedTokens": 266639415296,
          "blendedPricePerMillion": 0.4711886485414099,
          "estimatedRetailValue": 125637.46574119398,
          "pricedTokenShare": 0.12435050816609568
        },
        {
          "key": "2026-02-18",
          "label": "02-18",
          "startDate": "2026-02-18",
          "endDate": "2026-02-18",
          "totalTokens": 2279287336434,
          "pricedTokens": 268694042250,
          "blendedPricePerMillion": 0.48193224161359305,
          "estimatedRetailValue": 129492.32208975998,
          "pricedTokenShare": 0.1178851116991587
        },
        {
          "key": "2026-02-19",
          "label": "02-19",
          "startDate": "2026-02-19",
          "endDate": "2026-02-19",
          "totalTokens": 2104731463727,
          "pricedTokens": 260431486578,
          "blendedPricePerMillion": 0.4845441363244176,
          "estimatedRetailValue": 126190.54973562119,
          "pricedTokenShare": 0.12373620628868025
        },
        {
          "key": "2026-02-20",
          "label": "02-20",
          "startDate": "2026-02-20",
          "endDate": "2026-02-20",
          "totalTokens": 1966780747786,
          "pricedTokens": 259388318452,
          "blendedPricePerMillion": 0.47465580317749995,
          "estimatedRetailValue": 123120.17062969519,
          "pricedTokenShare": 0.13188471503190824
        },
        {
          "key": "2026-02-21",
          "label": "02-21",
          "startDate": "2026-02-21",
          "endDate": "2026-02-21",
          "totalTokens": 1629087927199,
          "pricedTokens": 230098530417,
          "blendedPricePerMillion": 0.4988455836088731,
          "estimatedRetailValue": 114783.6356934124,
          "pricedTokenShare": 0.1412437760880248
        },
        {
          "key": "2026-02-22",
          "label": "02-22",
          "startDate": "2026-02-22",
          "endDate": "2026-02-22",
          "totalTokens": 1662900393801,
          "pricedTokens": 230128186700,
          "blendedPricePerMillion": 0.4820325606065829,
          "estimatedRetailValue": 110929.27910275078,
          "pricedTokenShare": 0.13838963990740358
        },
        {
          "key": "2026-02-23",
          "label": "02-23",
          "startDate": "2026-02-23",
          "endDate": "2026-02-23",
          "totalTokens": 1983658606716,
          "pricedTokens": 292760714931,
          "blendedPricePerMillion": 0.4736799786210301,
          "estimatedRetailValue": 138674.88918959358,
          "pricedTokenShare": 0.14758623985992894
        },
        {
          "key": "2026-02-24",
          "label": "02-24",
          "startDate": "2026-02-24",
          "endDate": "2026-02-24",
          "totalTokens": 2006814297660,
          "pricedTokens": 284618883865,
          "blendedPricePerMillion": 0.4925697873071687,
          "estimatedRetailValue": 140194.6630889868,
          "pricedTokenShare": 0.1418262188967227
        },
        {
          "key": "2026-02-25",
          "label": "02-25",
          "startDate": "2026-02-25",
          "endDate": "2026-02-25",
          "totalTokens": 2037235418073,
          "pricedTokens": 360333153980,
          "blendedPricePerMillion": 0.4838687607128423,
          "estimatedRetailValue": 174353.95666005238,
          "pricedTokenShare": 0.1768735958462942
        },
        {
          "key": "2026-02-26",
          "label": "02-26",
          "startDate": "2026-02-26",
          "endDate": "2026-02-26",
          "totalTokens": 2076458858606,
          "pricedTokens": 387322996726,
          "blendedPricePerMillion": 0.4848897066124792,
          "estimatedRetailValue": 187808.93424673637,
          "pricedTokenShare": 0.1865305421875893
        },
        {
          "key": "2026-02-27",
          "label": "02-27",
          "startDate": "2026-02-27",
          "endDate": "2026-02-27",
          "totalTokens": 2038016175860,
          "pricedTokens": 327191037974,
          "blendedPricePerMillion": 0.4714360308636341,
          "estimatedRetailValue": 154249.64427661514,
          "pricedTokenShare": 0.16054388667250508
        },
        {
          "key": "2026-02-28",
          "label": "02-28",
          "startDate": "2026-02-28",
          "endDate": "2026-02-28",
          "totalTokens": 1751323124477,
          "pricedTokens": 305176947028,
          "blendedPricePerMillion": 0.4904971404334183,
          "estimatedRetailValue": 149688.41984343476,
          "pricedTokenShare": 0.17425507763973333
        },
        {
          "key": "2026-03-01",
          "label": "03-01",
          "startDate": "2026-03-01",
          "endDate": "2026-03-01",
          "totalTokens": 1722164707664,
          "pricedTokens": 315849424181,
          "blendedPricePerMillion": 0.4683311489459738,
          "estimatedRetailValue": 147922.12372061197,
          "pricedTokenShare": 0.1834025646765392
        },
        {
          "key": "2026-03-02",
          "label": "03-02",
          "startDate": "2026-03-02",
          "endDate": "2026-03-02",
          "totalTokens": 2108128326245,
          "pricedTokens": 347965494741,
          "blendedPricePerMillion": 0.48694254370249124,
          "estimatedRetailValue": 169439.20312987838,
          "pricedTokenShare": 0.16505897217404997
        },
        {
          "key": "2026-03-03",
          "label": "03-03",
          "startDate": "2026-03-03",
          "endDate": "2026-03-03",
          "totalTokens": 2268386622510,
          "pricedTokens": 366745045853,
          "blendedPricePerMillion": 0.45717543210378564,
          "estimatedRetailValue": 167666.82480976795,
          "pricedTokenShare": 0.16167660407342366
        },
        {
          "key": "2026-03-04",
          "label": "03-04",
          "startDate": "2026-03-04",
          "endDate": "2026-03-04",
          "totalTokens": 2260829829411,
          "pricedTokens": 310661866970,
          "blendedPricePerMillion": 0.47326562581553133,
          "estimatedRetailValue": 147025.58288857838,
          "pricedTokenShare": 0.13741054852011345
        },
        {
          "key": "2026-03-05",
          "label": "03-05",
          "startDate": "2026-03-05",
          "endDate": "2026-03-05",
          "totalTokens": 2263159268676,
          "pricedTokens": 328332300367,
          "blendedPricePerMillion": 0.4597637976281843,
          "estimatedRetailValue": 150955.3053007296,
          "pricedTokenShare": 0.1450769748781675
        },
        {
          "key": "2026-03-06",
          "label": "03-06",
          "startDate": "2026-03-06",
          "endDate": "2026-03-06",
          "totalTokens": 2165761557067,
          "pricedTokens": 302669491316,
          "blendedPricePerMillion": 0.46154816236998514,
          "estimatedRetailValue": 139696.54752235799,
          "pricedTokenShare": 0.13975199177784492
        },
        {
          "key": "2026-03-07",
          "label": "03-07",
          "startDate": "2026-03-07",
          "endDate": "2026-03-07",
          "totalTokens": 1841412026810,
          "pricedTokens": 286932416472,
          "blendedPricePerMillion": 0.42843927999475334,
          "estimatedRetailValue": 122933.11792041839,
          "pricedTokenShare": 0.155821952009878
        },
        {
          "key": "2026-03-08",
          "label": "03-08",
          "startDate": "2026-03-08",
          "endDate": "2026-03-08",
          "totalTokens": 1881232524277,
          "pricedTokens": 290055836793,
          "blendedPricePerMillion": 0.43081737634547107,
          "estimatedRetailValue": 124961.09460085041,
          "pricedTokenShare": 0.15418393688705492
        },
        {
          "key": "2026-03-09",
          "label": "03-09",
          "startDate": "2026-03-09",
          "endDate": "2026-03-09",
          "totalTokens": 2245462665118,
          "pricedTokens": 293636555350,
          "blendedPricePerMillion": 0.47154396253949105,
          "estimatedRetailValue": 138462.5448561856,
          "pricedTokenShare": 0.13076884328182284
        },
        {
          "key": "2026-03-10",
          "label": "03-10",
          "startDate": "2026-03-10",
          "endDate": "2026-03-10",
          "totalTokens": 2405339612587,
          "pricedTokens": 332807626360,
          "blendedPricePerMillion": 0.4444560538411178,
          "estimatedRetailValue": 147918.36430019478,
          "pricedTokenShare": 0.13836201117648309
        },
        {
          "key": "2026-03-11",
          "label": "03-11",
          "startDate": "2026-03-11",
          "endDate": "2026-03-11",
          "totalTokens": 2484681242838,
          "pricedTokens": 328755291524,
          "blendedPricePerMillion": 0.48539235320996976,
          "estimatedRetailValue": 159575.304583064,
          "pricedTokenShare": 0.13231286406319714
        },
        {
          "key": "2026-03-12",
          "label": "03-12",
          "startDate": "2026-03-12",
          "endDate": "2026-03-12",
          "totalTokens": 2655470164902,
          "pricedTokens": 329860619022,
          "blendedPricePerMillion": 0.4688853416859806,
          "estimatedRetailValue": 154666.80905887956,
          "pricedTokenShare": 0.12421929019645886
        },
        {
          "key": "2026-03-13",
          "label": "03-13",
          "startDate": "2026-03-13",
          "endDate": "2026-03-13",
          "totalTokens": 2514918954523,
          "pricedTokens": 307419968201,
          "blendedPricePerMillion": 0.4712230555577294,
          "estimatedRetailValue": 144863.37675513522,
          "pricedTokenShare": 0.1222385189185183
        },
        {
          "key": "2026-03-14",
          "label": "03-14",
          "startDate": "2026-03-14",
          "endDate": "2026-03-14",
          "totalTokens": 2224615577009,
          "pricedTokens": 257868587082,
          "blendedPricePerMillion": 0.4432559002315322,
          "estimatedRetailValue": 114301.77270846517,
          "pricedTokenShare": 0.11591602151267179
        },
        {
          "key": "2026-03-15",
          "label": "03-15",
          "startDate": "2026-03-15",
          "endDate": "2026-03-15",
          "totalTokens": 2343986663642,
          "pricedTokens": 281590292579,
          "blendedPricePerMillion": 0.41588796097449005,
          "estimatedRetailValue": 117110.01261089038,
          "pricedTokenShare": 0.12013306088588209
        },
        {
          "key": "2026-03-16",
          "label": "03-16",
          "startDate": "2026-03-16",
          "endDate": "2026-03-16",
          "totalTokens": 2758882292355,
          "pricedTokens": 322618279473,
          "blendedPricePerMillion": 0.46215567334568025,
          "estimatedRetailValue": 149099.86818346917,
          "pricedTokenShare": 0.11693803696047174
        },
        {
          "key": "2026-03-17",
          "label": "03-17",
          "startDate": "2026-03-17",
          "endDate": "2026-03-17",
          "totalTokens": 3171494754112,
          "pricedTokens": 373666737435,
          "blendedPricePerMillion": 0.4807978413875318,
          "estimatedRetailValue": 179658.16075706962,
          "pricedTokenShare": 0.11782038641259696
        },
        {
          "key": "2026-03-18",
          "label": "03-18",
          "startDate": "2026-03-18",
          "endDate": "2026-03-18",
          "totalTokens": 3133273576581,
          "pricedTokens": 324969020753,
          "blendedPricePerMillion": 0.47559591745357843,
          "estimatedRetailValue": 154553.939569014,
          "pricedTokenShare": 0.10371549525132857
        },
        {
          "key": "2026-03-19",
          "label": "03-19",
          "startDate": "2026-03-19",
          "endDate": "2026-03-19",
          "totalTokens": 2978864222218,
          "pricedTokens": 313250387720,
          "blendedPricePerMillion": 0.5088596219773119,
          "estimatedRetailValue": 159400.4738794456,
          "pricedTokenShare": 0.10515765887669774
        },
        {
          "key": "2026-03-20",
          "label": "03-20",
          "startDate": "2026-03-20",
          "endDate": "2026-03-20",
          "totalTokens": 3024001630072,
          "pricedTokens": 297717993323,
          "blendedPricePerMillion": 0.4578749682398885,
          "estimatedRetailValue": 136317.61673721197,
          "pricedTokenShare": 0.09845166429884215
        },
        {
          "key": "2026-03-21",
          "label": "03-21",
          "startDate": "2026-03-21",
          "endDate": "2026-03-21",
          "totalTokens": 2573341237095,
          "pricedTokens": 280367937268,
          "blendedPricePerMillion": 0.409144600309166,
          "estimatedRetailValue": 114711.0276330212,
          "pricedTokenShare": 0.10895093632607483
        },
        {
          "key": "2026-03-22",
          "label": "03-22",
          "startDate": "2026-03-22",
          "endDate": "2026-03-22",
          "totalTokens": 2656937122098,
          "pricedTokens": 276942594437,
          "blendedPricePerMillion": 0.4376970370982672,
          "estimatedRetailValue": 121216.95303138196,
          "pricedTokenShare": 0.10423377811000568
        },
        {
          "key": "2026-03-23",
          "label": "03-23",
          "startDate": "2026-03-23",
          "endDate": "2026-03-23",
          "totalTokens": 3224952376065,
          "pricedTokens": 340080049887,
          "blendedPricePerMillion": 0.4344909651237202,
          "estimatedRetailValue": 147761.70909472555,
          "pricedTokenShare": 0.10545273549185136
        },
        {
          "key": "2026-03-24",
          "label": "03-24",
          "startDate": "2026-03-24",
          "endDate": "2026-03-24",
          "totalTokens": 3341805624432,
          "pricedTokens": 342463728978,
          "blendedPricePerMillion": 0.4388641255367683,
          "estimatedRetailValue": 150295.04494599078,
          "pricedTokenShare": 0.10247865000712239
        },
        {
          "key": "2026-03-25",
          "label": "03-25",
          "startDate": "2026-03-25",
          "endDate": "2026-03-25",
          "totalTokens": 3404484437033,
          "pricedTokens": 365491304023,
          "blendedPricePerMillion": 0.44074996524270454,
          "estimatedRetailValue": 161090.27954464802,
          "pricedTokenShare": 0.10735584514568226
        },
        {
          "key": "2026-03-26",
          "label": "03-26",
          "startDate": "2026-03-26",
          "endDate": "2026-03-26",
          "totalTokens": 3389941787812,
          "pricedTokens": 355995390912,
          "blendedPricePerMillion": 0.43310756683863094,
          "estimatedRetailValue": 154184.2975636636,
          "pricedTokenShare": 0.10501519294281841
        },
        {
          "key": "2026-03-27",
          "label": "03-27",
          "startDate": "2026-03-27",
          "endDate": "2026-03-27",
          "totalTokens": 3311872762246,
          "pricedTokens": 315747481688,
          "blendedPricePerMillion": 0.44490282746047577,
          "estimatedRetailValue": 140476.947366516,
          "pricedTokenShare": 0.09533804718810235
        },
        {
          "key": "2026-03-28",
          "label": "03-28",
          "startDate": "2026-03-28",
          "endDate": "2026-03-28",
          "totalTokens": 2967065408662,
          "pricedTokens": 281904190404,
          "blendedPricePerMillion": 0.41012314951810774,
          "estimatedRetailValue": 115615.4344308408,
          "pricedTokenShare": 0.09501111420766584
        },
        {
          "key": "2026-03-29",
          "label": "03-29",
          "startDate": "2026-03-29",
          "endDate": "2026-03-29",
          "totalTokens": 2999802045325,
          "pricedTokens": 298645244064,
          "blendedPricePerMillion": 0.4062191318301522,
          "estimatedRetailValue": 121315.41176888198,
          "pricedTokenShare": 0.09955498381282177
        },
        {
          "key": "2026-03-30",
          "label": "03-30",
          "startDate": "2026-03-30",
          "endDate": "2026-03-30",
          "totalTokens": 3462453510031,
          "pricedTokens": 333808223923,
          "blendedPricePerMillion": 0.45246787053482546,
          "estimatedRetailValue": 151037.496245452,
          "pricedTokenShare": 0.09640800171206092
        },
        {
          "key": "2026-03-31",
          "label": "03-31",
          "startDate": "2026-03-31",
          "endDate": "2026-03-31",
          "totalTokens": 4002410847181,
          "pricedTokens": 339818986534,
          "blendedPricePerMillion": 0.44709848551778025,
          "estimatedRetailValue": 151932.55422953836,
          "pricedTokenShare": 0.08490357424784194
        },
        {
          "key": "2026-04-01",
          "label": "04-01",
          "startDate": "2026-04-01",
          "endDate": "2026-04-01",
          "totalTokens": 4128332043182,
          "pricedTokens": 322801083813,
          "blendedPricePerMillion": 0.44894307155443103,
          "estimatedRetailValue": 144919.31006810756,
          "pricedTokenShare": 0.078191647482937
        },
        {
          "key": "2026-04-02",
          "label": "04-02",
          "startDate": "2026-04-02",
          "endDate": "2026-04-02",
          "totalTokens": 4043252964147,
          "pricedTokens": 313413095980,
          "blendedPricePerMillion": 0.4530000626101546,
          "estimatedRetailValue": 141976.15210178238,
          "pricedTokenShare": 0.07751508470015316
        },
        {
          "key": "2026-04-03",
          "label": "04-03",
          "startDate": "2026-04-03",
          "endDate": "2026-04-03",
          "totalTokens": 4091886418048,
          "pricedTokens": 301144131188,
          "blendedPricePerMillion": 0.44436021918761376,
          "estimatedRetailValue": 133816.4721417632,
          "pricedTokenShare": 0.07359542773713115
        },
        {
          "key": "2026-04-04",
          "label": "04-04",
          "startDate": "2026-04-04",
          "endDate": "2026-04-04",
          "totalTokens": 3630286680857,
          "pricedTokens": 316411911679,
          "blendedPricePerMillion": 0.3959607925219029,
          "estimatedRetailValue": 125286.71131178719,
          "pricedTokenShare": 0.0871589324742543
        },
        {
          "key": "2026-04-05",
          "label": "04-05",
          "startDate": "2026-04-05",
          "endDate": "2026-04-05",
          "totalTokens": 3646933937468,
          "pricedTokens": 361883487462,
          "blendedPricePerMillion": 0.359885026777263,
          "estimatedRetailValue": 130236.44857551118,
          "pricedTokenShare": 0.09922951544146948
        },
        {
          "key": "2026-04-06",
          "label": "04-06",
          "startDate": "2026-04-06",
          "endDate": "2026-04-06",
          "totalTokens": 3640817422688,
          "pricedTokens": 404694236117,
          "blendedPricePerMillion": 0.41502205422477134,
          "estimatedRetailValue": 167957.033206202,
          "pricedTokenShare": 0.11115477353934874
        },
        {
          "key": "2026-04-07",
          "label": "04-07",
          "startDate": "2026-04-07",
          "endDate": "2026-04-07",
          "totalTokens": 3732909598850,
          "pricedTokens": 412575622430,
          "blendedPricePerMillion": 0.41068722995218193,
          "estimatedRetailValue": 169439.53952157398,
          "pricedTokenShare": 0.11052387193011651
        },
        {
          "key": "2026-04-08",
          "label": "04-08",
          "startDate": "2026-04-08",
          "endDate": "2026-04-08",
          "totalTokens": 2999093024213,
          "pricedTokens": 420575387823,
          "blendedPricePerMillion": 0.41266822023871125,
          "estimatedRetailValue": 173558.09676912316,
          "pricedTokenShare": 0.14023419227996914
        },
        {
          "key": "2026-04-09",
          "label": "04-09",
          "startDate": "2026-04-09",
          "endDate": "2026-04-09",
          "totalTokens": 2988091808528,
          "pricedTokens": 428148817402,
          "blendedPricePerMillion": 0.4155698724651099,
          "estimatedRetailValue": 177925.74944383677,
          "pricedTokenShare": 0.1432850276487708
        },
        {
          "key": "2026-04-10",
          "label": "04-10",
          "startDate": "2026-04-10",
          "endDate": "2026-04-10",
          "totalTokens": 2859280425773,
          "pricedTokens": 352851300407,
          "blendedPricePerMillion": 0.43747790342552706,
          "estimatedRetailValue": 154364.64712302518,
          "pricedTokenShare": 0.12340562934172764
        },
        {
          "key": "2026-04-11",
          "label": "04-11",
          "startDate": "2026-04-11",
          "endDate": "2026-04-11",
          "totalTokens": 2374060726524,
          "pricedTokens": 305930601883,
          "blendedPricePerMillion": 0.42125689970502345,
          "estimatedRetailValue": 128875.3768741244,
          "pricedTokenShare": 0.128863848538083
        },
        {
          "key": "2026-04-12",
          "label": "04-12",
          "startDate": "2026-04-12",
          "endDate": "2026-04-12",
          "totalTokens": 2396592809199,
          "pricedTokens": 300488107338,
          "blendedPricePerMillion": 0.41796470315437506,
          "estimatedRetailValue": 125593.42258494717,
          "pricedTokenShare": 0.1253813773389525
        },
        {
          "key": "2026-04-13",
          "label": "04-13",
          "startDate": "2026-04-13",
          "endDate": "2026-04-13",
          "totalTokens": 2957241118970,
          "pricedTokens": 345576690538,
          "blendedPricePerMillion": 0.4278792891724176,
          "estimatedRetailValue": 147865.10870195596,
          "pricedTokenShare": 0.11685779976519586
        },
        {
          "key": "2026-04-14",
          "label": "04-14",
          "startDate": "2026-04-14",
          "endDate": "2026-04-14",
          "totalTokens": 3099977701607,
          "pricedTokens": 380260012011,
          "blendedPricePerMillion": 0.4165082974289423,
          "estimatedRetailValue": 158381.45018301075,
          "pricedTokenShare": 0.12266540233946738
        },
        {
          "key": "2026-04-15",
          "label": "04-15",
          "startDate": "2026-04-15",
          "endDate": "2026-04-15",
          "totalTokens": 3165298086565,
          "pricedTokens": 384753062672,
          "blendedPricePerMillion": 0.40945199795389753,
          "estimatedRetailValue": 157537.91022993156,
          "pricedTokenShare": 0.12155350053919764
        },
        {
          "key": "2026-04-16",
          "label": "04-16",
          "startDate": "2026-04-16",
          "endDate": "2026-04-16",
          "totalTokens": 3143783248585,
          "pricedTokens": 398894120612,
          "blendedPricePerMillion": 0.4037118567709164,
          "estimatedRetailValue": 161038.2860872724,
          "pricedTokenShare": 0.12688346780635723
        },
        {
          "key": "2026-04-17",
          "label": "04-17",
          "startDate": "2026-04-17",
          "endDate": "2026-04-17",
          "totalTokens": 3193988270600,
          "pricedTokens": 405872104835,
          "blendedPricePerMillion": 0.3793604261008301,
          "estimatedRetailValue": 153971.8146326464,
          "pricedTokenShare": 0.12707376184532942
        },
        {
          "key": "2026-04-18",
          "label": "04-18",
          "startDate": "2026-04-18",
          "endDate": "2026-04-18",
          "totalTokens": 2462023731465,
          "pricedTokens": 352080204684,
          "blendedPricePerMillion": 0.38209463712948444,
          "estimatedRetailValue": 134527.95804920758,
          "pricedTokenShare": 0.14300439113740734
        },
        {
          "key": "2026-04-19",
          "label": "04-19",
          "startDate": "2026-04-19",
          "endDate": "2026-04-19",
          "totalTokens": 2446960959409,
          "pricedTokens": 367752978547,
          "blendedPricePerMillion": 0.3726681620688072,
          "estimatedRetailValue": 137049.82661043998,
          "pricedTokenShare": 0.1502896795851705
        },
        {
          "key": "2026-04-20",
          "label": "04-20",
          "startDate": "2026-04-20",
          "endDate": "2026-04-20",
          "totalTokens": 3134848054628,
          "pricedTokens": 456999191398,
          "blendedPricePerMillion": 0.3669817986756795,
          "estimatedRetailValue": 167710.38525256916,
          "pricedTokenShare": 0.1457803323906971
        },
        {
          "key": "2026-04-21",
          "label": "04-21",
          "startDate": "2026-04-21",
          "endDate": "2026-04-21",
          "totalTokens": 3318896487438,
          "pricedTokens": 408623989143,
          "blendedPricePerMillion": 0.3856428812963123,
          "estimatedRetailValue": 157582.93253989957,
          "pricedTokenShare": 0.12312043797980411
        },
        {
          "key": "2026-04-22",
          "label": "04-22",
          "startDate": "2026-04-22",
          "endDate": "2026-04-22",
          "totalTokens": 3382408425312,
          "pricedTokens": 460649642806,
          "blendedPricePerMillion": 0.3864865836495976,
          "estimatedRetailValue": 178034.90670749836,
          "pricedTokenShare": 0.1361898342490998
        },
        {
          "key": "2026-04-23",
          "label": "04-23",
          "startDate": "2026-04-23",
          "endDate": "2026-04-23",
          "totalTokens": 3375402500504,
          "pricedTokens": 461795984041,
          "blendedPricePerMillion": 0.3634618895464696,
          "estimatedRetailValue": 167845.24094451318,
          "pricedTokenShare": 0.13681212358290507
        },
        {
          "key": "2026-04-24",
          "label": "04-24",
          "startDate": "2026-04-24",
          "endDate": "2026-04-24",
          "totalTokens": 3254035491146,
          "pricedTokens": 417566202325,
          "blendedPricePerMillion": 0.3789502260157778,
          "estimatedRetailValue": 158236.80674760876,
          "pricedTokenShare": 0.1283225716072145
        },
        {
          "key": "2026-04-25",
          "label": "04-25",
          "startDate": "2026-04-25",
          "endDate": "2026-04-25",
          "totalTokens": 2715048699378,
          "pricedTokens": 375559030439,
          "blendedPricePerMillion": 0.2859490723964623,
          "estimatedRetailValue": 107390.75638414679,
          "pricedTokenShare": 0.138324970202206
        },
        {
          "key": "2026-04-26",
          "label": "04-26",
          "startDate": "2026-04-26",
          "endDate": "2026-04-26",
          "totalTokens": 2702629991782,
          "pricedTokens": 398470690491,
          "blendedPricePerMillion": 0.2783198708371904,
          "estimatedRetailValue": 110902.31110986118,
          "pricedTokenShare": 0.14743812201546141
        },
        {
          "key": "2026-04-27",
          "label": "04-27",
          "startDate": "2026-04-27",
          "endDate": "2026-04-27",
          "totalTokens": 3405122588401,
          "pricedTokens": 441747383790,
          "blendedPricePerMillion": 0.2847029679350559,
          "estimatedRetailValue": 125766.7912425592,
          "pricedTokenShare": 0.12973024386691426
        },
        {
          "key": "2026-04-28",
          "label": "04-28",
          "startDate": "2026-04-28",
          "endDate": "2026-04-28",
          "totalTokens": 3630994099588,
          "pricedTokens": 445841942091,
          "blendedPricePerMillion": 0.3704657044322215,
          "estimatedRetailValue": 165169.149142172,
          "pricedTokenShare": 0.12278784538415763
        },
        {
          "key": "2026-04-29",
          "label": "04-29",
          "startDate": "2026-04-29",
          "endDate": "2026-04-29",
          "totalTokens": 3712741085065,
          "pricedTokens": 424441812894,
          "blendedPricePerMillion": 0.3097170187760149,
          "estimatedRetailValue": 131456.85293341678,
          "pricedTokenShare": 0.11432033723045602
        },
        {
          "key": "2026-04-30",
          "label": "04-30",
          "startDate": "2026-04-30",
          "endDate": "2026-04-30",
          "totalTokens": 3509604277501,
          "pricedTokens": 405782921439,
          "blendedPricePerMillion": 0.3831888721655046,
          "estimatedRetailValue": 155491.50001023398,
          "pricedTokenShare": 0.11562070517190506
        },
        {
          "key": "2026-05-01",
          "label": "05-01",
          "startDate": "2026-05-01",
          "endDate": "2026-05-01",
          "totalTokens": 3324394613506,
          "pricedTokens": 366814972075,
          "blendedPricePerMillion": 0.295378205383481,
          "estimatedRetailValue": 108349.14815930519,
          "pricedTokenShare": 0.11034038215100662
        },
        {
          "key": "2026-05-02",
          "label": "05-02",
          "startDate": "2026-05-02",
          "endDate": "2026-05-02",
          "totalTokens": 3015068636931,
          "pricedTokens": 347240482585,
          "blendedPricePerMillion": 0.37687245473937225,
          "estimatedRetailValue": 130865.37305669319,
          "pricedTokenShare": 0.11516835084008292
        },
        {
          "key": "2026-05-03",
          "label": "05-03",
          "startDate": "2026-05-03",
          "endDate": "2026-05-03",
          "totalTokens": 3199831512578,
          "pricedTokens": 368207873937,
          "blendedPricePerMillion": 0.3579187761009675,
          "estimatedRetailValue": 131788.51159027038,
          "pricedTokenShare": 0.11507101936137472
        },
        {
          "key": "2026-05-04",
          "label": "05-04",
          "startDate": "2026-05-04",
          "endDate": "2026-05-04",
          "totalTokens": 3771624160550,
          "pricedTokens": 441004237589,
          "blendedPricePerMillion": 0.2918217941884593,
          "estimatedRetailValue": 128694.64785793558,
          "pricedTokenShare": 0.11692687786915922
        },
        {
          "key": "2026-05-05",
          "label": "05-05",
          "startDate": "2026-05-05",
          "endDate": "2026-05-05",
          "totalTokens": 3943247540034,
          "pricedTokens": 432520208497,
          "blendedPricePerMillion": 0.3850675915594311,
          "estimatedRetailValue": 166549.5149867228,
          "pricedTokenShare": 0.10968629387473622
        },
        {
          "key": "2026-05-06",
          "label": "05-06",
          "startDate": "2026-05-06",
          "endDate": "2026-05-06",
          "totalTokens": 3971715385948,
          "pricedTokens": 418734206937,
          "blendedPricePerMillion": 0.2918510013473549,
          "estimatedRetailValue": 122207.99759295398,
          "pricedTokenShare": 0.10542905677946841
        },
        {
          "key": "2026-05-07",
          "label": "05-07",
          "startDate": "2026-05-07",
          "endDate": "2026-05-07",
          "totalTokens": 3908273660198,
          "pricedTokens": 410311005826,
          "blendedPricePerMillion": 0.404741331856324,
          "estimatedRetailValue": 166069.82297332314,
          "pricedTokenShare": 0.10498522915747228
        },
        {
          "key": "2026-05-08",
          "label": "05-08",
          "startDate": "2026-05-08",
          "endDate": "2026-05-08",
          "totalTokens": 3795872616373,
          "pricedTokens": 384570784478,
          "blendedPricePerMillion": 0.39220916972269854,
          "estimatedRetailValue": 150832.18807972322,
          "pricedTokenShare": 0.10131287936776494
        },
        {
          "key": "2026-05-09",
          "label": "05-09",
          "startDate": "2026-05-09",
          "endDate": "2026-05-09",
          "totalTokens": 3175234843463,
          "pricedTokens": 353638224597,
          "blendedPricePerMillion": 0.3668023851107592,
          "estimatedRetailValue": 129715.34424851395,
          "pricedTokenShare": 0.1113738800533293
        },
        {
          "key": "2026-05-10",
          "label": "05-10",
          "startDate": "2026-05-10",
          "endDate": "2026-05-10",
          "totalTokens": 3165820373012,
          "pricedTokens": 360630395642,
          "blendedPricePerMillion": 0.36420732123397553,
          "estimatedRetailValue": 131344.23035232158,
          "pricedTokenShare": 0.11391372634919646
        },
        {
          "key": "2026-05-11",
          "label": "05-11",
          "startDate": "2026-05-11",
          "endDate": "2026-05-11",
          "totalTokens": 3904460018777,
          "pricedTokens": 412749880233,
          "blendedPricePerMillion": 0.3026055562943487,
          "estimatedRetailValue": 124900.40711833278,
          "pricedTokenShare": 0.10571241048647907
        },
        {
          "key": "2026-05-12",
          "label": "05-12",
          "startDate": "2026-05-12",
          "endDate": "2026-05-12",
          "totalTokens": 4090688100171,
          "pricedTokens": 430360031650,
          "blendedPricePerMillion": 0.3034675694156321,
          "estimatedRetailValue": 130600.31277846,
          "pricedTokenShare": 0.10520480200678463
        },
        {
          "key": "2026-05-13",
          "label": "05-13",
          "startDate": "2026-05-13",
          "endDate": "2026-05-13",
          "totalTokens": 4158854730105,
          "pricedTokens": 436170263257,
          "blendedPricePerMillion": 0.29363114036339333,
          "estimatedRetailValue": 128073.17179275438,
          "pricedTokenShare": 0.104877494301415
        },
        {
          "key": "2026-05-14",
          "label": "05-14",
          "startDate": "2026-05-14",
          "endDate": "2026-05-14",
          "totalTokens": 4054631694946,
          "pricedTokens": 421437443070,
          "blendedPricePerMillion": 0.3059279710992993,
          "estimatedRetailValue": 128929.50190368156,
          "pricedTokenShare": 0.10393975945961048
        },
        {
          "key": "2026-05-15",
          "label": "05-15",
          "startDate": "2026-05-15",
          "endDate": "2026-05-15",
          "totalTokens": 4058162821358,
          "pricedTokens": 419181140976,
          "blendedPricePerMillion": 0.28221993178953647,
          "estimatedRetailValue": 118301.27301370678,
          "pricedTokenShare": 0.1032933274066435
        },
        {
          "key": "2026-05-16",
          "label": "05-16",
          "startDate": "2026-05-16",
          "endDate": "2026-05-16",
          "totalTokens": 3258661754494,
          "pricedTokens": 397390079572,
          "blendedPricePerMillion": 0.2744035486662784,
          "estimatedRetailValue": 109045.24803933156,
          "pricedTokenShare": 0.12194885800097596
        },
        {
          "key": "2026-05-17",
          "label": "05-17",
          "startDate": "2026-05-17",
          "endDate": "2026-05-17",
          "totalTokens": 3380223252621,
          "pricedTokens": 389859976885,
          "blendedPricePerMillion": 0.25977900597472764,
          "estimatedRetailValue": 101277.43726451558,
          "pricedTokenShare": 0.11533557038953136
        },
        {
          "key": "2026-05-18",
          "label": "05-18",
          "startDate": "2026-05-18",
          "endDate": "2026-05-18",
          "totalTokens": 4054837875343,
          "pricedTokens": 442959102115,
          "blendedPricePerMillion": 0.2789964153703838,
          "estimatedRetailValue": 123584.00164576877,
          "pricedTokenShare": 0.10924212403375806
        },
        {
          "key": "2026-05-19",
          "label": "05-19",
          "startDate": "2026-05-19",
          "endDate": "2026-05-19",
          "totalTokens": 4209273652355,
          "pricedTokens": 458886682911,
          "blendedPricePerMillion": 0.28429739555549066,
          "estimatedRetailValue": 130460.2888066956,
          "pricedTokenShare": 0.1090180208773698
        },
        {
          "key": "2026-05-20",
          "label": "05-20",
          "startDate": "2026-05-20",
          "endDate": "2026-05-20",
          "totalTokens": 4430559668843,
          "pricedTokens": 465655413268,
          "blendedPricePerMillion": 0.2837489673208795,
          "estimatedRetailValue": 132129.24264217238,
          "pricedTokenShare": 0.10510081074917599
        },
        {
          "key": "2026-05-21",
          "label": "05-21",
          "startDate": "2026-05-21",
          "endDate": "2026-05-21",
          "totalTokens": 4404565910297,
          "pricedTokens": 470356500030,
          "blendedPricePerMillion": 0.30073023408124955,
          "estimatedRetailValue": 141450.42035565915,
          "pricedTokenShare": 0.10678838950517233
        },
        {
          "key": "2026-05-22",
          "label": "05-22",
          "startDate": "2026-05-22",
          "endDate": "2026-05-22",
          "totalTokens": 4542455074756,
          "pricedTokens": 447553309905,
          "blendedPricePerMillion": 0.28835074601631805,
          "estimatedRetailValue": 129052.33079317915,
          "pricedTokenShare": 0.09852674435729901
        },
        {
          "key": "2026-05-23",
          "label": "05-23",
          "startDate": "2026-05-23",
          "endDate": "2026-05-23",
          "totalTokens": 3552676202089,
          "pricedTokens": 377766149292,
          "blendedPricePerMillion": 0.29361004218253095,
          "estimatedRetailValue": 110915.93502875639,
          "pricedTokenShare": 0.10633283975327408
        },
        {
          "key": "2026-05-24",
          "label": "05-24",
          "startDate": "2026-05-24",
          "endDate": "2026-05-24",
          "totalTokens": 3725836527145,
          "pricedTokens": 374318928576,
          "blendedPricePerMillion": 0.2861724307139335,
          "estimatedRetailValue": 107119.7576528292,
          "pricedTokenShare": 0.10046574127685352
        },
        {
          "key": "2026-05-25",
          "label": "05-25",
          "startDate": "2026-05-25",
          "endDate": "2026-05-25",
          "totalTokens": 4239156680433,
          "pricedTokens": 334118640704,
          "blendedPricePerMillion": 0.30617719851916214,
          "estimatedRetailValue": 102299.5093837812,
          "pricedTokenShare": 0.07881724264786366
        },
        {
          "key": "2026-05-26",
          "label": "05-26",
          "startDate": "2026-05-26",
          "endDate": "2026-05-26",
          "totalTokens": 4946042261303,
          "pricedTokens": 338374036775,
          "blendedPricePerMillion": 0.3291920998109858,
          "estimatedRetailValue": 111390.05968748197,
          "pricedTokenShare": 0.06841309048699025
        },
        {
          "key": "2026-05-27",
          "label": "05-27",
          "startDate": "2026-05-27",
          "endDate": "2026-05-27",
          "totalTokens": 4706418054828,
          "pricedTokens": 340007495322,
          "blendedPricePerMillion": 0.32670425514841434,
          "estimatedRetailValue": 111081.89550405198,
          "pricedTokenShare": 0.07224336881276601
        },
        {
          "key": "2026-05-28",
          "label": "05-28",
          "startDate": "2026-05-28",
          "endDate": "2026-05-28",
          "totalTokens": 4986780759242,
          "pricedTokens": 345071949979,
          "blendedPricePerMillion": 0.33052456902776534,
          "estimatedRetailValue": 114054.75755037957,
          "pricedTokenShare": 0.0691973372479787
        },
        {
          "key": "2026-05-29",
          "label": "05-29",
          "startDate": "2026-05-29",
          "endDate": "2026-05-29",
          "totalTokens": 4685825847136,
          "pricedTokens": 320737146540,
          "blendedPricePerMillion": 0.3380939870988203,
          "estimatedRetailValue": 108439.3006844072,
          "pricedTokenShare": 0.0684483711096596
        },
        {
          "key": "2026-05-30",
          "label": "05-30",
          "startDate": "2026-05-30",
          "endDate": "2026-05-30",
          "totalTokens": 4040118442007,
          "pricedTokens": 311381499354,
          "blendedPricePerMillion": 0.3050883204498425,
          "estimatedRetailValue": 94998.85865706558,
          "pricedTokenShare": 0.07707236899701281
        },
        {
          "key": "2026-05-31",
          "label": "05-31",
          "startDate": "2026-05-31",
          "endDate": "2026-05-31",
          "totalTokens": 4203405742573,
          "pricedTokens": 308693619815,
          "blendedPricePerMillion": 0.30585192594848637,
          "estimatedRetailValue": 94414.53814842759,
          "pricedTokenShare": 0.07343892993447776
        },
        {
          "key": "2026-06-01",
          "label": "06-01",
          "startDate": "2026-06-01",
          "endDate": "2026-06-01",
          "totalTokens": 4708382774313,
          "pricedTokens": 389503410761,
          "blendedPricePerMillion": 0.32912856205133906,
          "estimatedRetailValue": 128196.69749785999,
          "pricedTokenShare": 0.08272551944713807
        },
        {
          "key": "2026-06-02",
          "label": "06-02",
          "startDate": "2026-06-02",
          "endDate": "2026-06-02",
          "totalTokens": 4880205168494,
          "pricedTokens": 413519984760,
          "blendedPricePerMillion": 0.32859813325595066,
          "estimatedRetailValue": 135881.89505616517,
          "pricedTokenShare": 0.084734139341033
        },
        {
          "key": "2026-06-03",
          "label": "06-03",
          "startDate": "2026-06-03",
          "endDate": "2026-06-03",
          "totalTokens": 5561024317533,
          "pricedTokens": 411767244801,
          "blendedPricePerMillion": 0.3211436418481416,
          "estimatedRetailValue": 132236.4325891684,
          "pricedTokenShare": 0.07404521564539203
        },
        {
          "key": "2026-06-04",
          "label": "06-04",
          "startDate": "2026-06-04",
          "endDate": "2026-06-04",
          "totalTokens": 5413561492983,
          "pricedTokens": 359009403584,
          "blendedPricePerMillion": 0.32883363863615556,
          "estimatedRetailValue": 118054.36848512279,
          "pricedTokenShare": 0.06631667600882415
        },
        {
          "key": "2026-06-05",
          "label": "06-05",
          "startDate": "2026-06-05",
          "endDate": "2026-06-05",
          "totalTokens": 5437258364130,
          "pricedTokens": 373852391468,
          "blendedPricePerMillion": 0.3130823965303778,
          "estimatedRetailValue": 117046.6026694144,
          "pricedTokenShare": 0.0687575182989891
        },
        {
          "key": "2026-06-06",
          "label": "06-06",
          "startDate": "2026-06-06",
          "endDate": "2026-06-06",
          "totalTokens": 4818437093981,
          "pricedTokens": 279551670498,
          "blendedPricePerMillion": 0.32913554404538264,
          "estimatedRetailValue": 92010.39115815477,
          "pricedTokenShare": 0.05801708418009749
        },
        {
          "key": "2026-06-07",
          "label": "06-07",
          "startDate": "2026-06-07",
          "endDate": "2026-06-07",
          "totalTokens": 5307236051473,
          "pricedTokens": 255067281781,
          "blendedPricePerMillion": 0.3317492860162609,
          "estimatedRetailValue": 84618.38861695518,
          "pricedTokenShare": 0.04806028586390221
        },
        {
          "key": "2026-06-08",
          "label": "06-08",
          "startDate": "2026-06-08",
          "endDate": "2026-06-08",
          "totalTokens": 6524371265241,
          "pricedTokens": 349672075262,
          "blendedPricePerMillion": 0.34732335894971894,
          "estimatedRetailValue": 121449.27971091676,
          "pricedTokenShare": 0.0535947543520247
        },
        {
          "key": "2026-06-09",
          "label": "06-09",
          "startDate": "2026-06-09",
          "endDate": "2026-06-09",
          "totalTokens": 6430016419489,
          "pricedTokens": 332542370326,
          "blendedPricePerMillion": 0.34601656351361354,
          "estimatedRetailValue": 115065.16820287399,
          "pricedTokenShare": 0.05171718836021689
        },
        {
          "key": "2026-06-10",
          "label": "06-10",
          "startDate": "2026-06-10",
          "endDate": "2026-06-10",
          "totalTokens": 6700137711587,
          "pricedTokens": 345473292701,
          "blendedPricePerMillion": 0.3436490735229395,
          "estimatedRetailValue": 118721.57696361796,
          "pricedTokenShare": 0.05156211820893617
        },
        {
          "key": "2026-06-11",
          "label": "06-11",
          "startDate": "2026-06-11",
          "endDate": "2026-06-11",
          "totalTokens": 6929033546007,
          "pricedTokens": 383137114723,
          "blendedPricePerMillion": 0.33724639544965207,
          "estimatedRetailValue": 129211.61090331156,
          "pricedTokenShare": 0.0552944522752081
        },
        {
          "key": "2026-06-12",
          "label": "06-12",
          "startDate": "2026-06-12",
          "endDate": "2026-06-12",
          "totalTokens": 6768735721061,
          "pricedTokens": 379611930884,
          "blendedPricePerMillion": 0.32109149055956143,
          "estimatedRetailValue": 121890.16072173677,
          "pricedTokenShare": 0.05608313672268708
        },
        {
          "key": "2026-06-13",
          "label": "06-13",
          "startDate": "2026-06-13",
          "endDate": "2026-06-13",
          "totalTokens": 5669527799352,
          "pricedTokens": 307598754882,
          "blendedPricePerMillion": 0.3138693371138312,
          "estimatedRetailValue": 96545.8172918532,
          "pricedTokenShare": 0.05425473968346307
        },
        {
          "key": "2026-06-14",
          "label": "06-14",
          "startDate": "2026-06-14",
          "endDate": "2026-06-14",
          "totalTokens": 5583989560133,
          "pricedTokens": 318054689592,
          "blendedPricePerMillion": 0.307783777576838,
          "estimatedRetailValue": 97892.07383865438,
          "pricedTokenShare": 0.05695832453963695
        },
        {
          "key": "2026-06-15",
          "label": "06-15",
          "startDate": "2026-06-15",
          "endDate": "2026-06-15",
          "totalTokens": 6398466710994,
          "pricedTokens": 338765410543,
          "blendedPricePerMillion": 0.3248959729427567,
          "estimatedRetailValue": 110063.51765772038,
          "pricedTokenShare": 0.05294477971744779
        },
        {
          "key": "2026-06-16",
          "label": "06-16",
          "startDate": "2026-06-16",
          "endDate": "2026-06-16",
          "totalTokens": 7019551287662,
          "pricedTokens": 374400339850,
          "blendedPricePerMillion": 0.323340961090423,
          "estimatedRetailValue": 121058.96571967998,
          "pricedTokenShare": 0.053336790986636046
        },
        {
          "key": "2026-06-17",
          "label": "06-17",
          "startDate": "2026-06-17",
          "endDate": "2026-06-17",
          "totalTokens": 7760783359332,
          "pricedTokens": 385203350624,
          "blendedPricePerMillion": 0.3480601130294388,
          "estimatedRetailValue": 134073.92175750798,
          "pricedTokenShare": 0.04963459650768501
        },
        {
          "key": "2026-06-18",
          "label": "06-18",
          "startDate": "2026-06-18",
          "endDate": "2026-06-18",
          "totalTokens": 7306047428112,
          "pricedTokens": 347280272651,
          "blendedPricePerMillion": 0.3327347030049058,
          "estimatedRetailValue": 115552.19837999319,
          "pricedTokenShare": 0.04753326283028836
        },
        {
          "key": "2026-06-19",
          "label": "06-19",
          "startDate": "2026-06-19",
          "endDate": "2026-06-19",
          "totalTokens": 6557231537116,
          "pricedTokens": 311398663352,
          "blendedPricePerMillion": 0.3238705042024242,
          "estimatedRetailValue": 100852.84210777319,
          "pricedTokenShare": 0.047489349977865705
        },
        {
          "key": "2026-06-20",
          "label": "06-20",
          "startDate": "2026-06-20",
          "endDate": "2026-06-20",
          "totalTokens": 5830058052003,
          "pricedTokens": 309171948361,
          "blendedPricePerMillion": 0.2963212622918403,
          "estimatedRetailValue": 91614.22200355919,
          "pricedTokenShare": 0.05303068093031759
        },
        {
          "key": "2026-06-21",
          "label": "06-21",
          "startDate": "2026-06-21",
          "endDate": "2026-06-21",
          "totalTokens": 5775767190996,
          "pricedTokens": 322754809625,
          "blendedPricePerMillion": 0.3199400528279579,
          "estimatedRetailValue": 103262.1908419,
          "pricedTokenShare": 0.05588085512313433
        },
        {
          "key": "2026-06-22",
          "label": "06-22",
          "startDate": "2026-06-22",
          "endDate": "2026-06-22",
          "totalTokens": 6924964211885,
          "pricedTokens": 350570358593,
          "blendedPricePerMillion": 0.31868399374802125,
          "estimatedRetailValue": 111721.16196609319,
          "pricedTokenShare": 0.05062414012065681
        },
        {
          "key": "2026-06-23",
          "label": "06-23",
          "startDate": "2026-06-23",
          "endDate": "2026-06-23",
          "totalTokens": 7148395020746,
          "pricedTokens": 341304761409,
          "blendedPricePerMillion": 0.324978340866968,
          "estimatedRetailValue": 110916.65509269318,
          "pricedTokenShare": 0.04774564925671689
        },
        {
          "key": "2026-06-24",
          "label": "06-24",
          "startDate": "2026-06-24",
          "endDate": "2026-06-24",
          "totalTokens": 7249457010532,
          "pricedTokens": 320370347144,
          "blendedPricePerMillion": 0.33598442597118966,
          "estimatedRetailValue": 107639.44718336759,
          "pricedTokenShare": 0.04419232318759411
        },
        {
          "key": "2026-06-25",
          "label": "06-25",
          "startDate": "2026-06-25",
          "endDate": "2026-06-25",
          "totalTokens": 6972685667926,
          "pricedTokens": 342344611867,
          "blendedPricePerMillion": 0.43574596013026956,
          "estimatedRetailValue": 149175.2815934104,
          "pricedTokenShare": 0.0490979556760701
        },
        {
          "key": "2026-06-26",
          "label": "06-26",
          "startDate": "2026-06-26",
          "endDate": "2026-06-26",
          "totalTokens": 6781230881257,
          "pricedTokens": 357111533635,
          "blendedPricePerMillion": 0.428035637855032,
          "estimatedRetailValue": 152856.46308484595,
          "pricedTokenShare": 0.05266175711876133
        },
        {
          "key": "2026-06-27",
          "label": "06-27",
          "startDate": "2026-06-27",
          "endDate": "2026-06-27",
          "totalTokens": 5693223633861,
          "pricedTokens": 254833589342,
          "blendedPricePerMillion": 0.3126020110380131,
          "estimatedRetailValue": 79661.49250834438,
          "pricedTokenShare": 0.044760860582808044
        },
        {
          "key": "2026-06-28",
          "label": "06-28",
          "startDate": "2026-06-28",
          "endDate": "2026-06-28",
          "totalTokens": 5950391766228,
          "pricedTokens": 272380344490,
          "blendedPricePerMillion": 0.2930522763043429,
          "estimatedRetailValue": 79821.67997335558,
          "pricedTokenShare": 0.045775195178898956
        },
        {
          "key": "2026-06-29",
          "label": "06-29",
          "startDate": "2026-06-29",
          "endDate": "2026-06-29",
          "totalTokens": 7085048648169,
          "pricedTokens": 326517407120,
          "blendedPricePerMillion": 0.3364326029030411,
          "estimatedRetailValue": 109851.10117053357,
          "pricedTokenShare": 0.04608541498220797
        },
        {
          "key": "2026-06-30",
          "label": "06-30",
          "startDate": "2026-06-30",
          "endDate": "2026-06-30",
          "totalTokens": 7167154681834,
          "pricedTokens": 332685640457,
          "blendedPricePerMillion": 0.330787523453479,
          "estimatedRetailValue": 110048.25909530558,
          "pricedTokenShare": 0.04641809131038166
        },
        {
          "key": "2026-07-01",
          "label": "07-01",
          "startDate": "2026-07-01",
          "endDate": "2026-07-01",
          "totalTokens": 6977198358528,
          "pricedTokens": 355145708556,
          "blendedPricePerMillion": 0.4469817254868431,
          "estimatedRetailValue": 158743.64160960837,
          "pricedTokenShare": 0.05090090467643321
        },
        {
          "key": "2026-07-02",
          "label": "07-02",
          "startDate": "2026-07-02",
          "endDate": "2026-07-02",
          "totalTokens": 6974615024174,
          "pricedTokens": 352276585277,
          "blendedPricePerMillion": 0.34169066420274646,
          "estimatedRetailValue": 120369.62040637358,
          "pricedTokenShare": 0.05050839136726689
        },
        {
          "key": "2026-07-03",
          "label": "07-03",
          "startDate": "2026-07-03",
          "endDate": "2026-07-03",
          "totalTokens": 6991826989221,
          "pricedTokens": 382553938546,
          "blendedPricePerMillion": 0.3101121911059222,
          "estimatedRetailValue": 118634.64009870036,
          "pricedTokenShare": 0.05471444575727732
        },
        {
          "key": "2026-07-04",
          "label": "07-04",
          "startDate": "2026-07-04",
          "endDate": "2026-07-04",
          "totalTokens": 5714894093924,
          "pricedTokens": 304585484471,
          "blendedPricePerMillion": 0.30974327892752,
          "estimatedRetailValue": 94343.30667377477,
          "pricedTokenShare": 0.053296785463589125
        },
        {
          "key": "2026-07-05",
          "label": "07-05",
          "startDate": "2026-07-05",
          "endDate": "2026-07-05",
          "totalTokens": 5809000468188,
          "pricedTokens": 333161360748,
          "blendedPricePerMillion": 0.28813935532088275,
          "estimatedRetailValue": 95996.89970375678,
          "pricedTokenShare": 0.057352613857151735
        },
        {
          "key": "2026-07-06",
          "label": "07-06",
          "startDate": "2026-07-06",
          "endDate": "2026-07-06",
          "totalTokens": 7153369575731,
          "pricedTokens": 380696269741,
          "blendedPricePerMillion": 0.3053613992125696,
          "estimatedRetailValue": 116249.94560311758,
          "pricedTokenShare": 0.05321915297548384
        },
        {
          "key": "2026-07-07",
          "label": "07-07",
          "startDate": "2026-07-07",
          "endDate": "2026-07-07",
          "totalTokens": 7795823788771,
          "pricedTokens": 359596332441,
          "blendedPricePerMillion": 0.31489742164215456,
          "estimatedRetailValue": 113235.95791764597,
          "pricedTokenShare": 0.04612679072594711
        },
        {
          "key": "2026-07-08",
          "label": "07-08",
          "startDate": "2026-07-08",
          "endDate": "2026-07-08",
          "totalTokens": 7866992584618,
          "pricedTokens": 404462163123,
          "blendedPricePerMillion": 0.30320256539012885,
          "estimatedRetailValue": 122633.96546213438,
          "pricedTokenShare": 0.05141255171815312
        },
        {
          "key": "2026-07-09",
          "label": "07-09",
          "startDate": "2026-07-09",
          "endDate": "2026-07-09",
          "totalTokens": 7769244336449,
          "pricedTokens": 356738881956,
          "blendedPricePerMillion": 0.3115003535287527,
          "estimatedRetailValue": 111124.28784674598,
          "pricedTokenShare": 0.04591680561291892
        },
        {
          "key": "2026-07-10",
          "label": "07-10",
          "startDate": "2026-07-10",
          "endDate": "2026-07-10",
          "totalTokens": 7814025791624,
          "pricedTokens": 346348830899,
          "blendedPricePerMillion": 0.30847846243733124,
          "estimatedRetailValue": 106841.15482269078,
          "pricedTokenShare": 0.04432399382022232
        },
        {
          "key": "2026-07-11",
          "label": "07-11",
          "startDate": "2026-07-11",
          "endDate": "2026-07-11",
          "totalTokens": 7239751697474,
          "pricedTokens": 306788687474,
          "blendedPricePerMillion": 0.32169984376404553,
          "estimatedRetailValue": 98693.87282896238,
          "pricedTokenShare": 0.042375581414075394
        },
        {
          "key": "2026-07-12",
          "label": "07-12",
          "startDate": "2026-07-12",
          "endDate": "2026-07-12",
          "totalTokens": 6980460924641,
          "pricedTokens": 256447426996,
          "blendedPricePerMillion": 0.3142636621783311,
          "estimatedRetailValue": 80592.10756397319,
          "pricedTokenShare": 0.03673789306530484
        },
        {
          "key": "2026-07-13",
          "label": "07-13",
          "startDate": "2026-07-13",
          "endDate": "2026-07-13",
          "totalTokens": 8945200747827,
          "pricedTokens": 344322157451,
          "blendedPricePerMillion": 0.3116081263043862,
          "estimatedRetailValue": 107293.58232838997,
          "pricedTokenShare": 0.03849239018304245
        },
        {
          "key": "2026-07-14",
          "label": "07-14",
          "startDate": "2026-07-14",
          "endDate": "2026-07-14",
          "totalTokens": 9313408516626,
          "pricedTokens": 381261705780,
          "blendedPricePerMillion": 0.29944316843843605,
          "estimatedRetailValue": 114166.213183006,
          "pricedTokenShare": 0.04093686055963117
        },
        {
          "key": "2026-07-15",
          "label": "07-15",
          "startDate": "2026-07-15",
          "endDate": "2026-07-15",
          "totalTokens": 9480961115469,
          "pricedTokens": 380340035356,
          "blendedPricePerMillion": 0.30014807093275486,
          "estimatedRetailValue": 114158.32791059918,
          "pricedTokenShare": 0.040116189774836504
        },
        {
          "key": "2026-07-16",
          "label": "07-16",
          "startDate": "2026-07-16",
          "endDate": "2026-07-16",
          "totalTokens": 9619203914649,
          "pricedTokens": 373096532303,
          "blendedPricePerMillion": 0.311310591993996,
          "estimatedRetailValue": 116148.90234215398,
          "pricedTokenShare": 0.038786633032575034
        },
        {
          "key": "2026-07-17",
          "label": "07-17",
          "startDate": "2026-07-17",
          "endDate": "2026-07-17",
          "totalTokens": 9621566458152,
          "pricedTokens": 323445728681,
          "blendedPricePerMillion": 0.34587580882518176,
          "estimatedRetailValue": 111872.05301859118,
          "pricedTokenShare": 0.033616743187067664
        },
        {
          "key": "2026-07-18",
          "label": "07-18",
          "startDate": "2026-07-18",
          "endDate": "2026-07-18",
          "totalTokens": 8050764751145,
          "pricedTokens": 286545708307,
          "blendedPricePerMillion": 0.3098963384566702,
          "estimatedRetailValue": 88799.46580481237,
          "pricedTokenShare": 0.03559235888320383
        },
        {
          "key": "2026-07-19",
          "label": "07-19",
          "startDate": "2026-07-19",
          "endDate": "2026-07-19",
          "totalTokens": 7742838835750,
          "pricedTokens": 291137764852,
          "blendedPricePerMillion": 0.3041207220548782,
          "estimatedRetailValue": 88541.02726423359,
          "pricedTokenShare": 0.03760090724189784
        },
        {
          "key": "2026-07-20",
          "label": "07-20",
          "startDate": "2026-07-20",
          "endDate": "2026-07-20",
          "totalTokens": 8440173824425,
          "pricedTokens": 321507957846,
          "blendedPricePerMillion": 0.32964291879426816,
          "estimatedRetailValue": 105982.82163993997,
          "pricedTokenShare": 0.03809257540592219
        },
        {
          "key": "2026-07-21",
          "label": "07-21",
          "startDate": "2026-07-21",
          "endDate": "2026-07-21",
          "totalTokens": 8372722163355,
          "pricedTokens": 340859610228,
          "blendedPricePerMillion": 0.3192527695500536,
          "estimatedRetailValue": 108820.37459304077,
          "pricedTokenShare": 0.04071072747640482
        },
        {
          "key": "2026-07-22",
          "label": "07-22",
          "startDate": "2026-07-22",
          "endDate": "2026-07-22",
          "totalTokens": 9013659246552,
          "pricedTokens": 321791787679,
          "blendedPricePerMillion": 0.34254353652146546,
          "estimatedRetailValue": 110227.69697512919,
          "pricedTokenShare": 0.03570046069825584
        },
        {
          "key": "2026-07-23",
          "label": "07-23",
          "startDate": "2026-07-23",
          "endDate": "2026-07-23",
          "totalTokens": 8751994182349,
          "pricedTokens": 360209548807,
          "blendedPricePerMillion": 0.33711530563320413,
          "estimatedRetailValue": 121432.15213807038,
          "pricedTokenShare": 0.04115742553091154
        },
        {
          "key": "2026-07-24",
          "label": "07-24",
          "startDate": "2026-07-24",
          "endDate": "2026-07-24",
          "totalTokens": 8661084724352,
          "pricedTokens": 354176731590,
          "blendedPricePerMillion": 0.33818130241797684,
          "estimatedRetailValue": 119775.9483752484,
          "pricedTokenShare": 0.040892883843310815
        },
        {
          "key": "2026-07-25",
          "label": "07-25",
          "startDate": "2026-07-25",
          "endDate": "2026-07-25",
          "totalTokens": 7305381415398,
          "pricedTokens": 276505895113,
          "blendedPricePerMillion": 0.3304115529748509,
          "estimatedRetailValue": 91360.74221098758,
          "pricedTokenShare": 0.03784961788992859
        },
        {
          "key": "2026-07-26",
          "label": "07-26",
          "startDate": "2026-07-26",
          "endDate": "2026-07-26",
          "totalTokens": 7496481859549,
          "pricedTokens": 313723455624,
          "blendedPricePerMillion": 0.3008545555711349,
          "estimatedRetailValue": 94385.13081399917,
          "pricedTokenShare": 0.04184942503720993
        },
        {
          "key": "2026-07-27",
          "label": "07-27",
          "startDate": "2026-07-27",
          "endDate": "2026-07-27",
          "totalTokens": 8784326010554,
          "pricedTokens": 339547665528,
          "blendedPricePerMillion": 0.3198407612369487,
          "estimatedRetailValue": 108601.18381870438,
          "pricedTokenShare": 0.03865380965142319
        },
        {
          "key": "2026-07-28",
          "label": "07-28",
          "startDate": "2026-07-28",
          "endDate": "2026-07-28",
          "totalTokens": 8890418317802,
          "pricedTokens": 357699052766,
          "blendedPricePerMillion": 0.3100418288597073,
          "estimatedRetailValue": 110901.6685009556,
          "pricedTokenShare": 0.04023422070587504
        },
        {
          "key": "2026-07-29",
          "label": "07-29",
          "startDate": "2026-07-29",
          "endDate": "2026-07-29",
          "totalTokens": 8196705797925,
          "pricedTokens": 310741636624,
          "blendedPricePerMillion": 0.34196632263985705,
          "estimatedRetailValue": 106263.17476739999,
          "pricedTokenShare": 0.03791055141965256
        },
        {
          "key": "2026-07-30",
          "label": "07-30",
          "startDate": "2026-07-30",
          "endDate": "2026-07-30",
          "totalTokens": 8321933504398,
          "pricedTokens": 289425220012,
          "blendedPricePerMillion": 0.35702563653007047,
          "estimatedRetailValue": 103332.22340264,
          "pricedTokenShare": 0.0347786028161657
        },
        {
          "key": "2026-07-31",
          "label": "07-31",
          "startDate": "2026-07-31",
          "endDate": "2026-07-31",
          "totalTokens": 8296221899663,
          "pricedTokens": 273866881768,
          "blendedPricePerMillion": 0.3633439961121542,
          "estimatedRetailValue": 99507.88722435998,
          "pricedTokenShare": 0.03301103623796812
        },
        {
          "key": "2026-08-01",
          "label": "08-01",
          "startDate": "2026-08-01",
          "endDate": "2026-08-01",
          "totalTokens": 7066940419625,
          "pricedTokens": 282964612423,
          "blendedPricePerMillion": 0.3198421774492591,
          "estimatedRetailValue": 90504.01777845799,
          "pricedTokenShare": 0.04004061101706801
        },
        {
          "key": "2026-08-02",
          "label": "08-02",
          "startDate": "2026-08-02",
          "endDate": "2026-08-02",
          "totalTokens": 7232042961954,
          "pricedTokens": 275872947151,
          "blendedPricePerMillion": 0.291309152559374,
          "estimatedRetailValue": 80364.31444861478,
          "pricedTokenShare": 0.03814592205858009
        },
        {
          "key": "2026-08-03",
          "label": "08-03",
          "startDate": "2026-08-03",
          "endDate": "2026-08-03",
          "totalTokens": 9143823075351,
          "pricedTokens": 293451529922,
          "blendedPricePerMillion": 0.3336625568556186,
          "estimatedRetailValue": 97913.78778696757,
          "pricedTokenShare": 0.032092870509826156
        },
        {
          "key": "2026-08-04",
          "label": "08-04",
          "startDate": "2026-08-04",
          "endDate": "2026-08-04",
          "totalTokens": 9996550853376,
          "pricedTokens": 316135264853,
          "blendedPricePerMillion": 0.3349163175197892,
          "estimatedRetailValue": 105878.85874271,
          "pricedTokenShare": 0.031624434216351326
        },
        {
          "key": "2026-08-05",
          "label": "08-05",
          "startDate": "2026-08-05",
          "endDate": "2026-08-05",
          "totalTokens": 10787614259704,
          "pricedTokens": 291249741136,
          "blendedPricePerMillion": 0.3335921360297363,
          "estimatedRetailValue": 97158.623263666,
          "pricedTokenShare": 0.026998531290086336
        },
        {
          "key": "2026-08-06",
          "label": "08-06",
          "startDate": "2026-08-06",
          "endDate": "2026-08-06",
          "totalTokens": 11001204844264,
          "pricedTokens": 257968945149,
          "blendedPricePerMillion": 0.3501425601816092,
          "estimatedRetailValue": 90325.90690181998,
          "pricedTokenShare": 0.023449153870042184
        },
        {
          "key": "2026-08-07",
          "label": "08-07",
          "startDate": "2026-08-07",
          "endDate": "2026-08-07",
          "totalTokens": 10378071121073,
          "pricedTokens": 265331623255,
          "blendedPricePerMillion": 0.34572631954375593,
          "estimatedRetailValue": 91732.12556652159,
          "pricedTokenShare": 0.025566564360523198
        },
        {
          "key": "2026-08-08",
          "label": "08-08",
          "startDate": "2026-08-08",
          "endDate": "2026-08-08",
          "totalTokens": 8765239038152,
          "pricedTokens": 249300764212,
          "blendedPricePerMillion": 0.30508757684387283,
          "estimatedRetailValue": 76058.56605876477,
          "pricedTokenShare": 0.028441981231416683
        },
        {
          "key": "2026-08-09",
          "label": "08-09",
          "startDate": "2026-08-09",
          "endDate": "2026-08-09",
          "totalTokens": 8974034656012,
          "pricedTokens": 257630709551,
          "blendedPricePerMillion": 0.3102689527744963,
          "estimatedRetailValue": 79934.81045493919,
          "pricedTokenShare": 0.028708459397179253
        },
        {
          "key": "2026-08-10",
          "label": "08-10",
          "startDate": "2026-08-10",
          "endDate": "2026-08-10",
          "totalTokens": 10613720303759,
          "pricedTokens": 290701979537,
          "blendedPricePerMillion": 0.33822714226242817,
          "estimatedRetailValue": 98323.29978883038,
          "pricedTokenShare": 0.02738926325711106
        },
        {
          "key": "2026-08-11",
          "label": "08-11",
          "startDate": "2026-08-11",
          "endDate": "2026-08-11",
          "totalTokens": 10931401727980,
          "pricedTokens": 328385002311,
          "blendedPricePerMillion": 0.3114852319485385,
          "estimatedRetailValue": 102287.07861326319,
          "pricedTokenShare": 0.030040520921527036
        },
        {
          "key": "2026-08-12",
          "label": "08-12",
          "startDate": "2026-08-12",
          "endDate": "2026-08-12",
          "totalTokens": 11234116355431,
          "pricedTokens": 312500288113,
          "blendedPricePerMillion": 0.30699950343605903,
          "estimatedRetailValue": 95937.43327431638,
          "pricedTokenShare": 0.027817077750127223
        },
        {
          "key": "2026-08-13",
          "label": "08-13",
          "startDate": "2026-08-13",
          "endDate": "2026-08-13",
          "totalTokens": 11135113794296,
          "pricedTokens": 300462200979,
          "blendedPricePerMillion": 0.3143821817172257,
          "estimatedRetailValue": 94459.96226733757,
          "pricedTokenShare": 0.026983307627526248
        },
        {
          "key": "2026-08-14",
          "label": "08-14",
          "startDate": "2026-08-14",
          "endDate": "2026-08-14",
          "totalTokens": 11486043370983,
          "pricedTokens": 288731161015,
          "blendedPricePerMillion": 0.3070000144387567,
          "estimatedRetailValue": 88640.47060052399,
          "pricedTokenShare": 0.025137564928965593
        },
        {
          "key": "2026-08-15",
          "label": "08-15",
          "startDate": "2026-08-15",
          "endDate": "2026-08-15",
          "totalTokens": 9565041906391,
          "pricedTokens": 244567625468,
          "blendedPricePerMillion": 0.2883113145543278,
          "estimatedRetailValue": 70511.61359610959,
          "pricedTokenShare": 0.02556890266257894
        },
        {
          "key": "2026-08-16",
          "label": "08-16",
          "startDate": "2026-08-16",
          "endDate": "2026-08-16",
          "totalTokens": 10375143625991,
          "pricedTokens": 260893002897,
          "blendedPricePerMillion": 0.2649574469537024,
          "estimatedRetailValue": 69125.543975674,
          "pricedTokenShare": 0.025145965424847826
        },
        {
          "key": "2026-08-17",
          "label": "08-17",
          "startDate": "2026-08-17",
          "endDate": "2026-08-17",
          "totalTokens": 13311262793704,
          "pricedTokens": 306119980683,
          "blendedPricePerMillion": 0.2973499534071914,
          "estimatedRetailValue": 91024.76199310037,
          "pricedTokenShare": 0.02299706537442785
        },
        {
          "key": "2026-08-18",
          "label": "08-18",
          "startDate": "2026-08-18",
          "endDate": "2026-08-18",
          "totalTokens": 12704870921171,
          "pricedTokens": 332097642009,
          "blendedPricePerMillion": 0.2924633764764045,
          "estimatedRetailValue": 97126.39770180438,
          "pricedTokenShare": 0.02613939520279603
        },
        {
          "key": "2026-08-19",
          "label": "08-19",
          "startDate": "2026-08-19",
          "endDate": "2026-08-19",
          "totalTokens": 12119291448118,
          "pricedTokens": 322061107310,
          "blendedPricePerMillion": 0.30732065165586786,
          "estimatedRetailValue": 98976.02937151959,
          "pricedTokenShare": 0.026574252190297208
        },
        {
          "key": "2026-08-20",
          "label": "08-20",
          "startDate": "2026-08-20",
          "endDate": "2026-08-20",
          "totalTokens": 12130101854803,
          "pricedTokens": 334367011663,
          "blendedPricePerMillion": 0.3051728032706636,
          "estimatedRetailValue": 102039.71827043238,
          "pricedTokenShare": 0.027565062162326775
        },
        {
          "key": "2026-08-21",
          "label": "08-21",
          "startDate": "2026-08-21",
          "endDate": "2026-08-21",
          "totalTokens": 13888795396670,
          "pricedTokens": 306368580859,
          "blendedPricePerMillion": 0.30764873427990863,
          "estimatedRetailValue": 94253.90612440319,
          "pricedTokenShare": 0.02205868630856607
        },
        {
          "key": "2026-08-22",
          "label": "08-22",
          "startDate": "2026-08-22",
          "endDate": "2026-08-22",
          "totalTokens": 14075709916673,
          "pricedTokens": 292220352115,
          "blendedPricePerMillion": 0.26480017917842885,
          "estimatedRetailValue": 77380.00159963558,
          "pricedTokenShare": 0.02076061199363439
        },
        {
          "key": "2026-08-23",
          "label": "08-23",
          "startDate": "2026-08-23",
          "endDate": "2026-08-23",
          "totalTokens": 15147544875185,
          "pricedTokens": 243902068556,
          "blendedPricePerMillion": 0.2859918537674232,
          "estimatedRetailValue": 69754.00472403958,
          "pricedTokenShare": 0.016101755800411264
        },
        {
          "key": "2026-08-24",
          "label": "08-24",
          "startDate": "2026-08-24",
          "endDate": "2026-08-24",
          "totalTokens": 18352938225742,
          "pricedTokens": 331466644065,
          "blendedPricePerMillion": 0.2678427713184745,
          "estimatedRetailValue": 88780.94454600397,
          "pricedTokenShare": 0.018060685432923315
        },
        {
          "key": "2026-08-25",
          "label": "08-25",
          "startDate": "2026-08-25",
          "endDate": "2026-08-25",
          "totalTokens": 18775140916501,
          "pricedTokens": 314529503557,
          "blendedPricePerMillion": 0.29707741478098065,
          "estimatedRetailValue": 93439.6117890588,
          "pricedTokenShare": 0.01675244436011492
        },
        {
          "key": "2026-08-26",
          "label": "08-26",
          "startDate": "2026-08-26",
          "endDate": "2026-08-26",
          "totalTokens": 18436449188941,
          "pricedTokens": 423824142437,
          "blendedPricePerMillion": 0.26590863486820976,
          "estimatedRetailValue": 112698.49913961237,
          "pricedTokenShare": 0.022988382312317954
        },
        {
          "key": "2026-08-27",
          "label": "08-27",
          "startDate": "2026-08-27",
          "endDate": "2026-08-27",
          "totalTokens": 15797679821005,
          "pricedTokens": 401818624256,
          "blendedPricePerMillion": 0.26418688866033285,
          "estimatedRetailValue": 106155.21214796798,
          "pricedTokenShare": 0.025435293587969268
        },
        {
          "key": "2026-08-28",
          "label": "08-28",
          "startDate": "2026-08-28",
          "endDate": "2026-08-28",
          "totalTokens": 15116796693545,
          "pricedTokens": 376584970890,
          "blendedPricePerMillion": 0.2594257662004308,
          "estimatedRetailValue": 97695.84461270517,
          "pricedTokenShare": 0.024911691181955565
        },
        {
          "key": "2026-08-29",
          "label": "08-29",
          "startDate": "2026-08-29",
          "endDate": "2026-08-29",
          "totalTokens": 13204155770914,
          "pricedTokens": 283828507167,
          "blendedPricePerMillion": 0.24035996380446126,
          "estimatedRetailValue": 68221.0097093344,
          "pricedTokenShare": 0.021495392215245976
        },
        {
          "key": "2026-08-30",
          "label": "08-30",
          "startDate": "2026-08-30",
          "endDate": "2026-08-30",
          "totalTokens": 13313663519421,
          "pricedTokens": 338687366725,
          "blendedPricePerMillion": 0.23506913114544245,
          "estimatedRetailValue": 79614.94502598359,
          "pricedTokenShare": 0.025439081153804707
        },
        {
          "key": "2026-08-31",
          "label": "08-31",
          "startDate": "2026-08-31",
          "endDate": "2026-08-31",
          "totalTokens": 14318704603016,
          "pricedTokens": 366004128697,
          "blendedPricePerMillion": 0.26371863090855224,
          "estimatedRetailValue": 96522.1077268504,
          "pricedTokenShare": 0.02556125982373484
        },
        {
          "key": "2026-09-01",
          "label": "09-01",
          "startDate": "2026-09-01",
          "endDate": "2026-09-01",
          "totalTokens": 16194588394672,
          "pricedTokens": 370433871734,
          "blendedPricePerMillion": 0.291462273132615,
          "estimatedRetailValue": 107967.49830090719,
          "pricedTokenShare": 0.022873929408164045
        },
        {
          "key": "2026-09-02",
          "label": "09-02",
          "startDate": "2026-09-02",
          "endDate": "2026-09-02",
          "totalTokens": 18488527970063,
          "pricedTokens": 361900962748,
          "blendedPricePerMillion": 0.28966459894613167,
          "estimatedRetailValue": 104829.89723261837,
          "pricedTokenShare": 0.01957435244893468
        },
        {
          "key": "2026-09-03",
          "label": "09-03",
          "startDate": "2026-09-03",
          "endDate": "2026-09-03",
          "totalTokens": 18567158117428,
          "pricedTokens": 312924798740,
          "blendedPricePerMillion": 0.30509251302580864,
          "estimatedRetailValue": 95471.01323568198,
          "pricedTokenShare": 0.016853672315434973
        },
        {
          "key": "2026-09-04",
          "label": "09-04",
          "startDate": "2026-09-04",
          "endDate": "2026-09-04",
          "totalTokens": 18269560527417,
          "pricedTokens": 321335351997,
          "blendedPricePerMillion": 0.2997301029648862,
          "estimatedRetailValue": 96313.87814031877,
          "pricedTokenShare": 0.017588564952877455
        },
        {
          "key": "2026-09-05",
          "label": "09-05",
          "startDate": "2026-09-05",
          "endDate": "2026-09-05",
          "totalTokens": 15344774218059,
          "pricedTokens": 276895614905,
          "blendedPricePerMillion": 0.26708721658346696,
          "estimatedRetailValue": 73955.27906914399,
          "pricedTokenShare": 0.01804494552804344
        },
        {
          "key": "2026-09-06",
          "label": "09-06",
          "startDate": "2026-09-06",
          "endDate": "2026-09-06",
          "totalTokens": 14279989875501,
          "pricedTokens": 280699865049,
          "blendedPricePerMillion": 0.24989294527509673,
          "estimatedRetailValue": 70144.91601541679,
          "pricedTokenShare": 0.01965686723143786
        },
        {
          "key": "2026-09-07",
          "label": "09-07",
          "startDate": "2026-09-07",
          "endDate": "2026-09-07",
          "totalTokens": 19050916850409,
          "pricedTokens": 271727137632,
          "blendedPricePerMillion": 0.289699840590719,
          "estimatedRetailValue": 78719.30845616278,
          "pricedTokenShare": 0.014263205270677896
        },
        {
          "key": "2026-09-08",
          "label": "09-08",
          "startDate": "2026-09-08",
          "endDate": "2026-09-08",
          "totalTokens": 19046273585455,
          "pricedTokens": 337469787931,
          "blendedPricePerMillion": 0.29118431423469326,
          "estimatedRetailValue": 98265.90877361559,
          "pricedTokenShare": 0.017718415437900373
        },
        {
          "key": "2026-09-09",
          "label": "09-09",
          "startDate": "2026-09-09",
          "endDate": "2026-09-09",
          "totalTokens": 17947794799521,
          "pricedTokens": 316786293512,
          "blendedPricePerMillion": 0.29839309890933663,
          "estimatedRetailValue": 94526.84381304837,
          "pricedTokenShare": 0.01765042987456345
        },
        {
          "key": "2026-09-10",
          "label": "09-10",
          "startDate": "2026-09-10",
          "endDate": "2026-09-10",
          "totalTokens": 19184120113922,
          "pricedTokens": 275223532281,
          "blendedPricePerMillion": 0.3442348129754762,
          "estimatedRetailValue": 94741.52116119998,
          "pricedTokenShare": 0.014346424576505288
        },
        {
          "key": "2026-09-11",
          "label": "09-11",
          "startDate": "2026-09-11",
          "endDate": "2026-09-11",
          "totalTokens": 17751297946007,
          "pricedTokens": 286958504071,
          "blendedPricePerMillion": 0.3270616282446141,
          "estimatedRetailValue": 93853.11558009998,
          "pricedTokenShare": 0.016165494204639207
        },
        {
          "key": "2026-09-12",
          "label": "09-12",
          "startDate": "2026-09-12",
          "endDate": "2026-09-12",
          "totalTokens": 17051827575447,
          "pricedTokens": 260990405645,
          "blendedPricePerMillion": 0.2829325804580842,
          "estimatedRetailValue": 73842.68894394199,
          "pricedTokenShare": 0.015305714562866049
        },
        {
          "key": "2026-09-13",
          "label": "09-13",
          "startDate": "2026-09-13",
          "endDate": "2026-09-13",
          "totalTokens": 16730791173422,
          "pricedTokens": 269395938835,
          "blendedPricePerMillion": 0.2612975831776576,
          "estimatedRetailValue": 70392.50773546158,
          "pricedTokenShare": 0.01610180511146142
        },
        {
          "key": "2026-09-14",
          "label": "09-14",
          "startDate": "2026-09-14",
          "endDate": "2026-09-14",
          "totalTokens": 18120484812487,
          "pricedTokens": 304252208171,
          "blendedPricePerMillion": 0.30659372804281254,
          "estimatedRetailValue": 93281.81876840477,
          "pricedTokenShare": 0.01679051147468951
        },
        {
          "key": "2026-09-15",
          "label": "09-15",
          "startDate": "2026-09-15",
          "endDate": "2026-09-15",
          "totalTokens": 17750550231758,
          "pricedTokens": 304656628562,
          "blendedPricePerMillion": 0.3351054740079074,
          "estimatedRetailValue": 102092.10392391999,
          "pricedTokenShare": 0.01716322167956971
        },
        {
          "key": "2026-09-16",
          "label": "09-16",
          "startDate": "2026-09-16",
          "endDate": "2026-09-16",
          "totalTokens": 18403097790101,
          "pricedTokens": 380026082007,
          "blendedPricePerMillion": 0.3259471129426804,
          "estimatedRetailValue": 123868.40427309996,
          "pricedTokenShare": 0.020650114798140967
        },
        {
          "key": "2026-09-17",
          "label": "09-17",
          "startDate": "2026-09-17",
          "endDate": "2026-09-17",
          "totalTokens": 19950735154131,
          "pricedTokens": 257585280962,
          "blendedPricePerMillion": 0.35321109805712075,
          "estimatedRetailValue": 90981.97993193999,
          "pricedTokenShare": 0.012911067134719813
        },
        {
          "key": "2026-09-18",
          "label": "09-18",
          "startDate": "2026-09-18",
          "endDate": "2026-09-18",
          "totalTokens": 19516151287053,
          "pricedTokens": 231359189673,
          "blendedPricePerMillion": 0.3644483888182467,
          "estimatedRetailValue": 84318.48391461998,
          "pricedTokenShare": 0.01185475487815487
        },
        {
          "key": "2026-09-19",
          "label": "09-19",
          "startDate": "2026-09-19",
          "endDate": "2026-09-19",
          "totalTokens": 17822770536307,
          "pricedTokens": 264643847380,
          "blendedPricePerMillion": 0.2765440682906293,
          "estimatedRetailValue": 73185.6862025496,
          "pricedTokenShare": 0.01484863685143062
        },
        {
          "key": "2026-09-20",
          "label": "09-20",
          "startDate": "2026-09-20",
          "endDate": "2026-09-20",
          "totalTokens": 17331480167240,
          "pricedTokens": 241826466273,
          "blendedPricePerMillion": 0.27304305233957493,
          "estimatedRetailValue": 66029.03648767319,
          "pricedTokenShare": 0.013953018665428293
        },
        {
          "key": "2026-09-21",
          "label": "09-21",
          "startDate": "2026-09-21",
          "endDate": "2026-09-21",
          "totalTokens": 20836773421509,
          "pricedTokens": 262530519265,
          "blendedPricePerMillion": 0.36344919896161076,
          "estimatedRetailValue": 95416.50692983998,
          "pricedTokenShare": 0.012599384461031756
        },
        {
          "key": "2026-09-22",
          "label": "09-22",
          "startDate": "2026-09-22",
          "endDate": "2026-09-22",
          "totalTokens": 20461970574170,
          "pricedTokens": 283999745819,
          "blendedPricePerMillion": 0.35555734772958514,
          "estimatedRetailValue": 100978.19637927998,
          "pricedTokenShare": 0.013879393716727592
        },
        {
          "key": "2026-09-23",
          "label": "09-23",
          "startDate": "2026-09-23",
          "endDate": "2026-09-23",
          "totalTokens": 19839776739539,
          "pricedTokens": 280902925074,
          "blendedPricePerMillion": 0.3538065239449476,
          "estimatedRetailValue": 99385.28748639999,
          "pricedTokenShare": 0.014158572889289837
        },
        {
          "key": "2026-09-24",
          "label": "09-24",
          "startDate": "2026-09-24",
          "endDate": "2026-09-24",
          "totalTokens": 21879527010648,
          "pricedTokens": 287375435625,
          "blendedPricePerMillion": 0.33466753942177685,
          "estimatedRetailValue": 96175.22993087998,
          "pricedTokenShare": 0.013134444610486526
        },
        {
          "key": "2026-09-25",
          "label": "09-25",
          "startDate": "2026-09-25",
          "endDate": "2026-09-25",
          "totalTokens": 22441110438066,
          "pricedTokens": 279534118126,
          "blendedPricePerMillion": 0.3360153059611924,
          "estimatedRetailValue": 93927.74222869998,
          "pricedTokenShare": 0.012456340736679275
        },
        {
          "key": "2026-09-26",
          "label": "09-26",
          "startDate": "2026-09-26",
          "endDate": "2026-09-26",
          "totalTokens": 19855703336813,
          "pricedTokens": 276054180732,
          "blendedPricePerMillion": 0.27508994458115776,
          "estimatedRetailValue": 75939.72927896278,
          "pricedTokenShare": 0.013903016984555174
        },
        {
          "key": "2026-09-27",
          "label": "09-27",
          "startDate": "2026-09-27",
          "endDate": "2026-09-27",
          "totalTokens": 20530243814309,
          "pricedTokens": 247114322236,
          "blendedPricePerMillion": 0.2671825661244551,
          "estimatedRetailValue": 66024.63874111998,
          "pricedTokenShare": 0.012036599490541281
        },
        {
          "key": "2026-09-28",
          "label": "09-28",
          "startDate": "2026-09-28",
          "endDate": "2026-09-28",
          "totalTokens": 23934998683834,
          "pricedTokens": 251115364890,
          "blendedPricePerMillion": 0.3381985391812317,
          "estimatedRetailValue": 84926.84957175997,
          "pricedTokenShare": 0.010491555408340443
        },
        {
          "key": "2026-09-29",
          "label": "09-29",
          "startDate": "2026-09-29",
          "endDate": "2026-09-29",
          "totalTokens": 24936730343781,
          "pricedTokens": 294549377433,
          "blendedPricePerMillion": 0.33522575965090984,
          "estimatedRetailValue": 98740.53880467998,
          "pricedTokenShare": 0.011811868411467906
        },
        {
          "key": "2026-09-30",
          "label": "09-30",
          "startDate": "2026-09-30",
          "endDate": "2026-09-30",
          "totalTokens": 24377727661254,
          "pricedTokens": 279687677951,
          "blendedPricePerMillion": 0.3350739732747848,
          "estimatedRetailValue": 93716.06152703997,
          "pricedTokenShare": 0.011473082390510746
        },
        {
          "key": "2026-10-01",
          "label": "10-01",
          "startDate": "2026-10-01",
          "endDate": "2026-10-01",
          "totalTokens": 23446998494287,
          "pricedTokens": 245998461212,
          "blendedPricePerMillion": 0.353093077105894,
          "estimatedRetailValue": 86860.35363265999,
          "pricedTokenShare": 0.010491682390474797
        },
        {
          "key": "2026-10-02",
          "label": "10-02",
          "startDate": "2026-10-02",
          "endDate": "2026-10-02",
          "totalTokens": 24060063479633,
          "pricedTokens": 249191811848,
          "blendedPricePerMillion": 0.3720436382073044,
          "estimatedRetailValue": 92710.22829139998,
          "pricedTokenShare": 0.010357072085821489
        },
        {
          "key": "2026-10-03",
          "label": "10-03",
          "startDate": "2026-10-03",
          "endDate": "2026-10-03",
          "totalTokens": 22318533815723,
          "pricedTokens": 187993466065,
          "blendedPricePerMillion": 0.36287259329701,
          "estimatedRetailValue": 68217.67655389999,
          "pricedTokenShare": 0.00842319964282609
        },
        {
          "key": "2026-10-04",
          "label": "10-04",
          "startDate": "2026-10-04",
          "endDate": "2026-10-04",
          "totalTokens": 22780997379051,
          "pricedTokens": 231168070625,
          "blendedPricePerMillion": 0.2957920090131772,
          "estimatedRetailValue": 68377.66802986879,
          "pricedTokenShare": 0.010147407805664296
        },
        {
          "key": "2026-10-05",
          "label": "10-05",
          "startDate": "2026-10-05",
          "endDate": "2026-10-05",
          "totalTokens": 25873213536983,
          "pricedTokens": 229769497429,
          "blendedPricePerMillion": 0.36379532161761136,
          "estimatedRetailValue": 83589.06821509998,
          "pricedTokenShare": 0.008880593711352051
        },
        {
          "key": "2026-10-06",
          "label": "10-06",
          "startDate": "2026-10-06",
          "endDate": "2026-10-06",
          "totalTokens": 22109724903182,
          "pricedTokens": 238757267127,
          "blendedPricePerMillion": 0.3537147238240007,
          "estimatedRetailValue": 84451.96080279998,
          "pricedTokenShare": 0.010798744361248854
        },
        {
          "key": "2026-10-07",
          "label": "10-07",
          "startDate": "2026-10-07",
          "endDate": "2026-10-07",
          "totalTokens": 25121204185746,
          "pricedTokens": 242325593416,
          "blendedPricePerMillion": 0.34370764855884456,
          "estimatedRetailValue": 83289.15989863998,
          "pricedTokenShare": 0.009646257067306421
        },
        {
          "key": "2026-10-08",
          "label": "10-08",
          "startDate": "2026-10-08",
          "endDate": "2026-10-08",
          "totalTokens": 24455189713768,
          "pricedTokens": 222206560125,
          "blendedPricePerMillion": 0.3526312592492367,
          "estimatedRetailValue": 78356.97911031998,
          "pricedTokenShare": 0.009086274231595928
        },
        {
          "key": "2026-10-09",
          "label": "10-09",
          "startDate": "2026-10-09",
          "endDate": "2026-10-09",
          "totalTokens": 26639007266335,
          "pricedTokens": 218411177448,
          "blendedPricePerMillion": 0.3458721059711577,
          "estimatedRetailValue": 75542.33391157999,
          "pricedTokenShare": 0.008198923303122363
        },
        {
          "key": "2026-10-10",
          "label": "10-10",
          "startDate": "2026-10-10",
          "endDate": "2026-10-10",
          "totalTokens": 24019743394927,
          "pricedTokens": 175286831314,
          "blendedPricePerMillion": 0.3512843624503469,
          "estimatedRetailValue": 61575.52278407999,
          "pricedTokenShare": 0.007297614651079944
        },
        {
          "key": "2026-10-11",
          "label": "10-11",
          "startDate": "2026-10-11",
          "endDate": "2026-10-11",
          "totalTokens": 23624418723773,
          "pricedTokens": 67891727613,
          "blendedPricePerMillion": 0.15999999999999998,
          "estimatedRetailValue": 10862.676418079998,
          "pricedTokenShare": 0.0028737946277882925
        },
        {
          "key": "2026-10-12",
          "label": "10-12",
          "startDate": "2026-10-12",
          "endDate": "2026-10-12",
          "totalTokens": 26944742365440,
          "pricedTokens": 221344983099,
          "blendedPricePerMillion": 0.34164369500770325,
          "estimatedRetailValue": 75621.11789735999,
          "pricedTokenShare": 0.008214774522502119
        },
        {
          "key": "2026-10-13",
          "label": "10-13",
          "startDate": "2026-10-13",
          "endDate": "2026-10-13",
          "totalTokens": 26210571251367,
          "pricedTokens": 253224515864,
          "blendedPricePerMillion": 0.3285624978251493,
          "estimatedRetailValue": 83200.07944283998,
          "pricedTokenShare": 0.009661159744879395
        },
        {
          "key": "2026-10-14",
          "label": "10-14",
          "startDate": "2026-10-14",
          "endDate": "2026-10-14",
          "totalTokens": 26374532234884,
          "pricedTokens": 253160917129,
          "blendedPricePerMillion": 0.3283624024448499,
          "estimatedRetailValue": 83128.52695361999,
          "pricedTokenShare": 0.009598688419359316
        },
        {
          "key": "2026-10-15",
          "label": "10-15",
          "startDate": "2026-10-15",
          "endDate": "2026-10-15",
          "totalTokens": 24438956540182,
          "pricedTokens": 256875059185,
          "blendedPricePerMillion": 0.3186298716692984,
          "estimatedRetailValue": 81848.06714315998,
          "pricedTokenShare": 0.010510884896523779
        },
        {
          "key": "2026-10-16",
          "label": "10-16",
          "startDate": "2026-10-16",
          "endDate": "2026-10-16",
          "totalTokens": 22407801051165,
          "pricedTokens": 188782226366,
          "blendedPricePerMillion": 0.19654341472753425,
          "estimatedRetailValue": 37103.90340983999,
          "pricedTokenShare": 0.008424843916408525
        },
        {
          "key": "2026-10-17",
          "label": "10-17",
          "startDate": "2026-10-17",
          "endDate": "2026-10-17",
          "totalTokens": 18338242794490,
          "pricedTokens": 152936757471,
          "blendedPricePerMillion": 0.1950003399216503,
          "estimatedRetailValue": 29822.71969335999,
          "pricedTokenShare": 0.008339771655600074
        }
      ],
      "modelShares": [
        {
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "name": "deepseek-v4.1-flash-20260910",
          "tokens": 137073542196373,
          "previousTokens": 0,
          "share": 0.060942079939520506,
          "previousShare": 0,
          "shareDeltaPctPoints": 6.09420799395205,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "deepseek/deepseek-v4-flash-20260423",
          "name": "deepseek-v4-flash-20260423",
          "tokens": 104815889274284,
          "previousTokens": 0,
          "share": 0.04660051969718752,
          "previousShare": 0,
          "shareDeltaPctPoints": 4.660051969718753,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "xiaomi/mimo-v2.5-20260422",
          "name": "mimo-v2.5-20260422",
          "tokens": 102572433994235,
          "previousTokens": 0,
          "share": 0.045603092850060326,
          "previousShare": 0,
          "shareDeltaPctPoints": 4.560309285006032,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "deepseek/deepseek-v4-flash-20260731",
          "name": "deepseek-v4-flash-20260731",
          "tokens": 101390812122071,
          "previousTokens": 0,
          "share": 0.045077750807840815,
          "previousShare": 0,
          "shareDeltaPctPoints": 4.507775080784081,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "name": "glm-5.3-flash-20260826",
          "tokens": 93602735938457,
          "previousTokens": 0,
          "share": 0.041615218551419426,
          "previousShare": 0,
          "shareDeltaPctPoints": 4.161521855141943,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "openai/gpt-5.6-luna-20260709",
          "name": "gpt-5.6-luna-20260709",
          "tokens": 82169207176715,
          "previousTokens": 0,
          "share": 0.036531939804667055,
          "previousShare": 0,
          "shareDeltaPctPoints": 3.6531939804667055,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "tencent/hy4-preview-20260827",
          "name": "hy4-preview-20260827",
          "tokens": 78212445675738,
          "previousTokens": 0,
          "share": 0.034772787222553815,
          "previousShare": 0,
          "shareDeltaPctPoints": 3.4772787222553814,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "tencent/hy3-20260706",
          "name": "hy3-20260706",
          "tokens": 64150843539083,
          "previousTokens": 0,
          "share": 0.02852108271591682,
          "previousShare": 0,
          "shareDeltaPctPoints": 2.852108271591682,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "nvidia/nemotron-3-ultra-550b-a55b-20260604:free",
          "name": "nemotron-3-ultra-550b-a55b-20260604:free",
          "tokens": 62056042271533,
          "previousTokens": 0,
          "share": 0.027589746556809236,
          "previousShare": 0,
          "shareDeltaPctPoints": 2.7589746556809236,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "stealth/space-bunny-alpha",
          "name": "space-bunny-alpha",
          "tokens": 56716522847075,
          "previousTokens": 0,
          "share": 0.025215828042777052,
          "previousShare": 0,
          "shareDeltaPctPoints": 2.5215828042777053,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "minimax/minimax-m3-20260531",
          "name": "minimax-m3-20260531",
          "tokens": 46442704993517,
          "previousTokens": 0,
          "share": 0.020648149854242053,
          "previousShare": 0,
          "shareDeltaPctPoints": 2.0648149854242055,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "z-ai/glm-5.2-20260616",
          "name": "glm-5.2-20260616",
          "tokens": 44268196235379,
          "previousTokens": 0,
          "share": 0.019681376219853986,
          "previousShare": 0,
          "shareDeltaPctPoints": 1.9681376219853985,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "deepseek/deepseek-v4-pro-20260423",
          "name": "deepseek-v4-pro-20260423",
          "tokens": 42411320502664,
          "previousTokens": 0,
          "share": 0.018855820335562646,
          "previousShare": 0,
          "shareDeltaPctPoints": 1.8855820335562645,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "google/gemini-3-flash-preview-20251217",
          "name": "gemini-3-flash-preview-20251217",
          "tokens": 37339773408726,
          "previousTokens": 0,
          "share": 0.01660104072263753,
          "previousShare": 0,
          "shareDeltaPctPoints": 1.660104072263753,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "xiaomi/mimo-v2.6-flash-20260921",
          "name": "mimo-v2.6-flash-20260921",
          "tokens": 35479245491272,
          "previousTokens": 0,
          "share": 0.015773861098777254,
          "previousShare": 0,
          "shareDeltaPctPoints": 1.5773861098777253,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "anthropic/claude-4.6-sonnet-20260217",
          "name": "claude-4.6-sonnet-20260217",
          "tokens": 35408047704548,
          "previousTokens": 0,
          "share": 0.015742206987119187,
          "previousShare": 0,
          "shareDeltaPctPoints": 1.5742206987119187,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "deepseek/deepseek-v3.2-20251201",
          "name": "deepseek-v3.2-20251201",
          "tokens": 29276678629967,
          "previousTokens": 0,
          "share": 0.013016236837850612,
          "previousShare": 0,
          "shareDeltaPctPoints": 1.3016236837850612,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "stealth/ox-alpha",
          "name": "ox-alpha",
          "tokens": 27237502959584,
          "previousTokens": 0,
          "share": 0.012109631487730067,
          "previousShare": 0,
          "shareDeltaPctPoints": 1.2109631487730068,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "tencent/hy3-preview-20260421",
          "name": "hy3-preview-20260421",
          "tokens": 27210550265225,
          "previousTokens": 0,
          "share": 0.012097648480448775,
          "previousShare": 0,
          "shareDeltaPctPoints": 1.2097648480448775,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "anthropic/claude-4.7-opus-20260416",
          "name": "claude-4.7-opus-20260416",
          "tokens": 27004780390027,
          "previousTokens": 0,
          "share": 0.012006164420268169,
          "previousShare": 0,
          "shareDeltaPctPoints": 1.2006164420268168,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        }
      ],
      "providerPrices": [
        {
          "provider": "OpenInference",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.04,
          "completionPricePerMillion": 0.144,
          "blendedPricePerMillion": 0.060799999999999986,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Relace",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.049999999999999996,
          "completionPricePerMillion": 0.6,
          "blendedPricePerMillion": 0.15999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Morph",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.081,
          "completionPricePerMillion": 0.55,
          "blendedPricePerMillion": 0.17479999999999998,
          "throughput": null,
          "latency": null,
          "uptime": null,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Decart",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.09,
          "completionPricePerMillion": 0.18,
          "blendedPricePerMillion": 0.108,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Sail Research",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.09,
          "completionPricePerMillion": 0.3,
          "blendedPricePerMillion": 0.13199999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Wafer",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.09999999999999999,
          "completionPricePerMillion": 0.65,
          "blendedPricePerMillion": 0.20999999999999996,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "InferenceNet",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.103,
          "completionPricePerMillion": 0.7150000000000001,
          "blendedPricePerMillion": 0.22539999999999996,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DeepInfra",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.112,
          "completionPricePerMillion": 0.33599999999999997,
          "blendedPricePerMillion": 0.15679999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "AtlasCloud",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.135,
          "completionPricePerMillion": 0.54,
          "blendedPricePerMillion": 0.21599999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DeepInfra",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.14,
          "completionPricePerMillion": 0.42,
          "blendedPricePerMillion": 0.196,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "StreamLake",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.1497,
          "completionPricePerMillion": 0.5988,
          "blendedPricePerMillion": 0.23952,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "CoreWeave",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.65,
          "blendedPricePerMillion": 0.24999999999999994,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "GMICloud",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.18,
          "completionPricePerMillion": 0.72,
          "blendedPricePerMillion": 0.288,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DigitalOcean",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.195,
          "completionPricePerMillion": 0.78,
          "blendedPricePerMillion": 0.312,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Novita",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.195,
          "completionPricePerMillion": 0.78,
          "blendedPricePerMillion": 0.312,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DeepInfra",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.21,
          "completionPricePerMillion": 0.63,
          "blendedPricePerMillion": 0.294,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Phala",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.21,
          "completionPricePerMillion": 0.84,
          "blendedPricePerMillion": 0.33599999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Ionstream",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.27,
          "completionPricePerMillion": 0.75,
          "blendedPricePerMillion": 0.366,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Makora",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.27,
          "completionPricePerMillion": 1.15,
          "blendedPricePerMillion": 0.44599999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Crusoe",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.29,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47199999999999986,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Nebius",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "PrimeIntellect",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Baidu",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "BaseTen",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Alibaba",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Together",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "SiliconFlow",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Modal",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "BaseTen",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Parasail",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Fireworks",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Venice",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Fireworks",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.44999999999999996,
          "completionPricePerMillion": 1.7999999999999998,
          "blendedPricePerMillion": 0.7199999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "BaseTen",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.6,
          "completionPricePerMillion": 2.4,
          "blendedPricePerMillion": 0.9599999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "OpenInference",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.048,
          "completionPricePerMillion": 0.19999999999999998,
          "blendedPricePerMillion": 0.07839999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Reka",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.06,
          "completionPricePerMillion": 1.5999999999999999,
          "blendedPricePerMillion": 0.3679999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "StreamLake",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.075,
          "completionPricePerMillion": 0.25,
          "blendedPricePerMillion": 0.10999999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DeepInfra",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.075,
          "completionPricePerMillion": 0.25,
          "blendedPricePerMillion": 0.10999999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Relace",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.075,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.15999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Sail Research",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.07835,
          "completionPricePerMillion": 0.3,
          "blendedPricePerMillion": 0.12267999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Sail Research",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.07835,
          "completionPricePerMillion": 0.3,
          "blendedPricePerMillion": 0.12267999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Near AI",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.08,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.16399999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Novita",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.08399999999999999,
          "completionPricePerMillion": 0.28,
          "blendedPricePerMillion": 0.12319999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "GMICloud",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.09,
          "completionPricePerMillion": 0.3,
          "blendedPricePerMillion": 0.13199999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Inceptron",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.09999999999999999,
          "completionPricePerMillion": 0.69,
          "blendedPricePerMillion": 0.21799999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "InferenceNet",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.12,
          "completionPricePerMillion": 0.38799999999999996,
          "blendedPricePerMillion": 0.17359999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Wafer",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.12,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.19599999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 96.66666666666667,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Phala",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.1275,
          "completionPricePerMillion": 0.425,
          "blendedPricePerMillion": 0.18699999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Morph",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.129,
          "completionPricePerMillion": 0.65,
          "blendedPricePerMillion": 0.2332,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DigitalOcean",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.13124999999999998,
          "completionPricePerMillion": 0.4375,
          "blendedPricePerMillion": 0.19249999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Makora",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.14,
          "completionPricePerMillion": 0.47,
          "blendedPricePerMillion": 0.206,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "PrimeIntellect",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Modal",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "BaseTen",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Crusoe",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "CoreWeave",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "AtlasCloud",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 96.29629629629629,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Fireworks",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Friendli",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "SiliconFlow",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Together",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Parasail",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "BaseTen",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Venice",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Z.AI",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Parasail",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.1875,
          "completionPricePerMillion": 0.625,
          "blendedPricePerMillion": 0.275,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Fireworks",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.22499999999999998,
          "completionPricePerMillion": 0.75,
          "blendedPricePerMillion": 0.32999999999999996,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "NextBit",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.25,
          "completionPricePerMillion": 0.7,
          "blendedPricePerMillion": 0.3399999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Darkbloom",
          "modelSlug": "xiaomi/mimo-v2.6-flash-20260921",
          "modelName": "Xiaomi: MiMo-V2.6-Flash",
          "promptPricePerMillion": 0.09999999999999999,
          "completionPricePerMillion": 0.28,
          "blendedPricePerMillion": 0.136,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Makora",
          "modelSlug": "xiaomi/mimo-v2.6-flash-20260921",
          "modelName": "Xiaomi: MiMo-V2.6-Flash",
          "promptPricePerMillion": 0.13,
          "completionPricePerMillion": 0.28,
          "blendedPricePerMillion": 0.16,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DeepInfra",
          "modelSlug": "xiaomi/mimo-v2.6-flash-20260921",
          "modelName": "Xiaomi: MiMo-V2.6-Flash",
          "promptPricePerMillion": 0.133,
          "completionPricePerMillion": 0.266,
          "blendedPricePerMillion": 0.1596,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Novita",
          "modelSlug": "xiaomi/mimo-v2.6-flash-20260921",
          "modelName": "Xiaomi: MiMo-V2.6-Flash",
          "promptPricePerMillion": 0.14,
          "completionPricePerMillion": 0.28,
          "blendedPricePerMillion": 0.16799999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 95.23809523809523,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "GMICloud",
          "modelSlug": "xiaomi/mimo-v2.6-flash-20260921",
          "modelName": "Xiaomi: MiMo-V2.6-Flash",
          "promptPricePerMillion": 0.14,
          "completionPricePerMillion": 0.28,
          "blendedPricePerMillion": 0.16799999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 88.23529411764706,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Xiaomi",
          "modelSlug": "xiaomi/mimo-v2.6-flash-20260921",
          "modelName": "Xiaomi: MiMo-V2.6-Flash",
          "promptPricePerMillion": 0.14,
          "completionPricePerMillion": 0.28,
          "blendedPricePerMillion": 0.16799999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Io Net",
          "modelSlug": "xiaomi/mimo-v2.6-flash-20260921",
          "modelName": "Xiaomi: MiMo-V2.6-Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.29,
          "blendedPricePerMillion": 0.178,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Venice",
          "modelSlug": "xiaomi/mimo-v2.6-flash-20260921",
          "modelName": "Xiaomi: MiMo-V2.6-Flash",
          "promptPricePerMillion": 0.175,
          "completionPricePerMillion": 0.35,
          "blendedPricePerMillion": 0.21,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DeepInfra",
          "modelSlug": "tencent/hy4-preview-20260827",
          "modelName": "Tencent: Hy4 preview",
          "promptPricePerMillion": 0.834,
          "completionPricePerMillion": 2.501,
          "blendedPricePerMillion": 1.1674,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Novita",
          "modelSlug": "tencent/hy4-preview-20260827",
          "modelName": "Tencent: Hy4 preview",
          "promptPricePerMillion": 0.834,
          "completionPricePerMillion": 2.501,
          "blendedPricePerMillion": 1.1674,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "SiliconFlow",
          "modelSlug": "tencent/hy4-preview-20260827",
          "modelName": "Tencent: Hy4 preview",
          "promptPricePerMillion": 0.834,
          "completionPricePerMillion": 2.501,
          "blendedPricePerMillion": 1.1674,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Tencent",
          "modelSlug": "tencent/hy4-preview-20260827",
          "modelName": "Tencent: Hy4 preview",
          "promptPricePerMillion": 0.834,
          "completionPricePerMillion": 2.501,
          "blendedPricePerMillion": 1.1674,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Amazon Bedrock",
          "modelSlug": "anthropic/claude-opus-5.5-20260921",
          "modelName": "Anthropic: Claude Opus 5.5",
          "promptPricePerMillion": 4,
          "completionPricePerMillion": 20,
          "blendedPricePerMillion": 7.199999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Azure",
          "modelSlug": "anthropic/claude-opus-5.5-20260921",
          "modelName": "Anthropic: Claude Opus 5.5",
          "promptPricePerMillion": 4,
          "completionPricePerMillion": 20,
          "blendedPricePerMillion": 7.199999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Google",
          "modelSlug": "anthropic/claude-opus-5.5-20260921",
          "modelName": "Anthropic: Claude Opus 5.5",
          "promptPricePerMillion": 4,
          "completionPricePerMillion": 20,
          "blendedPricePerMillion": 7.199999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Claude Platform on AWS",
          "modelSlug": "anthropic/claude-opus-5.5-20260921",
          "modelName": "Anthropic: Claude Opus 5.5",
          "promptPricePerMillion": 4,
          "completionPricePerMillion": 20,
          "blendedPricePerMillion": 7.199999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Anthropic",
          "modelSlug": "anthropic/claude-opus-5.5-20260921",
          "modelName": "Anthropic: Claude Opus 5.5",
          "promptPricePerMillion": 4,
          "completionPricePerMillion": 20,
          "blendedPricePerMillion": 7.199999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Amazon Bedrock",
          "modelSlug": "anthropic/claude-opus-5.5-20260921",
          "modelName": "Anthropic: Claude Opus 5.5",
          "promptPricePerMillion": 4.4,
          "completionPricePerMillion": 22,
          "blendedPricePerMillion": 7.919999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Amazon Bedrock",
          "modelSlug": "anthropic/claude-opus-5.5-20260921",
          "modelName": "Anthropic: Claude Opus 5.5",
          "promptPricePerMillion": 4.4,
          "completionPricePerMillion": 22,
          "blendedPricePerMillion": 7.919999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Azure",
          "modelSlug": "anthropic/claude-opus-5.5-20260921",
          "modelName": "Anthropic: Claude Opus 5.5",
          "promptPricePerMillion": 4.4,
          "completionPricePerMillion": 22,
          "blendedPricePerMillion": 7.919999999999999,
          "throughput": null,
          "latency": null,
          "uptime": null,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Google",
          "modelSlug": "anthropic/claude-opus-5.5-20260921",
          "modelName": "Anthropic: Claude Opus 5.5",
          "promptPricePerMillion": 4.4,
          "completionPricePerMillion": 22,
          "blendedPricePerMillion": 7.919999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Google",
          "modelSlug": "anthropic/claude-opus-5.5-20260921",
          "modelName": "Anthropic: Claude Opus 5.5",
          "promptPricePerMillion": 4.4,
          "completionPricePerMillion": 22,
          "blendedPricePerMillion": 7.919999999999999,
          "throughput": null,
          "latency": null,
          "uptime": null,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Anthropic",
          "modelSlug": "anthropic/claude-opus-5.5-20260921",
          "modelName": "Anthropic: Claude Opus 5.5",
          "promptPricePerMillion": 8,
          "completionPricePerMillion": 40,
          "blendedPricePerMillion": 14.399999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Relace",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.049999999999999996,
          "completionPricePerMillion": 0.6,
          "blendedPricePerMillion": 0.15999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DeepInfra",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.0784,
          "completionPricePerMillion": 0.2352,
          "blendedPricePerMillion": 0.10976,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "InferenceNet",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.08,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.16399999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Morph",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.081,
          "completionPricePerMillion": 0.55,
          "blendedPricePerMillion": 0.17479999999999998,
          "throughput": null,
          "latency": null,
          "uptime": null,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DeepInfra",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.098,
          "completionPricePerMillion": 0.29400000000000004,
          "blendedPricePerMillion": 0.13720000000000002,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Cloudflare",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.09999999999999999,
          "completionPricePerMillion": 0.6,
          "blendedPricePerMillion": 0.19999999999999996,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DeepInfra",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.14700000000000002,
          "completionPricePerMillion": 0.441,
          "blendedPricePerMillion": 0.2058,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DeepSeek",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.6,
          "blendedPricePerMillion": 0.23999999999999994,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Wafer",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Fireworks",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "PrimeIntellect",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "BaseTen",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Parasail",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "OpenAI",
          "modelSlug": "openai/gpt-6-luna-20260922",
          "modelName": "OpenAI: GPT-6 Luna",
          "promptPricePerMillion": 0.049999999999999996,
          "completionPricePerMillion": 0.25,
          "blendedPricePerMillion": 0.08999999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "OpenAI",
          "modelSlug": "openai/gpt-6-luna-20260922",
          "modelName": "OpenAI: GPT-6 Luna",
          "promptPricePerMillion": 0.09999999999999999,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.17999999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Azure",
          "modelSlug": "openai/gpt-6-luna-20260922",
          "modelName": "OpenAI: GPT-6 Luna",
          "promptPricePerMillion": 0.09999999999999999,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.17999999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Azure",
          "modelSlug": "openai/gpt-6-luna-20260922",
          "modelName": "OpenAI: GPT-6 Luna",
          "promptPricePerMillion": 0.11,
          "completionPricePerMillion": 0.55,
          "blendedPricePerMillion": 0.198,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Azure",
          "modelSlug": "openai/gpt-6-luna-20260922",
          "modelName": "OpenAI: GPT-6 Luna",
          "promptPricePerMillion": 0.11,
          "completionPricePerMillion": 0.55,
          "blendedPricePerMillion": 0.198,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Amazon Bedrock",
          "modelSlug": "openai/gpt-6-luna-20260922",
          "modelName": "OpenAI: GPT-6 Luna",
          "promptPricePerMillion": 0.11,
          "completionPricePerMillion": 0.55,
          "blendedPricePerMillion": 0.198,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "OpenAI",
          "modelSlug": "openai/gpt-6-luna-20260922",
          "modelName": "OpenAI: GPT-6 Luna",
          "promptPricePerMillion": 0.19999999999999998,
          "completionPricePerMillion": 1,
          "blendedPricePerMillion": 0.35999999999999993,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Relace",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.075,
          "completionPricePerMillion": 2.2,
          "blendedPricePerMillion": 0.4999999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Wafer",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.079,
          "completionPricePerMillion": 2.5,
          "blendedPricePerMillion": 0.5631999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "InferenceNet",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.08,
          "completionPricePerMillion": 4.381,
          "blendedPricePerMillion": 0.9401999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Morph",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.08,
          "completionPricePerMillion": 6,
          "blendedPricePerMillion": 1.2639999999999996,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Reka",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.14,
          "completionPricePerMillion": 4.199999999999999,
          "blendedPricePerMillion": 0.9519999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Makora",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.14,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 0.9919999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Wafer",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.179,
          "completionPricePerMillion": 2.5,
          "blendedPricePerMillion": 0.6432,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DekaLLM",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.18,
          "completionPricePerMillion": 2.95,
          "blendedPricePerMillion": 0.7339999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "AkashML",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.19,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 1.0319999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Io Net",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.49,
          "completionPricePerMillion": 2.6,
          "blendedPricePerMillion": 0.9119999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Sail Research",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.5,
          "completionPricePerMillion": 1.505,
          "blendedPricePerMillion": 0.701,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Sail Research",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.5,
          "completionPricePerMillion": 1.505,
          "blendedPricePerMillion": 0.701,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Inceptron",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.55,
          "completionPricePerMillion": 1.505,
          "blendedPricePerMillion": 0.741,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DeepInfra",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.5625,
          "completionPricePerMillion": 2.5,
          "blendedPricePerMillion": 0.95,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Baidu",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.5992000000000001,
          "completionPricePerMillion": 1.8832,
          "blendedPricePerMillion": 0.856,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Tenstorrent",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.6,
          "completionPricePerMillion": 2.5,
          "blendedPricePerMillion": 0.98,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "SiliconFlow",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.7,
          "completionPricePerMillion": 2.2,
          "blendedPricePerMillion": 1,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Novita",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.7,
          "completionPricePerMillion": 2.2,
          "blendedPricePerMillion": 1,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Phala",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.84,
          "completionPricePerMillion": 2.64,
          "blendedPricePerMillion": 1.2,
          "throughput": null,
          "latency": null,
          "uptime": null,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Decart",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.84,
          "completionPricePerMillion": 2.66,
          "blendedPricePerMillion": 1.2039999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DigitalOcean",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.9099999999999999,
          "completionPricePerMillion": 2.8600000000000003,
          "blendedPricePerMillion": 1.2999999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "GMICloud",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.98,
          "completionPricePerMillion": 3.08,
          "blendedPricePerMillion": 1.4,
          "throughput": null,
          "latency": null,
          "uptime": null,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Alibaba",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.19,
          "completionPricePerMillion": 3.74,
          "blendedPricePerMillion": 1.6999999999999997,
          "throughput": null,
          "latency": null,
          "uptime": null,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "CoreWeave",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.2,
          "completionPricePerMillion": 4,
          "blendedPricePerMillion": 1.7599999999999996,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Friendli",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.26,
          "completionPricePerMillion": 3.9600000000000004,
          "blendedPricePerMillion": 1.8,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Mistral",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "BaseTen",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Mistral",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Nebius",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Crusoe",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "PrimeIntellect",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Venice",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": null,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Together",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Parasail",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Modal",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "BaseTen",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": null,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Fireworks",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Cloudflare",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": null,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "AtlasCloud",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": 96.66666666666667,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Z.AI",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Mistral",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.54,
          "completionPricePerMillion": 4.84,
          "blendedPricePerMillion": 2.2,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "ModelRun",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 2.0999999999999996,
          "completionPricePerMillion": 6.6000000000000005,
          "blendedPricePerMillion": 3,
          "throughput": null,
          "latency": null,
          "uptime": null,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Fireworks",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 2.0999999999999996,
          "completionPricePerMillion": 6.6000000000000005,
          "blendedPricePerMillion": 3,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "BaseTen",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 2.0999999999999996,
          "completionPricePerMillion": 6.6000000000000005,
          "blendedPricePerMillion": 3,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "BaseTen",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 2.0999999999999996,
          "completionPricePerMillion": 6.6000000000000005,
          "blendedPricePerMillion": 3,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Alibaba",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 2.8,
          "completionPricePerMillion": 8.8,
          "blendedPricePerMillion": 4,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "OpenInference",
          "modelSlug": "deepseek/deepseek-v4-flash-20260731",
          "modelName": "DeepSeek: DeepSeek V4 Flash 0731",
          "promptPricePerMillion": 0.00392,
          "completionPricePerMillion": 0.143616,
          "blendedPricePerMillion": 0.0318592,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Relace",
          "modelSlug": "deepseek/deepseek-v4-flash-20260731",
          "modelName": "DeepSeek: DeepSeek V4 Flash 0731",
          "promptPricePerMillion": 0.0199,
          "completionPricePerMillion": 0.44999999999999996,
          "blendedPricePerMillion": 0.10591999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Reka",
          "modelSlug": "deepseek/deepseek-v4-flash-20260731",
          "modelName": "DeepSeek: DeepSeek V4 Flash 0731",
          "promptPricePerMillion": 0.020999999999999998,
          "completionPricePerMillion": 0.5279999999999999,
          "blendedPricePerMillion": 0.12239999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        }
      ]
    },
    "all": {
      "meta": {
        "asOf": "2026-10-18T12:08:38.409Z",
        "availableStart": "2025-01-01",
        "availableEnd": "2026-10-17",
        "rangeStart": "2025-01-01",
        "rangeEnd": "2026-10-17",
        "previousStart": "2023-03-18",
        "previousEnd": "2024-12-31",
        "lastSync": "2026-10-18T12:08:32.383Z",
        "grain": "day",
        "sourceStatus": "live",
        "sourceCitation": "Source: OpenRouter (openrouter.ai/rankings), as of 2026-10-18T12:08:38.409Z.",
        "inputTokenShare": 0.8,
        "pricedTokenShare": 0.057397732410456974,
        "modelCount": 471,
        "providerCount": 52,
        "notes": [
          "公开需求样本、模型牌价与重点模型端点报价已在本地完成更新。",
          "Token 数据来自公开路由市场样本，不代表全球全部 AI 推理需求。",
          "公开排名只提供输入与输出 Token 合计，不提供两者的实际拆分。",
          "价格趋势是按当期模型结构加权的公开零售牌价，不是历史成交价。",
          "金额为 Token 与公开牌价的情景估算，不是平台流水或已确认收入。",
          "不同模型沿用上游 tokenizer，跨模型 Token 数量并非完全等价。"
        ]
      },
      "analysis": {
        "headline": "当前区间记录 2.35 千万亿 Token，等待形成完整对比基期。",
        "bullets": [
          "本期累计 2.35 千万亿 Token，对比区间为 2023-03-18 至 2024-12-31（暂无可比基期）。",
          "可定价 Token 覆盖率 5.7%；加权零售价 $0.49/百万 Token。",
          "deepseek-v4.1-flash-20260910 的样本份额变化最大，上升 5.8 个百分点。",
          "估算金额仅用于观察需求与牌价的共同变化，不等同于平台实际收入。"
        ],
        "generatedAt": "2026-10-18T12:08:32.383Z"
      },
      "headline": {
        "tokenTotal": 2348858159438770,
        "tokenDeltaPct": null,
        "blendedPricePerMillion": 0.48758439072038545,
        "priceDeltaPct": null,
        "estimatedRetailValue": 65735704.385152824,
        "valueDeltaPct": null
      },
      "trends": [
        {
          "key": "2025-01-01",
          "label": "01-01",
          "startDate": "2025-01-01",
          "endDate": "2025-01-01",
          "totalTokens": 49151682771,
          "pricedTokens": 11747072354,
          "blendedPricePerMillion": 0.4260387909055522,
          "estimatedRetailValue": 5004.708502378199,
          "pricedTokenShare": 0.23899634136088813
        },
        {
          "key": "2025-01-02",
          "label": "01-02",
          "startDate": "2025-01-02",
          "endDate": "2025-01-02",
          "totalTokens": 62408153540,
          "pricedTokens": 14108802811,
          "blendedPricePerMillion": 0.532226651639139,
          "estimatedRetailValue": 7509.080878735401,
          "pricedTokenShare": 0.22607306915364955
        },
        {
          "key": "2025-01-03",
          "label": "01-03",
          "startDate": "2025-01-03",
          "endDate": "2025-01-03",
          "totalTokens": 61193115505,
          "pricedTokens": 12755334917,
          "blendedPricePerMillion": 0.5751009562114345,
          "estimatedRetailValue": 7335.605307563799,
          "pricedTokenShare": 0.20844395340449337
        },
        {
          "key": "2025-01-04",
          "label": "01-04",
          "startDate": "2025-01-04",
          "endDate": "2025-01-04",
          "totalTokens": 53598360079,
          "pricedTokens": 11639719585,
          "blendedPricePerMillion": 0.4172170381900829,
          "estimatedRetailValue": 4856.289330616801,
          "pricedTokenShare": 0.2171655917801201
        },
        {
          "key": "2025-01-05",
          "label": "01-05",
          "startDate": "2025-01-05",
          "endDate": "2025-01-05",
          "totalTokens": 58396306085,
          "pricedTokens": 12121352450,
          "blendedPricePerMillion": 0.42827409310410747,
          "estimatedRetailValue": 5191.261227719001,
          "pricedTokenShare": 0.2075705342107856
        },
        {
          "key": "2025-01-06",
          "label": "01-06",
          "startDate": "2025-01-06",
          "endDate": "2025-01-06",
          "totalTokens": 69386292686,
          "pricedTokens": 15398303929,
          "blendedPricePerMillion": 0.421977503837371,
          "estimatedRetailValue": 6497.737855288602,
          "pricedTokenShare": 0.22192141030914164
        },
        {
          "key": "2025-01-07",
          "label": "01-07",
          "startDate": "2025-01-07",
          "endDate": "2025-01-07",
          "totalTokens": 75431755847,
          "pricedTokens": 16035568507,
          "blendedPricePerMillion": 0.4119065873301252,
          "estimatedRetailValue": 6605.156299616801,
          "pricedTokenShare": 0.2125837895053818
        },
        {
          "key": "2025-01-08",
          "label": "01-08",
          "startDate": "2025-01-08",
          "endDate": "2025-01-08",
          "totalTokens": 70221822873,
          "pricedTokens": 14518468766,
          "blendedPricePerMillion": 0.3934501708444286,
          "estimatedRetailValue": 5712.294016382201,
          "pricedTokenShare": 0.20675152213375952
        },
        {
          "key": "2025-01-09",
          "label": "01-09",
          "startDate": "2025-01-09",
          "endDate": "2025-01-09",
          "totalTokens": 72356616201,
          "pricedTokens": 14632948800,
          "blendedPricePerMillion": 0.4330953181262823,
          "estimatedRetailValue": 6337.461615661601,
          "pricedTokenShare": 0.20223373574229922
        },
        {
          "key": "2025-01-10",
          "label": "01-10",
          "startDate": "2025-01-10",
          "endDate": "2025-01-10",
          "totalTokens": 71507703702,
          "pricedTokens": 14974545499,
          "blendedPricePerMillion": 0.42725281919748775,
          "estimatedRetailValue": 6397.916780648801,
          "pricedTokenShare": 0.20941163991791245
        },
        {
          "key": "2025-01-11",
          "label": "01-11",
          "startDate": "2025-01-11",
          "endDate": "2025-01-11",
          "totalTokens": 63816995783,
          "pricedTokens": 15142822596,
          "blendedPricePerMillion": 0.38495410260325025,
          "estimatedRetailValue": 5829.2916833234,
          "pricedTokenShare": 0.23728510579675152
        },
        {
          "key": "2025-01-12",
          "label": "01-12",
          "startDate": "2025-01-12",
          "endDate": "2025-01-12",
          "totalTokens": 75866094246,
          "pricedTokens": 15443615823,
          "blendedPricePerMillion": 0.37092326729089997,
          "estimatedRetailValue": 5728.3964398526,
          "pricedTokenShare": 0.20356413463072479
        },
        {
          "key": "2025-01-13",
          "label": "01-13",
          "startDate": "2025-01-13",
          "endDate": "2025-01-13",
          "totalTokens": 85115007863,
          "pricedTokens": 18411628432,
          "blendedPricePerMillion": 0.3778800792213924,
          "estimatedRetailValue": 6957.387610479001,
          "pricedTokenShare": 0.21631471222601678
        },
        {
          "key": "2025-01-14",
          "label": "01-14",
          "startDate": "2025-01-14",
          "endDate": "2025-01-14",
          "totalTokens": 75222327281,
          "pricedTokens": 15979934580,
          "blendedPricePerMillion": 0.4264511541653634,
          "estimatedRetailValue": 6814.661545128001,
          "pricedTokenShare": 0.2124360566551666
        },
        {
          "key": "2025-01-15",
          "label": "01-15",
          "startDate": "2025-01-15",
          "endDate": "2025-01-15",
          "totalTokens": 84115145855,
          "pricedTokens": 16245611172,
          "blendedPricePerMillion": 0.41021579114961476,
          "estimatedRetailValue": 6664.206239631,
          "pricedTokenShare": 0.1931353861051924
        },
        {
          "key": "2025-01-16",
          "label": "01-16",
          "startDate": "2025-01-16",
          "endDate": "2025-01-16",
          "totalTokens": 77055116590,
          "pricedTokens": 15670512682,
          "blendedPricePerMillion": 0.45451824082628306,
          "estimatedRetailValue": 7122.533857068599,
          "pricedTokenShare": 0.20336758122605547
        },
        {
          "key": "2025-01-17",
          "label": "01-17",
          "startDate": "2025-01-17",
          "endDate": "2025-01-17",
          "totalTokens": 68495216858,
          "pricedTokens": 14525547284,
          "blendedPricePerMillion": 0.4462982352958343,
          "estimatedRetailValue": 6482.726119555398,
          "pricedTokenShare": 0.21206659311866194
        },
        {
          "key": "2025-01-18",
          "label": "01-18",
          "startDate": "2025-01-18",
          "endDate": "2025-01-18",
          "totalTokens": 60483766614,
          "pricedTokens": 13013703924,
          "blendedPricePerMillion": 0.4132818497431186,
          "estimatedRetailValue": 5378.327629720001,
          "pricedTokenShare": 0.21516027609609478
        },
        {
          "key": "2025-01-19",
          "label": "01-19",
          "startDate": "2025-01-19",
          "endDate": "2025-01-19",
          "totalTokens": 67857660985,
          "pricedTokens": 14881297810,
          "blendedPricePerMillion": 0.41196800383640736,
          "estimatedRetailValue": 6130.6185532808,
          "pricedTokenShare": 0.219301661654526
        },
        {
          "key": "2025-01-20",
          "label": "01-20",
          "startDate": "2025-01-20",
          "endDate": "2025-01-20",
          "totalTokens": 75688773433,
          "pricedTokens": 15641244131,
          "blendedPricePerMillion": 0.46259034860198234,
          "estimatedRetailValue": 7235.488575128001,
          "pricedTokenShare": 0.2066521020431873
        },
        {
          "key": "2025-01-21",
          "label": "01-21",
          "startDate": "2025-01-21",
          "endDate": "2025-01-21",
          "totalTokens": 81360080410,
          "pricedTokens": 16414032219,
          "blendedPricePerMillion": 0.5427700729024627,
          "estimatedRetailValue": 8909.04546413,
          "pricedTokenShare": 0.20174552601576023
        },
        {
          "key": "2025-01-22",
          "label": "01-22",
          "startDate": "2025-01-22",
          "endDate": "2025-01-22",
          "totalTokens": 81625733261,
          "pricedTokens": 18026597665,
          "blendedPricePerMillion": 0.5535679825324267,
          "estimatedRetailValue": 9978.947301337803,
          "pricedTokenShare": 0.2208445418476006
        },
        {
          "key": "2025-01-23",
          "label": "01-23",
          "startDate": "2025-01-23",
          "endDate": "2025-01-23",
          "totalTokens": 77114501415,
          "pricedTokens": 19842840902,
          "blendedPricePerMillion": 0.4432005649006438,
          "estimatedRetailValue": 8794.358297,
          "pricedTokenShare": 0.2573165946468825
        },
        {
          "key": "2025-01-24",
          "label": "01-24",
          "startDate": "2025-01-24",
          "endDate": "2025-01-24",
          "totalTokens": 72673110544,
          "pricedTokens": 18739046755,
          "blendedPricePerMillion": 0.407869791586365,
          "estimatedRetailValue": 7643.091094488999,
          "pricedTokenShare": 0.25785392443955496
        },
        {
          "key": "2025-01-25",
          "label": "01-25",
          "startDate": "2025-01-25",
          "endDate": "2025-01-25",
          "totalTokens": 67152928393,
          "pricedTokens": 16815814182,
          "blendedPricePerMillion": 0.4280096297209786,
          "estimatedRetailValue": 7197.330401494601,
          "pricedTokenShare": 0.25041073538280534
        },
        {
          "key": "2025-01-26",
          "label": "01-26",
          "startDate": "2025-01-26",
          "endDate": "2025-01-26",
          "totalTokens": 71483471593,
          "pricedTokens": 17556256915,
          "blendedPricePerMillion": 0.43079938076998686,
          "estimatedRetailValue": 7563.2246076208,
          "pricedTokenShare": 0.24559882898467386
        },
        {
          "key": "2025-01-27",
          "label": "01-27",
          "startDate": "2025-01-27",
          "endDate": "2025-01-27",
          "totalTokens": 73948446787,
          "pricedTokens": 16584778181,
          "blendedPricePerMillion": 0.4577626654618325,
          "estimatedRetailValue": 7591.892266227801,
          "pricedTokenShare": 0.22427486852794282
        },
        {
          "key": "2025-01-28",
          "label": "01-28",
          "startDate": "2025-01-28",
          "endDate": "2025-01-28",
          "totalTokens": 75487441672,
          "pricedTokens": 16580701730,
          "blendedPricePerMillion": 0.49134230037756066,
          "estimatedRetailValue": 8146.800129892401,
          "pricedTokenShare": 0.21964847877670435
        },
        {
          "key": "2025-01-29",
          "label": "01-29",
          "startDate": "2025-01-29",
          "endDate": "2025-01-29",
          "totalTokens": 78035168383,
          "pricedTokens": 18501231264,
          "blendedPricePerMillion": 0.4463030554823186,
          "estimatedRetailValue": 8257.1560433082,
          "pricedTokenShare": 0.2370883749900449
        },
        {
          "key": "2025-01-30",
          "label": "01-30",
          "startDate": "2025-01-30",
          "endDate": "2025-01-30",
          "totalTokens": 89094205165,
          "pricedTokens": 21264998604,
          "blendedPricePerMillion": 0.5854536287857356,
          "estimatedRetailValue": 12449.6705988354,
          "pricedTokenShare": 0.2386799294591361
        },
        {
          "key": "2025-01-31",
          "label": "01-31",
          "startDate": "2025-01-31",
          "endDate": "2025-01-31",
          "totalTokens": 84790953671,
          "pricedTokens": 21647908193,
          "blendedPricePerMillion": 0.4186335226236887,
          "estimatedRetailValue": 9062.5400642698,
          "pricedTokenShare": 0.255309172214252
        },
        {
          "key": "2025-02-01",
          "label": "02-01",
          "startDate": "2025-02-01",
          "endDate": "2025-02-01",
          "totalTokens": 82720395965,
          "pricedTokens": 19388708209,
          "blendedPricePerMillion": 0.4011717524371765,
          "estimatedRetailValue": 7778.2020496976,
          "pricedTokenShare": 0.23438848403486362
        },
        {
          "key": "2025-02-02",
          "label": "02-02",
          "startDate": "2025-02-02",
          "endDate": "2025-02-02",
          "totalTokens": 87631768147,
          "pricedTokens": 21577970861,
          "blendedPricePerMillion": 0.4075656943432277,
          "estimatedRetailValue": 8794.4406764814,
          "pricedTokenShare": 0.24623457128930137
        },
        {
          "key": "2025-02-03",
          "label": "02-03",
          "startDate": "2025-02-03",
          "endDate": "2025-02-03",
          "totalTokens": 88421824989,
          "pricedTokens": 21259748644,
          "blendedPricePerMillion": 0.4135873703497207,
          "estimatedRetailValue": 8792.763535968,
          "pricedTokenShare": 0.24043553327071446
        },
        {
          "key": "2025-02-04",
          "label": "02-04",
          "startDate": "2025-02-04",
          "endDate": "2025-02-04",
          "totalTokens": 102119870049,
          "pricedTokens": 23574154332,
          "blendedPricePerMillion": 0.4707272119241084,
          "estimatedRetailValue": 11096.995942171001,
          "pricedTokenShare": 0.23084786849697767
        },
        {
          "key": "2025-02-05",
          "label": "02-05",
          "startDate": "2025-02-05",
          "endDate": "2025-02-05",
          "totalTokens": 105669269279,
          "pricedTokens": 22616958440,
          "blendedPricePerMillion": 0.43008049223782374,
          "estimatedRetailValue": 9727.112618797602,
          "pricedTokenShare": 0.21403534437513844
        },
        {
          "key": "2025-02-06",
          "label": "02-06",
          "startDate": "2025-02-06",
          "endDate": "2025-02-06",
          "totalTokens": 114992702177,
          "pricedTokens": 25123761659,
          "blendedPricePerMillion": 0.46106791093429234,
          "estimatedRetailValue": 11583.7603029262,
          "pricedTokenShare": 0.21848135736760754
        },
        {
          "key": "2025-02-07",
          "label": "02-07",
          "startDate": "2025-02-07",
          "endDate": "2025-02-07",
          "totalTokens": 118370770895,
          "pricedTokens": 20822340746,
          "blendedPricePerMillion": 0.409299381454508,
          "estimatedRetailValue": 8522.571187772799,
          "pricedTokenShare": 0.17590779031480938
        },
        {
          "key": "2025-02-08",
          "label": "02-08",
          "startDate": "2025-02-08",
          "endDate": "2025-02-08",
          "totalTokens": 105864690395,
          "pricedTokens": 19903806617,
          "blendedPricePerMillion": 0.5361531557636113,
          "estimatedRetailValue": 10671.4887294132,
          "pricedTokenShare": 0.18801175862070116
        },
        {
          "key": "2025-02-09",
          "label": "02-09",
          "startDate": "2025-02-09",
          "endDate": "2025-02-09",
          "totalTokens": 107394888620,
          "pricedTokens": 18153642031,
          "blendedPricePerMillion": 0.4475281570202401,
          "estimatedRetailValue": 8124.2659613385995,
          "pricedTokenShare": 0.1690363690886055
        },
        {
          "key": "2025-02-10",
          "label": "02-10",
          "startDate": "2025-02-10",
          "endDate": "2025-02-10",
          "totalTokens": 110479150384,
          "pricedTokens": 20682507730,
          "blendedPricePerMillion": 0.4502143919775728,
          "estimatedRetailValue": 9311.562642233399,
          "pricedTokenShare": 0.18720733874321427
        },
        {
          "key": "2025-02-11",
          "label": "02-11",
          "startDate": "2025-02-11",
          "endDate": "2025-02-11",
          "totalTokens": 124503350714,
          "pricedTokens": 22725993709,
          "blendedPricePerMillion": 0.43494747454384236,
          "estimatedRetailValue": 9884.6135702288,
          "pricedTokenShare": 0.1825331894978834
        },
        {
          "key": "2025-02-12",
          "label": "02-12",
          "startDate": "2025-02-12",
          "endDate": "2025-02-12",
          "totalTokens": 124490739152,
          "pricedTokens": 22014536137,
          "blendedPricePerMillion": 0.415944058517457,
          "estimatedRetailValue": 9156.815507203,
          "pricedTokenShare": 0.17683673731040198
        },
        {
          "key": "2025-02-13",
          "label": "02-13",
          "startDate": "2025-02-13",
          "endDate": "2025-02-13",
          "totalTokens": 123401049224,
          "pricedTokens": 22543673440,
          "blendedPricePerMillion": 0.4111906321702733,
          "estimatedRetailValue": 9269.7473332338,
          "pricedTokenShare": 0.1826862379352892
        },
        {
          "key": "2025-02-14",
          "label": "02-14",
          "startDate": "2025-02-14",
          "endDate": "2025-02-14",
          "totalTokens": 123551521514,
          "pricedTokens": 25315680033,
          "blendedPricePerMillion": 0.4001548462764773,
          "estimatedRetailValue": 10130.192051989601,
          "pricedTokenShare": 0.20489978369170794
        },
        {
          "key": "2025-02-15",
          "label": "02-15",
          "startDate": "2025-02-15",
          "endDate": "2025-02-15",
          "totalTokens": 115361835640,
          "pricedTokens": 20514831046,
          "blendedPricePerMillion": 0.4408404685288969,
          "estimatedRetailValue": 9043.767730109801,
          "pricedTokenShare": 0.17783031045049344
        },
        {
          "key": "2025-02-16",
          "label": "02-16",
          "startDate": "2025-02-16",
          "endDate": "2025-02-16",
          "totalTokens": 118560036919,
          "pricedTokens": 21461215537,
          "blendedPricePerMillion": 0.423302756646025,
          "estimatedRetailValue": 9084.591697786602,
          "pricedTokenShare": 0.1810155942483576
        },
        {
          "key": "2025-02-17",
          "label": "02-17",
          "startDate": "2025-02-17",
          "endDate": "2025-02-17",
          "totalTokens": 128184132562,
          "pricedTokens": 20798338106,
          "blendedPricePerMillion": 0.4896866285194527,
          "estimatedRetailValue": 10184.6680659348,
          "pricedTokenShare": 0.16225360885396853
        },
        {
          "key": "2025-02-18",
          "label": "02-18",
          "startDate": "2025-02-18",
          "endDate": "2025-02-18",
          "totalTokens": 142100553307,
          "pricedTokens": 19981103182,
          "blendedPricePerMillion": 0.5387313144752971,
          "estimatedRetailValue": 10764.445981905401,
          "pricedTokenShare": 0.1406124235057128
        },
        {
          "key": "2025-02-19",
          "label": "02-19",
          "startDate": "2025-02-19",
          "endDate": "2025-02-19",
          "totalTokens": 133578195110,
          "pricedTokens": 18381335554,
          "blendedPricePerMillion": 0.5888915294939183,
          "estimatedRetailValue": 10824.612808536,
          "pricedTokenShare": 0.13760730588449108
        },
        {
          "key": "2025-02-20",
          "label": "02-20",
          "startDate": "2025-02-20",
          "endDate": "2025-02-20",
          "totalTokens": 139567174082,
          "pricedTokens": 19926045088,
          "blendedPricePerMillion": 0.5837232196923754,
          "estimatedRetailValue": 11631.295194502802,
          "pricedTokenShare": 0.14277028405184186
        },
        {
          "key": "2025-02-21",
          "label": "02-21",
          "startDate": "2025-02-21",
          "endDate": "2025-02-21",
          "totalTokens": 133191771578,
          "pricedTokens": 18884154977,
          "blendedPricePerMillion": 0.5803673420878748,
          "estimatedRetailValue": 10959.746831577002,
          "pricedTokenShare": 0.141781693818383
        },
        {
          "key": "2025-02-22",
          "label": "02-22",
          "startDate": "2025-02-22",
          "endDate": "2025-02-22",
          "totalTokens": 135116394860,
          "pricedTokens": 25475799320,
          "blendedPricePerMillion": 0.7497663866564875,
          "estimatedRetailValue": 19100.8980033422,
          "pricedTokenShare": 0.18854706230429394
        },
        {
          "key": "2025-02-23",
          "label": "02-23",
          "startDate": "2025-02-23",
          "endDate": "2025-02-23",
          "totalTokens": 139667620904,
          "pricedTokens": 17813516180,
          "blendedPricePerMillion": 0.490635750603652,
          "estimatedRetailValue": 8739.9478818646,
          "pricedTokenShare": 0.12754220387446888
        },
        {
          "key": "2025-02-24",
          "label": "02-24",
          "startDate": "2025-02-24",
          "endDate": "2025-02-24",
          "totalTokens": 149673286419,
          "pricedTokens": 20612398037,
          "blendedPricePerMillion": 0.5203725169470538,
          "estimatedRetailValue": 10726.1254468282,
          "pricedTokenShare": 0.1377159447097127
        },
        {
          "key": "2025-02-25",
          "label": "02-25",
          "startDate": "2025-02-25",
          "endDate": "2025-02-25",
          "totalTokens": 165872108916,
          "pricedTokens": 24245723200,
          "blendedPricePerMillion": 0.529591255721405,
          "estimatedRetailValue": 12840.322995361601,
          "pricedTokenShare": 0.14617118790162836
        },
        {
          "key": "2025-02-26",
          "label": "02-26",
          "startDate": "2025-02-26",
          "endDate": "2025-02-26",
          "totalTokens": 163891595218,
          "pricedTokens": 21515672411,
          "blendedPricePerMillion": 0.5113658979642568,
          "estimatedRetailValue": 11002.381142755801,
          "pricedTokenShare": 0.13127990109792378
        },
        {
          "key": "2025-02-27",
          "label": "02-27",
          "startDate": "2025-02-27",
          "endDate": "2025-02-27",
          "totalTokens": 157817685268,
          "pricedTokens": 20218786018,
          "blendedPricePerMillion": 0.5267064990771989,
          "estimatedRetailValue": 10649.3659991318,
          "pricedTokenShare": 0.1281148306266514
        },
        {
          "key": "2025-02-28",
          "label": "02-28",
          "startDate": "2025-02-28",
          "endDate": "2025-02-28",
          "totalTokens": 154373044616,
          "pricedTokens": 20121223838,
          "blendedPricePerMillion": 0.6322671066590715,
          "estimatedRetailValue": 12721.9879784918,
          "pricedTokenShare": 0.1303415624667581
        },
        {
          "key": "2025-03-01",
          "label": "03-01",
          "startDate": "2025-03-01",
          "endDate": "2025-03-01",
          "totalTokens": 150042042719,
          "pricedTokens": 18991619124,
          "blendedPricePerMillion": 0.5406344138993591,
          "estimatedRetailValue": 10267.5228741036,
          "pricedTokenShare": 0.12657531702342698
        },
        {
          "key": "2025-03-02",
          "label": "03-02",
          "startDate": "2025-03-02",
          "endDate": "2025-03-02",
          "totalTokens": 157225740186,
          "pricedTokens": 19287819172,
          "blendedPricePerMillion": 0.506386198417466,
          "estimatedRetailValue": 9767.085426272599,
          "pricedTokenShare": 0.12267596354885829
        },
        {
          "key": "2025-03-03",
          "label": "03-03",
          "startDate": "2025-03-03",
          "endDate": "2025-03-03",
          "totalTokens": 163696491542,
          "pricedTokens": 20398515928,
          "blendedPricePerMillion": 0.5736083900261962,
          "estimatedRetailValue": 11700.759880383801,
          "pricedTokenShare": 0.12461180893890023
        },
        {
          "key": "2025-03-04",
          "label": "03-04",
          "startDate": "2025-03-04",
          "endDate": "2025-03-04",
          "totalTokens": 166790068558,
          "pricedTokens": 21643444297,
          "blendedPricePerMillion": 0.49488687218584054,
          "estimatedRetailValue": 10711.056451470798,
          "pricedTokenShare": 0.1297645866095058
        },
        {
          "key": "2025-03-05",
          "label": "03-05",
          "startDate": "2025-03-05",
          "endDate": "2025-03-05",
          "totalTokens": 173962185656,
          "pricedTokens": 24542817840,
          "blendedPricePerMillion": 0.47870524554327215,
          "estimatedRetailValue": 11748.775640421001,
          "pricedTokenShare": 0.1410813375760407
        },
        {
          "key": "2025-03-06",
          "label": "03-06",
          "startDate": "2025-03-06",
          "endDate": "2025-03-06",
          "totalTokens": 182100870835,
          "pricedTokens": 27408632898,
          "blendedPricePerMillion": 0.4269977816504302,
          "estimatedRetailValue": 11703.425445517001,
          "pricedTokenShare": 0.15051346417137523
        },
        {
          "key": "2025-03-07",
          "label": "03-07",
          "startDate": "2025-03-07",
          "endDate": "2025-03-07",
          "totalTokens": 227794006971,
          "pricedTokens": 32946951371,
          "blendedPricePerMillion": 0.40448398832360055,
          "estimatedRetailValue": 13326.5142936458,
          "pricedTokenShare": 0.14463484711076885
        },
        {
          "key": "2025-03-08",
          "label": "03-08",
          "startDate": "2025-03-08",
          "endDate": "2025-03-08",
          "totalTokens": 180393189127,
          "pricedTokens": 25338175450,
          "blendedPricePerMillion": 0.40584288135933644,
          "estimatedRetailValue": 10283.3181330164,
          "pricedTokenShare": 0.14046082101337803
        },
        {
          "key": "2025-03-09",
          "label": "03-09",
          "startDate": "2025-03-09",
          "endDate": "2025-03-09",
          "totalTokens": 187301072720,
          "pricedTokens": 26439866988,
          "blendedPricePerMillion": 0.39860783261699817,
          "estimatedRetailValue": 10539.1380747684,
          "pricedTokenShare": 0.14116238953700747
        },
        {
          "key": "2025-03-10",
          "label": "03-10",
          "startDate": "2025-03-10",
          "endDate": "2025-03-10",
          "totalTokens": 194916718158,
          "pricedTokens": 29023270064,
          "blendedPricePerMillion": 0.4471139098159066,
          "estimatedRetailValue": 12976.707753957997,
          "pricedTokenShare": 0.14890087591395657
        },
        {
          "key": "2025-03-11",
          "label": "03-11",
          "startDate": "2025-03-11",
          "endDate": "2025-03-11",
          "totalTokens": 204393400391,
          "pricedTokens": 30086035443,
          "blendedPricePerMillion": 0.4503440340986772,
          "estimatedRetailValue": 13549.066571436402,
          "pricedTokenShare": 0.14719670686747266
        },
        {
          "key": "2025-03-12",
          "label": "03-12",
          "startDate": "2025-03-12",
          "endDate": "2025-03-12",
          "totalTokens": 203060022546,
          "pricedTokens": 27600656599,
          "blendedPricePerMillion": 0.45837595033128226,
          "estimatedRetailValue": 12651.477198334002,
          "pricedTokenShare": 0.13592363604090268
        },
        {
          "key": "2025-03-13",
          "label": "03-13",
          "startDate": "2025-03-13",
          "endDate": "2025-03-13",
          "totalTokens": 221928492539,
          "pricedTokens": 32535831930,
          "blendedPricePerMillion": 0.4472647606691212,
          "estimatedRetailValue": 14552.131081342202,
          "pricedTokenShare": 0.14660502379739457
        },
        {
          "key": "2025-03-14",
          "label": "03-14",
          "startDate": "2025-03-14",
          "endDate": "2025-03-14",
          "totalTokens": 214068053396,
          "pricedTokens": 31695460252,
          "blendedPricePerMillion": 0.43786058823236296,
          "estimatedRetailValue": 13878.192870236198,
          "pricedTokenShare": 0.14806254249141618
        },
        {
          "key": "2025-03-15",
          "label": "03-15",
          "startDate": "2025-03-15",
          "endDate": "2025-03-15",
          "totalTokens": 190299583462,
          "pricedTokens": 30178378563,
          "blendedPricePerMillion": 0.39925951728099807,
          "estimatedRetailValue": 12049.0048573866,
          "pricedTokenShare": 0.15858352400979467
        },
        {
          "key": "2025-03-16",
          "label": "03-16",
          "startDate": "2025-03-16",
          "endDate": "2025-03-16",
          "totalTokens": 190302450623,
          "pricedTokens": 31348462477,
          "blendedPricePerMillion": 0.36272103316361304,
          "estimatedRetailValue": 11370.746697748196,
          "pricedTokenShare": 0.16472968358722342
        },
        {
          "key": "2025-03-17",
          "label": "03-17",
          "startDate": "2025-03-17",
          "endDate": "2025-03-17",
          "totalTokens": 230930657288,
          "pricedTokens": 33617449360,
          "blendedPricePerMillion": 0.41628711426168113,
          "estimatedRetailValue": 13994.5109829126,
          "pricedTokenShare": 0.1455737828610376
        },
        {
          "key": "2025-03-18",
          "label": "03-18",
          "startDate": "2025-03-18",
          "endDate": "2025-03-18",
          "totalTokens": 230236003769,
          "pricedTokens": 36176265282,
          "blendedPricePerMillion": 0.39988425659238297,
          "estimatedRetailValue": 14466.318948581404,
          "pricedTokenShare": 0.1571268815032783
        },
        {
          "key": "2025-03-19",
          "label": "03-19",
          "startDate": "2025-03-19",
          "endDate": "2025-03-19",
          "totalTokens": 205403798836,
          "pricedTokens": 37084676697,
          "blendedPricePerMillion": 0.41012078252641104,
          "estimatedRetailValue": 15209.196626712599,
          "pricedTokenShare": 0.18054523288836258
        },
        {
          "key": "2025-03-20",
          "label": "03-20",
          "startDate": "2025-03-20",
          "endDate": "2025-03-20",
          "totalTokens": 203790419935,
          "pricedTokens": 34073228921,
          "blendedPricePerMillion": 0.39798644515862963,
          "estimatedRetailValue": 13560.683253345,
          "pricedTokenShare": 0.16719740276244502
        },
        {
          "key": "2025-03-21",
          "label": "03-21",
          "startDate": "2025-03-21",
          "endDate": "2025-03-21",
          "totalTokens": 212462970583,
          "pricedTokens": 36622957836,
          "blendedPricePerMillion": 0.3101870185172336,
          "estimatedRetailValue": 11359.966100431198,
          "pricedTokenShare": 0.17237336810036274
        },
        {
          "key": "2025-03-22",
          "label": "03-22",
          "startDate": "2025-03-22",
          "endDate": "2025-03-22",
          "totalTokens": 188084657023,
          "pricedTokens": 37124726178,
          "blendedPricePerMillion": 0.31567133265209557,
          "estimatedRetailValue": 11719.211786953398,
          "pricedTokenShare": 0.19738306550682755
        },
        {
          "key": "2025-03-23",
          "label": "03-23",
          "startDate": "2025-03-23",
          "endDate": "2025-03-23",
          "totalTokens": 198759550985,
          "pricedTokens": 41465087916,
          "blendedPricePerMillion": 0.2840253519553107,
          "estimatedRetailValue": 11777.136189199802,
          "pricedTokenShare": 0.2086193479030816
        },
        {
          "key": "2025-03-24",
          "label": "03-24",
          "startDate": "2025-03-24",
          "endDate": "2025-03-24",
          "totalTokens": 222905959539,
          "pricedTokens": 45610670763,
          "blendedPricePerMillion": 0.31885829612385264,
          "estimatedRetailValue": 14543.3407645562,
          "pricedTokenShare": 0.20461844473485188
        },
        {
          "key": "2025-03-25",
          "label": "03-25",
          "startDate": "2025-03-25",
          "endDate": "2025-03-25",
          "totalTokens": 228382944505,
          "pricedTokens": 44643480783,
          "blendedPricePerMillion": 0.3217561150502819,
          "estimatedRetailValue": 14364.312939059999,
          "pricedTokenShare": 0.19547642176065655
        },
        {
          "key": "2025-03-26",
          "label": "03-26",
          "startDate": "2025-03-26",
          "endDate": "2025-03-26",
          "totalTokens": 244887222843,
          "pricedTokens": 52193642283,
          "blendedPricePerMillion": 0.34831455802488315,
          "estimatedRetailValue": 18179.805443512,
          "pricedTokenShare": 0.21313338310207364
        },
        {
          "key": "2025-03-27",
          "label": "03-27",
          "startDate": "2025-03-27",
          "endDate": "2025-03-27",
          "totalTokens": 247700609528,
          "pricedTokens": 55495591696,
          "blendedPricePerMillion": 0.35050298014043185,
          "estimatedRetailValue": 19451.370274104604,
          "pricedTokenShare": 0.2240430162919191
        },
        {
          "key": "2025-03-28",
          "label": "03-28",
          "startDate": "2025-03-28",
          "endDate": "2025-03-28",
          "totalTokens": 252577751172,
          "pricedTokens": 60337938673,
          "blendedPricePerMillion": 0.3814420770654025,
          "estimatedRetailValue": 23015.428653273997,
          "pricedTokenShare": 0.23888857349082646
        },
        {
          "key": "2025-03-29",
          "label": "03-29",
          "startDate": "2025-03-29",
          "endDate": "2025-03-29",
          "totalTokens": 218184167792,
          "pricedTokens": 50551074300,
          "blendedPricePerMillion": 0.3259542154357775,
          "estimatedRetailValue": 16477.335762892195,
          "pricedTokenShare": 0.2316899287953446
        },
        {
          "key": "2025-03-30",
          "label": "03-30",
          "startDate": "2025-03-30",
          "endDate": "2025-03-30",
          "totalTokens": 205111873157,
          "pricedTokens": 30334123084,
          "blendedPricePerMillion": 0.3492367240281355,
          "estimatedRetailValue": 10593.789772122402,
          "pricedTokenShare": 0.14789062484345394
        },
        {
          "key": "2025-03-31",
          "label": "03-31",
          "startDate": "2025-03-31",
          "endDate": "2025-03-31",
          "totalTokens": 263186845381,
          "pricedTokens": 56796348566,
          "blendedPricePerMillion": 0.298369238905484,
          "estimatedRetailValue": 16946.283294247998,
          "pricedTokenShare": 0.21580238360233883
        },
        {
          "key": "2025-04-01",
          "label": "04-01",
          "startDate": "2025-04-01",
          "endDate": "2025-04-01",
          "totalTokens": 279117467876,
          "pricedTokens": 54863195061,
          "blendedPricePerMillion": 0.3089399266013812,
          "estimatedRetailValue": 16949.4314552626,
          "pricedTokenShare": 0.19655951839378746
        },
        {
          "key": "2025-04-02",
          "label": "04-02",
          "startDate": "2025-04-02",
          "endDate": "2025-04-02",
          "totalTokens": 287084138362,
          "pricedTokens": 77140027054,
          "blendedPricePerMillion": 0.29122068996016653,
          "estimatedRetailValue": 22464.771902211793,
          "pricedTokenShare": 0.2687018080975618
        },
        {
          "key": "2025-04-03",
          "label": "04-03",
          "startDate": "2025-04-03",
          "endDate": "2025-04-03",
          "totalTokens": 310210765749,
          "pricedTokens": 95439290158,
          "blendedPricePerMillion": 0.29096617098421146,
          "estimatedRetailValue": 27769.604818724398,
          "pricedTokenShare": 0.30765950345908544
        },
        {
          "key": "2025-04-04",
          "label": "04-04",
          "startDate": "2025-04-04",
          "endDate": "2025-04-04",
          "totalTokens": 282175536516,
          "pricedTokens": 86632993403,
          "blendedPricePerMillion": 0.33701770241756585,
          "estimatedRetailValue": 29196.8523902352,
          "pricedTokenShare": 0.3070180869420894
        },
        {
          "key": "2025-04-05",
          "label": "04-05",
          "startDate": "2025-04-05",
          "endDate": "2025-04-05",
          "totalTokens": 283090401484,
          "pricedTokens": 82157765778,
          "blendedPricePerMillion": 0.2851997052715787,
          "estimatedRetailValue": 23431.370585656994,
          "pricedTokenShare": 0.29021741940849055
        },
        {
          "key": "2025-04-06",
          "label": "04-06",
          "startDate": "2025-04-06",
          "endDate": "2025-04-06",
          "totalTokens": 330016992208,
          "pricedTokens": 83743082115,
          "blendedPricePerMillion": 0.2800813353928704,
          "estimatedRetailValue": 23454.874268683998,
          "pricedTokenShare": 0.2537538493236712
        },
        {
          "key": "2025-04-07",
          "label": "04-07",
          "startDate": "2025-04-07",
          "endDate": "2025-04-07",
          "totalTokens": 371768869788,
          "pricedTokens": 90873433970,
          "blendedPricePerMillion": 0.31294683857889205,
          "estimatedRetailValue": 28438.553871719196,
          "pricedTokenShare": 0.24443529664498342
        },
        {
          "key": "2025-04-08",
          "label": "04-08",
          "startDate": "2025-04-08",
          "endDate": "2025-04-08",
          "totalTokens": 335124133287,
          "pricedTokens": 87117239585,
          "blendedPricePerMillion": 0.3203440516176818,
          "estimatedRetailValue": 27907.489494407197,
          "pricedTokenShare": 0.25995513581945734
        },
        {
          "key": "2025-04-09",
          "label": "04-09",
          "startDate": "2025-04-09",
          "endDate": "2025-04-09",
          "totalTokens": 329550655879,
          "pricedTokens": 90133048947,
          "blendedPricePerMillion": 0.37139429524261075,
          "estimatedRetailValue": 33474.9001917388,
          "pricedTokenShare": 0.27350286621821757
        },
        {
          "key": "2025-04-10",
          "label": "04-10",
          "startDate": "2025-04-10",
          "endDate": "2025-04-10",
          "totalTokens": 318345562644,
          "pricedTokens": 74014287131,
          "blendedPricePerMillion": 0.4001589020454251,
          "estimatedRetailValue": 29617.475874015796,
          "pricedTokenShare": 0.23249668227280687
        },
        {
          "key": "2025-04-11",
          "label": "04-11",
          "startDate": "2025-04-11",
          "endDate": "2025-04-11",
          "totalTokens": 290444046062,
          "pricedTokens": 47984136148,
          "blendedPricePerMillion": 0.37224443690453496,
          "estimatedRetailValue": 17861.8277407628,
          "pricedTokenShare": 0.1652095706508544
        },
        {
          "key": "2025-04-12",
          "label": "04-12",
          "startDate": "2025-04-12",
          "endDate": "2025-04-12",
          "totalTokens": 274911788714,
          "pricedTokens": 38682285270,
          "blendedPricePerMillion": 0.39603913283914416,
          "estimatedRetailValue": 15319.698714567201,
          "pricedTokenShare": 0.14070799019187383
        },
        {
          "key": "2025-04-13",
          "label": "04-13",
          "startDate": "2025-04-13",
          "endDate": "2025-04-13",
          "totalTokens": 262977334963,
          "pricedTokens": 34289844469,
          "blendedPricePerMillion": 0.355469975230922,
          "estimatedRetailValue": 12189.010164067598,
          "pricedTokenShare": 0.13039087369953178
        },
        {
          "key": "2025-04-14",
          "label": "04-14",
          "startDate": "2025-04-14",
          "endDate": "2025-04-14",
          "totalTokens": 272286805249,
          "pricedTokens": 40081713388,
          "blendedPricePerMillion": 0.3713695521946733,
          "estimatedRetailValue": 14885.127952096802,
          "pricedTokenShare": 0.14720402390173185
        },
        {
          "key": "2025-04-15",
          "label": "04-15",
          "startDate": "2025-04-15",
          "endDate": "2025-04-15",
          "totalTokens": 252985364647,
          "pricedTokens": 39241942060,
          "blendedPricePerMillion": 0.4903771134639812,
          "estimatedRetailValue": 19243.3502741036,
          "pricedTokenShare": 0.15511546335795257
        },
        {
          "key": "2025-04-16",
          "label": "04-16",
          "startDate": "2025-04-16",
          "endDate": "2025-04-16",
          "totalTokens": 251118350224,
          "pricedTokens": 36919978532,
          "blendedPricePerMillion": 0.48072564715977784,
          "estimatedRetailValue": 17748.380572920803,
          "pricedTokenShare": 0.14702222477595533
        },
        {
          "key": "2025-04-17",
          "label": "04-17",
          "startDate": "2025-04-17",
          "endDate": "2025-04-17",
          "totalTokens": 248960978027,
          "pricedTokens": 36077813852,
          "blendedPricePerMillion": 0.44028707664517835,
          "estimatedRetailValue": 15884.595192646,
          "pricedTokenShare": 0.14491352877030927
        },
        {
          "key": "2025-04-18",
          "label": "04-18",
          "startDate": "2025-04-18",
          "endDate": "2025-04-18",
          "totalTokens": 260110794546,
          "pricedTokens": 34915633518,
          "blendedPricePerMillion": 0.4249855810557657,
          "estimatedRetailValue": 14838.6407985774,
          "pricedTokenShare": 0.13423369675580785
        },
        {
          "key": "2025-04-19",
          "label": "04-19",
          "startDate": "2025-04-19",
          "endDate": "2025-04-19",
          "totalTokens": 243572111478,
          "pricedTokens": 29489921912,
          "blendedPricePerMillion": 0.4642293526251301,
          "estimatedRetailValue": 13690.0873581734,
          "pricedTokenShare": 0.12107265373303462
        },
        {
          "key": "2025-04-20",
          "label": "04-20",
          "startDate": "2025-04-20",
          "endDate": "2025-04-20",
          "totalTokens": 249634165943,
          "pricedTokens": 31775325564,
          "blendedPricePerMillion": 0.36584178668854,
          "estimatedRetailValue": 11624.7418769438,
          "pricedTokenShare": 0.12728756676381947
        },
        {
          "key": "2025-04-21",
          "label": "04-21",
          "startDate": "2025-04-21",
          "endDate": "2025-04-21",
          "totalTokens": 265611051403,
          "pricedTokens": 33565454597,
          "blendedPricePerMillion": 0.4634785807804145,
          "estimatedRetailValue": 15556.869259867,
          "pricedTokenShare": 0.12637070038954293
        },
        {
          "key": "2025-04-22",
          "label": "04-22",
          "startDate": "2025-04-22",
          "endDate": "2025-04-22",
          "totalTokens": 267828807102,
          "pricedTokens": 35052242584,
          "blendedPricePerMillion": 0.5607038946238511,
          "estimatedRetailValue": 19653.9289321488,
          "pricedTokenShare": 0.1308755505551376
        },
        {
          "key": "2025-04-23",
          "label": "04-23",
          "startDate": "2025-04-23",
          "endDate": "2025-04-23",
          "totalTokens": 258244769365,
          "pricedTokens": 34460055556,
          "blendedPricePerMillion": 0.3999236395926836,
          "estimatedRetailValue": 13781.3908385216,
          "pricedTokenShare": 0.13343951027830725
        },
        {
          "key": "2025-04-24",
          "label": "04-24",
          "startDate": "2025-04-24",
          "endDate": "2025-04-24",
          "totalTokens": 248136852554,
          "pricedTokens": 31759814695,
          "blendedPricePerMillion": 0.4112749194170322,
          "estimatedRetailValue": 13062.015229386001,
          "pricedTokenShare": 0.12799313914118568
        },
        {
          "key": "2025-04-25",
          "label": "04-25",
          "startDate": "2025-04-25",
          "endDate": "2025-04-25",
          "totalTokens": 254213410032,
          "pricedTokens": 40439440738,
          "blendedPricePerMillion": 0.3888359082560465,
          "estimatedRetailValue": 15724.306668726798,
          "pricedTokenShare": 0.1590767408096589
        },
        {
          "key": "2025-04-26",
          "label": "04-26",
          "startDate": "2025-04-26",
          "endDate": "2025-04-26",
          "totalTokens": 232948687662,
          "pricedTokens": 42680374312,
          "blendedPricePerMillion": 0.31726413363506106,
          "estimatedRetailValue": 13540.951979316796,
          "pricedTokenShare": 0.1832179212528025
        },
        {
          "key": "2025-04-27",
          "label": "04-27",
          "startDate": "2025-04-27",
          "endDate": "2025-04-27",
          "totalTokens": 236480346124,
          "pricedTokens": 37934582003,
          "blendedPricePerMillion": 0.35224625694029954,
          "estimatedRetailValue": 13362.314519151601,
          "pricedTokenShare": 0.16041325473664841
        },
        {
          "key": "2025-04-28",
          "label": "04-28",
          "startDate": "2025-04-28",
          "endDate": "2025-04-28",
          "totalTokens": 276156543714,
          "pricedTokens": 44362950673,
          "blendedPricePerMillion": 0.3852697790117889,
          "estimatedRetailValue": 17091.7042020976,
          "pricedTokenShare": 0.1606442131566661
        },
        {
          "key": "2025-04-29",
          "label": "04-29",
          "startDate": "2025-04-29",
          "endDate": "2025-04-29",
          "totalTokens": 264007460755,
          "pricedTokens": 43600031502,
          "blendedPricePerMillion": 0.4070822343892902,
          "estimatedRetailValue": 17748.7982432776,
          "pricedTokenShare": 0.16514696735203635
        },
        {
          "key": "2025-04-30",
          "label": "04-30",
          "startDate": "2025-04-30",
          "endDate": "2025-04-30",
          "totalTokens": 257745468847,
          "pricedTokens": 36359351811,
          "blendedPricePerMillion": 0.38789777392432834,
          "estimatedRetailValue": 14103.711628818397,
          "pricedTokenShare": 0.1410668904235257
        },
        {
          "key": "2025-05-01",
          "label": "05-01",
          "startDate": "2025-05-01",
          "endDate": "2025-05-01",
          "totalTokens": 247853999972,
          "pricedTokens": 38570694858,
          "blendedPricePerMillion": 0.36749290149006625,
          "estimatedRetailValue": 14174.4565658544,
          "pricedTokenShare": 0.15561860959418577
        },
        {
          "key": "2025-05-02",
          "label": "05-02",
          "startDate": "2025-05-02",
          "endDate": "2025-05-02",
          "totalTokens": 257124033765,
          "pricedTokens": 43050376727,
          "blendedPricePerMillion": 0.3480391264895051,
          "estimatedRetailValue": 14983.2155111092,
          "pricedTokenShare": 0.16743038795955628
        },
        {
          "key": "2025-05-03",
          "label": "05-03",
          "startDate": "2025-05-03",
          "endDate": "2025-05-03",
          "totalTokens": 240108996884,
          "pricedTokens": 63053159437,
          "blendedPricePerMillion": 0.3683941946722405,
          "estimatedRetailValue": 23228.417892333997,
          "pricedTokenShare": 0.2626022358814895
        },
        {
          "key": "2025-05-04",
          "label": "05-04",
          "startDate": "2025-05-04",
          "endDate": "2025-05-04",
          "totalTokens": 259953508223,
          "pricedTokens": 68509533984,
          "blendedPricePerMillion": 0.3714967540355821,
          "estimatedRetailValue": 25451.069495546402,
          "pricedTokenShare": 0.2635453333648777
        },
        {
          "key": "2025-05-05",
          "label": "05-05",
          "startDate": "2025-05-05",
          "endDate": "2025-05-05",
          "totalTokens": 311745800261,
          "pricedTokens": 84301851306,
          "blendedPricePerMillion": 0.38396539264003804,
          "estimatedRetailValue": 32368.993436990393,
          "pricedTokenShare": 0.2704185629298639
        },
        {
          "key": "2025-05-06",
          "label": "05-06",
          "startDate": "2025-05-06",
          "endDate": "2025-05-06",
          "totalTokens": 310263302559,
          "pricedTokens": 83490402286,
          "blendedPricePerMillion": 0.40616999573513823,
          "estimatedRetailValue": 33911.296340429595,
          "pricedTokenShare": 0.2690953187095769
        },
        {
          "key": "2025-05-07",
          "label": "05-07",
          "startDate": "2025-05-07",
          "endDate": "2025-05-07",
          "totalTokens": 313740594702,
          "pricedTokens": 82326421873,
          "blendedPricePerMillion": 0.3883824402602723,
          "estimatedRetailValue": 31974.1366249324,
          "pricedTokenShare": 0.2624028361748853
        },
        {
          "key": "2025-05-08",
          "label": "05-08",
          "startDate": "2025-05-08",
          "endDate": "2025-05-08",
          "totalTokens": 314099176805,
          "pricedTokens": 88702683877,
          "blendedPricePerMillion": 0.39967627312067555,
          "estimatedRetailValue": 35452.358107760796,
          "pricedTokenShare": 0.2824034267751955
        },
        {
          "key": "2025-05-09",
          "label": "05-09",
          "startDate": "2025-05-09",
          "endDate": "2025-05-09",
          "totalTokens": 310235395101,
          "pricedTokens": 88241811199,
          "blendedPricePerMillion": 0.38768152496313985,
          "estimatedRetailValue": 34209.71993113779,
          "pricedTokenShare": 0.2844350212530458
        },
        {
          "key": "2025-05-10",
          "label": "05-10",
          "startDate": "2025-05-10",
          "endDate": "2025-05-10",
          "totalTokens": 281325208183,
          "pricedTokens": 78344146321,
          "blendedPricePerMillion": 0.35334523644006255,
          "estimatedRetailValue": 27682.5309054886,
          "pricedTokenShare": 0.2784824965633286
        },
        {
          "key": "2025-05-11",
          "label": "05-11",
          "startDate": "2025-05-11",
          "endDate": "2025-05-11",
          "totalTokens": 288603619977,
          "pricedTokens": 80296546245,
          "blendedPricePerMillion": 0.36063405460512654,
          "estimatedRetailValue": 28957.669043122398,
          "pricedTokenShare": 0.27822432113429196
        },
        {
          "key": "2025-05-12",
          "label": "05-12",
          "startDate": "2025-05-12",
          "endDate": "2025-05-12",
          "totalTokens": 322905510657,
          "pricedTokens": 82839223657,
          "blendedPricePerMillion": 0.35842462339298636,
          "estimatedRetailValue": 29691.617541427593,
          "pricedTokenShare": 0.25654323299856696
        },
        {
          "key": "2025-05-13",
          "label": "05-13",
          "startDate": "2025-05-13",
          "endDate": "2025-05-13",
          "totalTokens": 342403647632,
          "pricedTokens": 110019446000,
          "blendedPricePerMillion": 0.29184253714886177,
          "estimatedRetailValue": 32108.354256352195,
          "pricedTokenShare": 0.3213150524559947
        },
        {
          "key": "2025-05-14",
          "label": "05-14",
          "startDate": "2025-05-14",
          "endDate": "2025-05-14",
          "totalTokens": 326602519998,
          "pricedTokens": 103295845296,
          "blendedPricePerMillion": 0.2997800668686034,
          "estimatedRetailValue": 30966.035410083794,
          "pricedTokenShare": 0.3162738771783897
        },
        {
          "key": "2025-05-15",
          "label": "05-15",
          "startDate": "2025-05-15",
          "endDate": "2025-05-15",
          "totalTokens": 331569364598,
          "pricedTokens": 102301122655,
          "blendedPricePerMillion": 0.3304032856062462,
          "estimatedRetailValue": 33800.62704641959,
          "pricedTokenShare": 0.3085361121315641
        },
        {
          "key": "2025-05-16",
          "label": "05-16",
          "startDate": "2025-05-16",
          "endDate": "2025-05-16",
          "totalTokens": 298119972316,
          "pricedTokens": 90481967157,
          "blendedPricePerMillion": 0.3481516198507134,
          "estimatedRetailValue": 31501.4434329886,
          "pricedTokenShare": 0.3035085722505411
        },
        {
          "key": "2025-05-17",
          "label": "05-17",
          "startDate": "2025-05-17",
          "endDate": "2025-05-17",
          "totalTokens": 264429024209,
          "pricedTokens": 84571730515,
          "blendedPricePerMillion": 0.3577001223357431,
          "estimatedRetailValue": 30251.318351361,
          "pricedTokenShare": 0.3198277147071269
        },
        {
          "key": "2025-05-18",
          "label": "05-18",
          "startDate": "2025-05-18",
          "endDate": "2025-05-18",
          "totalTokens": 269232227294,
          "pricedTokens": 80734964734,
          "blendedPricePerMillion": 0.3443651012919906,
          "estimatedRetailValue": 27802.304308429197,
          "pricedTokenShare": 0.2998711021538959
        },
        {
          "key": "2025-05-19",
          "label": "05-19",
          "startDate": "2025-05-19",
          "endDate": "2025-05-19",
          "totalTokens": 333465897864,
          "pricedTokens": 103178292659,
          "blendedPricePerMillion": 0.36181449094038937,
          "estimatedRetailValue": 37331.4014345146,
          "pricedTokenShare": 0.3094118268761623
        },
        {
          "key": "2025-05-20",
          "label": "05-20",
          "startDate": "2025-05-20",
          "endDate": "2025-05-20",
          "totalTokens": 332801509438,
          "pricedTokens": 104800087325,
          "blendedPricePerMillion": 0.3518638766728508,
          "estimatedRetailValue": 36875.36500182779,
          "pricedTokenShare": 0.3149026802852406
        },
        {
          "key": "2025-05-21",
          "label": "05-21",
          "startDate": "2025-05-21",
          "endDate": "2025-05-21",
          "totalTokens": 339695778677,
          "pricedTokens": 103309955248,
          "blendedPricePerMillion": 0.354705618775784,
          "estimatedRetailValue": 36644.621601940395,
          "pricedTokenShare": 0.3041249309907744
        },
        {
          "key": "2025-05-22",
          "label": "05-22",
          "startDate": "2025-05-22",
          "endDate": "2025-05-22",
          "totalTokens": 366743895165,
          "pricedTokens": 106825505121,
          "blendedPricePerMillion": 0.3995113486947066,
          "estimatedRetailValue": 42678.001625884,
          "pricedTokenShare": 0.2912809361773797
        },
        {
          "key": "2025-05-23",
          "label": "05-23",
          "startDate": "2025-05-23",
          "endDate": "2025-05-23",
          "totalTokens": 366523366643,
          "pricedTokens": 105252019890,
          "blendedPricePerMillion": 0.36703535852579056,
          "estimatedRetailValue": 38631.21285588979,
          "pricedTokenShare": 0.2871631919514623
        },
        {
          "key": "2025-05-24",
          "label": "05-24",
          "startDate": "2025-05-24",
          "endDate": "2025-05-24",
          "totalTokens": 307671303826,
          "pricedTokens": 88385735248,
          "blendedPricePerMillion": 0.3219308996822251,
          "estimatedRetailValue": 28454.099267463596,
          "pricedTokenShare": 0.2872732495650148
        },
        {
          "key": "2025-05-25",
          "label": "05-25",
          "startDate": "2025-05-25",
          "endDate": "2025-05-25",
          "totalTokens": 321070374909,
          "pricedTokens": 92167590062,
          "blendedPricePerMillion": 0.3300515054797701,
          "estimatedRetailValue": 30420.051856405396,
          "pricedTokenShare": 0.28706351399789776
        },
        {
          "key": "2025-05-26",
          "label": "05-26",
          "startDate": "2025-05-26",
          "endDate": "2025-05-26",
          "totalTokens": 388143121737,
          "pricedTokens": 111716583333,
          "blendedPricePerMillion": 0.32930044104938433,
          "estimatedRetailValue": 36788.3201640872,
          "pricedTokenShare": 0.28782316902345495
        },
        {
          "key": "2025-05-27",
          "label": "05-27",
          "startDate": "2025-05-27",
          "endDate": "2025-05-27",
          "totalTokens": 403216090874,
          "pricedTokens": 115245312624,
          "blendedPricePerMillion": 0.33237615670451975,
          "estimatedRetailValue": 38304.79408817599,
          "pricedTokenShare": 0.28581526192121315
        },
        {
          "key": "2025-05-28",
          "label": "05-28",
          "startDate": "2025-05-28",
          "endDate": "2025-05-28",
          "totalTokens": 391273310120,
          "pricedTokens": 114714780463,
          "blendedPricePerMillion": 0.34255963370484327,
          "estimatedRetailValue": 39296.65317593679,
          "pricedTokenShare": 0.293183249396229
        },
        {
          "key": "2025-05-29",
          "label": "05-29",
          "startDate": "2025-05-29",
          "endDate": "2025-05-29",
          "totalTokens": 379196749612,
          "pricedTokens": 105592748020,
          "blendedPricePerMillion": 0.35188420270949394,
          "estimatedRetailValue": 37156.419948922194,
          "pricedTokenShare": 0.27846427515015393
        },
        {
          "key": "2025-05-30",
          "label": "05-30",
          "startDate": "2025-05-30",
          "endDate": "2025-05-30",
          "totalTokens": 352460561300,
          "pricedTokens": 102293120623,
          "blendedPricePerMillion": 0.34491764091184735,
          "estimatedRetailValue": 35282.7018467962,
          "pricedTokenShare": 0.2902257212713575
        },
        {
          "key": "2025-05-31",
          "label": "05-31",
          "startDate": "2025-05-31",
          "endDate": "2025-05-31",
          "totalTokens": 288600168394,
          "pricedTokens": 88969775827,
          "blendedPricePerMillion": 0.32983418407639137,
          "estimatedRetailValue": 29345.273417357996,
          "pricedTokenShare": 0.30828040164390175
        },
        {
          "key": "2025-06-01",
          "label": "06-01",
          "startDate": "2025-06-01",
          "endDate": "2025-06-01",
          "totalTokens": 295219520457,
          "pricedTokens": 91075640530,
          "blendedPricePerMillion": 0.3075316515723636,
          "estimatedRetailValue": 28008.6421502018,
          "pricedTokenShare": 0.30850141748423293
        },
        {
          "key": "2025-06-02",
          "label": "06-02",
          "startDate": "2025-06-02",
          "endDate": "2025-06-02",
          "totalTokens": 364374914687,
          "pricedTokens": 110388038891,
          "blendedPricePerMillion": 0.3458816778893817,
          "estimatedRetailValue": 38181.2001105374,
          "pricedTokenShare": 0.3029518071676913
        },
        {
          "key": "2025-06-03",
          "label": "06-03",
          "startDate": "2025-06-03",
          "endDate": "2025-06-03",
          "totalTokens": 395741118681,
          "pricedTokens": 108513634914,
          "blendedPricePerMillion": 0.3519787404198114,
          "estimatedRetailValue": 38194.49253540499,
          "pricedTokenShare": 0.27420358863813427
        },
        {
          "key": "2025-06-04",
          "label": "06-04",
          "startDate": "2025-06-04",
          "endDate": "2025-06-04",
          "totalTokens": 402370845061,
          "pricedTokens": 105802724406,
          "blendedPricePerMillion": 0.35548719766074444,
          "estimatedRetailValue": 37611.51400396099,
          "pricedTokenShare": 0.2629482868967809
        },
        {
          "key": "2025-06-05",
          "label": "06-05",
          "startDate": "2025-06-05",
          "endDate": "2025-06-05",
          "totalTokens": 352830171237,
          "pricedTokens": 85318146117,
          "blendedPricePerMillion": 0.36558660803289805,
          "estimatedRetailValue": 31191.1716425692,
          "pricedTokenShare": 0.24181080041392164
        },
        {
          "key": "2025-06-06",
          "label": "06-06",
          "startDate": "2025-06-06",
          "endDate": "2025-06-06",
          "totalTokens": 304215269313,
          "pricedTokens": 60105953757,
          "blendedPricePerMillion": 0.4061992311482521,
          "estimatedRetailValue": 24414.9922035258,
          "pricedTokenShare": 0.1975770443499941
        },
        {
          "key": "2025-06-07",
          "label": "06-07",
          "startDate": "2025-06-07",
          "endDate": "2025-06-07",
          "totalTokens": 270384691186,
          "pricedTokens": 51186082075,
          "blendedPricePerMillion": 0.3753293909453607,
          "estimatedRetailValue": 19211.641010088995,
          "pricedTokenShare": 0.18930835858524492
        },
        {
          "key": "2025-06-08",
          "label": "06-08",
          "startDate": "2025-06-08",
          "endDate": "2025-06-08",
          "totalTokens": 275452808619,
          "pricedTokens": 51597782745,
          "blendedPricePerMillion": 0.3784248502989118,
          "estimatedRetailValue": 19525.8832110324,
          "pricedTokenShare": 0.18731986434877443
        },
        {
          "key": "2025-06-09",
          "label": "06-09",
          "startDate": "2025-06-09",
          "endDate": "2025-06-09",
          "totalTokens": 318563944013,
          "pricedTokens": 53537784435,
          "blendedPricePerMillion": 0.4422929372802688,
          "estimatedRetailValue": 23679.383933234007,
          "pricedTokenShare": 0.16805977399882777
        },
        {
          "key": "2025-06-10",
          "label": "06-10",
          "startDate": "2025-06-10",
          "endDate": "2025-06-10",
          "totalTokens": 338769282506,
          "pricedTokens": 50025075428,
          "blendedPricePerMillion": 0.4873780441937927,
          "estimatedRetailValue": 24381.123422745597,
          "pricedTokenShare": 0.14766709383432366
        },
        {
          "key": "2025-06-11",
          "label": "06-11",
          "startDate": "2025-06-11",
          "endDate": "2025-06-11",
          "totalTokens": 324423607390,
          "pricedTokens": 45574849851,
          "blendedPricePerMillion": 0.501136627692404,
          "estimatedRetailValue": 22839.2265619178,
          "pricedTokenShare": 0.1404794497467412
        },
        {
          "key": "2025-06-12",
          "label": "06-12",
          "startDate": "2025-06-12",
          "endDate": "2025-06-12",
          "totalTokens": 282516932434,
          "pricedTokens": 40815979860,
          "blendedPricePerMillion": 0.5311880828967461,
          "estimatedRetailValue": 21680.9620933856,
          "pricedTokenShare": 0.14447268525944085
        },
        {
          "key": "2025-06-13",
          "label": "06-13",
          "startDate": "2025-06-13",
          "endDate": "2025-06-13",
          "totalTokens": 296812822131,
          "pricedTokens": 44157099387,
          "blendedPricePerMillion": 0.5661637534821259,
          "estimatedRetailValue": 25000.1491318272,
          "pricedTokenShare": 0.14877086195255748
        },
        {
          "key": "2025-06-14",
          "label": "06-14",
          "startDate": "2025-06-14",
          "endDate": "2025-06-14",
          "totalTokens": 260938723000,
          "pricedTokens": 38676049681,
          "blendedPricePerMillion": 0.5220396500596584,
          "estimatedRetailValue": 20190.4314411592,
          "pricedTokenShare": 0.14821889689787437
        },
        {
          "key": "2025-06-16",
          "label": "06-16",
          "startDate": "2025-06-16",
          "endDate": "2025-06-16",
          "totalTokens": 316856763083,
          "pricedTokens": 43896928163,
          "blendedPricePerMillion": 0.5207408884444039,
          "estimatedRetailValue": 22858.925371580797,
          "pricedTokenShare": 0.13853871300042692
        },
        {
          "key": "2025-06-17",
          "label": "06-17",
          "startDate": "2025-06-17",
          "endDate": "2025-06-17",
          "totalTokens": 311927875980,
          "pricedTokens": 45735822937,
          "blendedPricePerMillion": 0.5290909071525733,
          "estimatedRetailValue": 24198.4080471068,
          "pricedTokenShare": 0.14662307045598086
        },
        {
          "key": "2025-06-18",
          "label": "06-18",
          "startDate": "2025-06-18",
          "endDate": "2025-06-18",
          "totalTokens": 345151126563,
          "pricedTokens": 59687645891,
          "blendedPricePerMillion": 0.807356995114264,
          "estimatedRetailValue": 48189.23843200201,
          "pricedTokenShare": 0.17293191676749545
        },
        {
          "key": "2025-06-19",
          "label": "06-19",
          "startDate": "2025-06-19",
          "endDate": "2025-06-19",
          "totalTokens": 315354469724,
          "pricedTokens": 57849994741,
          "blendedPricePerMillion": 0.8312799361835296,
          "estimatedRetailValue": 48089.539936516,
          "pricedTokenShare": 0.18344434690153794
        },
        {
          "key": "2025-06-20",
          "label": "06-20",
          "startDate": "2025-06-20",
          "endDate": "2025-06-20",
          "totalTokens": 325911386735,
          "pricedTokens": 60081024693,
          "blendedPricePerMillion": 0.7982241370701982,
          "estimatedRetailValue": 47958.124089863195,
          "pricedTokenShare": 0.184347731126842
        },
        {
          "key": "2025-06-21",
          "label": "06-21",
          "startDate": "2025-06-21",
          "endDate": "2025-06-21",
          "totalTokens": 320183191755,
          "pricedTokens": 51410650440,
          "blendedPricePerMillion": 0.7714019298657989,
          "estimatedRetailValue": 39658.274965071985,
          "pricedTokenShare": 0.16056636251955025
        },
        {
          "key": "2025-06-22",
          "label": "06-22",
          "startDate": "2025-06-22",
          "endDate": "2025-06-22",
          "totalTokens": 319506734767,
          "pricedTokens": 57331047854,
          "blendedPricePerMillion": 0.8049844265877106,
          "estimatedRetailValue": 46150.60068242479,
          "pricedTokenShare": 0.17943611703774762
        },
        {
          "key": "2025-06-23",
          "label": "06-23",
          "startDate": "2025-06-23",
          "endDate": "2025-06-23",
          "totalTokens": 355834204069,
          "pricedTokens": 62869193451,
          "blendedPricePerMillion": 0.8367173032533325,
          "estimatedRetailValue": 52603.74200203279,
          "pricedTokenShare": 0.17668114175670702
        },
        {
          "key": "2025-06-24",
          "label": "06-24",
          "startDate": "2025-06-24",
          "endDate": "2025-06-24",
          "totalTokens": 371824750027,
          "pricedTokens": 67753300552,
          "blendedPricePerMillion": 0.8597622798791267,
          "estimatedRetailValue": 58251.732151923214,
          "pricedTokenShare": 0.18221837181919737
        },
        {
          "key": "2025-06-25",
          "label": "06-25",
          "startDate": "2025-06-25",
          "endDate": "2025-06-25",
          "totalTokens": 383015104888,
          "pricedTokens": 77452111464,
          "blendedPricePerMillion": 0.9319489784518447,
          "estimatedRetailValue": 72181.4161578132,
          "pricedTokenShare": 0.2022168590104254
        },
        {
          "key": "2025-06-26",
          "label": "06-26",
          "startDate": "2025-06-26",
          "endDate": "2025-06-26",
          "totalTokens": 373973432435,
          "pricedTokens": 95606262958,
          "blendedPricePerMillion": 1.1358697710035768,
          "estimatedRetailValue": 108596.26401261121,
          "pricedTokenShare": 0.2556498795529205
        },
        {
          "key": "2025-06-27",
          "label": "06-27",
          "startDate": "2025-06-27",
          "endDate": "2025-06-27",
          "totalTokens": 333429689986,
          "pricedTokens": 83122680338,
          "blendedPricePerMillion": 1.0723516984496448,
          "estimatedRetailValue": 89136.7474401412,
          "pricedTokenShare": 0.24929597703638853
        },
        {
          "key": "2025-06-28",
          "label": "06-28",
          "startDate": "2025-06-28",
          "endDate": "2025-06-28",
          "totalTokens": 259521603134,
          "pricedTokens": 78725921394,
          "blendedPricePerMillion": 0.9574618898697066,
          "estimatedRetailValue": 75377.06947963321,
          "pricedTokenShare": 0.3033501660104615
        },
        {
          "key": "2025-06-29",
          "label": "06-29",
          "startDate": "2025-06-29",
          "endDate": "2025-06-29",
          "totalTokens": 281077592894,
          "pricedTokens": 88903079819,
          "blendedPricePerMillion": 0.9164820183713102,
          "estimatedRetailValue": 81478.07403194282,
          "pricedTokenShare": 0.31629372837459563
        },
        {
          "key": "2025-06-30",
          "label": "06-30",
          "startDate": "2025-06-30",
          "endDate": "2025-06-30",
          "totalTokens": 315454333288,
          "pricedTokens": 91897911614,
          "blendedPricePerMillion": 1.109455597936021,
          "estimatedRetailValue": 101956.65247878198,
          "pricedTokenShare": 0.2913192241049359
        },
        {
          "key": "2025-07-01",
          "label": "07-01",
          "startDate": "2025-07-01",
          "endDate": "2025-07-01",
          "totalTokens": 347819643900,
          "pricedTokens": 87312326328,
          "blendedPricePerMillion": 1.1517438756524527,
          "estimatedRetailValue": 100561.4371172424,
          "pricedTokenShare": 0.2510275881747
        },
        {
          "key": "2025-07-02",
          "label": "07-02",
          "startDate": "2025-07-02",
          "endDate": "2025-07-02",
          "totalTokens": 307981945626,
          "pricedTokens": 89957247904,
          "blendedPricePerMillion": 1.1948305995266253,
          "estimatedRetailValue": 107483.67244490157,
          "pricedTokenShare": 0.29208610823324105
        },
        {
          "key": "2025-07-03",
          "label": "07-03",
          "startDate": "2025-07-03",
          "endDate": "2025-07-03",
          "totalTokens": 311736368098,
          "pricedTokens": 92826823110,
          "blendedPricePerMillion": 1.1350002870693394,
          "estimatedRetailValue": 105358.4708775848,
          "pricedTokenShare": 0.2977734798039932
        },
        {
          "key": "2025-07-04",
          "label": "07-04",
          "startDate": "2025-07-04",
          "endDate": "2025-07-04",
          "totalTokens": 299561203271,
          "pricedTokens": 90670292613,
          "blendedPricePerMillion": 1.211972728096152,
          "estimatedRetailValue": 109889.921895454,
          "pricedTokenShare": 0.302677020999193
        },
        {
          "key": "2025-07-05",
          "label": "07-05",
          "startDate": "2025-07-05",
          "endDate": "2025-07-05",
          "totalTokens": 253061798022,
          "pricedTokens": 77168752829,
          "blendedPricePerMillion": 1.1241970628415587,
          "estimatedRetailValue": 86752.88527350801,
          "pricedTokenShare": 0.3049403482950489
        },
        {
          "key": "2025-07-06",
          "label": "07-06",
          "startDate": "2025-07-06",
          "endDate": "2025-07-06",
          "totalTokens": 274289625800,
          "pricedTokens": 75240088428,
          "blendedPricePerMillion": 1.1550647679234012,
          "estimatedRetailValue": 86907.175278624,
          "pricedTokenShare": 0.2743089105486687
        },
        {
          "key": "2025-07-07",
          "label": "07-07",
          "startDate": "2025-07-07",
          "endDate": "2025-07-07",
          "totalTokens": 333244344472,
          "pricedTokens": 92809861658,
          "blendedPricePerMillion": 1.2667658891565976,
          "estimatedRetailValue": 117568.36692569719,
          "pricedTokenShare": 0.2785039362184828
        },
        {
          "key": "2025-07-08",
          "label": "07-08",
          "startDate": "2025-07-08",
          "endDate": "2025-07-08",
          "totalTokens": 348300492893,
          "pricedTokens": 99488723494,
          "blendedPricePerMillion": 1.1363894373428678,
          "estimatedRetailValue": 113057.93451330681,
          "pricedTokenShare": 0.2856404901056615
        },
        {
          "key": "2025-07-09",
          "label": "07-09",
          "startDate": "2025-07-09",
          "endDate": "2025-07-09",
          "totalTokens": 350738237774,
          "pricedTokens": 105660206133,
          "blendedPricePerMillion": 1.134477117694067,
          "estimatedRetailValue": 119869.08610872681,
          "pricedTokenShare": 0.30125088956249674
        },
        {
          "key": "2025-07-10",
          "label": "07-10",
          "startDate": "2025-07-10",
          "endDate": "2025-07-10",
          "totalTokens": 375287543974,
          "pricedTokens": 103671462747,
          "blendedPricePerMillion": 1.1507817892054384,
          "estimatedRetailValue": 119303.23138953763,
          "pricedTokenShare": 0.27624541344804765
        },
        {
          "key": "2025-07-11",
          "label": "07-11",
          "startDate": "2025-07-11",
          "endDate": "2025-07-11",
          "totalTokens": 353861055816,
          "pricedTokens": 102068259837,
          "blendedPricePerMillion": 1.1705472621033222,
          "estimatedRetailValue": 119475.72209985083,
          "pricedTokenShare": 0.28844163029365194
        },
        {
          "key": "2025-07-12",
          "label": "07-12",
          "startDate": "2025-07-12",
          "endDate": "2025-07-12",
          "totalTokens": 300696977506,
          "pricedTokens": 85065622762,
          "blendedPricePerMillion": 1.0746837111644163,
          "estimatedRetailValue": 91418.6391623784,
          "pricedTokenShare": 0.28289483807765453
        },
        {
          "key": "2025-07-13",
          "label": "07-13",
          "startDate": "2025-07-13",
          "endDate": "2025-07-13",
          "totalTokens": 309570142792,
          "pricedTokens": 81176583952,
          "blendedPricePerMillion": 1.0722840698438851,
          "estimatedRetailValue": 87044.35781607438,
          "pricedTokenShare": 0.2622235568969017
        },
        {
          "key": "2025-07-14",
          "label": "07-14",
          "startDate": "2025-07-14",
          "endDate": "2025-07-14",
          "totalTokens": 372143032204,
          "pricedTokens": 101226296940,
          "blendedPricePerMillion": 1.1574301184755915,
          "estimatedRetailValue": 117162.3648601096,
          "pricedTokenShare": 0.27200911526004373
        },
        {
          "key": "2025-07-16",
          "label": "07-16",
          "startDate": "2025-07-16",
          "endDate": "2025-07-16",
          "totalTokens": 393212930827,
          "pricedTokens": 126618149383,
          "blendedPricePerMillion": 1.158917627686326,
          "estimatedRetailValue": 146740.0053049792,
          "pricedTokenShare": 0.32200911886773015
        },
        {
          "key": "2025-07-17",
          "label": "07-17",
          "startDate": "2025-07-17",
          "endDate": "2025-07-17",
          "totalTokens": 387832453655,
          "pricedTokens": 121856522506,
          "blendedPricePerMillion": 1.199888863953864,
          "estimatedRetailValue": 146214.2843550928,
          "pricedTokenShare": 0.3141988798451576
        },
        {
          "key": "2025-07-18",
          "label": "07-18",
          "startDate": "2025-07-18",
          "endDate": "2025-07-18",
          "totalTokens": 384226470319,
          "pricedTokens": 124833972826,
          "blendedPricePerMillion": 1.1085081773674414,
          "estimatedRetailValue": 138379.47969088596,
          "pricedTokenShare": 0.324896857632838
        },
        {
          "key": "2025-07-19",
          "label": "07-19",
          "startDate": "2025-07-19",
          "endDate": "2025-07-19",
          "totalTokens": 345796902507,
          "pricedTokens": 115750111622,
          "blendedPricePerMillion": 1.0575538780257123,
          "estimatedRetailValue": 122411.97942775518,
          "pricedTokenShare": 0.33473437958183233
        },
        {
          "key": "2025-07-20",
          "label": "07-20",
          "startDate": "2025-07-20",
          "endDate": "2025-07-20",
          "totalTokens": 339423137933,
          "pricedTokens": 118497771302,
          "blendedPricePerMillion": 0.9860564186651964,
          "estimatedRetailValue": 116845.4879898576,
          "pricedTokenShare": 0.34911518414337067
        },
        {
          "key": "2025-07-21",
          "label": "07-21",
          "startDate": "2025-07-21",
          "endDate": "2025-07-21",
          "totalTokens": 411420971977,
          "pricedTokens": 140682270046,
          "blendedPricePerMillion": 1.1235890898483147,
          "estimatedRetailValue": 158069.06375878,
          "pricedTokenShare": 0.34194238900846474
        },
        {
          "key": "2025-07-22",
          "label": "07-22",
          "startDate": "2025-07-22",
          "endDate": "2025-07-22",
          "totalTokens": 439002125731,
          "pricedTokens": 143381433220,
          "blendedPricePerMillion": 1.1415316654371106,
          "estimatedRetailValue": 163674.44625638644,
          "pricedTokenShare": 0.3266076057860764
        },
        {
          "key": "2025-07-23",
          "label": "07-23",
          "startDate": "2025-07-23",
          "endDate": "2025-07-23",
          "totalTokens": 464710917479,
          "pricedTokens": 151268133964,
          "blendedPricePerMillion": 1.0642480992935215,
          "estimatedRetailValue": 160986.8240548648,
          "pricedTokenShare": 0.3255101790691967
        },
        {
          "key": "2025-07-24",
          "label": "07-24",
          "startDate": "2025-07-24",
          "endDate": "2025-07-24",
          "totalTokens": 480589511202,
          "pricedTokens": 144950820932,
          "blendedPricePerMillion": 1.0557561833500468,
          "estimatedRetailValue": 153032.7254806244,
          "pricedTokenShare": 0.3016104545633221
        },
        {
          "key": "2025-07-25",
          "label": "07-25",
          "startDate": "2025-07-25",
          "endDate": "2025-07-25",
          "totalTokens": 444545364757,
          "pricedTokens": 126528361999,
          "blendedPricePerMillion": 1.039014192978275,
          "estimatedRetailValue": 131464.763931254,
          "pricedTokenShare": 0.2846241846839718
        },
        {
          "key": "2025-07-26",
          "label": "07-26",
          "startDate": "2025-07-26",
          "endDate": "2025-07-26",
          "totalTokens": 374916246404,
          "pricedTokens": 105040071767,
          "blendedPricePerMillion": 0.960950689947127,
          "estimatedRetailValue": 100938.32943659439,
          "pricedTokenShare": 0.28016943190509686
        },
        {
          "key": "2025-07-27",
          "label": "07-27",
          "startDate": "2025-07-27",
          "endDate": "2025-07-27",
          "totalTokens": 381299360956,
          "pricedTokens": 107160841802,
          "blendedPricePerMillion": 0.9983031268564203,
          "estimatedRetailValue": 106979.00344750281,
          "pricedTokenShare": 0.2810412310509112
        },
        {
          "key": "2025-07-28",
          "label": "07-28",
          "startDate": "2025-07-28",
          "endDate": "2025-07-28",
          "totalTokens": 481812982036,
          "pricedTokens": 132555088142,
          "blendedPricePerMillion": 1.0683571884645098,
          "estimatedRetailValue": 141616.1812840524,
          "pricedTokenShare": 0.27511730294576364
        },
        {
          "key": "2025-07-29",
          "label": "07-29",
          "startDate": "2025-07-29",
          "endDate": "2025-07-29",
          "totalTokens": 514471143689,
          "pricedTokens": 135788385506,
          "blendedPricePerMillion": 1.0620939594930159,
          "estimatedRetailValue": 144220.02401523158,
          "pricedTokenShare": 0.2639378071476146
        },
        {
          "key": "2025-07-30",
          "label": "07-30",
          "startDate": "2025-07-30",
          "endDate": "2025-07-30",
          "totalTokens": 509064942422,
          "pricedTokens": 140255658879,
          "blendedPricePerMillion": 1.0457440776659988,
          "estimatedRetailValue": 146671.52463185682,
          "pricedTokenShare": 0.2755162400531839
        },
        {
          "key": "2025-07-31",
          "label": "07-31",
          "startDate": "2025-07-31",
          "endDate": "2025-07-31",
          "totalTokens": 498032267972,
          "pricedTokens": 137727873513,
          "blendedPricePerMillion": 1.0079070530169973,
          "estimatedRetailValue": 138816.8951107856,
          "pricedTokenShare": 0.2765440762981712
        },
        {
          "key": "2025-08-01",
          "label": "08-01",
          "startDate": "2025-08-01",
          "endDate": "2025-08-01",
          "totalTokens": 499064274817,
          "pricedTokens": 130195638458,
          "blendedPricePerMillion": 1.0076841444997158,
          "estimatedRetailValue": 131196.080557144,
          "pricedTokenShare": 0.2608794999516664
        },
        {
          "key": "2025-08-02",
          "label": "08-02",
          "startDate": "2025-08-02",
          "endDate": "2025-08-02",
          "totalTokens": 456016334999,
          "pricedTokens": 118035410613,
          "blendedPricePerMillion": 0.9681605283609248,
          "estimatedRetailValue": 114277.2255043808,
          "pricedTokenShare": 0.25884031240516603
        },
        {
          "key": "2025-08-03",
          "label": "08-03",
          "startDate": "2025-08-03",
          "endDate": "2025-08-03",
          "totalTokens": 449623336077,
          "pricedTokens": 109696076042,
          "blendedPricePerMillion": 0.9480397039924958,
          "estimatedRetailValue": 103996.235459996,
          "pricedTokenShare": 0.24397327104751088
        },
        {
          "key": "2025-08-04",
          "label": "08-04",
          "startDate": "2025-08-04",
          "endDate": "2025-08-04",
          "totalTokens": 537927259052,
          "pricedTokens": 144298541002,
          "blendedPricePerMillion": 1.016850288621595,
          "estimatedRetailValue": 146730.01306555877,
          "pricedTokenShare": 0.26824917044787844
        },
        {
          "key": "2025-08-05",
          "label": "08-05",
          "startDate": "2025-08-05",
          "endDate": "2025-08-05",
          "totalTokens": 539539996362,
          "pricedTokens": 152792980064,
          "blendedPricePerMillion": 0.9986049804132315,
          "estimatedRetailValue": 152579.83086409,
          "pricedTokenShare": 0.2831912019391511
        },
        {
          "key": "2025-08-06",
          "label": "08-06",
          "startDate": "2025-08-06",
          "endDate": "2025-08-06",
          "totalTokens": 552586703600,
          "pricedTokens": 154492915206,
          "blendedPricePerMillion": 0.9806462410020476,
          "estimatedRetailValue": 151502.89655821197,
          "pricedTokenShare": 0.27958131131188513
        },
        {
          "key": "2025-08-07",
          "label": "08-07",
          "startDate": "2025-08-07",
          "endDate": "2025-08-07",
          "totalTokens": 548248080187,
          "pricedTokens": 157489159497,
          "blendedPricePerMillion": 0.9622817217930485,
          "estimatedRetailValue": 151548.9395645132,
          "pricedTokenShare": 0.2872589347568396
        },
        {
          "key": "2025-08-08",
          "label": "08-08",
          "startDate": "2025-08-08",
          "endDate": "2025-08-08",
          "totalTokens": 486043209609,
          "pricedTokens": 150490475751,
          "blendedPricePerMillion": 0.935371937174658,
          "estimatedRetailValue": 140764.56782954876,
          "pricedTokenShare": 0.3096236564482875
        },
        {
          "key": "2025-08-09",
          "label": "08-09",
          "startDate": "2025-08-09",
          "endDate": "2025-08-09",
          "totalTokens": 378181043372,
          "pricedTokens": 126376421405,
          "blendedPricePerMillion": 0.8679463787181955,
          "estimatedRetailValue": 109687.9573138344,
          "pricedTokenShare": 0.3341691066220077
        },
        {
          "key": "2025-08-10",
          "label": "08-10",
          "startDate": "2025-08-10",
          "endDate": "2025-08-10",
          "totalTokens": 388699957625,
          "pricedTokens": 123291400281,
          "blendedPricePerMillion": 0.878437719536018,
          "estimatedRetailValue": 108303.816501244,
          "pricedTokenShare": 0.317189127146615
        },
        {
          "key": "2025-08-11",
          "label": "08-11",
          "startDate": "2025-08-11",
          "endDate": "2025-08-11",
          "totalTokens": 478600254157,
          "pricedTokens": 148900871265,
          "blendedPricePerMillion": 0.9396341370638603,
          "estimatedRetailValue": 139912.34167914523,
          "pricedTokenShare": 0.3111174095117688
        },
        {
          "key": "2025-08-12",
          "label": "08-12",
          "startDate": "2025-08-12",
          "endDate": "2025-08-12",
          "totalTokens": 519093889487,
          "pricedTokens": 170911414176,
          "blendedPricePerMillion": 0.9060850918128207,
          "estimatedRetailValue": 154860.28440551998,
          "pricedTokenShare": 0.32924952043821015
        },
        {
          "key": "2025-08-13",
          "label": "08-13",
          "startDate": "2025-08-13",
          "endDate": "2025-08-13",
          "totalTokens": 486377558919,
          "pricedTokens": 154130446834,
          "blendedPricePerMillion": 0.9289887493195871,
          "estimatedRetailValue": 143185.45103638677,
          "pricedTokenShare": 0.3168946510948472
        },
        {
          "key": "2025-08-14",
          "label": "08-14",
          "startDate": "2025-08-14",
          "endDate": "2025-08-14",
          "totalTokens": 477464329038,
          "pricedTokens": 146575399582,
          "blendedPricePerMillion": 0.9441514108061878,
          "estimatedRetailValue": 138389.370304826,
          "pricedTokenShare": 0.3069871206448482
        },
        {
          "key": "2025-08-15",
          "label": "08-15",
          "startDate": "2025-08-15",
          "endDate": "2025-08-15",
          "totalTokens": 445390829459,
          "pricedTokens": 135663096659,
          "blendedPricePerMillion": 0.9430441169033966,
          "estimatedRetailValue": 127936.2851851668,
          "pricedTokenShare": 0.30459337661663355
        },
        {
          "key": "2025-08-16",
          "label": "08-16",
          "startDate": "2025-08-16",
          "endDate": "2025-08-16",
          "totalTokens": 389454674939,
          "pricedTokens": 117193003148,
          "blendedPricePerMillion": 0.8422118165806147,
          "estimatedRetailValue": 98701.33207181479,
          "pricedTokenShare": 0.3009156409955943
        },
        {
          "key": "2025-08-17",
          "label": "08-17",
          "startDate": "2025-08-17",
          "endDate": "2025-08-17",
          "totalTokens": 407273603704,
          "pricedTokens": 128884943295,
          "blendedPricePerMillion": 0.796613812155371,
          "estimatedRetailValue": 102671.52600765877,
          "pricedTokenShare": 0.3164578851240051
        },
        {
          "key": "2025-08-18",
          "label": "08-18",
          "startDate": "2025-08-18",
          "endDate": "2025-08-18",
          "totalTokens": 485260347251,
          "pricedTokens": 159063556150,
          "blendedPricePerMillion": 0.8874658516654118,
          "estimatedRetailValue": 141163.4743275888,
          "pricedTokenShare": 0.3277901379148226
        },
        {
          "key": "2025-08-19",
          "label": "08-19",
          "startDate": "2025-08-19",
          "endDate": "2025-08-19",
          "totalTokens": 493722773971,
          "pricedTokens": 162115414844,
          "blendedPricePerMillion": 0.8658519154868407,
          "estimatedRetailValue": 140367.94247262122,
          "pricedTokenShare": 0.328353123231707
        },
        {
          "key": "2025-08-20",
          "label": "08-20",
          "startDate": "2025-08-20",
          "endDate": "2025-08-20",
          "totalTokens": 493617116586,
          "pricedTokens": 159475364378,
          "blendedPricePerMillion": 0.9142749934239475,
          "estimatedRetailValue": 145804.33771797759,
          "pricedTokenShare": 0.32307502924732057
        },
        {
          "key": "2025-08-21",
          "label": "08-21",
          "startDate": "2025-08-21",
          "endDate": "2025-08-21",
          "totalTokens": 469360617547,
          "pricedTokens": 153384184902,
          "blendedPricePerMillion": 0.9250350599284812,
          "estimatedRetailValue": 141885.74867290282,
          "pricedTokenShare": 0.3267938961381665
        },
        {
          "key": "2025-08-22",
          "label": "08-22",
          "startDate": "2025-08-22",
          "endDate": "2025-08-22",
          "totalTokens": 459620039867,
          "pricedTokens": 160749184205,
          "blendedPricePerMillion": 0.8290939662414792,
          "estimatedRetailValue": 133276.1787026056,
          "pricedTokenShare": 0.34974363661670604
        },
        {
          "key": "2025-08-23",
          "label": "08-23",
          "startDate": "2025-08-23",
          "endDate": "2025-08-23",
          "totalTokens": 397945064237,
          "pricedTokens": 141405455702,
          "blendedPricePerMillion": 0.7083767975404278,
          "estimatedRetailValue": 100168.34386492759,
          "pricedTokenShare": 0.3553391370065709
        },
        {
          "key": "2025-08-24",
          "label": "08-24",
          "startDate": "2025-08-24",
          "endDate": "2025-08-24",
          "totalTokens": 407889643724,
          "pricedTokens": 153932014723,
          "blendedPricePerMillion": 0.7718414597802625,
          "estimatedRetailValue": 118811.11095071718,
          "pricedTokenShare": 0.377386425694982
        },
        {
          "key": "2025-08-25",
          "label": "08-25",
          "startDate": "2025-08-25",
          "endDate": "2025-08-25",
          "totalTokens": 493622049699,
          "pricedTokens": 173742461163,
          "blendedPricePerMillion": 0.7787033733945287,
          "estimatedRetailValue": 135293.840609496,
          "pricedTokenShare": 0.35197467631144996
        },
        {
          "key": "2025-08-26",
          "label": "08-26",
          "startDate": "2025-08-26",
          "endDate": "2025-08-26",
          "totalTokens": 503923094951,
          "pricedTokens": 184516567411,
          "blendedPricePerMillion": 0.835833836232372,
          "estimatedRetailValue": 154225.1903875652,
          "pricedTokenShare": 0.3661601725734397
        },
        {
          "key": "2025-08-27",
          "label": "08-27",
          "startDate": "2025-08-27",
          "endDate": "2025-08-27",
          "totalTokens": 521637394678,
          "pricedTokens": 186788441936,
          "blendedPricePerMillion": 0.8913287674401537,
          "estimatedRetailValue": 166489.9117228816,
          "pricedTokenShare": 0.3580810038576741
        },
        {
          "key": "2025-08-28",
          "label": "08-28",
          "startDate": "2025-08-28",
          "endDate": "2025-08-28",
          "totalTokens": 535672761499,
          "pricedTokens": 159794298382,
          "blendedPricePerMillion": 0.8647512029794897,
          "estimatedRetailValue": 138182.31175509802,
          "pricedTokenShare": 0.2983058125539921
        },
        {
          "key": "2025-08-29",
          "label": "08-29",
          "startDate": "2025-08-29",
          "endDate": "2025-08-29",
          "totalTokens": 610251515109,
          "pricedTokens": 190157062064,
          "blendedPricePerMillion": 0.926928354458191,
          "estimatedRetailValue": 176261.97262758762,
          "pricedTokenShare": 0.31160440794650895
        },
        {
          "key": "2025-08-30",
          "label": "08-30",
          "startDate": "2025-08-30",
          "endDate": "2025-08-30",
          "totalTokens": 521523584511,
          "pricedTokens": 166155946047,
          "blendedPricePerMillion": 1.0459991732067586,
          "estimatedRetailValue": 173798.98218854878,
          "pricedTokenShare": 0.31859718521223546
        },
        {
          "key": "2025-08-31",
          "label": "08-31",
          "startDate": "2025-08-31",
          "endDate": "2025-08-31",
          "totalTokens": 538615331454,
          "pricedTokens": 174445376030,
          "blendedPricePerMillion": 0.7759942676830698,
          "estimatedRetailValue": 135368.6118230976,
          "pricedTokenShare": 0.3238774796088372
        },
        {
          "key": "2025-09-01",
          "label": "09-01",
          "startDate": "2025-09-01",
          "endDate": "2025-09-01",
          "totalTokens": 713177483965,
          "pricedTokens": 274428699563,
          "blendedPricePerMillion": 0.7903867232788707,
          "estimatedRetailValue": 216904.8006212812,
          "pricedTokenShare": 0.3847972008836834
        },
        {
          "key": "2025-09-02",
          "label": "09-02",
          "startDate": "2025-09-02",
          "endDate": "2025-09-02",
          "totalTokens": 640458972964,
          "pricedTokens": 157577064005,
          "blendedPricePerMillion": 0.8649632523346314,
          "estimatedRetailValue": 136298.3697751072,
          "pricedTokenShare": 0.24603771772568694
        },
        {
          "key": "2025-09-03",
          "label": "09-03",
          "startDate": "2025-09-03",
          "endDate": "2025-09-03",
          "totalTokens": 697991366083,
          "pricedTokens": 186696597060,
          "blendedPricePerMillion": 0.8614047213402509,
          "estimatedRetailValue": 160821.3301656424,
          "pricedTokenShare": 0.26747694331479654
        },
        {
          "key": "2025-09-04",
          "label": "09-04",
          "startDate": "2025-09-04",
          "endDate": "2025-09-04",
          "totalTokens": 668785563468,
          "pricedTokens": 167363059988,
          "blendedPricePerMillion": 0.8800529953958073,
          "estimatedRetailValue": 147288.3622610476,
          "pricedTokenShare": 0.25024921160100366
        },
        {
          "key": "2025-09-05",
          "label": "09-05",
          "startDate": "2025-09-05",
          "endDate": "2025-09-05",
          "totalTokens": 656252833815,
          "pricedTokens": 181722884236,
          "blendedPricePerMillion": 0.8174509810955582,
          "estimatedRetailValue": 148549.55000623275,
          "pricedTokenShare": 0.2769098659423516
        },
        {
          "key": "2025-09-06",
          "label": "09-06",
          "startDate": "2025-09-06",
          "endDate": "2025-09-06",
          "totalTokens": 603488321805,
          "pricedTokens": 157547647556,
          "blendedPricePerMillion": 0.8088784274710569,
          "estimatedRetailValue": 127436.89340686159,
          "pricedTokenShare": 0.2610616342745188
        },
        {
          "key": "2025-09-07",
          "label": "09-07",
          "startDate": "2025-09-07",
          "endDate": "2025-09-07",
          "totalTokens": 619571722342,
          "pricedTokens": 155696592821,
          "blendedPricePerMillion": 0.8085570234956169,
          "estimatedRetailValue": 125889.5736597568,
          "pricedTokenShare": 0.25129712542796845
        },
        {
          "key": "2025-09-08",
          "label": "09-08",
          "startDate": "2025-09-08",
          "endDate": "2025-09-08",
          "totalTokens": 762151554820,
          "pricedTokens": 189937535254,
          "blendedPricePerMillion": 0.7865106868516952,
          "estimatedRetailValue": 149387.90131154162,
          "pricedTokenShare": 0.24921229124679567
        },
        {
          "key": "2025-09-09",
          "label": "09-09",
          "startDate": "2025-09-09",
          "endDate": "2025-09-09",
          "totalTokens": 748493026824,
          "pricedTokens": 190245822167,
          "blendedPricePerMillion": 0.7484411744210746,
          "estimatedRetailValue": 142387.80657137238,
          "pricedTokenShare": 0.25417180300830544
        },
        {
          "key": "2025-09-10",
          "label": "09-10",
          "startDate": "2025-09-10",
          "endDate": "2025-09-10",
          "totalTokens": 749592748652,
          "pricedTokens": 190214391748,
          "blendedPricePerMillion": 0.7776141865419498,
          "estimatedRetailValue": 147913.4095076928,
          "pricedTokenShare": 0.2537569794932841
        },
        {
          "key": "2025-09-11",
          "label": "09-11",
          "startDate": "2025-09-11",
          "endDate": "2025-09-11",
          "totalTokens": 731589502627,
          "pricedTokens": 184119351325,
          "blendedPricePerMillion": 0.7824264525885789,
          "estimatedRetailValue": 144059.85091013002,
          "pricedTokenShare": 0.25167030235379556
        },
        {
          "key": "2025-09-12",
          "label": "09-12",
          "startDate": "2025-09-12",
          "endDate": "2025-09-12",
          "totalTokens": 682942968401,
          "pricedTokens": 177131430357,
          "blendedPricePerMillion": 0.8146372513311777,
          "estimatedRetailValue": 144297.8615503864,
          "pricedTokenShare": 0.2593648936333944
        },
        {
          "key": "2025-09-13",
          "label": "09-13",
          "startDate": "2025-09-13",
          "endDate": "2025-09-13",
          "totalTokens": 613463442764,
          "pricedTokens": 158994080549,
          "blendedPricePerMillion": 0.7322037063576843,
          "estimatedRetailValue": 116416.05506690999,
          "pricedTokenShare": 0.25917449918880525
        },
        {
          "key": "2025-09-14",
          "label": "09-14",
          "startDate": "2025-09-14",
          "endDate": "2025-09-14",
          "totalTokens": 609240434697,
          "pricedTokens": 146029414636,
          "blendedPricePerMillion": 0.751409007530526,
          "estimatedRetailValue": 109727.81752190042,
          "pricedTokenShare": 0.2396909435412414
        },
        {
          "key": "2025-09-15",
          "label": "09-15",
          "startDate": "2025-09-15",
          "endDate": "2025-09-15",
          "totalTokens": 725965796379,
          "pricedTokens": 163280529411,
          "blendedPricePerMillion": 0.8164990549849338,
          "estimatedRetailValue": 133318.3979615212,
          "pricedTokenShare": 0.22491490677028708
        },
        {
          "key": "2025-09-16",
          "label": "09-16",
          "startDate": "2025-09-16",
          "endDate": "2025-09-16",
          "totalTokens": 803652511533,
          "pricedTokens": 181374686722,
          "blendedPricePerMillion": 0.8423266941426196,
          "estimatedRetailValue": 152776.74026769554,
          "pricedTokenShare": 0.22568794860856015
        },
        {
          "key": "2025-09-17",
          "label": "09-17",
          "startDate": "2025-09-17",
          "endDate": "2025-09-17",
          "totalTokens": 750120281892,
          "pricedTokens": 169503504687,
          "blendedPricePerMillion": 0.8291902646423845,
          "estimatedRetailValue": 140550.6559092252,
          "pricedTokenShare": 0.225968433035123
        },
        {
          "key": "2025-09-18",
          "label": "09-18",
          "startDate": "2025-09-18",
          "endDate": "2025-09-18",
          "totalTokens": 748597258835,
          "pricedTokens": 174942909230,
          "blendedPricePerMillion": 0.8500459165280773,
          "estimatedRetailValue": 148709.50561650356,
          "pricedTokenShare": 0.23369429578496434
        },
        {
          "key": "2025-09-19",
          "label": "09-19",
          "startDate": "2025-09-19",
          "endDate": "2025-09-19",
          "totalTokens": 710109208550,
          "pricedTokens": 172429126740,
          "blendedPricePerMillion": 0.8676376501171951,
          "estimatedRetailValue": 149606.00233645362,
          "pricedTokenShare": 0.24282057557328376
        },
        {
          "key": "2025-09-20",
          "label": "09-20",
          "startDate": "2025-09-20",
          "endDate": "2025-09-20",
          "totalTokens": 571331950922,
          "pricedTokens": 148295936491,
          "blendedPricePerMillion": 0.7952967758661603,
          "estimatedRetailValue": 117939.28016534518,
          "pricedTokenShare": 0.25956177709243117
        },
        {
          "key": "2025-09-21",
          "label": "09-21",
          "startDate": "2025-09-21",
          "endDate": "2025-09-21",
          "totalTokens": 607595765850,
          "pricedTokens": 145214860520,
          "blendedPricePerMillion": 0.7289084816478751,
          "estimatedRetailValue": 105848.34349434117,
          "pricedTokenShare": 0.23899913179422957
        },
        {
          "key": "2025-09-22",
          "label": "09-22",
          "startDate": "2025-09-22",
          "endDate": "2025-09-22",
          "totalTokens": 708182416131,
          "pricedTokens": 177486227580,
          "blendedPricePerMillion": 0.7977058617763833,
          "estimatedRetailValue": 141581.8041251432,
          "pricedTokenShare": 0.2506221893359867
        },
        {
          "key": "2025-09-23",
          "label": "09-23",
          "startDate": "2025-09-23",
          "endDate": "2025-09-23",
          "totalTokens": 742472408316,
          "pricedTokens": 185602016685,
          "blendedPricePerMillion": 0.7826918364651754,
          "estimatedRetailValue": 145269.18329082278,
          "pricedTokenShare": 0.2499783353646279
        },
        {
          "key": "2025-09-24",
          "label": "09-24",
          "startDate": "2025-09-24",
          "endDate": "2025-09-24",
          "totalTokens": 776032293626,
          "pricedTokens": 185832250888,
          "blendedPricePerMillion": 0.7995975089081006,
          "estimatedRetailValue": 148591.00488482995,
          "pricedTokenShare": 0.23946458467559567
        },
        {
          "key": "2025-09-25",
          "label": "09-25",
          "startDate": "2025-09-25",
          "endDate": "2025-09-25",
          "totalTokens": 788701352249,
          "pricedTokens": 172068309637,
          "blendedPricePerMillion": 0.841890271030484,
          "estimatedRetailValue": 144862.63583605117,
          "pricedTokenShare": 0.21816662180981847
        },
        {
          "key": "2025-09-26",
          "label": "09-26",
          "startDate": "2025-09-26",
          "endDate": "2025-09-26",
          "totalTokens": 774854727313,
          "pricedTokens": 171088833048,
          "blendedPricePerMillion": 0.7940602582146148,
          "estimatedRetailValue": 135854.842947732,
          "pricedTokenShare": 0.22080117345517494
        },
        {
          "key": "2025-09-27",
          "label": "09-27",
          "startDate": "2025-09-27",
          "endDate": "2025-09-27",
          "totalTokens": 717589473264,
          "pricedTokens": 175546446012,
          "blendedPricePerMillion": 0.6073034382228595,
          "estimatedRetailValue": 106609.96023089119,
          "pricedTokenShare": 0.24463353010672823
        },
        {
          "key": "2025-09-28",
          "label": "09-28",
          "startDate": "2025-09-28",
          "endDate": "2025-09-28",
          "totalTokens": 750147399913,
          "pricedTokens": 187773386377,
          "blendedPricePerMillion": 0.6114331469996995,
          "estimatedRetailValue": 114810.87255527962,
          "pricedTokenShare": 0.2503153198941667
        },
        {
          "key": "2025-09-29",
          "label": "09-29",
          "startDate": "2025-09-29",
          "endDate": "2025-09-29",
          "totalTokens": 838856679073,
          "pricedTokens": 184525729701,
          "blendedPricePerMillion": 0.7504381069917273,
          "estimatedRetailValue": 138475.1392880856,
          "pricedTokenShare": 0.21997289203790435
        },
        {
          "key": "2025-09-30",
          "label": "09-30",
          "startDate": "2025-09-30",
          "endDate": "2025-09-30",
          "totalTokens": 908756341363,
          "pricedTokens": 222274718658,
          "blendedPricePerMillion": 0.7878513830581637,
          "estimatedRetailValue": 175119.44451356953,
          "pricedTokenShare": 0.2445922064484533
        },
        {
          "key": "2025-10-01",
          "label": "10-01",
          "startDate": "2025-10-01",
          "endDate": "2025-10-01",
          "totalTokens": 775173608351,
          "pricedTokens": 196008631302,
          "blendedPricePerMillion": 0.7437313397561207,
          "estimatedRetailValue": 145777.76196199996,
          "pricedTokenShare": 0.2528577201163522
        },
        {
          "key": "2025-10-02",
          "label": "10-02",
          "startDate": "2025-10-02",
          "endDate": "2025-10-02",
          "totalTokens": 756705726947,
          "pricedTokens": 197835723648,
          "blendedPricePerMillion": 0.7053312543945955,
          "estimatedRetailValue": 139539.71912470637,
          "pricedTokenShare": 0.2614434073945584
        },
        {
          "key": "2025-10-03",
          "label": "10-03",
          "startDate": "2025-10-03",
          "endDate": "2025-10-03",
          "totalTokens": 788794649883,
          "pricedTokens": 221593633764,
          "blendedPricePerMillion": 0.6678227510756656,
          "estimatedRetailValue": 147985.27012112798,
          "pricedTokenShare": 0.28092689750985056
        },
        {
          "key": "2025-10-04",
          "label": "10-04",
          "startDate": "2025-10-04",
          "endDate": "2025-10-04",
          "totalTokens": 659066896093,
          "pricedTokens": 231350748868,
          "blendedPricePerMillion": 0.5230652057042746,
          "estimatedRetailValue": 121011.5270464784,
          "pricedTokenShare": 0.35102771849028575
        },
        {
          "key": "2025-10-05",
          "label": "10-05",
          "startDate": "2025-10-05",
          "endDate": "2025-10-05",
          "totalTokens": 652969757580,
          "pricedTokens": 214351077951,
          "blendedPricePerMillion": 0.5474216552333871,
          "estimatedRetailValue": 117340.42189299721,
          "pricedTokenShare": 0.3282710653329734
        },
        {
          "key": "2025-10-06",
          "label": "10-06",
          "startDate": "2025-10-06",
          "endDate": "2025-10-06",
          "totalTokens": 754198039772,
          "pricedTokens": 231547130746,
          "blendedPricePerMillion": 0.6215860731239088,
          "estimatedRetailValue": 143926.4717435144,
          "pricedTokenShare": 0.30701104820691194
        },
        {
          "key": "2025-10-07",
          "label": "10-07",
          "startDate": "2025-10-07",
          "endDate": "2025-10-07",
          "totalTokens": 794072114739,
          "pricedTokens": 249345048009,
          "blendedPricePerMillion": 0.6468349481616579,
          "estimatedRetailValue": 161285.0912032676,
          "pricedTokenShare": 0.3140080647347201
        },
        {
          "key": "2025-10-08",
          "label": "10-08",
          "startDate": "2025-10-08",
          "endDate": "2025-10-08",
          "totalTokens": 762229990867,
          "pricedTokens": 231805370596,
          "blendedPricePerMillion": 0.6177637439814566,
          "estimatedRetailValue": 143200.953614394,
          "pricedTokenShare": 0.30411473357579716
        },
        {
          "key": "2025-10-09",
          "label": "10-09",
          "startDate": "2025-10-09",
          "endDate": "2025-10-09",
          "totalTokens": 793301227322,
          "pricedTokens": 250734324766,
          "blendedPricePerMillion": 0.65986991083835,
          "estimatedRetailValue": 165452.03652745433,
          "pricedTokenShare": 0.31606446092667806
        },
        {
          "key": "2025-10-10",
          "label": "10-10",
          "startDate": "2025-10-10",
          "endDate": "2025-10-10",
          "totalTokens": 718543585964,
          "pricedTokens": 213556773176,
          "blendedPricePerMillion": 0.6925212432540995,
          "estimatedRetailValue": 147892.60206517723,
          "pricedTokenShare": 0.29720782057986317
        },
        {
          "key": "2025-10-11",
          "label": "10-11",
          "startDate": "2025-10-11",
          "endDate": "2025-10-11",
          "totalTokens": 606528651400,
          "pricedTokens": 189285171773,
          "blendedPricePerMillion": 0.6572092289536918,
          "estimatedRetailValue": 124399.96179330043,
          "pricedTokenShare": 0.31207952227168273
        },
        {
          "key": "2025-10-12",
          "label": "10-12",
          "startDate": "2025-10-12",
          "endDate": "2025-10-12",
          "totalTokens": 590837662180,
          "pricedTokens": 194871122881,
          "blendedPricePerMillion": 0.6208827327438711,
          "estimatedRetailValue": 120992.11530722199,
          "pricedTokenShare": 0.32982176891362774
        },
        {
          "key": "2025-10-13",
          "label": "10-13",
          "startDate": "2025-10-13",
          "endDate": "2025-10-13",
          "totalTokens": 729734457606,
          "pricedTokens": 248208012600,
          "blendedPricePerMillion": 0.6481052253325267,
          "estimatedRetailValue": 160864.90993546162,
          "pricedTokenShare": 0.3401347024426974
        },
        {
          "key": "2025-10-14",
          "label": "10-14",
          "startDate": "2025-10-14",
          "endDate": "2025-10-14",
          "totalTokens": 717584744786,
          "pricedTokens": 204238178249,
          "blendedPricePerMillion": 0.7744038831444914,
          "estimatedRetailValue": 158162.8383223824,
          "pricedTokenShare": 0.28461889655960904
        },
        {
          "key": "2025-10-15",
          "label": "10-15",
          "startDate": "2025-10-15",
          "endDate": "2025-10-15",
          "totalTokens": 685403678592,
          "pricedTokens": 189163500438,
          "blendedPricePerMillion": 0.8620702610365617,
          "estimatedRetailValue": 163072.22820117642,
          "pricedTokenShare": 0.27598845227471164
        },
        {
          "key": "2025-10-16",
          "label": "10-16",
          "startDate": "2025-10-16",
          "endDate": "2025-10-16",
          "totalTokens": 707939948219,
          "pricedTokens": 183475877534,
          "blendedPricePerMillion": 0.8006245311286132,
          "estimatedRetailValue": 146895.28842406961,
          "pricedTokenShare": 0.259168702084943
        },
        {
          "key": "2025-10-17",
          "label": "10-17",
          "startDate": "2025-10-17",
          "endDate": "2025-10-17",
          "totalTokens": 685830324309,
          "pricedTokens": 177106192412,
          "blendedPricePerMillion": 0.8038183493009641,
          "estimatedRetailValue": 142361.20723559277,
          "pricedTokenShare": 0.2582361644484606
        },
        {
          "key": "2025-10-18",
          "label": "10-18",
          "startDate": "2025-10-18",
          "endDate": "2025-10-18",
          "totalTokens": 561448579540,
          "pricedTokens": 163195094700,
          "blendedPricePerMillion": 0.729050671371313,
          "estimatedRetailValue": 118977.49335554,
          "pricedTokenShare": 0.2906679269430288
        },
        {
          "key": "2025-10-19",
          "label": "10-19",
          "startDate": "2025-10-19",
          "endDate": "2025-10-19",
          "totalTokens": 556555665134,
          "pricedTokens": 167914134401,
          "blendedPricePerMillion": 0.7315785244712263,
          "estimatedRetailValue": 122842.37468294676,
          "pricedTokenShare": 0.3017023182408392
        },
        {
          "key": "2025-10-20",
          "label": "10-20",
          "startDate": "2025-10-20",
          "endDate": "2025-10-20",
          "totalTokens": 689957530774,
          "pricedTokens": 188822014937,
          "blendedPricePerMillion": 0.7704332394436512,
          "estimatedRetailValue": 145474.7566461904,
          "pricedTokenShare": 0.273671938510734
        },
        {
          "key": "2025-10-21",
          "label": "10-21",
          "startDate": "2025-10-21",
          "endDate": "2025-10-21",
          "totalTokens": 747952422691,
          "pricedTokens": 209103985207,
          "blendedPricePerMillion": 0.7564852246589465,
          "estimatedRetailValue": 158184.07522639842,
          "pricedTokenShare": 0.2795685646082688
        },
        {
          "key": "2025-10-22",
          "label": "10-22",
          "startDate": "2025-10-22",
          "endDate": "2025-10-22",
          "totalTokens": 728888793419,
          "pricedTokens": 198024817523,
          "blendedPricePerMillion": 0.7874929780928596,
          "estimatedRetailValue": 155943.15328748236,
          "pricedTokenShare": 0.2716804254790702
        },
        {
          "key": "2025-10-23",
          "label": "10-23",
          "startDate": "2025-10-23",
          "endDate": "2025-10-23",
          "totalTokens": 754399295557,
          "pricedTokens": 200306076451,
          "blendedPricePerMillion": 0.8165926019599204,
          "estimatedRetailValue": 163568.46015750483,
          "pricedTokenShare": 0.2655173164008681
        },
        {
          "key": "2025-10-24",
          "label": "10-24",
          "startDate": "2025-10-24",
          "endDate": "2025-10-24",
          "totalTokens": 746130090866,
          "pricedTokens": 212638375825,
          "blendedPricePerMillion": 0.7655529083716711,
          "estimatedRetailValue": 162785.9270442572,
          "pricedTokenShare": 0.2849883397387178
        },
        {
          "key": "2025-10-25",
          "label": "10-25",
          "startDate": "2025-10-25",
          "endDate": "2025-10-25",
          "totalTokens": 612859382202,
          "pricedTokens": 177583570364,
          "blendedPricePerMillion": 0.7548843038413706,
          "estimatedRetailValue": 134055.0498878932,
          "pricedTokenShare": 0.28976234275135565
        },
        {
          "key": "2025-10-26",
          "label": "10-26",
          "startDate": "2025-10-26",
          "endDate": "2025-10-26",
          "totalTokens": 606124678848,
          "pricedTokens": 179762964758,
          "blendedPricePerMillion": 0.7667752343937518,
          "estimatedRetailValue": 137837.7894376312,
          "pricedTokenShare": 0.2965775376439998
        },
        {
          "key": "2025-10-27",
          "label": "10-27",
          "startDate": "2025-10-27",
          "endDate": "2025-10-27",
          "totalTokens": 808198435444,
          "pricedTokens": 230284066822,
          "blendedPricePerMillion": 0.7215775494708002,
          "estimatedRetailValue": 166167.81261958875,
          "pricedTokenShare": 0.28493505644500394
        },
        {
          "key": "2025-10-28",
          "label": "10-28",
          "startDate": "2025-10-28",
          "endDate": "2025-10-28",
          "totalTokens": 836836800480,
          "pricedTokens": 216714629426,
          "blendedPricePerMillion": 0.8217501885004856,
          "estimatedRetailValue": 178085.2875816284,
          "pricedTokenShare": 0.25896880885459983
        },
        {
          "key": "2025-10-29",
          "label": "10-29",
          "startDate": "2025-10-29",
          "endDate": "2025-10-29",
          "totalTokens": 882670634720,
          "pricedTokens": 234947442179,
          "blendedPricePerMillion": 0.7893199230181844,
          "estimatedRetailValue": 185448.6969740476,
          "pricedTokenShare": 0.26617792972520243
        },
        {
          "key": "2025-10-30",
          "label": "10-30",
          "startDate": "2025-10-30",
          "endDate": "2025-10-30",
          "totalTokens": 839936886983,
          "pricedTokens": 221566498506,
          "blendedPricePerMillion": 0.8172721911295572,
          "estimatedRetailValue": 181080.13771490238,
          "pricedTokenShare": 0.26378946077943166
        },
        {
          "key": "2025-10-31",
          "label": "10-31",
          "startDate": "2025-10-31",
          "endDate": "2025-10-31",
          "totalTokens": 795584528430,
          "pricedTokens": 205735992361,
          "blendedPricePerMillion": 0.8671202192658035,
          "estimatedRetailValue": 178397.838806938,
          "pricedTokenShare": 0.2585972766049105
        },
        {
          "key": "2025-11-01",
          "label": "11-01",
          "startDate": "2025-11-01",
          "endDate": "2025-11-01",
          "totalTokens": 667615679989,
          "pricedTokens": 178203728456,
          "blendedPricePerMillion": 0.8159988136873912,
          "estimatedRetailValue": 145414.031014766,
          "pricedTokenShare": 0.2669256187316274
        },
        {
          "key": "2025-11-02",
          "label": "11-02",
          "startDate": "2025-11-02",
          "endDate": "2025-11-02",
          "totalTokens": 680316040142,
          "pricedTokens": 188998590401,
          "blendedPricePerMillion": 0.7716164810330287,
          "estimatedRetailValue": 145834.42724542238,
          "pricedTokenShare": 0.2778099871958788
        },
        {
          "key": "2025-11-03",
          "label": "11-03",
          "startDate": "2025-11-03",
          "endDate": "2025-11-03",
          "totalTokens": 855212355442,
          "pricedTokens": 219212257511,
          "blendedPricePerMillion": 0.7750048601205184,
          "estimatedRetailValue": 169890.56496901563,
          "pricedTokenShare": 0.25632494212236256
        },
        {
          "key": "2025-11-04",
          "label": "11-04",
          "startDate": "2025-11-04",
          "endDate": "2025-11-04",
          "totalTokens": 843660094744,
          "pricedTokens": 224609180840,
          "blendedPricePerMillion": 0.729177383803858,
          "estimatedRetailValue": 163779.93486323883,
          "pricedTokenShare": 0.26623184175631226
        },
        {
          "key": "2025-11-05",
          "label": "11-05",
          "startDate": "2025-11-05",
          "endDate": "2025-11-05",
          "totalTokens": 870220639953,
          "pricedTokens": 226998840268,
          "blendedPricePerMillion": 0.789850175554621,
          "estimatedRetailValue": 179295.07383637517,
          "pricedTokenShare": 0.2608520527394754
        },
        {
          "key": "2025-11-06",
          "label": "11-06",
          "startDate": "2025-11-06",
          "endDate": "2025-11-06",
          "totalTokens": 815410486832,
          "pricedTokens": 256521125165,
          "blendedPricePerMillion": 0.811892872442923,
          "estimatedRetailValue": 208267.67315250242,
          "pricedTokenShare": 0.31459139820684123
        },
        {
          "key": "2025-11-07",
          "label": "11-07",
          "startDate": "2025-11-07",
          "endDate": "2025-11-07",
          "totalTokens": 902186629114,
          "pricedTokens": 259028460133,
          "blendedPricePerMillion": 0.7478690748554369,
          "estimatedRetailValue": 193719.37484089512,
          "pricedTokenShare": 0.2871118367021035
        },
        {
          "key": "2025-11-08",
          "label": "11-08",
          "startDate": "2025-11-08",
          "endDate": "2025-11-08",
          "totalTokens": 797042525948,
          "pricedTokens": 258791956821,
          "blendedPricePerMillion": 0.6662175359725782,
          "estimatedRetailValue": 172411.73980280844,
          "pricedTokenShare": 0.3246902748547747
        },
        {
          "key": "2025-11-09",
          "label": "11-09",
          "startDate": "2025-11-09",
          "endDate": "2025-11-09",
          "totalTokens": 744474553464,
          "pricedTokens": 227486146399,
          "blendedPricePerMillion": 0.7053767307956796,
          "estimatedRetailValue": 160463.43424823397,
          "pricedTokenShare": 0.30556604700660245
        },
        {
          "key": "2025-11-10",
          "label": "11-10",
          "startDate": "2025-11-10",
          "endDate": "2025-11-10",
          "totalTokens": 910825672740,
          "pricedTokens": 269363179423,
          "blendedPricePerMillion": 0.7814949051520438,
          "estimatedRetailValue": 210505.95235463034,
          "pricedTokenShare": 0.29573516369239533
        },
        {
          "key": "2025-11-11",
          "label": "11-11",
          "startDate": "2025-11-11",
          "endDate": "2025-11-11",
          "totalTokens": 949647793603,
          "pricedTokens": 292553848517,
          "blendedPricePerMillion": 0.7586375353536476,
          "estimatedRetailValue": 221942.33059716126,
          "pricedTokenShare": 0.30806563284587807
        },
        {
          "key": "2025-11-12",
          "label": "11-12",
          "startDate": "2025-11-12",
          "endDate": "2025-11-12",
          "totalTokens": 881916356487,
          "pricedTokens": 265159049560,
          "blendedPricePerMillion": 0.7064929005248726,
          "estimatedRetailValue": 187332.98602406282,
          "pricedTokenShare": 0.30066235602685365
        },
        {
          "key": "2025-11-13",
          "label": "11-13",
          "startDate": "2025-11-13",
          "endDate": "2025-11-13",
          "totalTokens": 901368356290,
          "pricedTokens": 251010392185,
          "blendedPricePerMillion": 0.7412405354750161,
          "estimatedRetailValue": 186059.0775130032,
          "pricedTokenShare": 0.27847704041680565
        },
        {
          "key": "2025-11-14",
          "label": "11-14",
          "startDate": "2025-11-14",
          "endDate": "2025-11-14",
          "totalTokens": 812896999546,
          "pricedTokens": 229170848032,
          "blendedPricePerMillion": 0.7466383597306651,
          "estimatedRetailValue": 171107.74607269798,
          "pricedTokenShare": 0.28191867870098064
        },
        {
          "key": "2025-11-15",
          "label": "11-15",
          "startDate": "2025-11-15",
          "endDate": "2025-11-15",
          "totalTokens": 693672882394,
          "pricedTokens": 196919264433,
          "blendedPricePerMillion": 0.7081730332842309,
          "estimatedRetailValue": 139452.91280561718,
          "pricedTokenShare": 0.28387914452327057
        },
        {
          "key": "2025-11-16",
          "label": "11-16",
          "startDate": "2025-11-16",
          "endDate": "2025-11-16",
          "totalTokens": 777386360554,
          "pricedTokens": 207805709119,
          "blendedPricePerMillion": 0.6901042616940556,
          "estimatedRetailValue": 143407.60546737717,
          "pricedTokenShare": 0.26731329447420255
        },
        {
          "key": "2025-11-17",
          "label": "11-17",
          "startDate": "2025-11-17",
          "endDate": "2025-11-17",
          "totalTokens": 895158521563,
          "pricedTokens": 252417468132,
          "blendedPricePerMillion": 0.7469136034990644,
          "estimatedRetailValue": 188534.04070858238,
          "pricedTokenShare": 0.2819807464841692
        },
        {
          "key": "2025-11-18",
          "label": "11-18",
          "startDate": "2025-11-18",
          "endDate": "2025-11-18",
          "totalTokens": 946644725789,
          "pricedTokens": 249790270802,
          "blendedPricePerMillion": 0.7130379868092042,
          "estimatedRetailValue": 178109.95181718402,
          "pricedTokenShare": 0.2638690778040382
        },
        {
          "key": "2025-11-19",
          "label": "11-19",
          "startDate": "2025-11-19",
          "endDate": "2025-11-19",
          "totalTokens": 974905831481,
          "pricedTokens": 267770813367,
          "blendedPricePerMillion": 0.6502828930517179,
          "estimatedRetailValue": 174126.7791911044,
          "pricedTokenShare": 0.27466325948653286
        },
        {
          "key": "2025-11-20",
          "label": "11-20",
          "startDate": "2025-11-20",
          "endDate": "2025-11-20",
          "totalTokens": 950497881430,
          "pricedTokens": 263148023448,
          "blendedPricePerMillion": 0.636574949356898,
          "estimatedRetailValue": 167513.4396997784,
          "pricedTokenShare": 0.2768528248080895
        },
        {
          "key": "2025-11-21",
          "label": "11-21",
          "startDate": "2025-11-21",
          "endDate": "2025-11-21",
          "totalTokens": 914059968966,
          "pricedTokens": 240964646157,
          "blendedPricePerMillion": 0.6628591675588871,
          "estimatedRetailValue": 159725.6247627508,
          "pricedTokenShare": 0.26362017191233444
        },
        {
          "key": "2025-11-22",
          "label": "11-22",
          "startDate": "2025-11-22",
          "endDate": "2025-11-22",
          "totalTokens": 766516913255,
          "pricedTokens": 210775384434,
          "blendedPricePerMillion": 0.6434591604559872,
          "estimatedRetailValue": 135625.3519126896,
          "pricedTokenShare": 0.2749781261041537
        },
        {
          "key": "2025-11-23",
          "label": "11-23",
          "startDate": "2025-11-23",
          "endDate": "2025-11-23",
          "totalTokens": 824048259184,
          "pricedTokens": 223017873901,
          "blendedPricePerMillion": 0.6344760914817147,
          "estimatedRetailValue": 141499.5089632684,
          "pricedTokenShare": 0.2706369092046135
        },
        {
          "key": "2025-11-24",
          "label": "11-24",
          "startDate": "2025-11-24",
          "endDate": "2025-11-24",
          "totalTokens": 1015013853257,
          "pricedTokens": 257796032008,
          "blendedPricePerMillion": 0.6879541881367636,
          "estimatedRetailValue": 177351.85990494277,
          "pricedTokenShare": 0.2539827719402825
        },
        {
          "key": "2025-11-25",
          "label": "11-25",
          "startDate": "2025-11-25",
          "endDate": "2025-11-25",
          "totalTokens": 1043852595370,
          "pricedTokens": 255125289052,
          "blendedPricePerMillion": 0.6669917719367239,
          "estimatedRetailValue": 170166.46861066236,
          "pricedTokenShare": 0.2444073906446238
        },
        {
          "key": "2025-11-26",
          "label": "11-26",
          "startDate": "2025-11-26",
          "endDate": "2025-11-26",
          "totalTokens": 1084308770070,
          "pricedTokens": 262221496298,
          "blendedPricePerMillion": 0.6878656938486999,
          "estimatedRetailValue": 180373.17149306805,
          "pricedTokenShare": 0.24183286489610492
        },
        {
          "key": "2025-11-27",
          "label": "11-27",
          "startDate": "2025-11-27",
          "endDate": "2025-11-27",
          "totalTokens": 1088012755787,
          "pricedTokens": 247955800663,
          "blendedPricePerMillion": 0.690301177911632,
          "estimatedRetailValue": 171164.18126769073,
          "pricedTokenShare": 0.22789788018950602
        },
        {
          "key": "2025-11-28",
          "label": "11-28",
          "startDate": "2025-11-28",
          "endDate": "2025-11-28",
          "totalTokens": 1103763003384,
          "pricedTokens": 216244753565,
          "blendedPricePerMillion": 0.6944067230882157,
          "estimatedRetailValue": 150161.8107080904,
          "pricedTokenShare": 0.19591592842124667
        },
        {
          "key": "2025-11-29",
          "label": "11-29",
          "startDate": "2025-11-29",
          "endDate": "2025-11-29",
          "totalTokens": 927904867275,
          "pricedTokens": 194127114567,
          "blendedPricePerMillion": 0.6875954715130734,
          "estimatedRetailValue": 133480.9248741688,
          "pricedTokenShare": 0.2092101479509399
        },
        {
          "key": "2025-11-30",
          "label": "11-30",
          "startDate": "2025-11-30",
          "endDate": "2025-11-30",
          "totalTokens": 922030064198,
          "pricedTokens": 209079954032,
          "blendedPricePerMillion": 0.6820045242112012,
          "estimatedRetailValue": 142593.47457169398,
          "pricedTokenShare": 0.22676045190984295
        },
        {
          "key": "2025-12-01",
          "label": "12-01",
          "startDate": "2025-12-01",
          "endDate": "2025-12-01",
          "totalTokens": 1015109519099,
          "pricedTokens": 241021133844,
          "blendedPricePerMillion": 0.7219911678822993,
          "estimatedRetailValue": 174015.12990834555,
          "pricedTokenShare": 0.23743362593814282
        },
        {
          "key": "2025-12-02",
          "label": "12-02",
          "startDate": "2025-12-02",
          "endDate": "2025-12-02",
          "totalTokens": 1026570896607,
          "pricedTokens": 239472990311,
          "blendedPricePerMillion": 0.716653368846449,
          "estimatedRetailValue": 171619.1252541112,
          "pricedTokenShare": 0.2332746730912604
        },
        {
          "key": "2025-12-03",
          "label": "12-03",
          "startDate": "2025-12-03",
          "endDate": "2025-12-03",
          "totalTokens": 976117437403,
          "pricedTokens": 253199578175,
          "blendedPricePerMillion": 0.7352743639900339,
          "estimatedRetailValue": 186171.15880516797,
          "pricedTokenShare": 0.25939458560298617
        },
        {
          "key": "2025-12-04",
          "label": "12-04",
          "startDate": "2025-12-04",
          "endDate": "2025-12-04",
          "totalTokens": 898751591697,
          "pricedTokens": 281564469473,
          "blendedPricePerMillion": 0.6218929604723891,
          "estimatedRetailValue": 175102.96148440157,
          "pricedTokenShare": 0.3132839730957885
        },
        {
          "key": "2025-12-05",
          "label": "12-05",
          "startDate": "2025-12-05",
          "endDate": "2025-12-05",
          "totalTokens": 843822919210,
          "pricedTokens": 263058415680,
          "blendedPricePerMillion": 0.6425717604335858,
          "estimatedRetailValue": 169033.90926036757,
          "pricedTokenShare": 0.31174599515059315
        },
        {
          "key": "2025-12-06",
          "label": "12-06",
          "startDate": "2025-12-06",
          "endDate": "2025-12-06",
          "totalTokens": 703381365260,
          "pricedTokens": 223214173633,
          "blendedPricePerMillion": 0.6623898622488528,
          "estimatedRetailValue": 147854.80572475438,
          "pricedTokenShare": 0.3173444516126617
        },
        {
          "key": "2025-12-07",
          "label": "12-07",
          "startDate": "2025-12-07",
          "endDate": "2025-12-07",
          "totalTokens": 719935353270,
          "pricedTokens": 224507835121,
          "blendedPricePerMillion": 0.6551802648068027,
          "estimatedRetailValue": 147093.10286577878,
          "pricedTokenShare": 0.3118444372835265
        },
        {
          "key": "2025-12-08",
          "label": "12-08",
          "startDate": "2025-12-08",
          "endDate": "2025-12-08",
          "totalTokens": 926168784356,
          "pricedTokens": 269314036469,
          "blendedPricePerMillion": 0.7062765481177176,
          "estimatedRetailValue": 190210.1880369744,
          "pricedTokenShare": 0.29078289078406394
        },
        {
          "key": "2025-12-09",
          "label": "12-09",
          "startDate": "2025-12-09",
          "endDate": "2025-12-09",
          "totalTokens": 933583522452,
          "pricedTokens": 291181363026,
          "blendedPricePerMillion": 0.6940491122161669,
          "estimatedRetailValue": 202094.16650208872,
          "pricedTokenShare": 0.311896424929641
        },
        {
          "key": "2025-12-10",
          "label": "12-10",
          "startDate": "2025-12-10",
          "endDate": "2025-12-10",
          "totalTokens": 899477293159,
          "pricedTokens": 282297815529,
          "blendedPricePerMillion": 0.621659152174262,
          "estimatedRetailValue": 175493.02066240436,
          "pricedTokenShare": 0.3138465169449235
        },
        {
          "key": "2025-12-11",
          "label": "12-11",
          "startDate": "2025-12-11",
          "endDate": "2025-12-11",
          "totalTokens": 850751596689,
          "pricedTokens": 277085084020,
          "blendedPricePerMillion": 0.6582756725422999,
          "estimatedRetailValue": 182398.37003470518,
          "pricedTokenShare": 0.3256944625180539
        },
        {
          "key": "2025-12-12",
          "label": "12-12",
          "startDate": "2025-12-12",
          "endDate": "2025-12-12",
          "totalTokens": 838859646336,
          "pricedTokens": 271183542901,
          "blendedPricePerMillion": 0.6385237192640655,
          "estimatedRetailValue": 173157.12441635277,
          "pricedTokenShare": 0.32327641946478747
        },
        {
          "key": "2025-12-13",
          "label": "12-13",
          "startDate": "2025-12-13",
          "endDate": "2025-12-13",
          "totalTokens": 662233192347,
          "pricedTokens": 241635517536,
          "blendedPricePerMillion": 0.5879303099452741,
          "estimatedRetailValue": 142064.8447187272,
          "pricedTokenShare": 0.36487980416630444
        },
        {
          "key": "2025-12-14",
          "label": "12-14",
          "startDate": "2025-12-14",
          "endDate": "2025-12-14",
          "totalTokens": 661672600380,
          "pricedTokens": 243985116812,
          "blendedPricePerMillion": 0.574305182428237,
          "estimatedRetailValue": 140121.91702049036,
          "pricedTokenShare": 0.36873994279327693
        },
        {
          "key": "2025-12-15",
          "label": "12-15",
          "startDate": "2025-12-15",
          "endDate": "2025-12-15",
          "totalTokens": 862177267218,
          "pricedTokens": 303014232981,
          "blendedPricePerMillion": 0.5848099911455571,
          "estimatedRetailValue": 177205.7509065964,
          "pricedTokenShare": 0.3514523573078428
        },
        {
          "key": "2025-12-16",
          "label": "12-16",
          "startDate": "2025-12-16",
          "endDate": "2025-12-16",
          "totalTokens": 885696419175,
          "pricedTokens": 275678473321,
          "blendedPricePerMillion": 0.6353449358089799,
          "estimatedRetailValue": 175150.92193604834,
          "pricedTokenShare": 0.31125616786142857
        },
        {
          "key": "2025-12-17",
          "label": "12-17",
          "startDate": "2025-12-17",
          "endDate": "2025-12-17",
          "totalTokens": 923604614263,
          "pricedTokens": 265650512502,
          "blendedPricePerMillion": 0.6343007416404836,
          "estimatedRetailValue": 168502.31709719315,
          "pricedTokenShare": 0.2876236307177597
        },
        {
          "key": "2025-12-18",
          "label": "12-18",
          "startDate": "2025-12-18",
          "endDate": "2025-12-18",
          "totalTokens": 900483548874,
          "pricedTokens": 260711600733,
          "blendedPricePerMillion": 0.6249081550874372,
          "estimatedRetailValue": 162920.8054239516,
          "pricedTokenShare": 0.2895240019198619
        },
        {
          "key": "2025-12-19",
          "label": "12-19",
          "startDate": "2025-12-19",
          "endDate": "2025-12-19",
          "totalTokens": 858310522853,
          "pricedTokens": 232163922126,
          "blendedPricePerMillion": 0.6200423801440873,
          "estimatedRetailValue": 143951.47085859158,
          "pricedTokenShare": 0.2704894277123548
        },
        {
          "key": "2025-12-20",
          "label": "12-20",
          "startDate": "2025-12-20",
          "endDate": "2025-12-20",
          "totalTokens": 691575313543,
          "pricedTokens": 186318955925,
          "blendedPricePerMillion": 0.6530205501850865,
          "estimatedRetailValue": 121670.10710805439,
          "pricedTokenShare": 0.26941238687435487
        },
        {
          "key": "2025-12-21",
          "label": "12-21",
          "startDate": "2025-12-21",
          "endDate": "2025-12-21",
          "totalTokens": 718652924977,
          "pricedTokens": 193209199651,
          "blendedPricePerMillion": 0.6157921581942261,
          "estimatedRetailValue": 118976.7100360684,
          "pricedTokenShare": 0.2688491105176863
        },
        {
          "key": "2025-12-22",
          "label": "12-22",
          "startDate": "2025-12-22",
          "endDate": "2025-12-22",
          "totalTokens": 895710872569,
          "pricedTokens": 216994007463,
          "blendedPricePerMillion": 0.6371691426072771,
          "estimatedRetailValue": 138261.8856861168,
          "pricedTokenShare": 0.24225898569327026
        },
        {
          "key": "2025-12-23",
          "label": "12-23",
          "startDate": "2025-12-23",
          "endDate": "2025-12-23",
          "totalTokens": 919893606912,
          "pricedTokens": 216713426701,
          "blendedPricePerMillion": 0.6047882978893712,
          "estimatedRetailValue": 131065.74446427079,
          "pricedTokenShare": 0.23558531668514085
        },
        {
          "key": "2025-12-24",
          "label": "12-24",
          "startDate": "2025-12-24",
          "endDate": "2025-12-24",
          "totalTokens": 832020782412,
          "pricedTokens": 200736628243,
          "blendedPricePerMillion": 0.6223721859110553,
          "estimatedRetailValue": 124932.89411201078,
          "pricedTokenShare": 0.24126395937018705
        },
        {
          "key": "2025-12-25",
          "label": "12-25",
          "startDate": "2025-12-25",
          "endDate": "2025-12-25",
          "totalTokens": 737262325637,
          "pricedTokens": 188597507835,
          "blendedPricePerMillion": 0.6429141906882123,
          "estimatedRetailValue": 121252.0141155528,
          "pricedTokenShare": 0.2558078736385321
        },
        {
          "key": "2025-12-26",
          "label": "12-26",
          "startDate": "2025-12-26",
          "endDate": "2025-12-26",
          "totalTokens": 817227654508,
          "pricedTokens": 209359327546,
          "blendedPricePerMillion": 0.6016801129190057,
          "estimatedRetailValue": 125967.34383852438,
          "pricedTokenShare": 0.2561823824623773
        },
        {
          "key": "2025-12-27",
          "label": "12-27",
          "startDate": "2025-12-27",
          "endDate": "2025-12-27",
          "totalTokens": 733624354484,
          "pricedTokens": 199608318674,
          "blendedPricePerMillion": 0.5885238081135424,
          "estimatedRetailValue": 117474.247837164,
          "pricedTokenShare": 0.27208518563208817
        },
        {
          "key": "2025-12-28",
          "label": "12-28",
          "startDate": "2025-12-28",
          "endDate": "2025-12-28",
          "totalTokens": 729209611978,
          "pricedTokens": 210587843767,
          "blendedPricePerMillion": 0.5626116997599011,
          "estimatedRetailValue": 118479.18473052437,
          "pricedTokenShare": 0.28878917708692153
        },
        {
          "key": "2025-12-29",
          "label": "12-29",
          "startDate": "2025-12-29",
          "endDate": "2025-12-29",
          "totalTokens": 908489661987,
          "pricedTokens": 251041178149,
          "blendedPricePerMillion": 0.5885820694935444,
          "estimatedRetailValue": 147758.33616303597,
          "pricedTokenShare": 0.2763280515486947
        },
        {
          "key": "2025-12-30",
          "label": "12-30",
          "startDate": "2025-12-30",
          "endDate": "2025-12-30",
          "totalTokens": 875711094778,
          "pricedTokens": 239221868513,
          "blendedPricePerMillion": 0.5700666270378402,
          "estimatedRetailValue": 136372.4036968956,
          "pricedTokenShare": 0.2731744178411314
        },
        {
          "key": "2025-12-31",
          "label": "12-31",
          "startDate": "2025-12-31",
          "endDate": "2025-12-31",
          "totalTokens": 768652128021,
          "pricedTokens": 201187771811,
          "blendedPricePerMillion": 0.5784784875970336,
          "estimatedRetailValue": 116382.79796024438,
          "pricedTokenShare": 0.2617409937171259
        },
        {
          "key": "2026-01-01",
          "label": "01-01",
          "startDate": "2026-01-01",
          "endDate": "2026-01-01",
          "totalTokens": 676146556672,
          "pricedTokens": 187380445116,
          "blendedPricePerMillion": 0.5651223380194311,
          "estimatedRetailValue": 105892.8752430756,
          "pricedTokenShare": 0.2771299258525968
        },
        {
          "key": "2026-01-02",
          "label": "01-02",
          "startDate": "2026-01-02",
          "endDate": "2026-01-02",
          "totalTokens": 780433027499,
          "pricedTokens": 212728959964,
          "blendedPricePerMillion": 0.5706816137404203,
          "estimatedRetailValue": 121400.50616157678,
          "pricedTokenShare": 0.27257811044429764
        },
        {
          "key": "2026-01-03",
          "label": "01-03",
          "startDate": "2026-01-03",
          "endDate": "2026-01-03",
          "totalTokens": 752494217391,
          "pricedTokens": 201030960387,
          "blendedPricePerMillion": 0.5661467557739405,
          "estimatedRetailValue": 113813.02603321958,
          "pricedTokenShare": 0.2671528308669291
        },
        {
          "key": "2026-01-04",
          "label": "01-04",
          "startDate": "2026-01-04",
          "endDate": "2026-01-04",
          "totalTokens": 804614702335,
          "pricedTokens": 205345352418,
          "blendedPricePerMillion": 0.6019244225124453,
          "estimatedRetailValue": 123602.3826698192,
          "pricedTokenShare": 0.2552095454160677
        },
        {
          "key": "2026-01-05",
          "label": "01-05",
          "startDate": "2026-01-05",
          "endDate": "2026-01-05",
          "totalTokens": 920385666646,
          "pricedTokens": 244021149144,
          "blendedPricePerMillion": 0.5922928134128694,
          "estimatedRetailValue": 144531.97295874116,
          "pricedTokenShare": 0.2651292365658447
        },
        {
          "key": "2026-01-06",
          "label": "01-06",
          "startDate": "2026-01-06",
          "endDate": "2026-01-06",
          "totalTokens": 963414695887,
          "pricedTokens": 221883250057,
          "blendedPricePerMillion": 0.5974011956576846,
          "estimatedRetailValue": 132553.3188804648,
          "pricedTokenShare": 0.23030918150227692
        },
        {
          "key": "2026-01-07",
          "label": "01-07",
          "startDate": "2026-01-07",
          "endDate": "2026-01-07",
          "totalTokens": 1017214808143,
          "pricedTokens": 253171186360,
          "blendedPricePerMillion": 0.5770557419212639,
          "estimatedRetailValue": 146093.88677805636,
          "pricedTokenShare": 0.24888665042360375
        },
        {
          "key": "2026-01-08",
          "label": "01-08",
          "startDate": "2026-01-08",
          "endDate": "2026-01-08",
          "totalTokens": 969015458231,
          "pricedTokens": 244219514259,
          "blendedPricePerMillion": 0.56720243718754,
          "estimatedRetailValue": 138521.903696462,
          "pricedTokenShare": 0.25202850190319814
        },
        {
          "key": "2026-01-09",
          "label": "01-09",
          "startDate": "2026-01-09",
          "endDate": "2026-01-09",
          "totalTokens": 957089207783,
          "pricedTokens": 234248696878,
          "blendedPricePerMillion": 0.5451316258449866,
          "estimatedRetailValue": 127696.3729811736,
          "pricedTokenShare": 0.2447511631863589
        },
        {
          "key": "2026-01-10",
          "label": "01-10",
          "startDate": "2026-01-10",
          "endDate": "2026-01-10",
          "totalTokens": 802870338890,
          "pricedTokens": 214305555928,
          "blendedPricePerMillion": 0.5168435994802242,
          "estimatedRetailValue": 110762.45491443801,
          "pricedTokenShare": 0.2669242411225278
        },
        {
          "key": "2026-01-11",
          "label": "01-11",
          "startDate": "2026-01-11",
          "endDate": "2026-01-11",
          "totalTokens": 789693535502,
          "pricedTokens": 189333606457,
          "blendedPricePerMillion": 0.571650205086213,
          "estimatedRetailValue": 108232.5949608564,
          "pricedTokenShare": 0.23975580139027297
        },
        {
          "key": "2026-01-12",
          "label": "01-12",
          "startDate": "2026-01-12",
          "endDate": "2026-01-12",
          "totalTokens": 1014313612337,
          "pricedTokens": 225682013275,
          "blendedPricePerMillion": 0.5672399748708542,
          "estimatedRetailValue": 128015.85953891477,
          "pricedTokenShare": 0.22249727355529014
        },
        {
          "key": "2026-01-13",
          "label": "01-13",
          "startDate": "2026-01-13",
          "endDate": "2026-01-13",
          "totalTokens": 1098350562760,
          "pricedTokens": 251207312770,
          "blendedPricePerMillion": 0.5797180205526657,
          "estimatedRetailValue": 145629.4061073788,
          "pricedTokenShare": 0.22871323718244516
        },
        {
          "key": "2026-01-14",
          "label": "01-14",
          "startDate": "2026-01-14",
          "endDate": "2026-01-14",
          "totalTokens": 1168753721245,
          "pricedTokens": 261345463101,
          "blendedPricePerMillion": 0.5487685407701343,
          "estimatedRetailValue": 143418.16842283073,
          "pricedTokenShare": 0.22361037945839016
        },
        {
          "key": "2026-01-15",
          "label": "01-15",
          "startDate": "2026-01-15",
          "endDate": "2026-01-15",
          "totalTokens": 1227040917358,
          "pricedTokens": 276418628571,
          "blendedPricePerMillion": 0.5497503240036317,
          "estimatedRetailValue": 151961.23061754677,
          "pricedTokenShare": 0.22527254361343554
        },
        {
          "key": "2026-01-16",
          "label": "01-16",
          "startDate": "2026-01-16",
          "endDate": "2026-01-16",
          "totalTokens": 1111775956968,
          "pricedTokens": 283333722194,
          "blendedPricePerMillion": 0.8261729753226793,
          "estimatedRetailValue": 234082.66427426643,
          "pricedTokenShare": 0.2548478588857945
        },
        {
          "key": "2026-01-17",
          "label": "01-17",
          "startDate": "2026-01-17",
          "endDate": "2026-01-17",
          "totalTokens": 965416302518,
          "pricedTokens": 289910110549,
          "blendedPricePerMillion": 1.2284038098024612,
          "estimatedRetailValue": 356126.6842986443,
          "pricedTokenShare": 0.30029543710092327
        },
        {
          "key": "2026-01-18",
          "label": "01-18",
          "startDate": "2026-01-18",
          "endDate": "2026-01-18",
          "totalTokens": 1057621484506,
          "pricedTokens": 386013503821,
          "blendedPricePerMillion": 1.6292723412451686,
          "estimatedRetailValue": 628921.1251226915,
          "pricedTokenShare": 0.36498266107113114
        },
        {
          "key": "2026-01-19",
          "label": "01-19",
          "startDate": "2026-01-19",
          "endDate": "2026-01-19",
          "totalTokens": 1118470681107,
          "pricedTokens": 264504342240,
          "blendedPricePerMillion": 0.7232305618664099,
          "estimatedRetailValue": 191297.62405434038,
          "pricedTokenShare": 0.23648750629583631
        },
        {
          "key": "2026-01-20",
          "label": "01-20",
          "startDate": "2026-01-20",
          "endDate": "2026-01-20",
          "totalTokens": 1167369854809,
          "pricedTokens": 261929852257,
          "blendedPricePerMillion": 0.5475420993053333,
          "estimatedRetailValue": 143417.62117553357,
          "pricedTokenShare": 0.22437606314569072
        },
        {
          "key": "2026-01-21",
          "label": "01-21",
          "startDate": "2026-01-21",
          "endDate": "2026-01-21",
          "totalTokens": 1109751264958,
          "pricedTokens": 260650911148,
          "blendedPricePerMillion": 0.5668679561093877,
          "estimatedRetailValue": 147754.64926051637,
          "pricedTokenShare": 0.23487327239754457
        },
        {
          "key": "2026-01-22",
          "label": "01-22",
          "startDate": "2026-01-22",
          "endDate": "2026-01-22",
          "totalTokens": 1165644748031,
          "pricedTokens": 276225800645,
          "blendedPricePerMillion": 0.5441368168819587,
          "estimatedRetailValue": 150304.6279036408,
          "pricedTokenShare": 0.23697254340278112
        },
        {
          "key": "2026-01-23",
          "label": "01-23",
          "startDate": "2026-01-23",
          "endDate": "2026-01-23",
          "totalTokens": 1098227750683,
          "pricedTokens": 232021970395,
          "blendedPricePerMillion": 0.5679226948247139,
          "estimatedRetailValue": 131770.5426852684,
          "pricedTokenShare": 0.21126944775407738
        },
        {
          "key": "2026-01-24",
          "label": "01-24",
          "startDate": "2026-01-24",
          "endDate": "2026-01-24",
          "totalTokens": 921779225469,
          "pricedTokens": 207536513561,
          "blendedPricePerMillion": 0.5522431903320277,
          "estimatedRetailValue": 114610.62635931278,
          "pricedTokenShare": 0.2251477445213692
        },
        {
          "key": "2026-01-25",
          "label": "01-25",
          "startDate": "2026-01-25",
          "endDate": "2026-01-25",
          "totalTokens": 912436067961,
          "pricedTokens": 207084634246,
          "blendedPricePerMillion": 0.558718919740768,
          "estimatedRetailValue": 115702.10314083718,
          "pricedTokenShare": 0.22695796617155578
        },
        {
          "key": "2026-01-26",
          "label": "01-26",
          "startDate": "2026-01-26",
          "endDate": "2026-01-26",
          "totalTokens": 1123037386403,
          "pricedTokens": 257023351870,
          "blendedPricePerMillion": 0.5527929623834923,
          "estimatedRetailValue": 142080.700081952,
          "pricedTokenShare": 0.2288644661182879
        },
        {
          "key": "2026-01-27",
          "label": "01-27",
          "startDate": "2026-01-27",
          "endDate": "2026-01-27",
          "totalTokens": 1171091999378,
          "pricedTokens": 291622355864,
          "blendedPricePerMillion": 0.5408210422427958,
          "estimatedRetailValue": 157715.50643966798,
          "pricedTokenShare": 0.24901746064262148
        },
        {
          "key": "2026-01-28",
          "label": "01-28",
          "startDate": "2026-01-28",
          "endDate": "2026-01-28",
          "totalTokens": 1262244728033,
          "pricedTokens": 298718320550,
          "blendedPricePerMillion": 0.5356885090645463,
          "estimatedRetailValue": 160019.97176569476,
          "pricedTokenShare": 0.23665642162396128
        },
        {
          "key": "2026-01-29",
          "label": "01-29",
          "startDate": "2026-01-29",
          "endDate": "2026-01-29",
          "totalTokens": 1299991615800,
          "pricedTokens": 313199040098,
          "blendedPricePerMillion": 0.573721804720044,
          "estimatedRetailValue": 179689.11852160998,
          "pricedTokenShare": 0.24092389234776787
        },
        {
          "key": "2026-01-30",
          "label": "01-30",
          "startDate": "2026-01-30",
          "endDate": "2026-01-30",
          "totalTokens": 1226664854860,
          "pricedTokens": 256734451787,
          "blendedPricePerMillion": 0.534366485637398,
          "estimatedRetailValue": 137190.2867434632,
          "pricedTokenShare": 0.20929469917543309
        },
        {
          "key": "2026-01-31",
          "label": "01-31",
          "startDate": "2026-01-31",
          "endDate": "2026-01-31",
          "totalTokens": 1039939632945,
          "pricedTokens": 231073565869,
          "blendedPricePerMillion": 0.5092786717567057,
          "estimatedRetailValue": 117680.83870384998,
          "pricedTokenShare": 0.22219901862440217
        },
        {
          "key": "2026-02-01",
          "label": "02-01",
          "startDate": "2026-02-01",
          "endDate": "2026-02-01",
          "totalTokens": 1126964134499,
          "pricedTokens": 271720870086,
          "blendedPricePerMillion": 0.47574165440128396,
          "estimatedRetailValue": 129268.93627006999,
          "pricedTokenShare": 0.2411087112428786
        },
        {
          "key": "2026-02-02",
          "label": "02-02",
          "startDate": "2026-02-02",
          "endDate": "2026-02-02",
          "totalTokens": 1273715201835,
          "pricedTokens": 294643424580,
          "blendedPricePerMillion": 0.5081350353465933,
          "estimatedRetailValue": 149718.64696359957,
          "pricedTokenShare": 0.2313259857113402
        },
        {
          "key": "2026-02-03",
          "label": "02-03",
          "startDate": "2026-02-03",
          "endDate": "2026-02-03",
          "totalTokens": 1347876943352,
          "pricedTokens": 329867481021,
          "blendedPricePerMillion": 0.517921242668873,
          "estimatedRetailValue": 170845.37568644717,
          "pricedTokenShare": 0.24473115490844524
        },
        {
          "key": "2026-02-04",
          "label": "02-04",
          "startDate": "2026-02-04",
          "endDate": "2026-02-04",
          "totalTokens": 1420287125277,
          "pricedTokens": 324802169325,
          "blendedPricePerMillion": 0.5070338969941396,
          "estimatedRetailValue": 164685.70966500515,
          "pricedTokenShare": 0.22868768120506164
        },
        {
          "key": "2026-02-05",
          "label": "02-05",
          "startDate": "2026-02-05",
          "endDate": "2026-02-05",
          "totalTokens": 1547174716353,
          "pricedTokens": 312593631710,
          "blendedPricePerMillion": 0.5170357445095899,
          "estimatedRetailValue": 161622.0811001364,
          "pricedTokenShare": 0.20204158483590376
        },
        {
          "key": "2026-02-06",
          "label": "02-06",
          "startDate": "2026-02-06",
          "endDate": "2026-02-06",
          "totalTokens": 1535426387252,
          "pricedTokens": 309252270454,
          "blendedPricePerMillion": 0.6062426161494531,
          "estimatedRetailValue": 187481.90549019116,
          "pricedTokenShare": 0.2014113297919012
        },
        {
          "key": "2026-02-07",
          "label": "02-07",
          "startDate": "2026-02-07",
          "endDate": "2026-02-07",
          "totalTokens": 1326326438380,
          "pricedTokens": 262976637979,
          "blendedPricePerMillion": 0.5973768290255901,
          "estimatedRetailValue": 157096.15010370556,
          "pricedTokenShare": 0.19827444463838376
        },
        {
          "key": "2026-02-08",
          "label": "02-08",
          "startDate": "2026-02-08",
          "endDate": "2026-02-08",
          "totalTokens": 1353520117412,
          "pricedTokens": 271740047002,
          "blendedPricePerMillion": 0.4964673277439621,
          "estimatedRetailValue": 134910.0549761016,
          "pricedTokenShare": 0.20076542897757657
        },
        {
          "key": "2026-02-09",
          "label": "02-09",
          "startDate": "2026-02-09",
          "endDate": "2026-02-09",
          "totalTokens": 1662970178669,
          "pricedTokens": 325052579487,
          "blendedPricePerMillion": 0.5743148214686581,
          "estimatedRetailValue": 186682.5141560032,
          "pricedTokenShare": 0.19546506825947055
        },
        {
          "key": "2026-02-10",
          "label": "02-10",
          "startDate": "2026-02-10",
          "endDate": "2026-02-10",
          "totalTokens": 1771510403773,
          "pricedTokens": 357854358723,
          "blendedPricePerMillion": 0.5105761567260315,
          "estimatedRetailValue": 182711.90314444795,
          "pricedTokenShare": 0.20200522557521214
        },
        {
          "key": "2026-02-11",
          "label": "02-11",
          "startDate": "2026-02-11",
          "endDate": "2026-02-11",
          "totalTokens": 1809075488850,
          "pricedTokens": 354266359605,
          "blendedPricePerMillion": 0.4962979241593983,
          "estimatedRetailValue": 175821.6588714684,
          "pricedTokenShare": 0.19582729509546415
        },
        {
          "key": "2026-02-12",
          "label": "02-12",
          "startDate": "2026-02-12",
          "endDate": "2026-02-12",
          "totalTokens": 1817254332924,
          "pricedTokens": 364861423339,
          "blendedPricePerMillion": 0.5617786183846403,
          "estimatedRetailValue": 204971.34630523677,
          "pricedTokenShare": 0.20077620216864767
        },
        {
          "key": "2026-02-13",
          "label": "02-13",
          "startDate": "2026-02-13",
          "endDate": "2026-02-13",
          "totalTokens": 2083944013080,
          "pricedTokens": 303447918595,
          "blendedPricePerMillion": 0.4928887669958888,
          "estimatedRetailValue": 149566.0704437584,
          "pricedTokenShare": 0.14561231812869774
        },
        {
          "key": "2026-02-14",
          "label": "02-14",
          "startDate": "2026-02-14",
          "endDate": "2026-02-14",
          "totalTokens": 1862446469657,
          "pricedTokens": 234985313141,
          "blendedPricePerMillion": 0.47906583142277875,
          "estimatedRetailValue": 112573.43441203519,
          "pricedTokenShare": 0.12617023735682262
        },
        {
          "key": "2026-02-15",
          "label": "02-15",
          "startDate": "2026-02-15",
          "endDate": "2026-02-15",
          "totalTokens": 2007429240268,
          "pricedTokens": 240441584863,
          "blendedPricePerMillion": 0.4671635607901163,
          "estimatedRetailValue": 112325.54694661801,
          "pricedTokenShare": 0.11977587057110918
        },
        {
          "key": "2026-02-16",
          "label": "02-16",
          "startDate": "2026-02-16",
          "endDate": "2026-02-16",
          "totalTokens": 2160683192236,
          "pricedTokens": 270478555047,
          "blendedPricePerMillion": 0.4782622428566925,
          "estimatedRetailValue": 129359.68038141559,
          "pricedTokenShare": 0.12518195912242605
        },
        {
          "key": "2026-02-17",
          "label": "02-17",
          "startDate": "2026-02-17",
          "endDate": "2026-02-17",
          "totalTokens": 2144256740309,
          "pricedTokens": 266639415296,
          "blendedPricePerMillion": 0.4711886485414099,
          "estimatedRetailValue": 125637.46574119398,
          "pricedTokenShare": 0.12435050816609568
        },
        {
          "key": "2026-02-18",
          "label": "02-18",
          "startDate": "2026-02-18",
          "endDate": "2026-02-18",
          "totalTokens": 2279287336434,
          "pricedTokens": 268694042250,
          "blendedPricePerMillion": 0.48193224161359305,
          "estimatedRetailValue": 129492.32208975998,
          "pricedTokenShare": 0.1178851116991587
        },
        {
          "key": "2026-02-19",
          "label": "02-19",
          "startDate": "2026-02-19",
          "endDate": "2026-02-19",
          "totalTokens": 2104731463727,
          "pricedTokens": 260431486578,
          "blendedPricePerMillion": 0.4845441363244176,
          "estimatedRetailValue": 126190.54973562119,
          "pricedTokenShare": 0.12373620628868025
        },
        {
          "key": "2026-02-20",
          "label": "02-20",
          "startDate": "2026-02-20",
          "endDate": "2026-02-20",
          "totalTokens": 1966780747786,
          "pricedTokens": 259388318452,
          "blendedPricePerMillion": 0.47465580317749995,
          "estimatedRetailValue": 123120.17062969519,
          "pricedTokenShare": 0.13188471503190824
        },
        {
          "key": "2026-02-21",
          "label": "02-21",
          "startDate": "2026-02-21",
          "endDate": "2026-02-21",
          "totalTokens": 1629087927199,
          "pricedTokens": 230098530417,
          "blendedPricePerMillion": 0.4988455836088731,
          "estimatedRetailValue": 114783.6356934124,
          "pricedTokenShare": 0.1412437760880248
        },
        {
          "key": "2026-02-22",
          "label": "02-22",
          "startDate": "2026-02-22",
          "endDate": "2026-02-22",
          "totalTokens": 1662900393801,
          "pricedTokens": 230128186700,
          "blendedPricePerMillion": 0.4820325606065829,
          "estimatedRetailValue": 110929.27910275078,
          "pricedTokenShare": 0.13838963990740358
        },
        {
          "key": "2026-02-23",
          "label": "02-23",
          "startDate": "2026-02-23",
          "endDate": "2026-02-23",
          "totalTokens": 1983658606716,
          "pricedTokens": 292760714931,
          "blendedPricePerMillion": 0.4736799786210301,
          "estimatedRetailValue": 138674.88918959358,
          "pricedTokenShare": 0.14758623985992894
        },
        {
          "key": "2026-02-24",
          "label": "02-24",
          "startDate": "2026-02-24",
          "endDate": "2026-02-24",
          "totalTokens": 2006814297660,
          "pricedTokens": 284618883865,
          "blendedPricePerMillion": 0.4925697873071687,
          "estimatedRetailValue": 140194.6630889868,
          "pricedTokenShare": 0.1418262188967227
        },
        {
          "key": "2026-02-25",
          "label": "02-25",
          "startDate": "2026-02-25",
          "endDate": "2026-02-25",
          "totalTokens": 2037235418073,
          "pricedTokens": 360333153980,
          "blendedPricePerMillion": 0.4838687607128423,
          "estimatedRetailValue": 174353.95666005238,
          "pricedTokenShare": 0.1768735958462942
        },
        {
          "key": "2026-02-26",
          "label": "02-26",
          "startDate": "2026-02-26",
          "endDate": "2026-02-26",
          "totalTokens": 2076458858606,
          "pricedTokens": 387322996726,
          "blendedPricePerMillion": 0.4848897066124792,
          "estimatedRetailValue": 187808.93424673637,
          "pricedTokenShare": 0.1865305421875893
        },
        {
          "key": "2026-02-27",
          "label": "02-27",
          "startDate": "2026-02-27",
          "endDate": "2026-02-27",
          "totalTokens": 2038016175860,
          "pricedTokens": 327191037974,
          "blendedPricePerMillion": 0.4714360308636341,
          "estimatedRetailValue": 154249.64427661514,
          "pricedTokenShare": 0.16054388667250508
        },
        {
          "key": "2026-02-28",
          "label": "02-28",
          "startDate": "2026-02-28",
          "endDate": "2026-02-28",
          "totalTokens": 1751323124477,
          "pricedTokens": 305176947028,
          "blendedPricePerMillion": 0.4904971404334183,
          "estimatedRetailValue": 149688.41984343476,
          "pricedTokenShare": 0.17425507763973333
        },
        {
          "key": "2026-03-01",
          "label": "03-01",
          "startDate": "2026-03-01",
          "endDate": "2026-03-01",
          "totalTokens": 1722164707664,
          "pricedTokens": 315849424181,
          "blendedPricePerMillion": 0.4683311489459738,
          "estimatedRetailValue": 147922.12372061197,
          "pricedTokenShare": 0.1834025646765392
        },
        {
          "key": "2026-03-02",
          "label": "03-02",
          "startDate": "2026-03-02",
          "endDate": "2026-03-02",
          "totalTokens": 2108128326245,
          "pricedTokens": 347965494741,
          "blendedPricePerMillion": 0.48694254370249124,
          "estimatedRetailValue": 169439.20312987838,
          "pricedTokenShare": 0.16505897217404997
        },
        {
          "key": "2026-03-03",
          "label": "03-03",
          "startDate": "2026-03-03",
          "endDate": "2026-03-03",
          "totalTokens": 2268386622510,
          "pricedTokens": 366745045853,
          "blendedPricePerMillion": 0.45717543210378564,
          "estimatedRetailValue": 167666.82480976795,
          "pricedTokenShare": 0.16167660407342366
        },
        {
          "key": "2026-03-04",
          "label": "03-04",
          "startDate": "2026-03-04",
          "endDate": "2026-03-04",
          "totalTokens": 2260829829411,
          "pricedTokens": 310661866970,
          "blendedPricePerMillion": 0.47326562581553133,
          "estimatedRetailValue": 147025.58288857838,
          "pricedTokenShare": 0.13741054852011345
        },
        {
          "key": "2026-03-05",
          "label": "03-05",
          "startDate": "2026-03-05",
          "endDate": "2026-03-05",
          "totalTokens": 2263159268676,
          "pricedTokens": 328332300367,
          "blendedPricePerMillion": 0.4597637976281843,
          "estimatedRetailValue": 150955.3053007296,
          "pricedTokenShare": 0.1450769748781675
        },
        {
          "key": "2026-03-06",
          "label": "03-06",
          "startDate": "2026-03-06",
          "endDate": "2026-03-06",
          "totalTokens": 2165761557067,
          "pricedTokens": 302669491316,
          "blendedPricePerMillion": 0.46154816236998514,
          "estimatedRetailValue": 139696.54752235799,
          "pricedTokenShare": 0.13975199177784492
        },
        {
          "key": "2026-03-07",
          "label": "03-07",
          "startDate": "2026-03-07",
          "endDate": "2026-03-07",
          "totalTokens": 1841412026810,
          "pricedTokens": 286932416472,
          "blendedPricePerMillion": 0.42843927999475334,
          "estimatedRetailValue": 122933.11792041839,
          "pricedTokenShare": 0.155821952009878
        },
        {
          "key": "2026-03-08",
          "label": "03-08",
          "startDate": "2026-03-08",
          "endDate": "2026-03-08",
          "totalTokens": 1881232524277,
          "pricedTokens": 290055836793,
          "blendedPricePerMillion": 0.43081737634547107,
          "estimatedRetailValue": 124961.09460085041,
          "pricedTokenShare": 0.15418393688705492
        },
        {
          "key": "2026-03-09",
          "label": "03-09",
          "startDate": "2026-03-09",
          "endDate": "2026-03-09",
          "totalTokens": 2245462665118,
          "pricedTokens": 293636555350,
          "blendedPricePerMillion": 0.47154396253949105,
          "estimatedRetailValue": 138462.5448561856,
          "pricedTokenShare": 0.13076884328182284
        },
        {
          "key": "2026-03-10",
          "label": "03-10",
          "startDate": "2026-03-10",
          "endDate": "2026-03-10",
          "totalTokens": 2405339612587,
          "pricedTokens": 332807626360,
          "blendedPricePerMillion": 0.4444560538411178,
          "estimatedRetailValue": 147918.36430019478,
          "pricedTokenShare": 0.13836201117648309
        },
        {
          "key": "2026-03-11",
          "label": "03-11",
          "startDate": "2026-03-11",
          "endDate": "2026-03-11",
          "totalTokens": 2484681242838,
          "pricedTokens": 328755291524,
          "blendedPricePerMillion": 0.48539235320996976,
          "estimatedRetailValue": 159575.304583064,
          "pricedTokenShare": 0.13231286406319714
        },
        {
          "key": "2026-03-12",
          "label": "03-12",
          "startDate": "2026-03-12",
          "endDate": "2026-03-12",
          "totalTokens": 2655470164902,
          "pricedTokens": 329860619022,
          "blendedPricePerMillion": 0.4688853416859806,
          "estimatedRetailValue": 154666.80905887956,
          "pricedTokenShare": 0.12421929019645886
        },
        {
          "key": "2026-03-13",
          "label": "03-13",
          "startDate": "2026-03-13",
          "endDate": "2026-03-13",
          "totalTokens": 2514918954523,
          "pricedTokens": 307419968201,
          "blendedPricePerMillion": 0.4712230555577294,
          "estimatedRetailValue": 144863.37675513522,
          "pricedTokenShare": 0.1222385189185183
        },
        {
          "key": "2026-03-14",
          "label": "03-14",
          "startDate": "2026-03-14",
          "endDate": "2026-03-14",
          "totalTokens": 2224615577009,
          "pricedTokens": 257868587082,
          "blendedPricePerMillion": 0.4432559002315322,
          "estimatedRetailValue": 114301.77270846517,
          "pricedTokenShare": 0.11591602151267179
        },
        {
          "key": "2026-03-15",
          "label": "03-15",
          "startDate": "2026-03-15",
          "endDate": "2026-03-15",
          "totalTokens": 2343986663642,
          "pricedTokens": 281590292579,
          "blendedPricePerMillion": 0.41588796097449005,
          "estimatedRetailValue": 117110.01261089038,
          "pricedTokenShare": 0.12013306088588209
        },
        {
          "key": "2026-03-16",
          "label": "03-16",
          "startDate": "2026-03-16",
          "endDate": "2026-03-16",
          "totalTokens": 2758882292355,
          "pricedTokens": 322618279473,
          "blendedPricePerMillion": 0.46215567334568025,
          "estimatedRetailValue": 149099.86818346917,
          "pricedTokenShare": 0.11693803696047174
        },
        {
          "key": "2026-03-17",
          "label": "03-17",
          "startDate": "2026-03-17",
          "endDate": "2026-03-17",
          "totalTokens": 3171494754112,
          "pricedTokens": 373666737435,
          "blendedPricePerMillion": 0.4807978413875318,
          "estimatedRetailValue": 179658.16075706962,
          "pricedTokenShare": 0.11782038641259696
        },
        {
          "key": "2026-03-18",
          "label": "03-18",
          "startDate": "2026-03-18",
          "endDate": "2026-03-18",
          "totalTokens": 3133273576581,
          "pricedTokens": 324969020753,
          "blendedPricePerMillion": 0.47559591745357843,
          "estimatedRetailValue": 154553.939569014,
          "pricedTokenShare": 0.10371549525132857
        },
        {
          "key": "2026-03-19",
          "label": "03-19",
          "startDate": "2026-03-19",
          "endDate": "2026-03-19",
          "totalTokens": 2978864222218,
          "pricedTokens": 313250387720,
          "blendedPricePerMillion": 0.5088596219773119,
          "estimatedRetailValue": 159400.4738794456,
          "pricedTokenShare": 0.10515765887669774
        },
        {
          "key": "2026-03-20",
          "label": "03-20",
          "startDate": "2026-03-20",
          "endDate": "2026-03-20",
          "totalTokens": 3024001630072,
          "pricedTokens": 297717993323,
          "blendedPricePerMillion": 0.4578749682398885,
          "estimatedRetailValue": 136317.61673721197,
          "pricedTokenShare": 0.09845166429884215
        },
        {
          "key": "2026-03-21",
          "label": "03-21",
          "startDate": "2026-03-21",
          "endDate": "2026-03-21",
          "totalTokens": 2573341237095,
          "pricedTokens": 280367937268,
          "blendedPricePerMillion": 0.409144600309166,
          "estimatedRetailValue": 114711.0276330212,
          "pricedTokenShare": 0.10895093632607483
        },
        {
          "key": "2026-03-22",
          "label": "03-22",
          "startDate": "2026-03-22",
          "endDate": "2026-03-22",
          "totalTokens": 2656937122098,
          "pricedTokens": 276942594437,
          "blendedPricePerMillion": 0.4376970370982672,
          "estimatedRetailValue": 121216.95303138196,
          "pricedTokenShare": 0.10423377811000568
        },
        {
          "key": "2026-03-23",
          "label": "03-23",
          "startDate": "2026-03-23",
          "endDate": "2026-03-23",
          "totalTokens": 3224952376065,
          "pricedTokens": 340080049887,
          "blendedPricePerMillion": 0.4344909651237202,
          "estimatedRetailValue": 147761.70909472555,
          "pricedTokenShare": 0.10545273549185136
        },
        {
          "key": "2026-03-24",
          "label": "03-24",
          "startDate": "2026-03-24",
          "endDate": "2026-03-24",
          "totalTokens": 3341805624432,
          "pricedTokens": 342463728978,
          "blendedPricePerMillion": 0.4388641255367683,
          "estimatedRetailValue": 150295.04494599078,
          "pricedTokenShare": 0.10247865000712239
        },
        {
          "key": "2026-03-25",
          "label": "03-25",
          "startDate": "2026-03-25",
          "endDate": "2026-03-25",
          "totalTokens": 3404484437033,
          "pricedTokens": 365491304023,
          "blendedPricePerMillion": 0.44074996524270454,
          "estimatedRetailValue": 161090.27954464802,
          "pricedTokenShare": 0.10735584514568226
        },
        {
          "key": "2026-03-26",
          "label": "03-26",
          "startDate": "2026-03-26",
          "endDate": "2026-03-26",
          "totalTokens": 3389941787812,
          "pricedTokens": 355995390912,
          "blendedPricePerMillion": 0.43310756683863094,
          "estimatedRetailValue": 154184.2975636636,
          "pricedTokenShare": 0.10501519294281841
        },
        {
          "key": "2026-03-27",
          "label": "03-27",
          "startDate": "2026-03-27",
          "endDate": "2026-03-27",
          "totalTokens": 3311872762246,
          "pricedTokens": 315747481688,
          "blendedPricePerMillion": 0.44490282746047577,
          "estimatedRetailValue": 140476.947366516,
          "pricedTokenShare": 0.09533804718810235
        },
        {
          "key": "2026-03-28",
          "label": "03-28",
          "startDate": "2026-03-28",
          "endDate": "2026-03-28",
          "totalTokens": 2967065408662,
          "pricedTokens": 281904190404,
          "blendedPricePerMillion": 0.41012314951810774,
          "estimatedRetailValue": 115615.4344308408,
          "pricedTokenShare": 0.09501111420766584
        },
        {
          "key": "2026-03-29",
          "label": "03-29",
          "startDate": "2026-03-29",
          "endDate": "2026-03-29",
          "totalTokens": 2999802045325,
          "pricedTokens": 298645244064,
          "blendedPricePerMillion": 0.4062191318301522,
          "estimatedRetailValue": 121315.41176888198,
          "pricedTokenShare": 0.09955498381282177
        },
        {
          "key": "2026-03-30",
          "label": "03-30",
          "startDate": "2026-03-30",
          "endDate": "2026-03-30",
          "totalTokens": 3462453510031,
          "pricedTokens": 333808223923,
          "blendedPricePerMillion": 0.45246787053482546,
          "estimatedRetailValue": 151037.496245452,
          "pricedTokenShare": 0.09640800171206092
        },
        {
          "key": "2026-03-31",
          "label": "03-31",
          "startDate": "2026-03-31",
          "endDate": "2026-03-31",
          "totalTokens": 4002410847181,
          "pricedTokens": 339818986534,
          "blendedPricePerMillion": 0.44709848551778025,
          "estimatedRetailValue": 151932.55422953836,
          "pricedTokenShare": 0.08490357424784194
        },
        {
          "key": "2026-04-01",
          "label": "04-01",
          "startDate": "2026-04-01",
          "endDate": "2026-04-01",
          "totalTokens": 4128332043182,
          "pricedTokens": 322801083813,
          "blendedPricePerMillion": 0.44894307155443103,
          "estimatedRetailValue": 144919.31006810756,
          "pricedTokenShare": 0.078191647482937
        },
        {
          "key": "2026-04-02",
          "label": "04-02",
          "startDate": "2026-04-02",
          "endDate": "2026-04-02",
          "totalTokens": 4043252964147,
          "pricedTokens": 313413095980,
          "blendedPricePerMillion": 0.4530000626101546,
          "estimatedRetailValue": 141976.15210178238,
          "pricedTokenShare": 0.07751508470015316
        },
        {
          "key": "2026-04-03",
          "label": "04-03",
          "startDate": "2026-04-03",
          "endDate": "2026-04-03",
          "totalTokens": 4091886418048,
          "pricedTokens": 301144131188,
          "blendedPricePerMillion": 0.44436021918761376,
          "estimatedRetailValue": 133816.4721417632,
          "pricedTokenShare": 0.07359542773713115
        },
        {
          "key": "2026-04-04",
          "label": "04-04",
          "startDate": "2026-04-04",
          "endDate": "2026-04-04",
          "totalTokens": 3630286680857,
          "pricedTokens": 316411911679,
          "blendedPricePerMillion": 0.3959607925219029,
          "estimatedRetailValue": 125286.71131178719,
          "pricedTokenShare": 0.0871589324742543
        },
        {
          "key": "2026-04-05",
          "label": "04-05",
          "startDate": "2026-04-05",
          "endDate": "2026-04-05",
          "totalTokens": 3646933937468,
          "pricedTokens": 361883487462,
          "blendedPricePerMillion": 0.359885026777263,
          "estimatedRetailValue": 130236.44857551118,
          "pricedTokenShare": 0.09922951544146948
        },
        {
          "key": "2026-04-06",
          "label": "04-06",
          "startDate": "2026-04-06",
          "endDate": "2026-04-06",
          "totalTokens": 3640817422688,
          "pricedTokens": 404694236117,
          "blendedPricePerMillion": 0.41502205422477134,
          "estimatedRetailValue": 167957.033206202,
          "pricedTokenShare": 0.11115477353934874
        },
        {
          "key": "2026-04-07",
          "label": "04-07",
          "startDate": "2026-04-07",
          "endDate": "2026-04-07",
          "totalTokens": 3732909598850,
          "pricedTokens": 412575622430,
          "blendedPricePerMillion": 0.41068722995218193,
          "estimatedRetailValue": 169439.53952157398,
          "pricedTokenShare": 0.11052387193011651
        },
        {
          "key": "2026-04-08",
          "label": "04-08",
          "startDate": "2026-04-08",
          "endDate": "2026-04-08",
          "totalTokens": 2999093024213,
          "pricedTokens": 420575387823,
          "blendedPricePerMillion": 0.41266822023871125,
          "estimatedRetailValue": 173558.09676912316,
          "pricedTokenShare": 0.14023419227996914
        },
        {
          "key": "2026-04-09",
          "label": "04-09",
          "startDate": "2026-04-09",
          "endDate": "2026-04-09",
          "totalTokens": 2988091808528,
          "pricedTokens": 428148817402,
          "blendedPricePerMillion": 0.4155698724651099,
          "estimatedRetailValue": 177925.74944383677,
          "pricedTokenShare": 0.1432850276487708
        },
        {
          "key": "2026-04-10",
          "label": "04-10",
          "startDate": "2026-04-10",
          "endDate": "2026-04-10",
          "totalTokens": 2859280425773,
          "pricedTokens": 352851300407,
          "blendedPricePerMillion": 0.43747790342552706,
          "estimatedRetailValue": 154364.64712302518,
          "pricedTokenShare": 0.12340562934172764
        },
        {
          "key": "2026-04-11",
          "label": "04-11",
          "startDate": "2026-04-11",
          "endDate": "2026-04-11",
          "totalTokens": 2374060726524,
          "pricedTokens": 305930601883,
          "blendedPricePerMillion": 0.42125689970502345,
          "estimatedRetailValue": 128875.3768741244,
          "pricedTokenShare": 0.128863848538083
        },
        {
          "key": "2026-04-12",
          "label": "04-12",
          "startDate": "2026-04-12",
          "endDate": "2026-04-12",
          "totalTokens": 2396592809199,
          "pricedTokens": 300488107338,
          "blendedPricePerMillion": 0.41796470315437506,
          "estimatedRetailValue": 125593.42258494717,
          "pricedTokenShare": 0.1253813773389525
        },
        {
          "key": "2026-04-13",
          "label": "04-13",
          "startDate": "2026-04-13",
          "endDate": "2026-04-13",
          "totalTokens": 2957241118970,
          "pricedTokens": 345576690538,
          "blendedPricePerMillion": 0.4278792891724176,
          "estimatedRetailValue": 147865.10870195596,
          "pricedTokenShare": 0.11685779976519586
        },
        {
          "key": "2026-04-14",
          "label": "04-14",
          "startDate": "2026-04-14",
          "endDate": "2026-04-14",
          "totalTokens": 3099977701607,
          "pricedTokens": 380260012011,
          "blendedPricePerMillion": 0.4165082974289423,
          "estimatedRetailValue": 158381.45018301075,
          "pricedTokenShare": 0.12266540233946738
        },
        {
          "key": "2026-04-15",
          "label": "04-15",
          "startDate": "2026-04-15",
          "endDate": "2026-04-15",
          "totalTokens": 3165298086565,
          "pricedTokens": 384753062672,
          "blendedPricePerMillion": 0.40945199795389753,
          "estimatedRetailValue": 157537.91022993156,
          "pricedTokenShare": 0.12155350053919764
        },
        {
          "key": "2026-04-16",
          "label": "04-16",
          "startDate": "2026-04-16",
          "endDate": "2026-04-16",
          "totalTokens": 3143783248585,
          "pricedTokens": 398894120612,
          "blendedPricePerMillion": 0.4037118567709164,
          "estimatedRetailValue": 161038.2860872724,
          "pricedTokenShare": 0.12688346780635723
        },
        {
          "key": "2026-04-17",
          "label": "04-17",
          "startDate": "2026-04-17",
          "endDate": "2026-04-17",
          "totalTokens": 3193988270600,
          "pricedTokens": 405872104835,
          "blendedPricePerMillion": 0.3793604261008301,
          "estimatedRetailValue": 153971.8146326464,
          "pricedTokenShare": 0.12707376184532942
        },
        {
          "key": "2026-04-18",
          "label": "04-18",
          "startDate": "2026-04-18",
          "endDate": "2026-04-18",
          "totalTokens": 2462023731465,
          "pricedTokens": 352080204684,
          "blendedPricePerMillion": 0.38209463712948444,
          "estimatedRetailValue": 134527.95804920758,
          "pricedTokenShare": 0.14300439113740734
        },
        {
          "key": "2026-04-19",
          "label": "04-19",
          "startDate": "2026-04-19",
          "endDate": "2026-04-19",
          "totalTokens": 2446960959409,
          "pricedTokens": 367752978547,
          "blendedPricePerMillion": 0.3726681620688072,
          "estimatedRetailValue": 137049.82661043998,
          "pricedTokenShare": 0.1502896795851705
        },
        {
          "key": "2026-04-20",
          "label": "04-20",
          "startDate": "2026-04-20",
          "endDate": "2026-04-20",
          "totalTokens": 3134848054628,
          "pricedTokens": 456999191398,
          "blendedPricePerMillion": 0.3669817986756795,
          "estimatedRetailValue": 167710.38525256916,
          "pricedTokenShare": 0.1457803323906971
        },
        {
          "key": "2026-04-21",
          "label": "04-21",
          "startDate": "2026-04-21",
          "endDate": "2026-04-21",
          "totalTokens": 3318896487438,
          "pricedTokens": 408623989143,
          "blendedPricePerMillion": 0.3856428812963123,
          "estimatedRetailValue": 157582.93253989957,
          "pricedTokenShare": 0.12312043797980411
        },
        {
          "key": "2026-04-22",
          "label": "04-22",
          "startDate": "2026-04-22",
          "endDate": "2026-04-22",
          "totalTokens": 3382408425312,
          "pricedTokens": 460649642806,
          "blendedPricePerMillion": 0.3864865836495976,
          "estimatedRetailValue": 178034.90670749836,
          "pricedTokenShare": 0.1361898342490998
        },
        {
          "key": "2026-04-23",
          "label": "04-23",
          "startDate": "2026-04-23",
          "endDate": "2026-04-23",
          "totalTokens": 3375402500504,
          "pricedTokens": 461795984041,
          "blendedPricePerMillion": 0.3634618895464696,
          "estimatedRetailValue": 167845.24094451318,
          "pricedTokenShare": 0.13681212358290507
        },
        {
          "key": "2026-04-24",
          "label": "04-24",
          "startDate": "2026-04-24",
          "endDate": "2026-04-24",
          "totalTokens": 3254035491146,
          "pricedTokens": 417566202325,
          "blendedPricePerMillion": 0.3789502260157778,
          "estimatedRetailValue": 158236.80674760876,
          "pricedTokenShare": 0.1283225716072145
        },
        {
          "key": "2026-04-25",
          "label": "04-25",
          "startDate": "2026-04-25",
          "endDate": "2026-04-25",
          "totalTokens": 2715048699378,
          "pricedTokens": 375559030439,
          "blendedPricePerMillion": 0.2859490723964623,
          "estimatedRetailValue": 107390.75638414679,
          "pricedTokenShare": 0.138324970202206
        },
        {
          "key": "2026-04-26",
          "label": "04-26",
          "startDate": "2026-04-26",
          "endDate": "2026-04-26",
          "totalTokens": 2702629991782,
          "pricedTokens": 398470690491,
          "blendedPricePerMillion": 0.2783198708371904,
          "estimatedRetailValue": 110902.31110986118,
          "pricedTokenShare": 0.14743812201546141
        },
        {
          "key": "2026-04-27",
          "label": "04-27",
          "startDate": "2026-04-27",
          "endDate": "2026-04-27",
          "totalTokens": 3405122588401,
          "pricedTokens": 441747383790,
          "blendedPricePerMillion": 0.2847029679350559,
          "estimatedRetailValue": 125766.7912425592,
          "pricedTokenShare": 0.12973024386691426
        },
        {
          "key": "2026-04-28",
          "label": "04-28",
          "startDate": "2026-04-28",
          "endDate": "2026-04-28",
          "totalTokens": 3630994099588,
          "pricedTokens": 445841942091,
          "blendedPricePerMillion": 0.3704657044322215,
          "estimatedRetailValue": 165169.149142172,
          "pricedTokenShare": 0.12278784538415763
        },
        {
          "key": "2026-04-29",
          "label": "04-29",
          "startDate": "2026-04-29",
          "endDate": "2026-04-29",
          "totalTokens": 3712741085065,
          "pricedTokens": 424441812894,
          "blendedPricePerMillion": 0.3097170187760149,
          "estimatedRetailValue": 131456.85293341678,
          "pricedTokenShare": 0.11432033723045602
        },
        {
          "key": "2026-04-30",
          "label": "04-30",
          "startDate": "2026-04-30",
          "endDate": "2026-04-30",
          "totalTokens": 3509604277501,
          "pricedTokens": 405782921439,
          "blendedPricePerMillion": 0.3831888721655046,
          "estimatedRetailValue": 155491.50001023398,
          "pricedTokenShare": 0.11562070517190506
        },
        {
          "key": "2026-05-01",
          "label": "05-01",
          "startDate": "2026-05-01",
          "endDate": "2026-05-01",
          "totalTokens": 3324394613506,
          "pricedTokens": 366814972075,
          "blendedPricePerMillion": 0.295378205383481,
          "estimatedRetailValue": 108349.14815930519,
          "pricedTokenShare": 0.11034038215100662
        },
        {
          "key": "2026-05-02",
          "label": "05-02",
          "startDate": "2026-05-02",
          "endDate": "2026-05-02",
          "totalTokens": 3015068636931,
          "pricedTokens": 347240482585,
          "blendedPricePerMillion": 0.37687245473937225,
          "estimatedRetailValue": 130865.37305669319,
          "pricedTokenShare": 0.11516835084008292
        },
        {
          "key": "2026-05-03",
          "label": "05-03",
          "startDate": "2026-05-03",
          "endDate": "2026-05-03",
          "totalTokens": 3199831512578,
          "pricedTokens": 368207873937,
          "blendedPricePerMillion": 0.3579187761009675,
          "estimatedRetailValue": 131788.51159027038,
          "pricedTokenShare": 0.11507101936137472
        },
        {
          "key": "2026-05-04",
          "label": "05-04",
          "startDate": "2026-05-04",
          "endDate": "2026-05-04",
          "totalTokens": 3771624160550,
          "pricedTokens": 441004237589,
          "blendedPricePerMillion": 0.2918217941884593,
          "estimatedRetailValue": 128694.64785793558,
          "pricedTokenShare": 0.11692687786915922
        },
        {
          "key": "2026-05-05",
          "label": "05-05",
          "startDate": "2026-05-05",
          "endDate": "2026-05-05",
          "totalTokens": 3943247540034,
          "pricedTokens": 432520208497,
          "blendedPricePerMillion": 0.3850675915594311,
          "estimatedRetailValue": 166549.5149867228,
          "pricedTokenShare": 0.10968629387473622
        },
        {
          "key": "2026-05-06",
          "label": "05-06",
          "startDate": "2026-05-06",
          "endDate": "2026-05-06",
          "totalTokens": 3971715385948,
          "pricedTokens": 418734206937,
          "blendedPricePerMillion": 0.2918510013473549,
          "estimatedRetailValue": 122207.99759295398,
          "pricedTokenShare": 0.10542905677946841
        },
        {
          "key": "2026-05-07",
          "label": "05-07",
          "startDate": "2026-05-07",
          "endDate": "2026-05-07",
          "totalTokens": 3908273660198,
          "pricedTokens": 410311005826,
          "blendedPricePerMillion": 0.404741331856324,
          "estimatedRetailValue": 166069.82297332314,
          "pricedTokenShare": 0.10498522915747228
        },
        {
          "key": "2026-05-08",
          "label": "05-08",
          "startDate": "2026-05-08",
          "endDate": "2026-05-08",
          "totalTokens": 3795872616373,
          "pricedTokens": 384570784478,
          "blendedPricePerMillion": 0.39220916972269854,
          "estimatedRetailValue": 150832.18807972322,
          "pricedTokenShare": 0.10131287936776494
        },
        {
          "key": "2026-05-09",
          "label": "05-09",
          "startDate": "2026-05-09",
          "endDate": "2026-05-09",
          "totalTokens": 3175234843463,
          "pricedTokens": 353638224597,
          "blendedPricePerMillion": 0.3668023851107592,
          "estimatedRetailValue": 129715.34424851395,
          "pricedTokenShare": 0.1113738800533293
        },
        {
          "key": "2026-05-10",
          "label": "05-10",
          "startDate": "2026-05-10",
          "endDate": "2026-05-10",
          "totalTokens": 3165820373012,
          "pricedTokens": 360630395642,
          "blendedPricePerMillion": 0.36420732123397553,
          "estimatedRetailValue": 131344.23035232158,
          "pricedTokenShare": 0.11391372634919646
        },
        {
          "key": "2026-05-11",
          "label": "05-11",
          "startDate": "2026-05-11",
          "endDate": "2026-05-11",
          "totalTokens": 3904460018777,
          "pricedTokens": 412749880233,
          "blendedPricePerMillion": 0.3026055562943487,
          "estimatedRetailValue": 124900.40711833278,
          "pricedTokenShare": 0.10571241048647907
        },
        {
          "key": "2026-05-12",
          "label": "05-12",
          "startDate": "2026-05-12",
          "endDate": "2026-05-12",
          "totalTokens": 4090688100171,
          "pricedTokens": 430360031650,
          "blendedPricePerMillion": 0.3034675694156321,
          "estimatedRetailValue": 130600.31277846,
          "pricedTokenShare": 0.10520480200678463
        },
        {
          "key": "2026-05-13",
          "label": "05-13",
          "startDate": "2026-05-13",
          "endDate": "2026-05-13",
          "totalTokens": 4158854730105,
          "pricedTokens": 436170263257,
          "blendedPricePerMillion": 0.29363114036339333,
          "estimatedRetailValue": 128073.17179275438,
          "pricedTokenShare": 0.104877494301415
        },
        {
          "key": "2026-05-14",
          "label": "05-14",
          "startDate": "2026-05-14",
          "endDate": "2026-05-14",
          "totalTokens": 4054631694946,
          "pricedTokens": 421437443070,
          "blendedPricePerMillion": 0.3059279710992993,
          "estimatedRetailValue": 128929.50190368156,
          "pricedTokenShare": 0.10393975945961048
        },
        {
          "key": "2026-05-15",
          "label": "05-15",
          "startDate": "2026-05-15",
          "endDate": "2026-05-15",
          "totalTokens": 4058162821358,
          "pricedTokens": 419181140976,
          "blendedPricePerMillion": 0.28221993178953647,
          "estimatedRetailValue": 118301.27301370678,
          "pricedTokenShare": 0.1032933274066435
        },
        {
          "key": "2026-05-16",
          "label": "05-16",
          "startDate": "2026-05-16",
          "endDate": "2026-05-16",
          "totalTokens": 3258661754494,
          "pricedTokens": 397390079572,
          "blendedPricePerMillion": 0.2744035486662784,
          "estimatedRetailValue": 109045.24803933156,
          "pricedTokenShare": 0.12194885800097596
        },
        {
          "key": "2026-05-17",
          "label": "05-17",
          "startDate": "2026-05-17",
          "endDate": "2026-05-17",
          "totalTokens": 3380223252621,
          "pricedTokens": 389859976885,
          "blendedPricePerMillion": 0.25977900597472764,
          "estimatedRetailValue": 101277.43726451558,
          "pricedTokenShare": 0.11533557038953136
        },
        {
          "key": "2026-05-18",
          "label": "05-18",
          "startDate": "2026-05-18",
          "endDate": "2026-05-18",
          "totalTokens": 4054837875343,
          "pricedTokens": 442959102115,
          "blendedPricePerMillion": 0.2789964153703838,
          "estimatedRetailValue": 123584.00164576877,
          "pricedTokenShare": 0.10924212403375806
        },
        {
          "key": "2026-05-19",
          "label": "05-19",
          "startDate": "2026-05-19",
          "endDate": "2026-05-19",
          "totalTokens": 4209273652355,
          "pricedTokens": 458886682911,
          "blendedPricePerMillion": 0.28429739555549066,
          "estimatedRetailValue": 130460.2888066956,
          "pricedTokenShare": 0.1090180208773698
        },
        {
          "key": "2026-05-20",
          "label": "05-20",
          "startDate": "2026-05-20",
          "endDate": "2026-05-20",
          "totalTokens": 4430559668843,
          "pricedTokens": 465655413268,
          "blendedPricePerMillion": 0.2837489673208795,
          "estimatedRetailValue": 132129.24264217238,
          "pricedTokenShare": 0.10510081074917599
        },
        {
          "key": "2026-05-21",
          "label": "05-21",
          "startDate": "2026-05-21",
          "endDate": "2026-05-21",
          "totalTokens": 4404565910297,
          "pricedTokens": 470356500030,
          "blendedPricePerMillion": 0.30073023408124955,
          "estimatedRetailValue": 141450.42035565915,
          "pricedTokenShare": 0.10678838950517233
        },
        {
          "key": "2026-05-22",
          "label": "05-22",
          "startDate": "2026-05-22",
          "endDate": "2026-05-22",
          "totalTokens": 4542455074756,
          "pricedTokens": 447553309905,
          "blendedPricePerMillion": 0.28835074601631805,
          "estimatedRetailValue": 129052.33079317915,
          "pricedTokenShare": 0.09852674435729901
        },
        {
          "key": "2026-05-23",
          "label": "05-23",
          "startDate": "2026-05-23",
          "endDate": "2026-05-23",
          "totalTokens": 3552676202089,
          "pricedTokens": 377766149292,
          "blendedPricePerMillion": 0.29361004218253095,
          "estimatedRetailValue": 110915.93502875639,
          "pricedTokenShare": 0.10633283975327408
        },
        {
          "key": "2026-05-24",
          "label": "05-24",
          "startDate": "2026-05-24",
          "endDate": "2026-05-24",
          "totalTokens": 3725836527145,
          "pricedTokens": 374318928576,
          "blendedPricePerMillion": 0.2861724307139335,
          "estimatedRetailValue": 107119.7576528292,
          "pricedTokenShare": 0.10046574127685352
        },
        {
          "key": "2026-05-25",
          "label": "05-25",
          "startDate": "2026-05-25",
          "endDate": "2026-05-25",
          "totalTokens": 4239156680433,
          "pricedTokens": 334118640704,
          "blendedPricePerMillion": 0.30617719851916214,
          "estimatedRetailValue": 102299.5093837812,
          "pricedTokenShare": 0.07881724264786366
        },
        {
          "key": "2026-05-26",
          "label": "05-26",
          "startDate": "2026-05-26",
          "endDate": "2026-05-26",
          "totalTokens": 4946042261303,
          "pricedTokens": 338374036775,
          "blendedPricePerMillion": 0.3291920998109858,
          "estimatedRetailValue": 111390.05968748197,
          "pricedTokenShare": 0.06841309048699025
        },
        {
          "key": "2026-05-27",
          "label": "05-27",
          "startDate": "2026-05-27",
          "endDate": "2026-05-27",
          "totalTokens": 4706418054828,
          "pricedTokens": 340007495322,
          "blendedPricePerMillion": 0.32670425514841434,
          "estimatedRetailValue": 111081.89550405198,
          "pricedTokenShare": 0.07224336881276601
        },
        {
          "key": "2026-05-28",
          "label": "05-28",
          "startDate": "2026-05-28",
          "endDate": "2026-05-28",
          "totalTokens": 4986780759242,
          "pricedTokens": 345071949979,
          "blendedPricePerMillion": 0.33052456902776534,
          "estimatedRetailValue": 114054.75755037957,
          "pricedTokenShare": 0.0691973372479787
        },
        {
          "key": "2026-05-29",
          "label": "05-29",
          "startDate": "2026-05-29",
          "endDate": "2026-05-29",
          "totalTokens": 4685825847136,
          "pricedTokens": 320737146540,
          "blendedPricePerMillion": 0.3380939870988203,
          "estimatedRetailValue": 108439.3006844072,
          "pricedTokenShare": 0.0684483711096596
        },
        {
          "key": "2026-05-30",
          "label": "05-30",
          "startDate": "2026-05-30",
          "endDate": "2026-05-30",
          "totalTokens": 4040118442007,
          "pricedTokens": 311381499354,
          "blendedPricePerMillion": 0.3050883204498425,
          "estimatedRetailValue": 94998.85865706558,
          "pricedTokenShare": 0.07707236899701281
        },
        {
          "key": "2026-05-31",
          "label": "05-31",
          "startDate": "2026-05-31",
          "endDate": "2026-05-31",
          "totalTokens": 4203405742573,
          "pricedTokens": 308693619815,
          "blendedPricePerMillion": 0.30585192594848637,
          "estimatedRetailValue": 94414.53814842759,
          "pricedTokenShare": 0.07343892993447776
        },
        {
          "key": "2026-06-01",
          "label": "06-01",
          "startDate": "2026-06-01",
          "endDate": "2026-06-01",
          "totalTokens": 4708382774313,
          "pricedTokens": 389503410761,
          "blendedPricePerMillion": 0.32912856205133906,
          "estimatedRetailValue": 128196.69749785999,
          "pricedTokenShare": 0.08272551944713807
        },
        {
          "key": "2026-06-02",
          "label": "06-02",
          "startDate": "2026-06-02",
          "endDate": "2026-06-02",
          "totalTokens": 4880205168494,
          "pricedTokens": 413519984760,
          "blendedPricePerMillion": 0.32859813325595066,
          "estimatedRetailValue": 135881.89505616517,
          "pricedTokenShare": 0.084734139341033
        },
        {
          "key": "2026-06-03",
          "label": "06-03",
          "startDate": "2026-06-03",
          "endDate": "2026-06-03",
          "totalTokens": 5561024317533,
          "pricedTokens": 411767244801,
          "blendedPricePerMillion": 0.3211436418481416,
          "estimatedRetailValue": 132236.4325891684,
          "pricedTokenShare": 0.07404521564539203
        },
        {
          "key": "2026-06-04",
          "label": "06-04",
          "startDate": "2026-06-04",
          "endDate": "2026-06-04",
          "totalTokens": 5413561492983,
          "pricedTokens": 359009403584,
          "blendedPricePerMillion": 0.32883363863615556,
          "estimatedRetailValue": 118054.36848512279,
          "pricedTokenShare": 0.06631667600882415
        },
        {
          "key": "2026-06-05",
          "label": "06-05",
          "startDate": "2026-06-05",
          "endDate": "2026-06-05",
          "totalTokens": 5437258364130,
          "pricedTokens": 373852391468,
          "blendedPricePerMillion": 0.3130823965303778,
          "estimatedRetailValue": 117046.6026694144,
          "pricedTokenShare": 0.0687575182989891
        },
        {
          "key": "2026-06-06",
          "label": "06-06",
          "startDate": "2026-06-06",
          "endDate": "2026-06-06",
          "totalTokens": 4818437093981,
          "pricedTokens": 279551670498,
          "blendedPricePerMillion": 0.32913554404538264,
          "estimatedRetailValue": 92010.39115815477,
          "pricedTokenShare": 0.05801708418009749
        },
        {
          "key": "2026-06-07",
          "label": "06-07",
          "startDate": "2026-06-07",
          "endDate": "2026-06-07",
          "totalTokens": 5307236051473,
          "pricedTokens": 255067281781,
          "blendedPricePerMillion": 0.3317492860162609,
          "estimatedRetailValue": 84618.38861695518,
          "pricedTokenShare": 0.04806028586390221
        },
        {
          "key": "2026-06-08",
          "label": "06-08",
          "startDate": "2026-06-08",
          "endDate": "2026-06-08",
          "totalTokens": 6524371265241,
          "pricedTokens": 349672075262,
          "blendedPricePerMillion": 0.34732335894971894,
          "estimatedRetailValue": 121449.27971091676,
          "pricedTokenShare": 0.0535947543520247
        },
        {
          "key": "2026-06-09",
          "label": "06-09",
          "startDate": "2026-06-09",
          "endDate": "2026-06-09",
          "totalTokens": 6430016419489,
          "pricedTokens": 332542370326,
          "blendedPricePerMillion": 0.34601656351361354,
          "estimatedRetailValue": 115065.16820287399,
          "pricedTokenShare": 0.05171718836021689
        },
        {
          "key": "2026-06-10",
          "label": "06-10",
          "startDate": "2026-06-10",
          "endDate": "2026-06-10",
          "totalTokens": 6700137711587,
          "pricedTokens": 345473292701,
          "blendedPricePerMillion": 0.3436490735229395,
          "estimatedRetailValue": 118721.57696361796,
          "pricedTokenShare": 0.05156211820893617
        },
        {
          "key": "2026-06-11",
          "label": "06-11",
          "startDate": "2026-06-11",
          "endDate": "2026-06-11",
          "totalTokens": 6929033546007,
          "pricedTokens": 383137114723,
          "blendedPricePerMillion": 0.33724639544965207,
          "estimatedRetailValue": 129211.61090331156,
          "pricedTokenShare": 0.0552944522752081
        },
        {
          "key": "2026-06-12",
          "label": "06-12",
          "startDate": "2026-06-12",
          "endDate": "2026-06-12",
          "totalTokens": 6768735721061,
          "pricedTokens": 379611930884,
          "blendedPricePerMillion": 0.32109149055956143,
          "estimatedRetailValue": 121890.16072173677,
          "pricedTokenShare": 0.05608313672268708
        },
        {
          "key": "2026-06-13",
          "label": "06-13",
          "startDate": "2026-06-13",
          "endDate": "2026-06-13",
          "totalTokens": 5669527799352,
          "pricedTokens": 307598754882,
          "blendedPricePerMillion": 0.3138693371138312,
          "estimatedRetailValue": 96545.8172918532,
          "pricedTokenShare": 0.05425473968346307
        },
        {
          "key": "2026-06-14",
          "label": "06-14",
          "startDate": "2026-06-14",
          "endDate": "2026-06-14",
          "totalTokens": 5583989560133,
          "pricedTokens": 318054689592,
          "blendedPricePerMillion": 0.307783777576838,
          "estimatedRetailValue": 97892.07383865438,
          "pricedTokenShare": 0.05695832453963695
        },
        {
          "key": "2026-06-15",
          "label": "06-15",
          "startDate": "2026-06-15",
          "endDate": "2026-06-15",
          "totalTokens": 6398466710994,
          "pricedTokens": 338765410543,
          "blendedPricePerMillion": 0.3248959729427567,
          "estimatedRetailValue": 110063.51765772038,
          "pricedTokenShare": 0.05294477971744779
        },
        {
          "key": "2026-06-16",
          "label": "06-16",
          "startDate": "2026-06-16",
          "endDate": "2026-06-16",
          "totalTokens": 7019551287662,
          "pricedTokens": 374400339850,
          "blendedPricePerMillion": 0.323340961090423,
          "estimatedRetailValue": 121058.96571967998,
          "pricedTokenShare": 0.053336790986636046
        },
        {
          "key": "2026-06-17",
          "label": "06-17",
          "startDate": "2026-06-17",
          "endDate": "2026-06-17",
          "totalTokens": 7760783359332,
          "pricedTokens": 385203350624,
          "blendedPricePerMillion": 0.3480601130294388,
          "estimatedRetailValue": 134073.92175750798,
          "pricedTokenShare": 0.04963459650768501
        },
        {
          "key": "2026-06-18",
          "label": "06-18",
          "startDate": "2026-06-18",
          "endDate": "2026-06-18",
          "totalTokens": 7306047428112,
          "pricedTokens": 347280272651,
          "blendedPricePerMillion": 0.3327347030049058,
          "estimatedRetailValue": 115552.19837999319,
          "pricedTokenShare": 0.04753326283028836
        },
        {
          "key": "2026-06-19",
          "label": "06-19",
          "startDate": "2026-06-19",
          "endDate": "2026-06-19",
          "totalTokens": 6557231537116,
          "pricedTokens": 311398663352,
          "blendedPricePerMillion": 0.3238705042024242,
          "estimatedRetailValue": 100852.84210777319,
          "pricedTokenShare": 0.047489349977865705
        },
        {
          "key": "2026-06-20",
          "label": "06-20",
          "startDate": "2026-06-20",
          "endDate": "2026-06-20",
          "totalTokens": 5830058052003,
          "pricedTokens": 309171948361,
          "blendedPricePerMillion": 0.2963212622918403,
          "estimatedRetailValue": 91614.22200355919,
          "pricedTokenShare": 0.05303068093031759
        },
        {
          "key": "2026-06-21",
          "label": "06-21",
          "startDate": "2026-06-21",
          "endDate": "2026-06-21",
          "totalTokens": 5775767190996,
          "pricedTokens": 322754809625,
          "blendedPricePerMillion": 0.3199400528279579,
          "estimatedRetailValue": 103262.1908419,
          "pricedTokenShare": 0.05588085512313433
        },
        {
          "key": "2026-06-22",
          "label": "06-22",
          "startDate": "2026-06-22",
          "endDate": "2026-06-22",
          "totalTokens": 6924964211885,
          "pricedTokens": 350570358593,
          "blendedPricePerMillion": 0.31868399374802125,
          "estimatedRetailValue": 111721.16196609319,
          "pricedTokenShare": 0.05062414012065681
        },
        {
          "key": "2026-06-23",
          "label": "06-23",
          "startDate": "2026-06-23",
          "endDate": "2026-06-23",
          "totalTokens": 7148395020746,
          "pricedTokens": 341304761409,
          "blendedPricePerMillion": 0.324978340866968,
          "estimatedRetailValue": 110916.65509269318,
          "pricedTokenShare": 0.04774564925671689
        },
        {
          "key": "2026-06-24",
          "label": "06-24",
          "startDate": "2026-06-24",
          "endDate": "2026-06-24",
          "totalTokens": 7249457010532,
          "pricedTokens": 320370347144,
          "blendedPricePerMillion": 0.33598442597118966,
          "estimatedRetailValue": 107639.44718336759,
          "pricedTokenShare": 0.04419232318759411
        },
        {
          "key": "2026-06-25",
          "label": "06-25",
          "startDate": "2026-06-25",
          "endDate": "2026-06-25",
          "totalTokens": 6972685667926,
          "pricedTokens": 342344611867,
          "blendedPricePerMillion": 0.43574596013026956,
          "estimatedRetailValue": 149175.2815934104,
          "pricedTokenShare": 0.0490979556760701
        },
        {
          "key": "2026-06-26",
          "label": "06-26",
          "startDate": "2026-06-26",
          "endDate": "2026-06-26",
          "totalTokens": 6781230881257,
          "pricedTokens": 357111533635,
          "blendedPricePerMillion": 0.428035637855032,
          "estimatedRetailValue": 152856.46308484595,
          "pricedTokenShare": 0.05266175711876133
        },
        {
          "key": "2026-06-27",
          "label": "06-27",
          "startDate": "2026-06-27",
          "endDate": "2026-06-27",
          "totalTokens": 5693223633861,
          "pricedTokens": 254833589342,
          "blendedPricePerMillion": 0.3126020110380131,
          "estimatedRetailValue": 79661.49250834438,
          "pricedTokenShare": 0.044760860582808044
        },
        {
          "key": "2026-06-28",
          "label": "06-28",
          "startDate": "2026-06-28",
          "endDate": "2026-06-28",
          "totalTokens": 5950391766228,
          "pricedTokens": 272380344490,
          "blendedPricePerMillion": 0.2930522763043429,
          "estimatedRetailValue": 79821.67997335558,
          "pricedTokenShare": 0.045775195178898956
        },
        {
          "key": "2026-06-29",
          "label": "06-29",
          "startDate": "2026-06-29",
          "endDate": "2026-06-29",
          "totalTokens": 7085048648169,
          "pricedTokens": 326517407120,
          "blendedPricePerMillion": 0.3364326029030411,
          "estimatedRetailValue": 109851.10117053357,
          "pricedTokenShare": 0.04608541498220797
        },
        {
          "key": "2026-06-30",
          "label": "06-30",
          "startDate": "2026-06-30",
          "endDate": "2026-06-30",
          "totalTokens": 7167154681834,
          "pricedTokens": 332685640457,
          "blendedPricePerMillion": 0.330787523453479,
          "estimatedRetailValue": 110048.25909530558,
          "pricedTokenShare": 0.04641809131038166
        },
        {
          "key": "2026-07-01",
          "label": "07-01",
          "startDate": "2026-07-01",
          "endDate": "2026-07-01",
          "totalTokens": 6977198358528,
          "pricedTokens": 355145708556,
          "blendedPricePerMillion": 0.4469817254868431,
          "estimatedRetailValue": 158743.64160960837,
          "pricedTokenShare": 0.05090090467643321
        },
        {
          "key": "2026-07-02",
          "label": "07-02",
          "startDate": "2026-07-02",
          "endDate": "2026-07-02",
          "totalTokens": 6974615024174,
          "pricedTokens": 352276585277,
          "blendedPricePerMillion": 0.34169066420274646,
          "estimatedRetailValue": 120369.62040637358,
          "pricedTokenShare": 0.05050839136726689
        },
        {
          "key": "2026-07-03",
          "label": "07-03",
          "startDate": "2026-07-03",
          "endDate": "2026-07-03",
          "totalTokens": 6991826989221,
          "pricedTokens": 382553938546,
          "blendedPricePerMillion": 0.3101121911059222,
          "estimatedRetailValue": 118634.64009870036,
          "pricedTokenShare": 0.05471444575727732
        },
        {
          "key": "2026-07-04",
          "label": "07-04",
          "startDate": "2026-07-04",
          "endDate": "2026-07-04",
          "totalTokens": 5714894093924,
          "pricedTokens": 304585484471,
          "blendedPricePerMillion": 0.30974327892752,
          "estimatedRetailValue": 94343.30667377477,
          "pricedTokenShare": 0.053296785463589125
        },
        {
          "key": "2026-07-05",
          "label": "07-05",
          "startDate": "2026-07-05",
          "endDate": "2026-07-05",
          "totalTokens": 5809000468188,
          "pricedTokens": 333161360748,
          "blendedPricePerMillion": 0.28813935532088275,
          "estimatedRetailValue": 95996.89970375678,
          "pricedTokenShare": 0.057352613857151735
        },
        {
          "key": "2026-07-06",
          "label": "07-06",
          "startDate": "2026-07-06",
          "endDate": "2026-07-06",
          "totalTokens": 7153369575731,
          "pricedTokens": 380696269741,
          "blendedPricePerMillion": 0.3053613992125696,
          "estimatedRetailValue": 116249.94560311758,
          "pricedTokenShare": 0.05321915297548384
        },
        {
          "key": "2026-07-07",
          "label": "07-07",
          "startDate": "2026-07-07",
          "endDate": "2026-07-07",
          "totalTokens": 7795823788771,
          "pricedTokens": 359596332441,
          "blendedPricePerMillion": 0.31489742164215456,
          "estimatedRetailValue": 113235.95791764597,
          "pricedTokenShare": 0.04612679072594711
        },
        {
          "key": "2026-07-08",
          "label": "07-08",
          "startDate": "2026-07-08",
          "endDate": "2026-07-08",
          "totalTokens": 7866992584618,
          "pricedTokens": 404462163123,
          "blendedPricePerMillion": 0.30320256539012885,
          "estimatedRetailValue": 122633.96546213438,
          "pricedTokenShare": 0.05141255171815312
        },
        {
          "key": "2026-07-09",
          "label": "07-09",
          "startDate": "2026-07-09",
          "endDate": "2026-07-09",
          "totalTokens": 7769244336449,
          "pricedTokens": 356738881956,
          "blendedPricePerMillion": 0.3115003535287527,
          "estimatedRetailValue": 111124.28784674598,
          "pricedTokenShare": 0.04591680561291892
        },
        {
          "key": "2026-07-10",
          "label": "07-10",
          "startDate": "2026-07-10",
          "endDate": "2026-07-10",
          "totalTokens": 7814025791624,
          "pricedTokens": 346348830899,
          "blendedPricePerMillion": 0.30847846243733124,
          "estimatedRetailValue": 106841.15482269078,
          "pricedTokenShare": 0.04432399382022232
        },
        {
          "key": "2026-07-11",
          "label": "07-11",
          "startDate": "2026-07-11",
          "endDate": "2026-07-11",
          "totalTokens": 7239751697474,
          "pricedTokens": 306788687474,
          "blendedPricePerMillion": 0.32169984376404553,
          "estimatedRetailValue": 98693.87282896238,
          "pricedTokenShare": 0.042375581414075394
        },
        {
          "key": "2026-07-12",
          "label": "07-12",
          "startDate": "2026-07-12",
          "endDate": "2026-07-12",
          "totalTokens": 6980460924641,
          "pricedTokens": 256447426996,
          "blendedPricePerMillion": 0.3142636621783311,
          "estimatedRetailValue": 80592.10756397319,
          "pricedTokenShare": 0.03673789306530484
        },
        {
          "key": "2026-07-13",
          "label": "07-13",
          "startDate": "2026-07-13",
          "endDate": "2026-07-13",
          "totalTokens": 8945200747827,
          "pricedTokens": 344322157451,
          "blendedPricePerMillion": 0.3116081263043862,
          "estimatedRetailValue": 107293.58232838997,
          "pricedTokenShare": 0.03849239018304245
        },
        {
          "key": "2026-07-14",
          "label": "07-14",
          "startDate": "2026-07-14",
          "endDate": "2026-07-14",
          "totalTokens": 9313408516626,
          "pricedTokens": 381261705780,
          "blendedPricePerMillion": 0.29944316843843605,
          "estimatedRetailValue": 114166.213183006,
          "pricedTokenShare": 0.04093686055963117
        },
        {
          "key": "2026-07-15",
          "label": "07-15",
          "startDate": "2026-07-15",
          "endDate": "2026-07-15",
          "totalTokens": 9480961115469,
          "pricedTokens": 380340035356,
          "blendedPricePerMillion": 0.30014807093275486,
          "estimatedRetailValue": 114158.32791059918,
          "pricedTokenShare": 0.040116189774836504
        },
        {
          "key": "2026-07-16",
          "label": "07-16",
          "startDate": "2026-07-16",
          "endDate": "2026-07-16",
          "totalTokens": 9619203914649,
          "pricedTokens": 373096532303,
          "blendedPricePerMillion": 0.311310591993996,
          "estimatedRetailValue": 116148.90234215398,
          "pricedTokenShare": 0.038786633032575034
        },
        {
          "key": "2026-07-17",
          "label": "07-17",
          "startDate": "2026-07-17",
          "endDate": "2026-07-17",
          "totalTokens": 9621566458152,
          "pricedTokens": 323445728681,
          "blendedPricePerMillion": 0.34587580882518176,
          "estimatedRetailValue": 111872.05301859118,
          "pricedTokenShare": 0.033616743187067664
        },
        {
          "key": "2026-07-18",
          "label": "07-18",
          "startDate": "2026-07-18",
          "endDate": "2026-07-18",
          "totalTokens": 8050764751145,
          "pricedTokens": 286545708307,
          "blendedPricePerMillion": 0.3098963384566702,
          "estimatedRetailValue": 88799.46580481237,
          "pricedTokenShare": 0.03559235888320383
        },
        {
          "key": "2026-07-19",
          "label": "07-19",
          "startDate": "2026-07-19",
          "endDate": "2026-07-19",
          "totalTokens": 7742838835750,
          "pricedTokens": 291137764852,
          "blendedPricePerMillion": 0.3041207220548782,
          "estimatedRetailValue": 88541.02726423359,
          "pricedTokenShare": 0.03760090724189784
        },
        {
          "key": "2026-07-20",
          "label": "07-20",
          "startDate": "2026-07-20",
          "endDate": "2026-07-20",
          "totalTokens": 8440173824425,
          "pricedTokens": 321507957846,
          "blendedPricePerMillion": 0.32964291879426816,
          "estimatedRetailValue": 105982.82163993997,
          "pricedTokenShare": 0.03809257540592219
        },
        {
          "key": "2026-07-21",
          "label": "07-21",
          "startDate": "2026-07-21",
          "endDate": "2026-07-21",
          "totalTokens": 8372722163355,
          "pricedTokens": 340859610228,
          "blendedPricePerMillion": 0.3192527695500536,
          "estimatedRetailValue": 108820.37459304077,
          "pricedTokenShare": 0.04071072747640482
        },
        {
          "key": "2026-07-22",
          "label": "07-22",
          "startDate": "2026-07-22",
          "endDate": "2026-07-22",
          "totalTokens": 9013659246552,
          "pricedTokens": 321791787679,
          "blendedPricePerMillion": 0.34254353652146546,
          "estimatedRetailValue": 110227.69697512919,
          "pricedTokenShare": 0.03570046069825584
        },
        {
          "key": "2026-07-23",
          "label": "07-23",
          "startDate": "2026-07-23",
          "endDate": "2026-07-23",
          "totalTokens": 8751994182349,
          "pricedTokens": 360209548807,
          "blendedPricePerMillion": 0.33711530563320413,
          "estimatedRetailValue": 121432.15213807038,
          "pricedTokenShare": 0.04115742553091154
        },
        {
          "key": "2026-07-24",
          "label": "07-24",
          "startDate": "2026-07-24",
          "endDate": "2026-07-24",
          "totalTokens": 8661084724352,
          "pricedTokens": 354176731590,
          "blendedPricePerMillion": 0.33818130241797684,
          "estimatedRetailValue": 119775.9483752484,
          "pricedTokenShare": 0.040892883843310815
        },
        {
          "key": "2026-07-25",
          "label": "07-25",
          "startDate": "2026-07-25",
          "endDate": "2026-07-25",
          "totalTokens": 7305381415398,
          "pricedTokens": 276505895113,
          "blendedPricePerMillion": 0.3304115529748509,
          "estimatedRetailValue": 91360.74221098758,
          "pricedTokenShare": 0.03784961788992859
        },
        {
          "key": "2026-07-26",
          "label": "07-26",
          "startDate": "2026-07-26",
          "endDate": "2026-07-26",
          "totalTokens": 7496481859549,
          "pricedTokens": 313723455624,
          "blendedPricePerMillion": 0.3008545555711349,
          "estimatedRetailValue": 94385.13081399917,
          "pricedTokenShare": 0.04184942503720993
        },
        {
          "key": "2026-07-27",
          "label": "07-27",
          "startDate": "2026-07-27",
          "endDate": "2026-07-27",
          "totalTokens": 8784326010554,
          "pricedTokens": 339547665528,
          "blendedPricePerMillion": 0.3198407612369487,
          "estimatedRetailValue": 108601.18381870438,
          "pricedTokenShare": 0.03865380965142319
        },
        {
          "key": "2026-07-28",
          "label": "07-28",
          "startDate": "2026-07-28",
          "endDate": "2026-07-28",
          "totalTokens": 8890418317802,
          "pricedTokens": 357699052766,
          "blendedPricePerMillion": 0.3100418288597073,
          "estimatedRetailValue": 110901.6685009556,
          "pricedTokenShare": 0.04023422070587504
        },
        {
          "key": "2026-07-29",
          "label": "07-29",
          "startDate": "2026-07-29",
          "endDate": "2026-07-29",
          "totalTokens": 8196705797925,
          "pricedTokens": 310741636624,
          "blendedPricePerMillion": 0.34196632263985705,
          "estimatedRetailValue": 106263.17476739999,
          "pricedTokenShare": 0.03791055141965256
        },
        {
          "key": "2026-07-30",
          "label": "07-30",
          "startDate": "2026-07-30",
          "endDate": "2026-07-30",
          "totalTokens": 8321933504398,
          "pricedTokens": 289425220012,
          "blendedPricePerMillion": 0.35702563653007047,
          "estimatedRetailValue": 103332.22340264,
          "pricedTokenShare": 0.0347786028161657
        },
        {
          "key": "2026-07-31",
          "label": "07-31",
          "startDate": "2026-07-31",
          "endDate": "2026-07-31",
          "totalTokens": 8296221899663,
          "pricedTokens": 273866881768,
          "blendedPricePerMillion": 0.3633439961121542,
          "estimatedRetailValue": 99507.88722435998,
          "pricedTokenShare": 0.03301103623796812
        },
        {
          "key": "2026-08-01",
          "label": "08-01",
          "startDate": "2026-08-01",
          "endDate": "2026-08-01",
          "totalTokens": 7066940419625,
          "pricedTokens": 282964612423,
          "blendedPricePerMillion": 0.3198421774492591,
          "estimatedRetailValue": 90504.01777845799,
          "pricedTokenShare": 0.04004061101706801
        },
        {
          "key": "2026-08-02",
          "label": "08-02",
          "startDate": "2026-08-02",
          "endDate": "2026-08-02",
          "totalTokens": 7232042961954,
          "pricedTokens": 275872947151,
          "blendedPricePerMillion": 0.291309152559374,
          "estimatedRetailValue": 80364.31444861478,
          "pricedTokenShare": 0.03814592205858009
        },
        {
          "key": "2026-08-03",
          "label": "08-03",
          "startDate": "2026-08-03",
          "endDate": "2026-08-03",
          "totalTokens": 9143823075351,
          "pricedTokens": 293451529922,
          "blendedPricePerMillion": 0.3336625568556186,
          "estimatedRetailValue": 97913.78778696757,
          "pricedTokenShare": 0.032092870509826156
        },
        {
          "key": "2026-08-04",
          "label": "08-04",
          "startDate": "2026-08-04",
          "endDate": "2026-08-04",
          "totalTokens": 9996550853376,
          "pricedTokens": 316135264853,
          "blendedPricePerMillion": 0.3349163175197892,
          "estimatedRetailValue": 105878.85874271,
          "pricedTokenShare": 0.031624434216351326
        },
        {
          "key": "2026-08-05",
          "label": "08-05",
          "startDate": "2026-08-05",
          "endDate": "2026-08-05",
          "totalTokens": 10787614259704,
          "pricedTokens": 291249741136,
          "blendedPricePerMillion": 0.3335921360297363,
          "estimatedRetailValue": 97158.623263666,
          "pricedTokenShare": 0.026998531290086336
        },
        {
          "key": "2026-08-06",
          "label": "08-06",
          "startDate": "2026-08-06",
          "endDate": "2026-08-06",
          "totalTokens": 11001204844264,
          "pricedTokens": 257968945149,
          "blendedPricePerMillion": 0.3501425601816092,
          "estimatedRetailValue": 90325.90690181998,
          "pricedTokenShare": 0.023449153870042184
        },
        {
          "key": "2026-08-07",
          "label": "08-07",
          "startDate": "2026-08-07",
          "endDate": "2026-08-07",
          "totalTokens": 10378071121073,
          "pricedTokens": 265331623255,
          "blendedPricePerMillion": 0.34572631954375593,
          "estimatedRetailValue": 91732.12556652159,
          "pricedTokenShare": 0.025566564360523198
        },
        {
          "key": "2026-08-08",
          "label": "08-08",
          "startDate": "2026-08-08",
          "endDate": "2026-08-08",
          "totalTokens": 8765239038152,
          "pricedTokens": 249300764212,
          "blendedPricePerMillion": 0.30508757684387283,
          "estimatedRetailValue": 76058.56605876477,
          "pricedTokenShare": 0.028441981231416683
        },
        {
          "key": "2026-08-09",
          "label": "08-09",
          "startDate": "2026-08-09",
          "endDate": "2026-08-09",
          "totalTokens": 8974034656012,
          "pricedTokens": 257630709551,
          "blendedPricePerMillion": 0.3102689527744963,
          "estimatedRetailValue": 79934.81045493919,
          "pricedTokenShare": 0.028708459397179253
        },
        {
          "key": "2026-08-10",
          "label": "08-10",
          "startDate": "2026-08-10",
          "endDate": "2026-08-10",
          "totalTokens": 10613720303759,
          "pricedTokens": 290701979537,
          "blendedPricePerMillion": 0.33822714226242817,
          "estimatedRetailValue": 98323.29978883038,
          "pricedTokenShare": 0.02738926325711106
        },
        {
          "key": "2026-08-11",
          "label": "08-11",
          "startDate": "2026-08-11",
          "endDate": "2026-08-11",
          "totalTokens": 10931401727980,
          "pricedTokens": 328385002311,
          "blendedPricePerMillion": 0.3114852319485385,
          "estimatedRetailValue": 102287.07861326319,
          "pricedTokenShare": 0.030040520921527036
        },
        {
          "key": "2026-08-12",
          "label": "08-12",
          "startDate": "2026-08-12",
          "endDate": "2026-08-12",
          "totalTokens": 11234116355431,
          "pricedTokens": 312500288113,
          "blendedPricePerMillion": 0.30699950343605903,
          "estimatedRetailValue": 95937.43327431638,
          "pricedTokenShare": 0.027817077750127223
        },
        {
          "key": "2026-08-13",
          "label": "08-13",
          "startDate": "2026-08-13",
          "endDate": "2026-08-13",
          "totalTokens": 11135113794296,
          "pricedTokens": 300462200979,
          "blendedPricePerMillion": 0.3143821817172257,
          "estimatedRetailValue": 94459.96226733757,
          "pricedTokenShare": 0.026983307627526248
        },
        {
          "key": "2026-08-14",
          "label": "08-14",
          "startDate": "2026-08-14",
          "endDate": "2026-08-14",
          "totalTokens": 11486043370983,
          "pricedTokens": 288731161015,
          "blendedPricePerMillion": 0.3070000144387567,
          "estimatedRetailValue": 88640.47060052399,
          "pricedTokenShare": 0.025137564928965593
        },
        {
          "key": "2026-08-15",
          "label": "08-15",
          "startDate": "2026-08-15",
          "endDate": "2026-08-15",
          "totalTokens": 9565041906391,
          "pricedTokens": 244567625468,
          "blendedPricePerMillion": 0.2883113145543278,
          "estimatedRetailValue": 70511.61359610959,
          "pricedTokenShare": 0.02556890266257894
        },
        {
          "key": "2026-08-16",
          "label": "08-16",
          "startDate": "2026-08-16",
          "endDate": "2026-08-16",
          "totalTokens": 10375143625991,
          "pricedTokens": 260893002897,
          "blendedPricePerMillion": 0.2649574469537024,
          "estimatedRetailValue": 69125.543975674,
          "pricedTokenShare": 0.025145965424847826
        },
        {
          "key": "2026-08-17",
          "label": "08-17",
          "startDate": "2026-08-17",
          "endDate": "2026-08-17",
          "totalTokens": 13311262793704,
          "pricedTokens": 306119980683,
          "blendedPricePerMillion": 0.2973499534071914,
          "estimatedRetailValue": 91024.76199310037,
          "pricedTokenShare": 0.02299706537442785
        },
        {
          "key": "2026-08-18",
          "label": "08-18",
          "startDate": "2026-08-18",
          "endDate": "2026-08-18",
          "totalTokens": 12704870921171,
          "pricedTokens": 332097642009,
          "blendedPricePerMillion": 0.2924633764764045,
          "estimatedRetailValue": 97126.39770180438,
          "pricedTokenShare": 0.02613939520279603
        },
        {
          "key": "2026-08-19",
          "label": "08-19",
          "startDate": "2026-08-19",
          "endDate": "2026-08-19",
          "totalTokens": 12119291448118,
          "pricedTokens": 322061107310,
          "blendedPricePerMillion": 0.30732065165586786,
          "estimatedRetailValue": 98976.02937151959,
          "pricedTokenShare": 0.026574252190297208
        },
        {
          "key": "2026-08-20",
          "label": "08-20",
          "startDate": "2026-08-20",
          "endDate": "2026-08-20",
          "totalTokens": 12130101854803,
          "pricedTokens": 334367011663,
          "blendedPricePerMillion": 0.3051728032706636,
          "estimatedRetailValue": 102039.71827043238,
          "pricedTokenShare": 0.027565062162326775
        },
        {
          "key": "2026-08-21",
          "label": "08-21",
          "startDate": "2026-08-21",
          "endDate": "2026-08-21",
          "totalTokens": 13888795396670,
          "pricedTokens": 306368580859,
          "blendedPricePerMillion": 0.30764873427990863,
          "estimatedRetailValue": 94253.90612440319,
          "pricedTokenShare": 0.02205868630856607
        },
        {
          "key": "2026-08-22",
          "label": "08-22",
          "startDate": "2026-08-22",
          "endDate": "2026-08-22",
          "totalTokens": 14075709916673,
          "pricedTokens": 292220352115,
          "blendedPricePerMillion": 0.26480017917842885,
          "estimatedRetailValue": 77380.00159963558,
          "pricedTokenShare": 0.02076061199363439
        },
        {
          "key": "2026-08-23",
          "label": "08-23",
          "startDate": "2026-08-23",
          "endDate": "2026-08-23",
          "totalTokens": 15147544875185,
          "pricedTokens": 243902068556,
          "blendedPricePerMillion": 0.2859918537674232,
          "estimatedRetailValue": 69754.00472403958,
          "pricedTokenShare": 0.016101755800411264
        },
        {
          "key": "2026-08-24",
          "label": "08-24",
          "startDate": "2026-08-24",
          "endDate": "2026-08-24",
          "totalTokens": 18352938225742,
          "pricedTokens": 331466644065,
          "blendedPricePerMillion": 0.2678427713184745,
          "estimatedRetailValue": 88780.94454600397,
          "pricedTokenShare": 0.018060685432923315
        },
        {
          "key": "2026-08-25",
          "label": "08-25",
          "startDate": "2026-08-25",
          "endDate": "2026-08-25",
          "totalTokens": 18775140916501,
          "pricedTokens": 314529503557,
          "blendedPricePerMillion": 0.29707741478098065,
          "estimatedRetailValue": 93439.6117890588,
          "pricedTokenShare": 0.01675244436011492
        },
        {
          "key": "2026-08-26",
          "label": "08-26",
          "startDate": "2026-08-26",
          "endDate": "2026-08-26",
          "totalTokens": 18436449188941,
          "pricedTokens": 423824142437,
          "blendedPricePerMillion": 0.26590863486820976,
          "estimatedRetailValue": 112698.49913961237,
          "pricedTokenShare": 0.022988382312317954
        },
        {
          "key": "2026-08-27",
          "label": "08-27",
          "startDate": "2026-08-27",
          "endDate": "2026-08-27",
          "totalTokens": 15797679821005,
          "pricedTokens": 401818624256,
          "blendedPricePerMillion": 0.26418688866033285,
          "estimatedRetailValue": 106155.21214796798,
          "pricedTokenShare": 0.025435293587969268
        },
        {
          "key": "2026-08-28",
          "label": "08-28",
          "startDate": "2026-08-28",
          "endDate": "2026-08-28",
          "totalTokens": 15116796693545,
          "pricedTokens": 376584970890,
          "blendedPricePerMillion": 0.2594257662004308,
          "estimatedRetailValue": 97695.84461270517,
          "pricedTokenShare": 0.024911691181955565
        },
        {
          "key": "2026-08-29",
          "label": "08-29",
          "startDate": "2026-08-29",
          "endDate": "2026-08-29",
          "totalTokens": 13204155770914,
          "pricedTokens": 283828507167,
          "blendedPricePerMillion": 0.24035996380446126,
          "estimatedRetailValue": 68221.0097093344,
          "pricedTokenShare": 0.021495392215245976
        },
        {
          "key": "2026-08-30",
          "label": "08-30",
          "startDate": "2026-08-30",
          "endDate": "2026-08-30",
          "totalTokens": 13313663519421,
          "pricedTokens": 338687366725,
          "blendedPricePerMillion": 0.23506913114544245,
          "estimatedRetailValue": 79614.94502598359,
          "pricedTokenShare": 0.025439081153804707
        },
        {
          "key": "2026-08-31",
          "label": "08-31",
          "startDate": "2026-08-31",
          "endDate": "2026-08-31",
          "totalTokens": 14318704603016,
          "pricedTokens": 366004128697,
          "blendedPricePerMillion": 0.26371863090855224,
          "estimatedRetailValue": 96522.1077268504,
          "pricedTokenShare": 0.02556125982373484
        },
        {
          "key": "2026-09-01",
          "label": "09-01",
          "startDate": "2026-09-01",
          "endDate": "2026-09-01",
          "totalTokens": 16194588394672,
          "pricedTokens": 370433871734,
          "blendedPricePerMillion": 0.291462273132615,
          "estimatedRetailValue": 107967.49830090719,
          "pricedTokenShare": 0.022873929408164045
        },
        {
          "key": "2026-09-02",
          "label": "09-02",
          "startDate": "2026-09-02",
          "endDate": "2026-09-02",
          "totalTokens": 18488527970063,
          "pricedTokens": 361900962748,
          "blendedPricePerMillion": 0.28966459894613167,
          "estimatedRetailValue": 104829.89723261837,
          "pricedTokenShare": 0.01957435244893468
        },
        {
          "key": "2026-09-03",
          "label": "09-03",
          "startDate": "2026-09-03",
          "endDate": "2026-09-03",
          "totalTokens": 18567158117428,
          "pricedTokens": 312924798740,
          "blendedPricePerMillion": 0.30509251302580864,
          "estimatedRetailValue": 95471.01323568198,
          "pricedTokenShare": 0.016853672315434973
        },
        {
          "key": "2026-09-04",
          "label": "09-04",
          "startDate": "2026-09-04",
          "endDate": "2026-09-04",
          "totalTokens": 18269560527417,
          "pricedTokens": 321335351997,
          "blendedPricePerMillion": 0.2997301029648862,
          "estimatedRetailValue": 96313.87814031877,
          "pricedTokenShare": 0.017588564952877455
        },
        {
          "key": "2026-09-05",
          "label": "09-05",
          "startDate": "2026-09-05",
          "endDate": "2026-09-05",
          "totalTokens": 15344774218059,
          "pricedTokens": 276895614905,
          "blendedPricePerMillion": 0.26708721658346696,
          "estimatedRetailValue": 73955.27906914399,
          "pricedTokenShare": 0.01804494552804344
        },
        {
          "key": "2026-09-06",
          "label": "09-06",
          "startDate": "2026-09-06",
          "endDate": "2026-09-06",
          "totalTokens": 14279989875501,
          "pricedTokens": 280699865049,
          "blendedPricePerMillion": 0.24989294527509673,
          "estimatedRetailValue": 70144.91601541679,
          "pricedTokenShare": 0.01965686723143786
        },
        {
          "key": "2026-09-07",
          "label": "09-07",
          "startDate": "2026-09-07",
          "endDate": "2026-09-07",
          "totalTokens": 19050916850409,
          "pricedTokens": 271727137632,
          "blendedPricePerMillion": 0.289699840590719,
          "estimatedRetailValue": 78719.30845616278,
          "pricedTokenShare": 0.014263205270677896
        },
        {
          "key": "2026-09-08",
          "label": "09-08",
          "startDate": "2026-09-08",
          "endDate": "2026-09-08",
          "totalTokens": 19046273585455,
          "pricedTokens": 337469787931,
          "blendedPricePerMillion": 0.29118431423469326,
          "estimatedRetailValue": 98265.90877361559,
          "pricedTokenShare": 0.017718415437900373
        },
        {
          "key": "2026-09-09",
          "label": "09-09",
          "startDate": "2026-09-09",
          "endDate": "2026-09-09",
          "totalTokens": 17947794799521,
          "pricedTokens": 316786293512,
          "blendedPricePerMillion": 0.29839309890933663,
          "estimatedRetailValue": 94526.84381304837,
          "pricedTokenShare": 0.01765042987456345
        },
        {
          "key": "2026-09-10",
          "label": "09-10",
          "startDate": "2026-09-10",
          "endDate": "2026-09-10",
          "totalTokens": 19184120113922,
          "pricedTokens": 275223532281,
          "blendedPricePerMillion": 0.3442348129754762,
          "estimatedRetailValue": 94741.52116119998,
          "pricedTokenShare": 0.014346424576505288
        },
        {
          "key": "2026-09-11",
          "label": "09-11",
          "startDate": "2026-09-11",
          "endDate": "2026-09-11",
          "totalTokens": 17751297946007,
          "pricedTokens": 286958504071,
          "blendedPricePerMillion": 0.3270616282446141,
          "estimatedRetailValue": 93853.11558009998,
          "pricedTokenShare": 0.016165494204639207
        },
        {
          "key": "2026-09-12",
          "label": "09-12",
          "startDate": "2026-09-12",
          "endDate": "2026-09-12",
          "totalTokens": 17051827575447,
          "pricedTokens": 260990405645,
          "blendedPricePerMillion": 0.2829325804580842,
          "estimatedRetailValue": 73842.68894394199,
          "pricedTokenShare": 0.015305714562866049
        },
        {
          "key": "2026-09-13",
          "label": "09-13",
          "startDate": "2026-09-13",
          "endDate": "2026-09-13",
          "totalTokens": 16730791173422,
          "pricedTokens": 269395938835,
          "blendedPricePerMillion": 0.2612975831776576,
          "estimatedRetailValue": 70392.50773546158,
          "pricedTokenShare": 0.01610180511146142
        },
        {
          "key": "2026-09-14",
          "label": "09-14",
          "startDate": "2026-09-14",
          "endDate": "2026-09-14",
          "totalTokens": 18120484812487,
          "pricedTokens": 304252208171,
          "blendedPricePerMillion": 0.30659372804281254,
          "estimatedRetailValue": 93281.81876840477,
          "pricedTokenShare": 0.01679051147468951
        },
        {
          "key": "2026-09-15",
          "label": "09-15",
          "startDate": "2026-09-15",
          "endDate": "2026-09-15",
          "totalTokens": 17750550231758,
          "pricedTokens": 304656628562,
          "blendedPricePerMillion": 0.3351054740079074,
          "estimatedRetailValue": 102092.10392391999,
          "pricedTokenShare": 0.01716322167956971
        },
        {
          "key": "2026-09-16",
          "label": "09-16",
          "startDate": "2026-09-16",
          "endDate": "2026-09-16",
          "totalTokens": 18403097790101,
          "pricedTokens": 380026082007,
          "blendedPricePerMillion": 0.3259471129426804,
          "estimatedRetailValue": 123868.40427309996,
          "pricedTokenShare": 0.020650114798140967
        },
        {
          "key": "2026-09-17",
          "label": "09-17",
          "startDate": "2026-09-17",
          "endDate": "2026-09-17",
          "totalTokens": 19950735154131,
          "pricedTokens": 257585280962,
          "blendedPricePerMillion": 0.35321109805712075,
          "estimatedRetailValue": 90981.97993193999,
          "pricedTokenShare": 0.012911067134719813
        },
        {
          "key": "2026-09-18",
          "label": "09-18",
          "startDate": "2026-09-18",
          "endDate": "2026-09-18",
          "totalTokens": 19516151287053,
          "pricedTokens": 231359189673,
          "blendedPricePerMillion": 0.3644483888182467,
          "estimatedRetailValue": 84318.48391461998,
          "pricedTokenShare": 0.01185475487815487
        },
        {
          "key": "2026-09-19",
          "label": "09-19",
          "startDate": "2026-09-19",
          "endDate": "2026-09-19",
          "totalTokens": 17822770536307,
          "pricedTokens": 264643847380,
          "blendedPricePerMillion": 0.2765440682906293,
          "estimatedRetailValue": 73185.6862025496,
          "pricedTokenShare": 0.01484863685143062
        },
        {
          "key": "2026-09-20",
          "label": "09-20",
          "startDate": "2026-09-20",
          "endDate": "2026-09-20",
          "totalTokens": 17331480167240,
          "pricedTokens": 241826466273,
          "blendedPricePerMillion": 0.27304305233957493,
          "estimatedRetailValue": 66029.03648767319,
          "pricedTokenShare": 0.013953018665428293
        },
        {
          "key": "2026-09-21",
          "label": "09-21",
          "startDate": "2026-09-21",
          "endDate": "2026-09-21",
          "totalTokens": 20836773421509,
          "pricedTokens": 262530519265,
          "blendedPricePerMillion": 0.36344919896161076,
          "estimatedRetailValue": 95416.50692983998,
          "pricedTokenShare": 0.012599384461031756
        },
        {
          "key": "2026-09-22",
          "label": "09-22",
          "startDate": "2026-09-22",
          "endDate": "2026-09-22",
          "totalTokens": 20461970574170,
          "pricedTokens": 283999745819,
          "blendedPricePerMillion": 0.35555734772958514,
          "estimatedRetailValue": 100978.19637927998,
          "pricedTokenShare": 0.013879393716727592
        },
        {
          "key": "2026-09-23",
          "label": "09-23",
          "startDate": "2026-09-23",
          "endDate": "2026-09-23",
          "totalTokens": 19839776739539,
          "pricedTokens": 280902925074,
          "blendedPricePerMillion": 0.3538065239449476,
          "estimatedRetailValue": 99385.28748639999,
          "pricedTokenShare": 0.014158572889289837
        },
        {
          "key": "2026-09-24",
          "label": "09-24",
          "startDate": "2026-09-24",
          "endDate": "2026-09-24",
          "totalTokens": 21879527010648,
          "pricedTokens": 287375435625,
          "blendedPricePerMillion": 0.33466753942177685,
          "estimatedRetailValue": 96175.22993087998,
          "pricedTokenShare": 0.013134444610486526
        },
        {
          "key": "2026-09-25",
          "label": "09-25",
          "startDate": "2026-09-25",
          "endDate": "2026-09-25",
          "totalTokens": 22441110438066,
          "pricedTokens": 279534118126,
          "blendedPricePerMillion": 0.3360153059611924,
          "estimatedRetailValue": 93927.74222869998,
          "pricedTokenShare": 0.012456340736679275
        },
        {
          "key": "2026-09-26",
          "label": "09-26",
          "startDate": "2026-09-26",
          "endDate": "2026-09-26",
          "totalTokens": 19855703336813,
          "pricedTokens": 276054180732,
          "blendedPricePerMillion": 0.27508994458115776,
          "estimatedRetailValue": 75939.72927896278,
          "pricedTokenShare": 0.013903016984555174
        },
        {
          "key": "2026-09-27",
          "label": "09-27",
          "startDate": "2026-09-27",
          "endDate": "2026-09-27",
          "totalTokens": 20530243814309,
          "pricedTokens": 247114322236,
          "blendedPricePerMillion": 0.2671825661244551,
          "estimatedRetailValue": 66024.63874111998,
          "pricedTokenShare": 0.012036599490541281
        },
        {
          "key": "2026-09-28",
          "label": "09-28",
          "startDate": "2026-09-28",
          "endDate": "2026-09-28",
          "totalTokens": 23934998683834,
          "pricedTokens": 251115364890,
          "blendedPricePerMillion": 0.3381985391812317,
          "estimatedRetailValue": 84926.84957175997,
          "pricedTokenShare": 0.010491555408340443
        },
        {
          "key": "2026-09-29",
          "label": "09-29",
          "startDate": "2026-09-29",
          "endDate": "2026-09-29",
          "totalTokens": 24936730343781,
          "pricedTokens": 294549377433,
          "blendedPricePerMillion": 0.33522575965090984,
          "estimatedRetailValue": 98740.53880467998,
          "pricedTokenShare": 0.011811868411467906
        },
        {
          "key": "2026-09-30",
          "label": "09-30",
          "startDate": "2026-09-30",
          "endDate": "2026-09-30",
          "totalTokens": 24377727661254,
          "pricedTokens": 279687677951,
          "blendedPricePerMillion": 0.3350739732747848,
          "estimatedRetailValue": 93716.06152703997,
          "pricedTokenShare": 0.011473082390510746
        },
        {
          "key": "2026-10-01",
          "label": "10-01",
          "startDate": "2026-10-01",
          "endDate": "2026-10-01",
          "totalTokens": 23446998494287,
          "pricedTokens": 245998461212,
          "blendedPricePerMillion": 0.353093077105894,
          "estimatedRetailValue": 86860.35363265999,
          "pricedTokenShare": 0.010491682390474797
        },
        {
          "key": "2026-10-02",
          "label": "10-02",
          "startDate": "2026-10-02",
          "endDate": "2026-10-02",
          "totalTokens": 24060063479633,
          "pricedTokens": 249191811848,
          "blendedPricePerMillion": 0.3720436382073044,
          "estimatedRetailValue": 92710.22829139998,
          "pricedTokenShare": 0.010357072085821489
        },
        {
          "key": "2026-10-03",
          "label": "10-03",
          "startDate": "2026-10-03",
          "endDate": "2026-10-03",
          "totalTokens": 22318533815723,
          "pricedTokens": 187993466065,
          "blendedPricePerMillion": 0.36287259329701,
          "estimatedRetailValue": 68217.67655389999,
          "pricedTokenShare": 0.00842319964282609
        },
        {
          "key": "2026-10-04",
          "label": "10-04",
          "startDate": "2026-10-04",
          "endDate": "2026-10-04",
          "totalTokens": 22780997379051,
          "pricedTokens": 231168070625,
          "blendedPricePerMillion": 0.2957920090131772,
          "estimatedRetailValue": 68377.66802986879,
          "pricedTokenShare": 0.010147407805664296
        },
        {
          "key": "2026-10-05",
          "label": "10-05",
          "startDate": "2026-10-05",
          "endDate": "2026-10-05",
          "totalTokens": 25873213536983,
          "pricedTokens": 229769497429,
          "blendedPricePerMillion": 0.36379532161761136,
          "estimatedRetailValue": 83589.06821509998,
          "pricedTokenShare": 0.008880593711352051
        },
        {
          "key": "2026-10-06",
          "label": "10-06",
          "startDate": "2026-10-06",
          "endDate": "2026-10-06",
          "totalTokens": 22109724903182,
          "pricedTokens": 238757267127,
          "blendedPricePerMillion": 0.3537147238240007,
          "estimatedRetailValue": 84451.96080279998,
          "pricedTokenShare": 0.010798744361248854
        },
        {
          "key": "2026-10-07",
          "label": "10-07",
          "startDate": "2026-10-07",
          "endDate": "2026-10-07",
          "totalTokens": 25121204185746,
          "pricedTokens": 242325593416,
          "blendedPricePerMillion": 0.34370764855884456,
          "estimatedRetailValue": 83289.15989863998,
          "pricedTokenShare": 0.009646257067306421
        },
        {
          "key": "2026-10-08",
          "label": "10-08",
          "startDate": "2026-10-08",
          "endDate": "2026-10-08",
          "totalTokens": 24455189713768,
          "pricedTokens": 222206560125,
          "blendedPricePerMillion": 0.3526312592492367,
          "estimatedRetailValue": 78356.97911031998,
          "pricedTokenShare": 0.009086274231595928
        },
        {
          "key": "2026-10-09",
          "label": "10-09",
          "startDate": "2026-10-09",
          "endDate": "2026-10-09",
          "totalTokens": 26639007266335,
          "pricedTokens": 218411177448,
          "blendedPricePerMillion": 0.3458721059711577,
          "estimatedRetailValue": 75542.33391157999,
          "pricedTokenShare": 0.008198923303122363
        },
        {
          "key": "2026-10-10",
          "label": "10-10",
          "startDate": "2026-10-10",
          "endDate": "2026-10-10",
          "totalTokens": 24019743394927,
          "pricedTokens": 175286831314,
          "blendedPricePerMillion": 0.3512843624503469,
          "estimatedRetailValue": 61575.52278407999,
          "pricedTokenShare": 0.007297614651079944
        },
        {
          "key": "2026-10-11",
          "label": "10-11",
          "startDate": "2026-10-11",
          "endDate": "2026-10-11",
          "totalTokens": 23624418723773,
          "pricedTokens": 67891727613,
          "blendedPricePerMillion": 0.15999999999999998,
          "estimatedRetailValue": 10862.676418079998,
          "pricedTokenShare": 0.0028737946277882925
        },
        {
          "key": "2026-10-12",
          "label": "10-12",
          "startDate": "2026-10-12",
          "endDate": "2026-10-12",
          "totalTokens": 26944742365440,
          "pricedTokens": 221344983099,
          "blendedPricePerMillion": 0.34164369500770325,
          "estimatedRetailValue": 75621.11789735999,
          "pricedTokenShare": 0.008214774522502119
        },
        {
          "key": "2026-10-13",
          "label": "10-13",
          "startDate": "2026-10-13",
          "endDate": "2026-10-13",
          "totalTokens": 26210571251367,
          "pricedTokens": 253224515864,
          "blendedPricePerMillion": 0.3285624978251493,
          "estimatedRetailValue": 83200.07944283998,
          "pricedTokenShare": 0.009661159744879395
        },
        {
          "key": "2026-10-14",
          "label": "10-14",
          "startDate": "2026-10-14",
          "endDate": "2026-10-14",
          "totalTokens": 26374532234884,
          "pricedTokens": 253160917129,
          "blendedPricePerMillion": 0.3283624024448499,
          "estimatedRetailValue": 83128.52695361999,
          "pricedTokenShare": 0.009598688419359316
        },
        {
          "key": "2026-10-15",
          "label": "10-15",
          "startDate": "2026-10-15",
          "endDate": "2026-10-15",
          "totalTokens": 24438956540182,
          "pricedTokens": 256875059185,
          "blendedPricePerMillion": 0.3186298716692984,
          "estimatedRetailValue": 81848.06714315998,
          "pricedTokenShare": 0.010510884896523779
        },
        {
          "key": "2026-10-16",
          "label": "10-16",
          "startDate": "2026-10-16",
          "endDate": "2026-10-16",
          "totalTokens": 22407801051165,
          "pricedTokens": 188782226366,
          "blendedPricePerMillion": 0.19654341472753425,
          "estimatedRetailValue": 37103.90340983999,
          "pricedTokenShare": 0.008424843916408525
        },
        {
          "key": "2026-10-17",
          "label": "10-17",
          "startDate": "2026-10-17",
          "endDate": "2026-10-17",
          "totalTokens": 18338242794490,
          "pricedTokens": 152936757471,
          "blendedPricePerMillion": 0.1950003399216503,
          "estimatedRetailValue": 29822.71969335999,
          "pricedTokenShare": 0.008339771655600074
        }
      ],
      "modelShares": [
        {
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "name": "deepseek-v4.1-flash-20260910",
          "tokens": 137073542196373,
          "previousTokens": 0,
          "share": 0.05835752220522545,
          "previousShare": 0,
          "shareDeltaPctPoints": 5.835752220522545,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "deepseek/deepseek-v4-flash-20260423",
          "name": "deepseek-v4-flash-20260423",
          "tokens": 104815889274284,
          "previousTokens": 0,
          "share": 0.04462418850328895,
          "previousShare": 0,
          "shareDeltaPctPoints": 4.462418850328895,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "xiaomi/mimo-v2.5-20260422",
          "name": "mimo-v2.5-20260422",
          "tokens": 102572433994235,
          "previousTokens": 0,
          "share": 0.04366906259624608,
          "previousShare": 0,
          "shareDeltaPctPoints": 4.366906259624608,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "deepseek/deepseek-v4-flash-20260731",
          "name": "deepseek-v4-flash-20260731",
          "tokens": 101390812122071,
          "previousTokens": 0,
          "share": 0.04316600034558794,
          "previousShare": 0,
          "shareDeltaPctPoints": 4.316600034558794,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "name": "glm-5.3-flash-20260826",
          "tokens": 93602735938457,
          "previousTokens": 0,
          "share": 0.039850314316477155,
          "previousShare": 0,
          "shareDeltaPctPoints": 3.9850314316477156,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "openai/gpt-5.6-luna-20260709",
          "name": "gpt-5.6-luna-20260709",
          "tokens": 82169207176715,
          "previousTokens": 0,
          "share": 0.03498261776536915,
          "previousShare": 0,
          "shareDeltaPctPoints": 3.498261776536915,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "tencent/hy4-preview-20260827",
          "name": "hy4-preview-20260827",
          "tokens": 78212445675738,
          "previousTokens": 0,
          "share": 0.03329807096330835,
          "previousShare": 0,
          "shareDeltaPctPoints": 3.329807096330835,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "tencent/hy3-20260706",
          "name": "hy3-20260706",
          "tokens": 64150843539083,
          "previousTokens": 0,
          "share": 0.0273115016678619,
          "previousShare": 0,
          "shareDeltaPctPoints": 2.73115016678619,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "nvidia/nemotron-3-ultra-550b-a55b-20260604:free",
          "name": "nemotron-3-ultra-550b-a55b-20260604:free",
          "tokens": 62056042271533,
          "previousTokens": 0,
          "share": 0.02641966353828726,
          "previousShare": 0,
          "shareDeltaPctPoints": 2.6419663538287264,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "stealth/space-bunny-alpha",
          "name": "space-bunny-alpha",
          "tokens": 56716522847075,
          "previousTokens": 0,
          "share": 0.02414642306908251,
          "previousShare": 0,
          "shareDeltaPctPoints": 2.414642306908251,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "minimax/minimax-m3-20260531",
          "name": "minimax-m3-20260531",
          "tokens": 46442704993517,
          "previousTokens": 0,
          "share": 0.019772460421626267,
          "previousShare": 0,
          "shareDeltaPctPoints": 1.9772460421626268,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "z-ai/glm-5.2-20260616",
          "name": "glm-5.2-20260616",
          "tokens": 44268196235379,
          "previousTokens": 0,
          "share": 0.018846687722495908,
          "previousShare": 0,
          "shareDeltaPctPoints": 1.8846687722495907,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "deepseek/deepseek-v4-pro-20260423",
          "name": "deepseek-v4-pro-20260423",
          "tokens": 42411320502664,
          "previousTokens": 0,
          "share": 0.018056143719124212,
          "previousShare": 0,
          "shareDeltaPctPoints": 1.8056143719124211,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "google/gemini-3-flash-preview-20251217",
          "name": "gemini-3-flash-preview-20251217",
          "tokens": 37339773408726,
          "previousTokens": 0,
          "share": 0.015896989462168234,
          "previousShare": 0,
          "shareDeltaPctPoints": 1.5896989462168234,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "xiaomi/mimo-v2.6-flash-20260921",
          "name": "mimo-v2.6-flash-20260921",
          "tokens": 35479245491272,
          "previousTokens": 0,
          "share": 0.015104890582132604,
          "previousShare": 0,
          "shareDeltaPctPoints": 1.5104890582132604,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "anthropic/claude-4.6-sonnet-20260217",
          "name": "claude-4.6-sonnet-20260217",
          "tokens": 35408047704548,
          "previousTokens": 0,
          "share": 0.015074578923492045,
          "previousShare": 0,
          "shareDeltaPctPoints": 1.5074578923492046,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "google/gemini-2.5-flash",
          "name": "Google: Gemini 2.5 Flash",
          "tokens": 29812671165890,
          "previousTokens": 0,
          "share": 0.012692410159416932,
          "previousShare": 0,
          "shareDeltaPctPoints": 1.2692410159416931,
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 2.5,
          "blendedPricePerMillion": 0.7399999999999999,
          "estimatedRetailValue": 22061376.662758596
        },
        {
          "modelSlug": "deepseek/deepseek-v3.2-20251201",
          "name": "deepseek-v3.2-20251201",
          "tokens": 29276678629967,
          "previousTokens": 0,
          "share": 0.012464217352725246,
          "previousShare": 0,
          "shareDeltaPctPoints": 1.2464217352725246,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "stealth/ox-alpha",
          "name": "ox-alpha",
          "tokens": 27237502959584,
          "previousTokens": 0,
          "share": 0.011596061196854926,
          "previousShare": 0,
          "shareDeltaPctPoints": 1.1596061196854925,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        },
        {
          "modelSlug": "tencent/hy3-preview-20260421",
          "name": "hy3-preview-20260421",
          "tokens": 27210550265225,
          "previousTokens": 0,
          "share": 0.011584586389723345,
          "previousShare": 0,
          "shareDeltaPctPoints": 1.1584586389723346,
          "promptPricePerMillion": null,
          "completionPricePerMillion": null,
          "blendedPricePerMillion": null,
          "estimatedRetailValue": null
        }
      ],
      "providerPrices": [
        {
          "provider": "OpenInference",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.04,
          "completionPricePerMillion": 0.144,
          "blendedPricePerMillion": 0.060799999999999986,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Relace",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.049999999999999996,
          "completionPricePerMillion": 0.6,
          "blendedPricePerMillion": 0.15999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Morph",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.081,
          "completionPricePerMillion": 0.55,
          "blendedPricePerMillion": 0.17479999999999998,
          "throughput": null,
          "latency": null,
          "uptime": null,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Decart",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.09,
          "completionPricePerMillion": 0.18,
          "blendedPricePerMillion": 0.108,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Sail Research",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.09,
          "completionPricePerMillion": 0.3,
          "blendedPricePerMillion": 0.13199999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Wafer",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.09999999999999999,
          "completionPricePerMillion": 0.65,
          "blendedPricePerMillion": 0.20999999999999996,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "InferenceNet",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.103,
          "completionPricePerMillion": 0.7150000000000001,
          "blendedPricePerMillion": 0.22539999999999996,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DeepInfra",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.112,
          "completionPricePerMillion": 0.33599999999999997,
          "blendedPricePerMillion": 0.15679999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "AtlasCloud",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.135,
          "completionPricePerMillion": 0.54,
          "blendedPricePerMillion": 0.21599999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DeepInfra",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.14,
          "completionPricePerMillion": 0.42,
          "blendedPricePerMillion": 0.196,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "StreamLake",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.1497,
          "completionPricePerMillion": 0.5988,
          "blendedPricePerMillion": 0.23952,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "CoreWeave",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.65,
          "blendedPricePerMillion": 0.24999999999999994,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "GMICloud",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.18,
          "completionPricePerMillion": 0.72,
          "blendedPricePerMillion": 0.288,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DigitalOcean",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.195,
          "completionPricePerMillion": 0.78,
          "blendedPricePerMillion": 0.312,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Novita",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.195,
          "completionPricePerMillion": 0.78,
          "blendedPricePerMillion": 0.312,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DeepInfra",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.21,
          "completionPricePerMillion": 0.63,
          "blendedPricePerMillion": 0.294,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Phala",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.21,
          "completionPricePerMillion": 0.84,
          "blendedPricePerMillion": 0.33599999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Ionstream",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.27,
          "completionPricePerMillion": 0.75,
          "blendedPricePerMillion": 0.366,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Makora",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.27,
          "completionPricePerMillion": 1.15,
          "blendedPricePerMillion": 0.44599999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Crusoe",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.29,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47199999999999986,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Nebius",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "PrimeIntellect",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Baidu",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "BaseTen",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Alibaba",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Together",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "SiliconFlow",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Modal",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "BaseTen",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Parasail",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Fireworks",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Venice",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Fireworks",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.44999999999999996,
          "completionPricePerMillion": 1.7999999999999998,
          "blendedPricePerMillion": 0.7199999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "BaseTen",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20260910",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash",
          "promptPricePerMillion": 0.6,
          "completionPricePerMillion": 2.4,
          "blendedPricePerMillion": 0.9599999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "OpenInference",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.048,
          "completionPricePerMillion": 0.19999999999999998,
          "blendedPricePerMillion": 0.07839999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Reka",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.06,
          "completionPricePerMillion": 1.5999999999999999,
          "blendedPricePerMillion": 0.3679999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "StreamLake",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.075,
          "completionPricePerMillion": 0.25,
          "blendedPricePerMillion": 0.10999999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DeepInfra",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.075,
          "completionPricePerMillion": 0.25,
          "blendedPricePerMillion": 0.10999999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Relace",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.075,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.15999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Sail Research",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.07835,
          "completionPricePerMillion": 0.3,
          "blendedPricePerMillion": 0.12267999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Sail Research",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.07835,
          "completionPricePerMillion": 0.3,
          "blendedPricePerMillion": 0.12267999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Near AI",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.08,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.16399999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Novita",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.08399999999999999,
          "completionPricePerMillion": 0.28,
          "blendedPricePerMillion": 0.12319999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "GMICloud",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.09,
          "completionPricePerMillion": 0.3,
          "blendedPricePerMillion": 0.13199999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Inceptron",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.09999999999999999,
          "completionPricePerMillion": 0.69,
          "blendedPricePerMillion": 0.21799999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "InferenceNet",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.12,
          "completionPricePerMillion": 0.38799999999999996,
          "blendedPricePerMillion": 0.17359999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Wafer",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.12,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.19599999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 96.66666666666667,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Phala",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.1275,
          "completionPricePerMillion": 0.425,
          "blendedPricePerMillion": 0.18699999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Morph",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.129,
          "completionPricePerMillion": 0.65,
          "blendedPricePerMillion": 0.2332,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DigitalOcean",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.13124999999999998,
          "completionPricePerMillion": 0.4375,
          "blendedPricePerMillion": 0.19249999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Makora",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.14,
          "completionPricePerMillion": 0.47,
          "blendedPricePerMillion": 0.206,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "PrimeIntellect",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Modal",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "BaseTen",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Crusoe",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "CoreWeave",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "AtlasCloud",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 96.29629629629629,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Fireworks",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Friendli",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "SiliconFlow",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Together",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Parasail",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "BaseTen",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Venice",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Z.AI",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.21999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Parasail",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.1875,
          "completionPricePerMillion": 0.625,
          "blendedPricePerMillion": 0.275,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Fireworks",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.22499999999999998,
          "completionPricePerMillion": 0.75,
          "blendedPricePerMillion": 0.32999999999999996,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "NextBit",
          "modelSlug": "z-ai/glm-5.3-flash-20260826",
          "modelName": "Z.ai: GLM 5.3 Flash",
          "promptPricePerMillion": 0.25,
          "completionPricePerMillion": 0.7,
          "blendedPricePerMillion": 0.3399999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Darkbloom",
          "modelSlug": "xiaomi/mimo-v2.6-flash-20260921",
          "modelName": "Xiaomi: MiMo-V2.6-Flash",
          "promptPricePerMillion": 0.09999999999999999,
          "completionPricePerMillion": 0.28,
          "blendedPricePerMillion": 0.136,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Makora",
          "modelSlug": "xiaomi/mimo-v2.6-flash-20260921",
          "modelName": "Xiaomi: MiMo-V2.6-Flash",
          "promptPricePerMillion": 0.13,
          "completionPricePerMillion": 0.28,
          "blendedPricePerMillion": 0.16,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DeepInfra",
          "modelSlug": "xiaomi/mimo-v2.6-flash-20260921",
          "modelName": "Xiaomi: MiMo-V2.6-Flash",
          "promptPricePerMillion": 0.133,
          "completionPricePerMillion": 0.266,
          "blendedPricePerMillion": 0.1596,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Novita",
          "modelSlug": "xiaomi/mimo-v2.6-flash-20260921",
          "modelName": "Xiaomi: MiMo-V2.6-Flash",
          "promptPricePerMillion": 0.14,
          "completionPricePerMillion": 0.28,
          "blendedPricePerMillion": 0.16799999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 95.23809523809523,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "GMICloud",
          "modelSlug": "xiaomi/mimo-v2.6-flash-20260921",
          "modelName": "Xiaomi: MiMo-V2.6-Flash",
          "promptPricePerMillion": 0.14,
          "completionPricePerMillion": 0.28,
          "blendedPricePerMillion": 0.16799999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 88.23529411764706,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Xiaomi",
          "modelSlug": "xiaomi/mimo-v2.6-flash-20260921",
          "modelName": "Xiaomi: MiMo-V2.6-Flash",
          "promptPricePerMillion": 0.14,
          "completionPricePerMillion": 0.28,
          "blendedPricePerMillion": 0.16799999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Io Net",
          "modelSlug": "xiaomi/mimo-v2.6-flash-20260921",
          "modelName": "Xiaomi: MiMo-V2.6-Flash",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.29,
          "blendedPricePerMillion": 0.178,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Venice",
          "modelSlug": "xiaomi/mimo-v2.6-flash-20260921",
          "modelName": "Xiaomi: MiMo-V2.6-Flash",
          "promptPricePerMillion": 0.175,
          "completionPricePerMillion": 0.35,
          "blendedPricePerMillion": 0.21,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DeepInfra",
          "modelSlug": "tencent/hy4-preview-20260827",
          "modelName": "Tencent: Hy4 preview",
          "promptPricePerMillion": 0.834,
          "completionPricePerMillion": 2.501,
          "blendedPricePerMillion": 1.1674,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Novita",
          "modelSlug": "tencent/hy4-preview-20260827",
          "modelName": "Tencent: Hy4 preview",
          "promptPricePerMillion": 0.834,
          "completionPricePerMillion": 2.501,
          "blendedPricePerMillion": 1.1674,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "SiliconFlow",
          "modelSlug": "tencent/hy4-preview-20260827",
          "modelName": "Tencent: Hy4 preview",
          "promptPricePerMillion": 0.834,
          "completionPricePerMillion": 2.501,
          "blendedPricePerMillion": 1.1674,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Tencent",
          "modelSlug": "tencent/hy4-preview-20260827",
          "modelName": "Tencent: Hy4 preview",
          "promptPricePerMillion": 0.834,
          "completionPricePerMillion": 2.501,
          "blendedPricePerMillion": 1.1674,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Amazon Bedrock",
          "modelSlug": "anthropic/claude-opus-5.5-20260921",
          "modelName": "Anthropic: Claude Opus 5.5",
          "promptPricePerMillion": 4,
          "completionPricePerMillion": 20,
          "blendedPricePerMillion": 7.199999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Azure",
          "modelSlug": "anthropic/claude-opus-5.5-20260921",
          "modelName": "Anthropic: Claude Opus 5.5",
          "promptPricePerMillion": 4,
          "completionPricePerMillion": 20,
          "blendedPricePerMillion": 7.199999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Google",
          "modelSlug": "anthropic/claude-opus-5.5-20260921",
          "modelName": "Anthropic: Claude Opus 5.5",
          "promptPricePerMillion": 4,
          "completionPricePerMillion": 20,
          "blendedPricePerMillion": 7.199999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Claude Platform on AWS",
          "modelSlug": "anthropic/claude-opus-5.5-20260921",
          "modelName": "Anthropic: Claude Opus 5.5",
          "promptPricePerMillion": 4,
          "completionPricePerMillion": 20,
          "blendedPricePerMillion": 7.199999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Anthropic",
          "modelSlug": "anthropic/claude-opus-5.5-20260921",
          "modelName": "Anthropic: Claude Opus 5.5",
          "promptPricePerMillion": 4,
          "completionPricePerMillion": 20,
          "blendedPricePerMillion": 7.199999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Amazon Bedrock",
          "modelSlug": "anthropic/claude-opus-5.5-20260921",
          "modelName": "Anthropic: Claude Opus 5.5",
          "promptPricePerMillion": 4.4,
          "completionPricePerMillion": 22,
          "blendedPricePerMillion": 7.919999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Amazon Bedrock",
          "modelSlug": "anthropic/claude-opus-5.5-20260921",
          "modelName": "Anthropic: Claude Opus 5.5",
          "promptPricePerMillion": 4.4,
          "completionPricePerMillion": 22,
          "blendedPricePerMillion": 7.919999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Azure",
          "modelSlug": "anthropic/claude-opus-5.5-20260921",
          "modelName": "Anthropic: Claude Opus 5.5",
          "promptPricePerMillion": 4.4,
          "completionPricePerMillion": 22,
          "blendedPricePerMillion": 7.919999999999999,
          "throughput": null,
          "latency": null,
          "uptime": null,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Google",
          "modelSlug": "anthropic/claude-opus-5.5-20260921",
          "modelName": "Anthropic: Claude Opus 5.5",
          "promptPricePerMillion": 4.4,
          "completionPricePerMillion": 22,
          "blendedPricePerMillion": 7.919999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Google",
          "modelSlug": "anthropic/claude-opus-5.5-20260921",
          "modelName": "Anthropic: Claude Opus 5.5",
          "promptPricePerMillion": 4.4,
          "completionPricePerMillion": 22,
          "blendedPricePerMillion": 7.919999999999999,
          "throughput": null,
          "latency": null,
          "uptime": null,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Anthropic",
          "modelSlug": "anthropic/claude-opus-5.5-20260921",
          "modelName": "Anthropic: Claude Opus 5.5",
          "promptPricePerMillion": 8,
          "completionPricePerMillion": 40,
          "blendedPricePerMillion": 14.399999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Relace",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.049999999999999996,
          "completionPricePerMillion": 0.6,
          "blendedPricePerMillion": 0.15999999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DeepInfra",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.0784,
          "completionPricePerMillion": 0.2352,
          "blendedPricePerMillion": 0.10976,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "InferenceNet",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.08,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.16399999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Morph",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.081,
          "completionPricePerMillion": 0.55,
          "blendedPricePerMillion": 0.17479999999999998,
          "throughput": null,
          "latency": null,
          "uptime": null,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DeepInfra",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.098,
          "completionPricePerMillion": 0.29400000000000004,
          "blendedPricePerMillion": 0.13720000000000002,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Cloudflare",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.09999999999999999,
          "completionPricePerMillion": 0.6,
          "blendedPricePerMillion": 0.19999999999999996,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DeepInfra",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.14700000000000002,
          "completionPricePerMillion": 0.441,
          "blendedPricePerMillion": 0.2058,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DeepSeek",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.15,
          "completionPricePerMillion": 0.6,
          "blendedPricePerMillion": 0.23999999999999994,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Wafer",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Fireworks",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "PrimeIntellect",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "BaseTen",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Parasail",
          "modelSlug": "deepseek/deepseek-v4.1-flash-20261017",
          "modelName": "DeepSeek: DeepSeek V4.1 Flash 1017",
          "promptPricePerMillion": 0.3,
          "completionPricePerMillion": 1.2,
          "blendedPricePerMillion": 0.47999999999999987,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "OpenAI",
          "modelSlug": "openai/gpt-6-luna-20260922",
          "modelName": "OpenAI: GPT-6 Luna",
          "promptPricePerMillion": 0.049999999999999996,
          "completionPricePerMillion": 0.25,
          "blendedPricePerMillion": 0.08999999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "OpenAI",
          "modelSlug": "openai/gpt-6-luna-20260922",
          "modelName": "OpenAI: GPT-6 Luna",
          "promptPricePerMillion": 0.09999999999999999,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.17999999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Azure",
          "modelSlug": "openai/gpt-6-luna-20260922",
          "modelName": "OpenAI: GPT-6 Luna",
          "promptPricePerMillion": 0.09999999999999999,
          "completionPricePerMillion": 0.5,
          "blendedPricePerMillion": 0.17999999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Azure",
          "modelSlug": "openai/gpt-6-luna-20260922",
          "modelName": "OpenAI: GPT-6 Luna",
          "promptPricePerMillion": 0.11,
          "completionPricePerMillion": 0.55,
          "blendedPricePerMillion": 0.198,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Azure",
          "modelSlug": "openai/gpt-6-luna-20260922",
          "modelName": "OpenAI: GPT-6 Luna",
          "promptPricePerMillion": 0.11,
          "completionPricePerMillion": 0.55,
          "blendedPricePerMillion": 0.198,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Amazon Bedrock",
          "modelSlug": "openai/gpt-6-luna-20260922",
          "modelName": "OpenAI: GPT-6 Luna",
          "promptPricePerMillion": 0.11,
          "completionPricePerMillion": 0.55,
          "blendedPricePerMillion": 0.198,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "OpenAI",
          "modelSlug": "openai/gpt-6-luna-20260922",
          "modelName": "OpenAI: GPT-6 Luna",
          "promptPricePerMillion": 0.19999999999999998,
          "completionPricePerMillion": 1,
          "blendedPricePerMillion": 0.35999999999999993,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Relace",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.075,
          "completionPricePerMillion": 2.2,
          "blendedPricePerMillion": 0.4999999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Wafer",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.079,
          "completionPricePerMillion": 2.5,
          "blendedPricePerMillion": 0.5631999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "InferenceNet",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.08,
          "completionPricePerMillion": 4.381,
          "blendedPricePerMillion": 0.9401999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Morph",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.08,
          "completionPricePerMillion": 6,
          "blendedPricePerMillion": 1.2639999999999996,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Reka",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.14,
          "completionPricePerMillion": 4.199999999999999,
          "blendedPricePerMillion": 0.9519999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Makora",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.14,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 0.9919999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Wafer",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.179,
          "completionPricePerMillion": 2.5,
          "blendedPricePerMillion": 0.6432,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DekaLLM",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.18,
          "completionPricePerMillion": 2.95,
          "blendedPricePerMillion": 0.7339999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "AkashML",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.19,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 1.0319999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Io Net",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.49,
          "completionPricePerMillion": 2.6,
          "blendedPricePerMillion": 0.9119999999999999,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Sail Research",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.5,
          "completionPricePerMillion": 1.505,
          "blendedPricePerMillion": 0.701,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Sail Research",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.5,
          "completionPricePerMillion": 1.505,
          "blendedPricePerMillion": 0.701,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Inceptron",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.55,
          "completionPricePerMillion": 1.505,
          "blendedPricePerMillion": 0.741,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DeepInfra",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.5625,
          "completionPricePerMillion": 2.5,
          "blendedPricePerMillion": 0.95,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Baidu",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.5992000000000001,
          "completionPricePerMillion": 1.8832,
          "blendedPricePerMillion": 0.856,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Tenstorrent",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.6,
          "completionPricePerMillion": 2.5,
          "blendedPricePerMillion": 0.98,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "SiliconFlow",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.7,
          "completionPricePerMillion": 2.2,
          "blendedPricePerMillion": 1,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Novita",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.7,
          "completionPricePerMillion": 2.2,
          "blendedPricePerMillion": 1,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Phala",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.84,
          "completionPricePerMillion": 2.64,
          "blendedPricePerMillion": 1.2,
          "throughput": null,
          "latency": null,
          "uptime": null,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Decart",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.84,
          "completionPricePerMillion": 2.66,
          "blendedPricePerMillion": 1.2039999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "DigitalOcean",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.9099999999999999,
          "completionPricePerMillion": 2.8600000000000003,
          "blendedPricePerMillion": 1.2999999999999998,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "GMICloud",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 0.98,
          "completionPricePerMillion": 3.08,
          "blendedPricePerMillion": 1.4,
          "throughput": null,
          "latency": null,
          "uptime": null,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Alibaba",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.19,
          "completionPricePerMillion": 3.74,
          "blendedPricePerMillion": 1.6999999999999997,
          "throughput": null,
          "latency": null,
          "uptime": null,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "CoreWeave",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.2,
          "completionPricePerMillion": 4,
          "blendedPricePerMillion": 1.7599999999999996,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Friendli",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.26,
          "completionPricePerMillion": 3.9600000000000004,
          "blendedPricePerMillion": 1.8,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Mistral",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "BaseTen",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Mistral",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Nebius",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Crusoe",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "PrimeIntellect",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Venice",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": null,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Together",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Parasail",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Modal",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "BaseTen",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": null,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Fireworks",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Cloudflare",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": null,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "AtlasCloud",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": 96.66666666666667,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Z.AI",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.4,
          "completionPricePerMillion": 4.4,
          "blendedPricePerMillion": 2,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Mistral",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 1.54,
          "completionPricePerMillion": 4.84,
          "blendedPricePerMillion": 2.2,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "ModelRun",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 2.0999999999999996,
          "completionPricePerMillion": 6.6000000000000005,
          "blendedPricePerMillion": 3,
          "throughput": null,
          "latency": null,
          "uptime": null,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Fireworks",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 2.0999999999999996,
          "completionPricePerMillion": 6.6000000000000005,
          "blendedPricePerMillion": 3,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "BaseTen",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 2.0999999999999996,
          "completionPricePerMillion": 6.6000000000000005,
          "blendedPricePerMillion": 3,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "BaseTen",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 2.0999999999999996,
          "completionPricePerMillion": 6.6000000000000005,
          "blendedPricePerMillion": 3,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Alibaba",
          "modelSlug": "z-ai/glm-5.3-20260816",
          "modelName": "Z.ai: GLM 5.3",
          "promptPricePerMillion": 2.8,
          "completionPricePerMillion": 8.8,
          "blendedPricePerMillion": 4,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "OpenInference",
          "modelSlug": "deepseek/deepseek-v4-flash-20260731",
          "modelName": "DeepSeek: DeepSeek V4 Flash 0731",
          "promptPricePerMillion": 0.00392,
          "completionPricePerMillion": 0.143616,
          "blendedPricePerMillion": 0.0318592,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Relace",
          "modelSlug": "deepseek/deepseek-v4-flash-20260731",
          "modelName": "DeepSeek: DeepSeek V4 Flash 0731",
          "promptPricePerMillion": 0.0199,
          "completionPricePerMillion": 0.44999999999999996,
          "blendedPricePerMillion": 0.10591999999999997,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        },
        {
          "provider": "Reka",
          "modelSlug": "deepseek/deepseek-v4-flash-20260731",
          "modelName": "DeepSeek: DeepSeek V4 Flash 0731",
          "promptPricePerMillion": 0.020999999999999998,
          "completionPricePerMillion": 0.5279999999999999,
          "blendedPricePerMillion": 0.12239999999999995,
          "throughput": null,
          "latency": null,
          "uptime": 100,
          "observedAt": "2026-10-18T12:08:32.383Z"
        }
      ]
    }
  },
  "events": [
    {
      "id": "gemini-2",
      "date": "2025-02-05",
      "provider": "Google",
      "model": "Gemini 2.0",
      "title": "Gemini 2.0 系列更新",
      "sourceUrl": "https://blog.google/innovation-and-ai/models-and-research/google-deepmind/gemini-model-updates-february-2025/",
      "importance": "major"
    },
    {
      "id": "claude-37",
      "date": "2025-02-24",
      "provider": "Anthropic",
      "model": "Claude 3.7 Sonnet",
      "title": "Claude 3.7 Sonnet 发布",
      "sourceUrl": "https://www.anthropic.com/news/claude-3-7-sonnet",
      "importance": "notable"
    },
    {
      "id": "llama-4",
      "date": "2025-04-05",
      "provider": "Meta",
      "model": "Llama 4",
      "title": "Llama 4 模型系列发布",
      "sourceUrl": "https://ai.meta.com/blog/llama-4-multimodal-intelligence/",
      "importance": "major"
    },
    {
      "id": "qwen-3",
      "date": "2025-04-29",
      "provider": "Alibaba",
      "model": "Qwen3",
      "title": "Qwen3 发布",
      "sourceUrl": "https://qwenlm.github.io/blog/qwen3/",
      "importance": "major"
    },
    {
      "id": "claude-4",
      "date": "2025-05-22",
      "provider": "Anthropic",
      "model": "Claude 4",
      "title": "Claude 4 系列发布",
      "sourceUrl": "https://www.anthropic.com/news/claude-4",
      "importance": "major"
    },
    {
      "id": "qwen3-coder",
      "date": "2025-07-22",
      "provider": "Alibaba",
      "model": "Qwen3-Coder",
      "title": "Qwen3-Coder 发布",
      "sourceUrl": "https://qwenlm.github.io/blog/qwen3-coder/",
      "importance": "notable"
    },
    {
      "id": "gpt-5",
      "date": "2025-08-07",
      "provider": "OpenAI",
      "model": "GPT-5",
      "title": "GPT-5 发布",
      "sourceUrl": "https://openai.com/index/introducing-gpt-5/",
      "importance": "major"
    },
    {
      "id": "grok-41",
      "date": "2025-11-17",
      "provider": "xAI",
      "model": "Grok 4.1",
      "title": "Grok 4.1 发布",
      "sourceUrl": "https://x.ai/news/grok-4-1",
      "importance": "notable"
    },
    {
      "id": "gemini-3",
      "date": "2025-11-18",
      "provider": "Google",
      "model": "Gemini 3",
      "title": "Gemini 3 发布",
      "sourceUrl": "https://blog.google/products-and-platforms/products/gemini/gemini-3/",
      "importance": "major"
    },
    {
      "id": "deepseek-v32",
      "date": "2025-12-01",
      "provider": "DeepSeek",
      "model": "DeepSeek V3.2",
      "title": "DeepSeek V3.2 发布",
      "sourceUrl": "https://api-docs.deepseek.com/updates/",
      "importance": "major"
    },
    {
      "id": "claude-opus-46",
      "date": "2026-02-05",
      "provider": "Anthropic",
      "model": "Claude Opus 4.6",
      "title": "Claude Opus 4.6 发布",
      "sourceUrl": "https://www.anthropic.com/news",
      "importance": "notable"
    },
    {
      "id": "deepseek-v4",
      "date": "2026-04-24",
      "provider": "DeepSeek",
      "model": "DeepSeek V4",
      "title": "DeepSeek V4 发布",
      "sourceUrl": "https://www.deepseek.com/en/transparency/",
      "importance": "major"
    },
    {
      "id": "gemini-35",
      "date": "2026-05-19",
      "provider": "Google",
      "model": "Gemini 3.5",
      "title": "Gemini 3.5 发布",
      "sourceUrl": "https://blog.google/innovation-and-ai/models-and-research/gemini-models/gemini-3-5/",
      "importance": "major"
    },
    {
      "id": "gpt-56",
      "date": "2026-07-09",
      "provider": "OpenAI",
      "model": "GPT-5.6",
      "title": "GPT-5.6 发布",
      "sourceUrl": "https://openai.com/index/gpt-5-6/",
      "importance": "major"
    },
    {
      "id": "grok-45",
      "date": "2026-07-16",
      "provider": "xAI",
      "model": "Grok 4.5",
      "title": "Grok 4.5 发布",
      "sourceUrl": "https://x.ai/news/grok-4-5",
      "importance": "notable"
    }
  ]
}
